import { computed as M, ref as E, useId as tt, toValue as me, watch as ye, onMounted as dt, nextTick as Ie, getCurrentScope as yr, onScopeDispose as ko, getCurrentInstance as Qn, isRef as Ne, hasInjectionContext as br, inject as pr, readonly as Cl, toRef as Co, customRef as $o, shallowRef as et, watchEffect as Xn, unref as r, onUnmounted as wr, defineComponent as te, openBlock as s, createBlock as G, resolveDynamicComponent as mt, normalizeClass as D, withCtx as U, createElementBlock as u, createElementVNode as d, renderSlot as P, markRaw as $e, createCommentVNode as S, provide as Mo, onBeforeUnmount as xr, createVNode as Q, Teleport as Jn, Transition as Qe, normalizeStyle as st, createTextVNode as re, toDisplayString as A, mergeProps as en, createSlots as kr, renderList as le, normalizeProps as Cr, guardReactiveProps as $r, useCssVars as Mr, Fragment as J, useModel as Te, withDirectives as Ze, vModelSelect as It, mergeModels as xe, useSlots as Qt, vModelCheckbox as So, resolveComponent as Wn, withKeys as Se, withModifiers as fe, vModelText as qn, vModelDynamic as Do, createStaticVNode as $l, vModelRadio as zo, TransitionGroup as To } from "vue";
function Ml(e) {
  const a = (b) => typeof b == "function" ? b() : b, t = M(() => a(e.prefix ?? "btn")), n = M(() => a(e.kind ?? "")), l = M(() => a(e.variant ?? "")), o = M(() => a(e.size ?? "")), i = M(() => a(e.disabled ?? !1)), h = M(() => a(e.active ?? !1)), c = M(() => a(e.block ?? !1)), f = M(() => a(e.pending ?? !1)), y = M(() => a(e.cta ?? !1)), m = M(() => n.value ? t.value : ""), g = M(() => n.value && {
    primary: `${t.value}-primary`,
    secondary: `${t.value}-secondary`,
    tertiary: `${t.value}-tertiary`,
    ghost: `${t.value}-ghost`
  }[n.value] || ""), v = M(() => l.value && {
    gray: `${t.value}-gray`,
    blue: `${t.value}-blue`,
    red: `${t.value}-red`,
    white: `${t.value}-white`
  }[l.value] || ""), C = M(() => !o.value || o.value === "md" ? "" : {
    xs: `${t.value}-xs`,
    sm: `${t.value}-sm`,
    lg: `${t.value}-lg`
  }[o.value] || ""), k = M(() => i.value ? "disabled" : ""), w = M(() => t.value === "btn" ? h.value || f.value ? "active" : "" : h.value ? "active" : ""), x = M(() => c.value ? t.value === "btn" ? "btn-block flex items-center justify-center" : "action-btn-block" : ""), I = M(() => f.value ? "active pointer-events-none" : ""), L = M(() => y.value && t.value === "btn" ? "btn-cta" : ""), z = M(() => [
    m.value,
    g.value,
    v.value,
    C.value,
    k.value,
    w.value,
    x.value,
    I.value,
    L.value
  ].filter(Boolean));
  return {
    btnClass: m,
    kindClass: g,
    variantClass: v,
    sizeClass: C,
    disabledClass: k,
    activeClass: w,
    blockClass: x,
    pendingClass: I,
    ctaClass: L,
    allClasses: z
  };
}
function Sl(e = {}) {
  const {
    prefix: a = "btn",
    openDelay: t = 0,
    closeDelay: n = 0,
    darkMode: l = !1
  } = e, o = E(), i = tt(), { zIndexClass: h } = _n(() => {
    const L = me(e.zIndex);
    return L !== void 0 ? L : "50";
  }), { btnClass: c, kindClass: f, variantClass: y, sizeClass: m, disabledClass: g, blockClass: v, activeClass: C } = Ml({
    prefix: () => me(a),
    kind: e.kind ? () => me(e.kind) || "" : void 0,
    variant: e.variant ? () => me(e.variant) || "" : void 0,
    size: e.size ? () => me(e.size) || "" : void 0,
    disabled: e.disabled ? () => me(e.disabled) || !1 : void 0,
    block: e.block ? () => me(e.block) || !1 : void 0,
    active: e.active ? () => me(e.active) || !1 : void 0
  }), k = (L, z, b) => {
    L ? b(n) : z(t);
  }, w = M(() => ({
    "[.dropdown-dark_&]:border-gray-700 [.dropdown-dark_&]:bg-gray-950 dark:border-gray-700 dark:bg-gray-950": me(l),
    "bg-white absolute border shadow-lg rounded-theme-md [.dropdown-dark_&]:border-gray-700 [.dropdown-dark_&]:bg-gray-950 dark:border-gray-700 dark:bg-gray-950": !0,
    [h.value]: !0
  })), x = M(() => me(e.iconOnly) ? me(a) === "btn" ? "btn-square" : "action-btn-square" : ""), I = M(() => {
    const L = me(e.size) || "sm", z = {
      xs: "w-4 h-4",
      sm: "w-4 h-4",
      md: "w-4.5 h-4.5",
      lg: "w-4.5 h-4.5"
    };
    return z[L] || z.sm;
  });
  return {
    id: i,
    buttonRef: o,
    zIndexClass: h,
    btnClass: c,
    kindClass: f,
    variantClass: y,
    sizeClass: m,
    disabledClass: g,
    blockClass: v,
    activeClass: C,
    iconOnlyClasses: x,
    iconSizeClasses: I,
    handleClick: k,
    dropdownClasses: w
  };
}
function _n(e) {
  const a = () => typeof e == "function" ? e() : e;
  return {
    zIndexClass: M(() => {
      const n = a();
      return {
        0: "z-0",
        10: "z-10",
        20: "z-20",
        30: "z-30",
        40: "z-40",
        50: "z-50",
        auto: "z-auto"
      }[n] || "";
    })
  };
}
function Sr(e, a, t = {}) {
  const {
    zIndex: n = "50",
    closeOnEscape: l = !0,
    focusTrap: o = !0,
    lockBodyScroll: i = !0,
    autoFocus: h = !1,
    transitionDuration: c = 250,
    restoreFocus: f = !1,
    onClose: y,
    onOpen: m,
    focusTrapOptions: g = {}
  } = t;
  let v = null;
  const { zIndexClass: C } = _n(() => me(n)), k = () => {
    e.value = !1, y?.();
  }, w = () => {
    e.value = !0, m?.();
  };
  l && ns(e, k);
  const { trapFocus: x } = o ? Ll(a, {
    enabled: e,
    ...g
  }) : { trapFocus: () => {
  } };
  return i && ye(e, (I) => {
    typeof document > "u" || (I ? document.documentElement.classList.add("sds-overlay-prevent-scroll") : document.documentElement.classList.remove("sds-overlay-prevent-scroll"));
  }, { immediate: !0 }), (h || f) && ye(e, (I) => {
    typeof document > "u" || (I ? (f && (v = document.activeElement), h && setTimeout(() => {
      if (!a.value) return;
      const L = a.value.querySelector("[autofocus]");
      if (L && !L.hasAttribute("disabled")) {
        L.focus();
        return;
      }
      const z = a.value.querySelector("main");
      if (z) {
        const $ = z.querySelectorAll(
          'button:not([disabled]), [href]:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"]):not([disabled])'
        );
        if ($.length > 0) {
          $[0].focus();
          return;
        }
      }
      const b = a.value.querySelectorAll(
        'button:not([disabled]), [href]:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"]):not([disabled])'
      );
      b.length > 0 && b[0].focus();
    }, c)) : f && v && typeof v.focus == "function" && setTimeout(() => {
      v?.focus(), v = null;
    }, 200));
  }, { immediate: !0 }), {
    zIndexClass: C,
    close: k,
    open: w,
    trapFocus: x
  };
}
function Dl(e, a) {
  return yr() ? (ko(e, a), !0) : !1;
}
const dl = /* @__PURE__ */ new WeakMap(), Bo = /* @__NO_SIDE_EFFECTS__ */ (...e) => {
  var a;
  const t = e[0], n = (a = Qn()) === null || a === void 0 ? void 0 : a.proxy, l = n ?? yr();
  if (l == null && !br()) throw new Error("injectLocal must be called in setup");
  return l && dl.has(l) && t in dl.get(l) ? dl.get(l)[t] : pr(...e);
}, Lo = typeof window < "u" && typeof document < "u";
typeof WorkerGlobalScope < "u" && globalThis instanceof WorkerGlobalScope;
const Io = (e) => e != null, Vo = Object.prototype.toString, Ao = (e) => Vo.call(e) === "[object Object]", kt = () => {
};
function Ho(...e) {
  if (e.length !== 1) return Co(...e);
  const a = e[0];
  return typeof a == "function" ? Cl($o(() => ({
    get: a,
    set: kt
  }))) : E(a);
}
function zl(e, a) {
  function t(...n) {
    return new Promise((l, o) => {
      Promise.resolve(e(() => a.apply(this, n), {
        fn: a,
        thisArg: this,
        args: n
      })).then(l).catch(o);
    });
  }
  return t;
}
const Dr = (e) => e();
function zr(e, a = {}) {
  let t, n, l = kt;
  const o = (c) => {
    clearTimeout(c), l(), l = kt;
  };
  let i;
  return (c) => {
    const f = me(e), y = me(a.maxWait);
    return t && o(t), f <= 0 || y !== void 0 && y <= 0 ? (n && (o(n), n = void 0), Promise.resolve(c())) : new Promise((m, g) => {
      l = a.rejectOnCancel ? g : m, i = c, y && !n && (n = setTimeout(() => {
        t && o(t), n = void 0, m(i());
      }, y)), t = setTimeout(() => {
        n && o(n), n = void 0, m(c());
      }, f);
    });
  };
}
function Oo(...e) {
  let a = 0, t, n = !0, l = kt, o, i, h, c, f;
  !Ne(e[0]) && typeof e[0] == "object" ? { delay: i, trailing: h = !0, leading: c = !0, rejectOnCancel: f = !1 } = e[0] : [i, h = !0, c = !0, f = !1] = e;
  const y = () => {
    t && (clearTimeout(t), t = void 0, l(), l = kt);
  };
  return (g) => {
    const v = me(i), C = Date.now() - a, k = () => o = g();
    return y(), v <= 0 ? (a = Date.now(), k()) : (C > v ? (a = Date.now(), (c || !n) && k()) : h && (o = new Promise((w, x) => {
      l = f ? x : w, t = setTimeout(() => {
        a = Date.now(), n = !0, w(k()), y();
      }, Math.max(0, v - C));
    })), !c && !t && (t = setTimeout(() => n = !0, v)), n = !1, o);
  };
}
function Po(e = Dr, a = {}) {
  const { initialState: t = "active" } = a, n = Ho(t === "active");
  function l() {
    n.value = !1;
  }
  function o() {
    n.value = !0;
  }
  const i = (...h) => {
    n.value && e(...h);
  };
  return {
    isActive: Cl(n),
    pause: l,
    resume: o,
    eventFilter: i
  };
}
function Fo(e, a) {
  var t;
  if (typeof e == "number") return e + a;
  const n = ((t = e.match(/^-?\d+\.?\d*/)) === null || t === void 0 ? void 0 : t[0]) || "", l = e.slice(n.length), o = Number.parseFloat(n) + a;
  return Number.isNaN(o) ? e : o + l;
}
function za(e) {
  return e.endsWith("rem") ? Number.parseFloat(e) * 16 : Number.parseFloat(e);
}
function tn(e) {
  return Array.isArray(e) ? e : [e];
}
function Eo(e) {
  return Qn();
}
// @__NO_SIDE_EFFECTS__
function Ro(e, a = 200, t = {}) {
  return zl(zr(a, t), e);
}
// @__NO_SIDE_EFFECTS__
function No(e, a = 200, t = !1, n = !0, l = !1) {
  return zl(Oo(a, t, n, l), e);
}
function Tr(e, a, t = {}) {
  const { eventFilter: n = Dr, ...l } = t;
  return ye(e, zl(n, a), l);
}
function Wo(e, a, t = {}) {
  const { eventFilter: n, initialState: l = "active", ...o } = t, { eventFilter: i, pause: h, resume: c, isActive: f } = Po(n, { initialState: l });
  return {
    stop: Tr(e, a, {
      ...o,
      eventFilter: i
    }),
    pause: h,
    resume: c,
    isActive: f
  };
}
function Tl(e, a = !0, t) {
  Eo() ? dt(e, t) : a ? e() : Ie(e);
}
function qo(e, a, t = {}) {
  const { debounce: n = 0, maxWait: l = void 0, ...o } = t;
  return Tr(e, a, {
    ...o,
    eventFilter: zr(n, { maxWait: l })
  });
}
function Yo(e, a, t) {
  return ye(e, a, {
    ...t,
    immediate: !0
  });
}
const nt = Lo ? window : void 0;
function ct(e) {
  var a;
  const t = me(e);
  return (a = t?.$el) !== null && a !== void 0 ? a : t;
}
function ht(...e) {
  const a = (n, l, o, i) => (n.addEventListener(l, o, i), () => n.removeEventListener(l, o, i)), t = M(() => {
    const n = tn(me(e[0])).filter((l) => l != null);
    return n.every((l) => typeof l != "string") ? n : void 0;
  });
  return Yo(() => {
    var n, l;
    return [
      (n = (l = t.value) === null || l === void 0 ? void 0 : l.map((o) => ct(o))) !== null && n !== void 0 ? n : [nt].filter((o) => o != null),
      tn(me(t.value ? e[1] : e[0])),
      tn(r(t.value ? e[2] : e[1])),
      me(t.value ? e[3] : e[2])
    ];
  }, ([n, l, o, i], h, c) => {
    if (!n?.length || !l?.length || !o?.length) return;
    const f = Ao(i) ? { ...i } : i, y = n.flatMap((m) => l.flatMap((g) => o.map((v) => a(m, g, v, f))));
    c(() => {
      y.forEach((m) => m());
    });
  }, { flush: "post" });
}
function gl(e, a, t = {}) {
  const { window: n = nt, ignore: l = [], capture: o = !0, detectIframe: i = !1, controls: h = !1 } = t;
  if (!n) return h ? {
    stop: kt,
    cancel: kt,
    trigger: kt
  } : kt;
  let c = !0;
  const f = (w) => me(l).some((x) => {
    if (typeof x == "string") return Array.from(n.document.querySelectorAll(x)).some((I) => I === w.target || w.composedPath().includes(I));
    {
      const I = ct(x);
      return I && (w.target === I || w.composedPath().includes(I));
    }
  });
  function y(w) {
    const x = me(w);
    return x && x.$.subTree.shapeFlag === 16;
  }
  function m(w, x) {
    const I = me(w), L = I.$.subTree && I.$.subTree.children;
    return L == null || !Array.isArray(L) ? !1 : L.some((z) => z.el === x.target || x.composedPath().includes(z.el));
  }
  const g = (w) => {
    const x = ct(e);
    if (w.target != null && !(!(x instanceof Element) && y(e) && m(e, w)) && !(!x || x === w.target || w.composedPath().includes(x))) {
      if ("detail" in w && w.detail === 0 && (c = !f(w)), !c) {
        c = !0;
        return;
      }
      a(w);
    }
  };
  let v = !1;
  const C = [
    ht(n, "click", (w) => {
      v || (v = !0, setTimeout(() => {
        v = !1;
      }, 0), g(w));
    }, {
      passive: !0,
      capture: o
    }),
    ht(n, "pointerdown", (w) => {
      const x = ct(e);
      c = !f(w) && !!(x && !w.composedPath().includes(x));
    }, { passive: !0 }),
    i && ht(n, "blur", (w) => {
      setTimeout(() => {
        var x;
        const I = ct(e);
        ((x = n.document.activeElement) === null || x === void 0 ? void 0 : x.tagName) === "IFRAME" && !I?.contains(n.document.activeElement) && a(w);
      }, 0);
    }, { passive: !0 })
  ].filter(Boolean), k = () => C.forEach((w) => w());
  return h ? {
    stop: k,
    cancel: () => {
      c = !1;
    },
    trigger: (w) => {
      c = !0, g(w), c = !1;
    }
  } : k;
}
// @__NO_SIDE_EFFECTS__
function jo() {
  const e = et(!1), a = Qn();
  return a && dt(() => {
    e.value = !0;
  }, a), e;
}
// @__NO_SIDE_EFFECTS__
function Bl(e) {
  const a = /* @__PURE__ */ jo();
  return M(() => (a.value, !!e()));
}
function Br(e, a, t = {}) {
  const { window: n = nt, ...l } = t;
  let o;
  const i = /* @__PURE__ */ Bl(() => n && "MutationObserver" in n), h = () => {
    o && (o.disconnect(), o = void 0);
  }, c = ye(M(() => {
    const m = tn(me(e)).map(ct).filter(Io);
    return new Set(m);
  }), (m) => {
    h(), i.value && m.size && (o = new MutationObserver(a), m.forEach((g) => o.observe(g, l)));
  }, {
    immediate: !0,
    flush: "post"
  }), f = () => o?.takeRecords(), y = () => {
    c(), h();
  };
  return Dl(y), {
    isSupported: i,
    stop: y,
    takeRecords: f
  };
}
function Go(e, a, t = {}) {
  const { window: n = nt, document: l = n?.document, flush: o = "sync" } = t;
  if (!n || !l) return kt;
  let i;
  const h = (y) => {
    i?.(), i = y;
  }, c = Xn(() => {
    const y = ct(e);
    if (y) {
      const { stop: m } = Br(l, (g) => {
        g.map((v) => [...v.removedNodes]).flat().some((v) => v === y || v.contains(y)) && a(g);
      }, {
        window: n,
        childList: !0,
        subtree: !0
      });
      h(m);
    }
  }, { flush: o }), f = () => {
    c(), h();
  };
  return Dl(f), f;
}
function Uo(e) {
  return typeof e == "function" ? e : typeof e == "string" ? (a) => a.key === e : Array.isArray(e) ? (a) => e.includes(a.key) : () => !0;
}
function Ya(...e) {
  let a, t, n = {};
  e.length === 3 ? (a = e[0], t = e[1], n = e[2]) : e.length === 2 ? typeof e[1] == "object" ? (a = !0, t = e[0], n = e[1]) : (a = e[0], t = e[1]) : (a = !0, t = e[0]);
  const { target: l = nt, eventName: o = "keydown", passive: i = !1, dedupe: h = !1 } = n, c = Uo(a);
  return ht(l, o, (y) => {
    y.repeat && me(h) || c(y) && t(y);
  }, i);
}
// @__NO_SIDE_EFFECTS__
function Ko(e = {}) {
  var a;
  const { window: t = nt, deep: n = !0, triggerOnRemoval: l = !1 } = e, o = (a = e.document) !== null && a !== void 0 ? a : t?.document, i = () => {
    let f = o?.activeElement;
    if (n)
      for (var y; f?.shadowRoot; ) f = f == null || (y = f.shadowRoot) === null || y === void 0 ? void 0 : y.activeElement;
    return f;
  }, h = et(), c = () => {
    h.value = i();
  };
  if (t) {
    const f = {
      capture: !0,
      passive: !0
    };
    ht(t, "blur", (y) => {
      y.relatedTarget === null && c();
    }, f), ht(t, "focus", c, f);
  }
  return l && Go(h, c, { document: o }), c(), h;
}
const Zo = /* @__PURE__ */ Symbol("vueuse-ssr-width");
// @__NO_SIDE_EFFECTS__
function Lr() {
  const e = br() ? /* @__PURE__ */ Bo(Zo, null) : null;
  return typeof e == "number" ? e : void 0;
}
function ka(e, a = {}) {
  const { window: t = nt, ssrWidth: n = /* @__PURE__ */ Lr() } = a, l = /* @__PURE__ */ Bl(() => t && "matchMedia" in t && typeof t.matchMedia == "function"), o = et(typeof n == "number"), i = et(), h = et(!1), c = (f) => {
    h.value = f.matches;
  };
  return Xn(() => {
    if (o.value) {
      o.value = !l.value, h.value = me(e).split(",").some((f) => {
        const y = f.includes("not all"), m = f.match(/\(\s*min-width:\s*(-?\d+(?:\.\d*)?[a-z]+\s*)\)/), g = f.match(/\(\s*max-width:\s*(-?\d+(?:\.\d*)?[a-z]+\s*)\)/);
        let v = !!(m || g);
        return m && v && (v = n >= za(m[1])), g && v && (v = n <= za(g[1])), y ? !v : v;
      });
      return;
    }
    l.value && (i.value = t.matchMedia(me(e)), h.value = i.value.matches);
  }), ht(i, "change", c, { passive: !0 }), M(() => h.value);
}
const Qo = {
  sm: 640,
  md: 768,
  lg: 1024,
  xl: 1280,
  "2xl": 1536
};
// @__NO_SIDE_EFFECTS__
function Xo(e, a = {}) {
  function t(v, C) {
    let k = me(e[me(v)]);
    return C != null && (k = Fo(k, C)), typeof k == "number" && (k = `${k}px`), k;
  }
  const { window: n = nt, strategy: l = "min-width", ssrWidth: o = /* @__PURE__ */ Lr() } = a, i = typeof o == "number", h = i ? et(!1) : { value: !0 };
  i && Tl(() => h.value = !!n);
  function c(v, C) {
    return !h.value && i ? v === "min" ? o >= za(C) : o <= za(C) : n ? n.matchMedia(`(${v}-width: ${C})`).matches : !1;
  }
  const f = (v) => ka(() => `(min-width: ${t(v)})`, a), y = (v) => ka(() => `(max-width: ${t(v)})`, a), m = Object.keys(e).reduce((v, C) => (Object.defineProperty(v, C, {
    get: () => l === "min-width" ? f(C) : y(C),
    enumerable: !0,
    configurable: !0
  }), v), {});
  function g() {
    const v = Object.keys(e).map((C) => [
      C,
      m[C],
      za(t(C))
    ]).sort((C, k) => C[2] - k[2]);
    return M(() => v.filter(([, C]) => C.value).map(([C]) => C));
  }
  return Object.assign(m, {
    greaterOrEqual: f,
    smallerOrEqual: y,
    greater(v) {
      return ka(() => `(min-width: ${t(v, 0.1)})`, a);
    },
    smaller(v) {
      return ka(() => `(max-width: ${t(v, -0.1)})`, a);
    },
    between(v, C) {
      return ka(() => `(min-width: ${t(v)}) and (max-width: ${t(C, -0.1)})`, a);
    },
    isGreater(v) {
      return c("min", t(v, 0.1));
    },
    isGreaterOrEqual(v) {
      return c("min", t(v));
    },
    isSmaller(v) {
      return c("max", t(v, -0.1));
    },
    isSmallerOrEqual(v) {
      return c("max", t(v));
    },
    isInBetween(v, C) {
      return c("min", t(v)) && c("max", t(C, -0.1));
    },
    current: g,
    active() {
      const v = g();
      return M(() => v.value.length === 0 ? "" : v.value.at(l === "min-width" ? -1 : 0));
    }
  });
}
const Qa = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {}, Xa = "__vueuse_ssr_handlers__", Jo = /* @__PURE__ */ _o();
function _o() {
  return Xa in Qa || (Qa[Xa] = Qa[Xa] || {}), Qa[Xa];
}
function es(e, a) {
  return Jo[e] || a;
}
function ts(e) {
  return e == null ? "any" : e instanceof Set ? "set" : e instanceof Map ? "map" : e instanceof Date ? "date" : typeof e == "boolean" ? "boolean" : typeof e == "string" ? "string" : typeof e == "object" ? "object" : Number.isNaN(e) ? "any" : "number";
}
const as = {
  boolean: {
    read: (e) => e === "true",
    write: (e) => String(e)
  },
  object: {
    read: (e) => JSON.parse(e),
    write: (e) => JSON.stringify(e)
  },
  number: {
    read: (e) => Number.parseFloat(e),
    write: (e) => String(e)
  },
  any: {
    read: (e) => e,
    write: (e) => String(e)
  },
  string: {
    read: (e) => e,
    write: (e) => String(e)
  },
  map: {
    read: (e) => new Map(JSON.parse(e)),
    write: (e) => JSON.stringify(Array.from(e.entries()))
  },
  set: {
    read: (e) => new Set(JSON.parse(e)),
    write: (e) => JSON.stringify(Array.from(e))
  },
  date: {
    read: (e) => new Date(e),
    write: (e) => e.toISOString()
  }
}, Zl = "vueuse-storage";
function Ir(e, a, t, n = {}) {
  var l;
  const { flush: o = "pre", deep: i = !0, listenToStorageChanges: h = !0, writeDefaults: c = !0, mergeDefaults: f = !1, shallow: y, window: m = nt, eventFilter: g, onError: v = (H) => {
    console.error(H);
  }, initOnMounted: C } = n, k = (y ? et : E)(typeof a == "function" ? a() : a), w = M(() => me(e));
  if (!t) try {
    t = es("getDefaultStorage", () => nt?.localStorage)();
  } catch (H) {
    v(H);
  }
  if (!t) return k;
  const x = me(a), I = ts(x), L = (l = n.serializer) !== null && l !== void 0 ? l : as[I], { pause: z, resume: b } = Wo(k, (H) => T(H), {
    flush: o,
    deep: i,
    eventFilter: g
  });
  ye(w, () => X(), { flush: o });
  let $ = !1;
  const p = (H) => {
    C && !$ || X(H);
  }, F = (H) => {
    C && !$ || pe(H);
  };
  m && h && (t instanceof Storage ? ht(m, "storage", p, { passive: !0 }) : ht(m, Zl, F)), C ? Tl(() => {
    $ = !0, X();
  }) : X();
  function R(H, Y) {
    if (m) {
      const O = {
        key: w.value,
        oldValue: H,
        newValue: Y,
        storageArea: t
      };
      m.dispatchEvent(t instanceof Storage ? new StorageEvent("storage", O) : new CustomEvent(Zl, { detail: O }));
    }
  }
  function T(H) {
    try {
      const Y = t.getItem(w.value);
      if (H == null)
        R(Y, null), t.removeItem(w.value);
      else {
        const O = L.write(H);
        Y !== O && (t.setItem(w.value, O), R(Y, O));
      }
    } catch (Y) {
      v(Y);
    }
  }
  function j(H) {
    const Y = H ? H.newValue : t.getItem(w.value);
    if (Y == null)
      return c && x != null && t.setItem(w.value, L.write(x)), x;
    if (!H && f) {
      const O = L.read(Y);
      return typeof f == "function" ? f(O, x) : I === "object" && !Array.isArray(O) ? {
        ...x,
        ...O
      } : O;
    } else return typeof Y != "string" ? Y : L.read(Y);
  }
  function X(H) {
    if (!(H && H.storageArea !== t)) {
      if (H && H.key == null) {
        k.value = x;
        return;
      }
      if (!(H && H.key !== w.value)) {
        z();
        try {
          const Y = L.write(k.value);
          (H === void 0 || H?.newValue !== Y) && (k.value = j(H));
        } catch (Y) {
          v(Y);
        } finally {
          H ? Ie(b) : b();
        }
      }
    }
  }
  function pe(H) {
    X(H.detail);
  }
  return k;
}
function Vr(e, a, t = {}) {
  const { window: n = nt, ...l } = t;
  let o;
  const i = /* @__PURE__ */ Bl(() => n && "ResizeObserver" in n), h = () => {
    o && (o.disconnect(), o = void 0);
  }, c = ye(M(() => {
    const y = me(e);
    return Array.isArray(y) ? y.map((m) => ct(m)) : [ct(y)];
  }), (y) => {
    if (h(), i.value && n) {
      o = new ResizeObserver(a);
      for (const m of y) m && o.observe(m, l);
    }
  }, {
    immediate: !0,
    flush: "post"
  }), f = () => {
    h(), c();
  };
  return Dl(f), {
    isSupported: i,
    stop: f
  };
}
function ul(e, a = {}) {
  const { reset: t = !0, windowResize: n = !0, windowScroll: l = !0, immediate: o = !0, updateTiming: i = "sync" } = a, h = et(0), c = et(0), f = et(0), y = et(0), m = et(0), g = et(0), v = et(0), C = et(0);
  function k() {
    const x = ct(e);
    if (!x) {
      t && (h.value = 0, c.value = 0, f.value = 0, y.value = 0, m.value = 0, g.value = 0, v.value = 0, C.value = 0);
      return;
    }
    const I = x.getBoundingClientRect();
    h.value = I.height, c.value = I.bottom, f.value = I.left, y.value = I.right, m.value = I.top, g.value = I.width, v.value = I.x, C.value = I.y;
  }
  function w() {
    i === "sync" ? k() : i === "next-frame" && requestAnimationFrame(() => k());
  }
  return Vr(e, w), ye(() => ct(e), (x) => !x && w()), Br(e, w, { attributeFilter: ["style", "class"] }), l && ht("scroll", w, {
    capture: !0,
    passive: !0
  }), n && ht("resize", w, { passive: !0 }), Tl(() => {
    o && w();
  }), {
    height: h,
    bottom: c,
    left: f,
    right: y,
    top: m,
    width: g,
    x: v,
    y: C,
    update: w
  };
}
function ns(e, a, t) {
  Ya("Escape", (n) => {
    const l = typeof e == "function" ? e() : e.value, o = t?.disabled ? typeof t.disabled == "function" ? t.disabled() : t.disabled.value : !1;
    l && !o && (n.preventDefault(), a());
  }, { eventName: "keyup", target: typeof document < "u" ? document : void 0 });
}
const ls = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';
function Ll(e, a = {}) {
  const {
    enabled: t = !0,
    focusableSelector: n = ls,
    handleEscape: l = !1,
    onEscape: o
  } = a, i = M(() => {
    if (!e.value) return [];
    const c = e.value.querySelectorAll(n);
    return Array.from(c);
  });
  return {
    trapFocus: (c) => {
      if (!(typeof t == "function" ? t() : r(t))) return;
      if (l && c.key === "Escape") {
        c.preventDefault(), o?.();
        return;
      }
      if (c.key !== "Tab") return;
      const y = i.value;
      if (y.length === 0) {
        c.preventDefault();
        return;
      }
      if (y.length === 1) {
        c.preventDefault(), y[0].focus();
        return;
      }
      const m = y[0], g = y[y.length - 1], v = document.activeElement;
      if (!c.shiftKey && v === g) {
        c.preventDefault(), m.focus();
        return;
      }
      if (c.shiftKey && v === m) {
        c.preventDefault(), g.focus();
        return;
      }
    },
    focusableElements: i
  };
}
function rs(e, a) {
  return e === 1 ? 1 : e * a - a + 1;
}
function os(e, a, t) {
  return Math.min(e + a - 1, t);
}
function ss(e, a, t, n) {
  const l = M(() => t.value === 0 || a.value === 0 || e.value > n.value ? 0 : rs(e.value, a.value)), o = M(() => a.value === 0 || e.value > n.value ? 0 : e.value === n.value ? t.value : os(l.value, a.value, t.value));
  return { start: l, end: o, total: t };
}
function ot(e, a, t) {
  return M(() => {
    const n = me(e);
    return n && n in a ? a[n] : t && t in a ? a[t] : t || "";
  });
}
function xv(e) {
  const a = {};
  for (const t in e) {
    const n = e[t];
    a[t] = ot(
      n.propGetter,
      n.classMap,
      n.defaultValue
    );
  }
  return a;
}
function ft(e, a, t, n = {}) {
  const { enabled: l = !0, ...o } = n;
  let i = null;
  const h = () => {
    if (i && (i(), i = null), !(typeof l == "function" ? l() : r(l))) return;
    const f = r(e);
    f && (f.addEventListener(a, t, o), i = () => {
      f.removeEventListener(a, t, o);
    });
  };
  dt(() => {
    h();
  }), (typeof l == "function" || r(l) !== l) && ye(
    () => typeof l == "function" ? l() : r(l),
    () => {
      h();
    }
  ), typeof e == "object" && "value" in e && ye(e, () => {
    h();
  }), wr(() => {
    i && (i(), i = null);
  });
}
function is(e = {}) {
  const {
    valid: a = !1,
    invalid: t = !1,
    required: n = !1,
    disabled: l = !1,
    readonly: o = !1
  } = e, i = M(() => me(a)), h = M(() => me(t)), c = M(() => me(n)), f = M(() => me(l)), y = M(() => me(o)), m = M(() => ({
    valid: i.value,
    invalid: h.value,
    disabled: f.value,
    readonly: y.value,
    required: c.value
  })), g = M(() => ({
    ...h.value && { "aria-invalid": "true" },
    ...f.value && { "aria-disabled": "true" },
    ...c.value && { "aria-required": "true" },
    ...y.value && { "aria-readonly": "true" }
  })), v = M(() => !f.value && !y.value), C = M(() => h.value ? "invalid" : i.value ? "valid" : "neutral");
  return {
    validationClasses: m,
    validationAttrs: g,
    isInteractive: v,
    validationState: C,
    isValid: i,
    isInvalid: h,
    isRequired: c,
    isDisabled: f,
    isReadonly: y
  };
}
const kv = {
  /**
   * Disables the component to prevent user interaction.
   */
  disabled: { type: Boolean, default: !1 },
  /**
   * Determines whether the field is read-only.
   */
  readonly: { type: Boolean, default: !1 },
  /**
   * Determines whether the field is required.
   */
  required: { type: Boolean, default: !1 },
  /**
   * Sets a valid styling if true.
   */
  valid: { type: Boolean, default: !1 },
  /**
   * Sets an invalid styling if true.
   */
  invalid: { type: Boolean, default: !1 }
};
function Xt(e) {
  return is({
    valid: () => e.valid,
    invalid: () => e.invalid,
    disabled: () => e.disabled,
    readonly: () => e.readonly,
    required: () => e.required
  });
}
function Ar(e, a = 300) {
  return /* @__PURE__ */ Ro(e, a);
}
function Cv(e, a = 300) {
  return /* @__PURE__ */ No(e, a);
}
function ds(e, a) {
  let t, n = !1;
  return () => {
    t && clearTimeout(t), n ? t = setTimeout(e, a) : (e(), n = !0, setTimeout(() => {
      n = !1;
    }, a));
  };
}
function us(e, a = 300) {
  return ds(e, a);
}
function Il(e, a, t) {
  return t ? gl(e, a, t) : gl(e, a);
}
function cs(e, a, t) {
  return Vr(e, ([n]) => a(n), t);
}
function $v(e, a) {
  return Ir(e, a, localStorage);
}
function Mv(e, a) {
  return Ir(e, a, sessionStorage);
}
function fs(e, a = {}) {
  const {
    delay: t = 5e3,
    enabled: n = !0,
    autoStart: l = !1
  } = a, o = E(), i = () => {
    o.value && (clearTimeout(o.value), o.value = void 0);
  }, h = () => {
    if (i(), !me(n)) return;
    const m = me(t);
    o.value = setTimeout(() => {
      e(), o.value = void 0;
    }, m);
  }, c = () => {
    i(), h();
  }, f = M(() => o.value !== void 0);
  return dt(() => {
    l && h();
  }), wr(() => {
    i();
  }), {
    start: h,
    clear: i,
    reset: c,
    isActive: f
  };
}
const hs = {
  key: 0,
  class: "relative flex items-center"
}, je = /* @__PURE__ */ te({
  name: "SdsActionButton",
  __name: "ActionButton",
  props: {
    kind: { default: "ghost" },
    variant: { default: "gray" },
    href: { default: null },
    external: { type: Boolean, default: !1 },
    type: { default: "button" },
    size: { default: "sm" },
    active: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 },
    block: { type: Boolean, default: !1 },
    pending: { type: Boolean, default: !1 }
  },
  emits: ["click"],
  setup(e, { emit: a }) {
    const t = e, n = a, { btnClass: l, kindClass: o, variantClass: i, sizeClass: h, disabledClass: c, activeClass: f, blockClass: y, pendingClass: m } = Ml({
      prefix: "action-btn",
      kind: () => t.kind,
      variant: () => t.variant,
      size: () => t.size,
      disabled: () => t.disabled,
      active: () => t.active,
      block: () => t.block,
      pending: () => t.pending
    }), g = () => {
      n("click");
    };
    return (v, C) => (s(), G(mt(e.href ? "a" : "button"), {
      "data-id": "sds-action-button",
      "data-pending": e.pending || void 0,
      type: e.href ? void 0 : e.type,
      target: e.external ? "_blank" : void 0,
      rel: e.external ? "noopener noreferrer" : void 0,
      href: e.href ?? void 0,
      class: D([r(l), r(o), r(i), r(h), r(c), r(f), r(y), r(m)]),
      disabled: e.href ? void 0 : e.disabled,
      "aria-disabled": e.disabled,
      onClick: g
    }, {
      default: U(() => [
        e.pending ? (s(), u("span", hs, [
          d("span", {
            class: D(["absolute inset-0 flex items-center", {
              "justify-center": !e.block
            }])
          }, [
            (s(), u("svg", {
              class: D(["animate-spin text-current", {
                "h-5 w-5": e.size === "lg",
                "h-4 w-4": e.size !== "lg" && e.size !== "xs" && e.size !== "sm",
                "h-3.5 w-3.5": e.size === "sm",
                "h-3 w-3": e.size === "xs"
              }]),
              xmlns: "http://www.w3.org/2000/svg",
              fill: "none",
              viewBox: "0 0 24 24",
              role: "graphics-symbol"
            }, [...C[0] || (C[0] = [
              d("title", null, "Pending", -1),
              d("circle", {
                class: "opacity-25",
                cx: "12",
                cy: "12",
                r: "10",
                stroke: "currentColor",
                "stroke-width": "4"
              }, null, -1),
              d("path", {
                class: "opacity-75",
                fill: "currentColor",
                d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
              }, null, -1)
            ])], 2))
          ], 2),
          d("span", {
            class: D(["inline-flex items-center opacity-0", {
              "gap-2": e.size !== "xs",
              "gap-1": e.size === "xs"
            }])
          }, [
            P(v.$slots, "default")
          ], 2)
        ])) : P(v.$slots, "default", { key: 1 })
      ]),
      _: 3
    }, 8, ["data-pending", "type", "target", "rel", "href", "class", "disabled", "aria-disabled"]));
  }
});
je.install = (e) => {
  e.component(je.name, je);
};
const ms = {
  viewBox: "0 0 640 640",
  "aria-hidden": "true",
  role: "img",
  width: "1.2em",
  height: "1.2em"
};
function gs(e, a) {
  return s(), u("svg", ms, [...a[0] || (a[0] = [
    d("path", {
      fill: "currentColor",
      d: "M297.4 470.6c12.5 12.5 32.8 12.5 45.3 0l192-192c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L320 402.7L150.6 233.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l192 192z"
    }, null, -1)
  ])]);
}
const Ua = $e({ name: "fa7-solid-chevron-down", render: gs }), vs = {
  viewBox: "0 0 640 640",
  "aria-hidden": "true",
  role: "img",
  width: "1.2em",
  height: "1.2em"
};
function ys(e, a) {
  return s(), u("svg", vs, [...a[0] || (a[0] = [
    d("path", {
      fill: "currentColor",
      d: "M96 160c0-17.7 14.3-32 32-32h384c17.7 0 32 14.3 32 32s-14.3 32-32 32H128c-17.7 0-32-14.3-32-32m0 160c0-17.7 14.3-32 32-32h384c17.7 0 32 14.3 32 32s-14.3 32-32 32H128c-17.7 0-32-14.3-32-32m448 160c0 17.7-14.3 32-32 32H128c-17.7 0-32-14.3-32-32s14.3-32 32-32h384c17.7 0 32 14.3 32 32"
    }, null, -1)
  ])]);
}
const Hr = $e({ name: "fa7-solid-bars", render: ys }), bs = ["top", "right", "bottom", "left"], Ql = ["start", "end"], Xl = /* @__PURE__ */ bs.reduce((e, a) => e.concat(a, a + "-" + Ql[0], a + "-" + Ql[1]), []), At = Math.min, Ct = Math.max, Yn = Math.round, Ja = Math.floor, $t = (e) => ({
  x: e,
  y: e
}), ps = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
}, ws = {
  start: "end",
  end: "start"
};
function vl(e, a, t) {
  return Ct(e, At(a, t));
}
function la(e, a) {
  return typeof e == "function" ? e(a) : e;
}
function gt(e) {
  return e.split("-")[0];
}
function Mt(e) {
  return e.split("-")[1];
}
function Or(e) {
  return e === "x" ? "y" : "x";
}
function Vl(e) {
  return e === "y" ? "height" : "width";
}
const xs = /* @__PURE__ */ new Set(["top", "bottom"]);
function Vt(e) {
  return xs.has(gt(e)) ? "y" : "x";
}
function Al(e) {
  return Or(Vt(e));
}
function Pr(e, a, t) {
  t === void 0 && (t = !1);
  const n = Mt(e), l = Al(e), o = Vl(l);
  let i = l === "x" ? n === (t ? "end" : "start") ? "right" : "left" : n === "start" ? "bottom" : "top";
  return a.reference[o] > a.floating[o] && (i = Gn(i)), [i, Gn(i)];
}
function ks(e) {
  const a = Gn(e);
  return [jn(e), a, jn(a)];
}
function jn(e) {
  return e.replace(/start|end/g, (a) => ws[a]);
}
const Jl = ["left", "right"], _l = ["right", "left"], Cs = ["top", "bottom"], $s = ["bottom", "top"];
function Ms(e, a, t) {
  switch (e) {
    case "top":
    case "bottom":
      return t ? a ? _l : Jl : a ? Jl : _l;
    case "left":
    case "right":
      return a ? Cs : $s;
    default:
      return [];
  }
}
function Ss(e, a, t, n) {
  const l = Mt(e);
  let o = Ms(gt(e), t === "start", n);
  return l && (o = o.map((i) => i + "-" + l), a && (o = o.concat(o.map(jn)))), o;
}
function Gn(e) {
  return e.replace(/left|right|bottom|top/g, (a) => ps[a]);
}
function Ds(e) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...e
  };
}
function Hl(e) {
  return typeof e != "number" ? Ds(e) : {
    top: e,
    right: e,
    bottom: e,
    left: e
  };
}
function va(e) {
  const {
    x: a,
    y: t,
    width: n,
    height: l
  } = e;
  return {
    width: n,
    height: l,
    top: t,
    left: a,
    right: a + n,
    bottom: t + l,
    x: a,
    y: t
  };
}
function er(e, a, t) {
  let {
    reference: n,
    floating: l
  } = e;
  const o = Vt(a), i = Al(a), h = Vl(i), c = gt(a), f = o === "y", y = n.x + n.width / 2 - l.width / 2, m = n.y + n.height / 2 - l.height / 2, g = n[h] / 2 - l[h] / 2;
  let v;
  switch (c) {
    case "top":
      v = {
        x: y,
        y: n.y - l.height
      };
      break;
    case "bottom":
      v = {
        x: y,
        y: n.y + n.height
      };
      break;
    case "right":
      v = {
        x: n.x + n.width,
        y: m
      };
      break;
    case "left":
      v = {
        x: n.x - l.width,
        y: m
      };
      break;
    default:
      v = {
        x: n.x,
        y: n.y
      };
  }
  switch (Mt(a)) {
    case "start":
      v[i] -= g * (t && f ? -1 : 1);
      break;
    case "end":
      v[i] += g * (t && f ? -1 : 1);
      break;
  }
  return v;
}
async function zs(e, a) {
  var t;
  a === void 0 && (a = {});
  const {
    x: n,
    y: l,
    platform: o,
    rects: i,
    elements: h,
    strategy: c
  } = e, {
    boundary: f = "clippingAncestors",
    rootBoundary: y = "viewport",
    elementContext: m = "floating",
    altBoundary: g = !1,
    padding: v = 0
  } = la(a, e), C = Hl(v), w = h[g ? m === "floating" ? "reference" : "floating" : m], x = va(await o.getClippingRect({
    element: (t = await (o.isElement == null ? void 0 : o.isElement(w))) == null || t ? w : w.contextElement || await (o.getDocumentElement == null ? void 0 : o.getDocumentElement(h.floating)),
    boundary: f,
    rootBoundary: y,
    strategy: c
  })), I = m === "floating" ? {
    x: n,
    y: l,
    width: i.floating.width,
    height: i.floating.height
  } : i.reference, L = await (o.getOffsetParent == null ? void 0 : o.getOffsetParent(h.floating)), z = await (o.isElement == null ? void 0 : o.isElement(L)) ? await (o.getScale == null ? void 0 : o.getScale(L)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, b = va(o.convertOffsetParentRelativeRectToViewportRelativeRect ? await o.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements: h,
    rect: I,
    offsetParent: L,
    strategy: c
  }) : I);
  return {
    top: (x.top - b.top + C.top) / z.y,
    bottom: (b.bottom - x.bottom + C.bottom) / z.y,
    left: (x.left - b.left + C.left) / z.x,
    right: (b.right - x.right + C.right) / z.x
  };
}
const Ts = async (e, a, t) => {
  const {
    placement: n = "bottom",
    strategy: l = "absolute",
    middleware: o = [],
    platform: i
  } = t, h = o.filter(Boolean), c = await (i.isRTL == null ? void 0 : i.isRTL(a));
  let f = await i.getElementRects({
    reference: e,
    floating: a,
    strategy: l
  }), {
    x: y,
    y: m
  } = er(f, n, c), g = n, v = {}, C = 0;
  for (let w = 0; w < h.length; w++) {
    var k;
    const {
      name: x,
      fn: I
    } = h[w], {
      x: L,
      y: z,
      data: b,
      reset: $
    } = await I({
      x: y,
      y: m,
      initialPlacement: n,
      placement: g,
      strategy: l,
      middlewareData: v,
      rects: f,
      platform: {
        ...i,
        detectOverflow: (k = i.detectOverflow) != null ? k : zs
      },
      elements: {
        reference: e,
        floating: a
      }
    });
    y = L ?? y, m = z ?? m, v = {
      ...v,
      [x]: {
        ...v[x],
        ...b
      }
    }, $ && C <= 50 && (C++, typeof $ == "object" && ($.placement && (g = $.placement), $.rects && (f = $.rects === !0 ? await i.getElementRects({
      reference: e,
      floating: a,
      strategy: l
    }) : $.rects), {
      x: y,
      y: m
    } = er(f, g, c)), w = -1);
  }
  return {
    x: y,
    y: m,
    placement: g,
    strategy: l,
    middlewareData: v
  };
}, Bs = (e) => ({
  name: "arrow",
  options: e,
  async fn(a) {
    const {
      x: t,
      y: n,
      placement: l,
      rects: o,
      platform: i,
      elements: h,
      middlewareData: c
    } = a, {
      element: f,
      padding: y = 0
    } = la(e, a) || {};
    if (f == null)
      return {};
    const m = Hl(y), g = {
      x: t,
      y: n
    }, v = Al(l), C = Vl(v), k = await i.getDimensions(f), w = v === "y", x = w ? "top" : "left", I = w ? "bottom" : "right", L = w ? "clientHeight" : "clientWidth", z = o.reference[C] + o.reference[v] - g[v] - o.floating[C], b = g[v] - o.reference[v], $ = await (i.getOffsetParent == null ? void 0 : i.getOffsetParent(f));
    let p = $ ? $[L] : 0;
    (!p || !await (i.isElement == null ? void 0 : i.isElement($))) && (p = h.floating[L] || o.floating[C]);
    const F = z / 2 - b / 2, R = p / 2 - k[C] / 2 - 1, T = At(m[x], R), j = At(m[I], R), X = T, pe = p - k[C] - j, H = p / 2 - k[C] / 2 + F, Y = vl(X, H, pe), O = !c.arrow && Mt(l) != null && H !== Y && o.reference[C] / 2 - (H < X ? T : j) - k[C] / 2 < 0, _ = O ? H < X ? H - X : H - pe : 0;
    return {
      [v]: g[v] + _,
      data: {
        [v]: Y,
        centerOffset: H - Y - _,
        ...O && {
          alignmentOffset: _
        }
      },
      reset: O
    };
  }
});
function Ls(e, a, t) {
  return (e ? [...t.filter((l) => Mt(l) === e), ...t.filter((l) => Mt(l) !== e)] : t.filter((l) => gt(l) === l)).filter((l) => e ? Mt(l) === e || (a ? jn(l) !== l : !1) : !0);
}
const Is = function(e) {
  return e === void 0 && (e = {}), {
    name: "autoPlacement",
    options: e,
    async fn(a) {
      var t, n, l;
      const {
        rects: o,
        middlewareData: i,
        placement: h,
        platform: c,
        elements: f
      } = a, {
        crossAxis: y = !1,
        alignment: m,
        allowedPlacements: g = Xl,
        autoAlignment: v = !0,
        ...C
      } = la(e, a), k = m !== void 0 || g === Xl ? Ls(m || null, v, g) : g, w = await c.detectOverflow(a, C), x = ((t = i.autoPlacement) == null ? void 0 : t.index) || 0, I = k[x];
      if (I == null)
        return {};
      const L = Pr(I, o, await (c.isRTL == null ? void 0 : c.isRTL(f.floating)));
      if (h !== I)
        return {
          reset: {
            placement: k[0]
          }
        };
      const z = [w[gt(I)], w[L[0]], w[L[1]]], b = [...((n = i.autoPlacement) == null ? void 0 : n.overflows) || [], {
        placement: I,
        overflows: z
      }], $ = k[x + 1];
      if ($)
        return {
          data: {
            index: x + 1,
            overflows: b
          },
          reset: {
            placement: $
          }
        };
      const p = b.map((T) => {
        const j = Mt(T.placement);
        return [T.placement, j && y ? (
          // Check along the mainAxis and main crossAxis side.
          T.overflows.slice(0, 2).reduce((X, pe) => X + pe, 0)
        ) : (
          // Check only the mainAxis.
          T.overflows[0]
        ), T.overflows];
      }).sort((T, j) => T[1] - j[1]), R = ((l = p.filter((T) => T[2].slice(
        0,
        // Aligned placements should not check their opposite crossAxis
        // side.
        Mt(T[0]) ? 2 : 3
      ).every((j) => j <= 0))[0]) == null ? void 0 : l[0]) || p[0][0];
      return R !== h ? {
        data: {
          index: x + 1,
          overflows: b
        },
        reset: {
          placement: R
        }
      } : {};
    }
  };
}, Vs = function(e) {
  return e === void 0 && (e = {}), {
    name: "flip",
    options: e,
    async fn(a) {
      var t, n;
      const {
        placement: l,
        middlewareData: o,
        rects: i,
        initialPlacement: h,
        platform: c,
        elements: f
      } = a, {
        mainAxis: y = !0,
        crossAxis: m = !0,
        fallbackPlacements: g,
        fallbackStrategy: v = "bestFit",
        fallbackAxisSideDirection: C = "none",
        flipAlignment: k = !0,
        ...w
      } = la(e, a);
      if ((t = o.arrow) != null && t.alignmentOffset)
        return {};
      const x = gt(l), I = Vt(h), L = gt(h) === h, z = await (c.isRTL == null ? void 0 : c.isRTL(f.floating)), b = g || (L || !k ? [Gn(h)] : ks(h)), $ = C !== "none";
      !g && $ && b.push(...Ss(h, k, C, z));
      const p = [h, ...b], F = await c.detectOverflow(a, w), R = [];
      let T = ((n = o.flip) == null ? void 0 : n.overflows) || [];
      if (y && R.push(F[x]), m) {
        const H = Pr(l, i, z);
        R.push(F[H[0]], F[H[1]]);
      }
      if (T = [...T, {
        placement: l,
        overflows: R
      }], !R.every((H) => H <= 0)) {
        var j, X;
        const H = (((j = o.flip) == null ? void 0 : j.index) || 0) + 1, Y = p[H];
        if (Y && (!(m === "alignment" ? I !== Vt(Y) : !1) || // We leave the current main axis only if every placement on that axis
        // overflows the main axis.
        T.every((oe) => Vt(oe.placement) === I ? oe.overflows[0] > 0 : !0)))
          return {
            data: {
              index: H,
              overflows: T
            },
            reset: {
              placement: Y
            }
          };
        let O = (X = T.filter((_) => _.overflows[0] <= 0).sort((_, oe) => _.overflows[1] - oe.overflows[1])[0]) == null ? void 0 : X.placement;
        if (!O)
          switch (v) {
            case "bestFit": {
              var pe;
              const _ = (pe = T.filter((oe) => {
                if ($) {
                  const K = Vt(oe.placement);
                  return K === I || // Create a bias to the `y` side axis due to horizontal
                  // reading directions favoring greater width.
                  K === "y";
                }
                return !0;
              }).map((oe) => [oe.placement, oe.overflows.filter((K) => K > 0).reduce((K, de) => K + de, 0)]).sort((oe, K) => oe[1] - K[1])[0]) == null ? void 0 : pe[0];
              _ && (O = _);
              break;
            }
            case "initialPlacement":
              O = h;
              break;
          }
        if (l !== O)
          return {
            reset: {
              placement: O
            }
          };
      }
      return {};
    }
  };
};
function Fr(e) {
  const a = At(...e.map((o) => o.left)), t = At(...e.map((o) => o.top)), n = Ct(...e.map((o) => o.right)), l = Ct(...e.map((o) => o.bottom));
  return {
    x: a,
    y: t,
    width: n - a,
    height: l - t
  };
}
function As(e) {
  const a = e.slice().sort((l, o) => l.y - o.y), t = [];
  let n = null;
  for (let l = 0; l < a.length; l++) {
    const o = a[l];
    !n || o.y - n.y > n.height / 2 ? t.push([o]) : t[t.length - 1].push(o), n = o;
  }
  return t.map((l) => va(Fr(l)));
}
const Hs = function(e) {
  return e === void 0 && (e = {}), {
    name: "inline",
    options: e,
    async fn(a) {
      const {
        placement: t,
        elements: n,
        rects: l,
        platform: o,
        strategy: i
      } = a, {
        padding: h = 2,
        x: c,
        y: f
      } = la(e, a), y = Array.from(await (o.getClientRects == null ? void 0 : o.getClientRects(n.reference)) || []), m = As(y), g = va(Fr(y)), v = Hl(h);
      function C() {
        if (m.length === 2 && m[0].left > m[1].right && c != null && f != null)
          return m.find((w) => c > w.left - v.left && c < w.right + v.right && f > w.top - v.top && f < w.bottom + v.bottom) || g;
        if (m.length >= 2) {
          if (Vt(t) === "y") {
            const T = m[0], j = m[m.length - 1], X = gt(t) === "top", pe = T.top, H = j.bottom, Y = X ? T.left : j.left, O = X ? T.right : j.right, _ = O - Y, oe = H - pe;
            return {
              top: pe,
              bottom: H,
              left: Y,
              right: O,
              width: _,
              height: oe,
              x: Y,
              y: pe
            };
          }
          const w = gt(t) === "left", x = Ct(...m.map((T) => T.right)), I = At(...m.map((T) => T.left)), L = m.filter((T) => w ? T.left === I : T.right === x), z = L[0].top, b = L[L.length - 1].bottom, $ = I, p = x, F = p - $, R = b - z;
          return {
            top: z,
            bottom: b,
            left: $,
            right: p,
            width: F,
            height: R,
            x: $,
            y: z
          };
        }
        return g;
      }
      const k = await o.getElementRects({
        reference: {
          getBoundingClientRect: C
        },
        floating: n.floating,
        strategy: i
      });
      return l.reference.x !== k.reference.x || l.reference.y !== k.reference.y || l.reference.width !== k.reference.width || l.reference.height !== k.reference.height ? {
        reset: {
          rects: k
        }
      } : {};
    }
  };
}, Os = /* @__PURE__ */ new Set(["left", "top"]);
async function Ps(e, a) {
  const {
    placement: t,
    platform: n,
    elements: l
  } = e, o = await (n.isRTL == null ? void 0 : n.isRTL(l.floating)), i = gt(t), h = Mt(t), c = Vt(t) === "y", f = Os.has(i) ? -1 : 1, y = o && c ? -1 : 1, m = la(a, e);
  let {
    mainAxis: g,
    crossAxis: v,
    alignmentAxis: C
  } = typeof m == "number" ? {
    mainAxis: m,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: m.mainAxis || 0,
    crossAxis: m.crossAxis || 0,
    alignmentAxis: m.alignmentAxis
  };
  return h && typeof C == "number" && (v = h === "end" ? C * -1 : C), c ? {
    x: v * y,
    y: g * f
  } : {
    x: g * f,
    y: v * y
  };
}
const Fs = function(e) {
  return e === void 0 && (e = 0), {
    name: "offset",
    options: e,
    async fn(a) {
      var t, n;
      const {
        x: l,
        y: o,
        placement: i,
        middlewareData: h
      } = a, c = await Ps(a, e);
      return i === ((t = h.offset) == null ? void 0 : t.placement) && (n = h.arrow) != null && n.alignmentOffset ? {} : {
        x: l + c.x,
        y: o + c.y,
        data: {
          ...c,
          placement: i
        }
      };
    }
  };
}, Es = function(e) {
  return e === void 0 && (e = {}), {
    name: "shift",
    options: e,
    async fn(a) {
      const {
        x: t,
        y: n,
        placement: l,
        platform: o
      } = a, {
        mainAxis: i = !0,
        crossAxis: h = !1,
        limiter: c = {
          fn: (x) => {
            let {
              x: I,
              y: L
            } = x;
            return {
              x: I,
              y: L
            };
          }
        },
        ...f
      } = la(e, a), y = {
        x: t,
        y: n
      }, m = await o.detectOverflow(a, f), g = Vt(gt(l)), v = Or(g);
      let C = y[v], k = y[g];
      if (i) {
        const x = v === "y" ? "top" : "left", I = v === "y" ? "bottom" : "right", L = C + m[x], z = C - m[I];
        C = vl(L, C, z);
      }
      if (h) {
        const x = g === "y" ? "top" : "left", I = g === "y" ? "bottom" : "right", L = k + m[x], z = k - m[I];
        k = vl(L, k, z);
      }
      const w = c.fn({
        ...a,
        [v]: C,
        [g]: k
      });
      return {
        ...w,
        data: {
          x: w.x - t,
          y: w.y - n,
          enabled: {
            [v]: i,
            [g]: h
          }
        }
      };
    }
  };
};
function el() {
  return typeof window < "u";
}
function pa(e) {
  return Er(e) ? (e.nodeName || "").toLowerCase() : "#document";
}
function lt(e) {
  var a;
  return (e == null || (a = e.ownerDocument) == null ? void 0 : a.defaultView) || window;
}
function zt(e) {
  var a;
  return (a = (Er(e) ? e.ownerDocument : e.document) || window.document) == null ? void 0 : a.documentElement;
}
function Er(e) {
  return el() ? e instanceof Node || e instanceof lt(e).Node : !1;
}
function vt(e) {
  return el() ? e instanceof Element || e instanceof lt(e).Element : !1;
}
function Dt(e) {
  return el() ? e instanceof HTMLElement || e instanceof lt(e).HTMLElement : !1;
}
function tr(e) {
  return !el() || typeof ShadowRoot > "u" ? !1 : e instanceof ShadowRoot || e instanceof lt(e).ShadowRoot;
}
const Rs = /* @__PURE__ */ new Set(["inline", "contents"]);
function Ka(e) {
  const {
    overflow: a,
    overflowX: t,
    overflowY: n,
    display: l
  } = yt(e);
  return /auto|scroll|overlay|hidden|clip/.test(a + n + t) && !Rs.has(l);
}
const Ns = /* @__PURE__ */ new Set(["table", "td", "th"]);
function Ws(e) {
  return Ns.has(pa(e));
}
const qs = [":popover-open", ":modal"];
function tl(e) {
  return qs.some((a) => {
    try {
      return e.matches(a);
    } catch {
      return !1;
    }
  });
}
const Ys = ["transform", "translate", "scale", "rotate", "perspective"], js = ["transform", "translate", "scale", "rotate", "perspective", "filter"], Gs = ["paint", "layout", "strict", "content"];
function Ol(e) {
  const a = Pl(), t = vt(e) ? yt(e) : e;
  return Ys.some((n) => t[n] ? t[n] !== "none" : !1) || (t.containerType ? t.containerType !== "normal" : !1) || !a && (t.backdropFilter ? t.backdropFilter !== "none" : !1) || !a && (t.filter ? t.filter !== "none" : !1) || js.some((n) => (t.willChange || "").includes(n)) || Gs.some((n) => (t.contain || "").includes(n));
}
function Us(e) {
  let a = Kt(e);
  for (; Dt(a) && !ya(a); ) {
    if (Ol(a))
      return a;
    if (tl(a))
      return null;
    a = Kt(a);
  }
  return null;
}
function Pl() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
const Ks = /* @__PURE__ */ new Set(["html", "body", "#document"]);
function ya(e) {
  return Ks.has(pa(e));
}
function yt(e) {
  return lt(e).getComputedStyle(e);
}
function al(e) {
  return vt(e) ? {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  } : {
    scrollLeft: e.scrollX,
    scrollTop: e.scrollY
  };
}
function Kt(e) {
  if (pa(e) === "html")
    return e;
  const a = (
    // Step into the shadow DOM of the parent of a slotted node.
    e.assignedSlot || // DOM Element detected.
    e.parentNode || // ShadowRoot detected.
    tr(e) && e.host || // Fallback.
    zt(e)
  );
  return tr(a) ? a.host : a;
}
function Rr(e) {
  const a = Kt(e);
  return ya(a) ? e.ownerDocument ? e.ownerDocument.body : e.body : Dt(a) && Ka(a) ? a : Rr(a);
}
function ja(e, a, t) {
  var n;
  a === void 0 && (a = []), t === void 0 && (t = !0);
  const l = Rr(e), o = l === ((n = e.ownerDocument) == null ? void 0 : n.body), i = lt(l);
  if (o) {
    const h = yl(i);
    return a.concat(i, i.visualViewport || [], Ka(l) ? l : [], h && t ? ja(h) : []);
  }
  return a.concat(l, ja(l, [], t));
}
function yl(e) {
  return e.parent && Object.getPrototypeOf(e.parent) ? e.frameElement : null;
}
function Nr(e) {
  const a = yt(e);
  let t = parseFloat(a.width) || 0, n = parseFloat(a.height) || 0;
  const l = Dt(e), o = l ? e.offsetWidth : t, i = l ? e.offsetHeight : n, h = Yn(t) !== o || Yn(n) !== i;
  return h && (t = o, n = i), {
    width: t,
    height: n,
    $: h
  };
}
function Fl(e) {
  return vt(e) ? e : e.contextElement;
}
function ua(e) {
  const a = Fl(e);
  if (!Dt(a))
    return $t(1);
  const t = a.getBoundingClientRect(), {
    width: n,
    height: l,
    $: o
  } = Nr(a);
  let i = (o ? Yn(t.width) : t.width) / n, h = (o ? Yn(t.height) : t.height) / l;
  return (!i || !Number.isFinite(i)) && (i = 1), (!h || !Number.isFinite(h)) && (h = 1), {
    x: i,
    y: h
  };
}
const Zs = /* @__PURE__ */ $t(0);
function Wr(e) {
  const a = lt(e);
  return !Pl() || !a.visualViewport ? Zs : {
    x: a.visualViewport.offsetLeft,
    y: a.visualViewport.offsetTop
  };
}
function Qs(e, a, t) {
  return a === void 0 && (a = !1), !t || a && t !== lt(e) ? !1 : a;
}
function na(e, a, t, n) {
  a === void 0 && (a = !1), t === void 0 && (t = !1);
  const l = e.getBoundingClientRect(), o = Fl(e);
  let i = $t(1);
  a && (n ? vt(n) && (i = ua(n)) : i = ua(e));
  const h = Qs(o, t, n) ? Wr(o) : $t(0);
  let c = (l.left + h.x) / i.x, f = (l.top + h.y) / i.y, y = l.width / i.x, m = l.height / i.y;
  if (o) {
    const g = lt(o), v = n && vt(n) ? lt(n) : n;
    let C = g, k = yl(C);
    for (; k && n && v !== C; ) {
      const w = ua(k), x = k.getBoundingClientRect(), I = yt(k), L = x.left + (k.clientLeft + parseFloat(I.paddingLeft)) * w.x, z = x.top + (k.clientTop + parseFloat(I.paddingTop)) * w.y;
      c *= w.x, f *= w.y, y *= w.x, m *= w.y, c += L, f += z, C = lt(k), k = yl(C);
    }
  }
  return va({
    width: y,
    height: m,
    x: c,
    y: f
  });
}
function nl(e, a) {
  const t = al(e).scrollLeft;
  return a ? a.left + t : na(zt(e)).left + t;
}
function qr(e, a) {
  const t = e.getBoundingClientRect(), n = t.left + a.scrollLeft - nl(e, t), l = t.top + a.scrollTop;
  return {
    x: n,
    y: l
  };
}
function Xs(e) {
  let {
    elements: a,
    rect: t,
    offsetParent: n,
    strategy: l
  } = e;
  const o = l === "fixed", i = zt(n), h = a ? tl(a.floating) : !1;
  if (n === i || h && o)
    return t;
  let c = {
    scrollLeft: 0,
    scrollTop: 0
  }, f = $t(1);
  const y = $t(0), m = Dt(n);
  if ((m || !m && !o) && ((pa(n) !== "body" || Ka(i)) && (c = al(n)), Dt(n))) {
    const v = na(n);
    f = ua(n), y.x = v.x + n.clientLeft, y.y = v.y + n.clientTop;
  }
  const g = i && !m && !o ? qr(i, c) : $t(0);
  return {
    width: t.width * f.x,
    height: t.height * f.y,
    x: t.x * f.x - c.scrollLeft * f.x + y.x + g.x,
    y: t.y * f.y - c.scrollTop * f.y + y.y + g.y
  };
}
function Js(e) {
  return Array.from(e.getClientRects());
}
function _s(e) {
  const a = zt(e), t = al(e), n = e.ownerDocument.body, l = Ct(a.scrollWidth, a.clientWidth, n.scrollWidth, n.clientWidth), o = Ct(a.scrollHeight, a.clientHeight, n.scrollHeight, n.clientHeight);
  let i = -t.scrollLeft + nl(e);
  const h = -t.scrollTop;
  return yt(n).direction === "rtl" && (i += Ct(a.clientWidth, n.clientWidth) - l), {
    width: l,
    height: o,
    x: i,
    y: h
  };
}
const ar = 25;
function ei(e, a) {
  const t = lt(e), n = zt(e), l = t.visualViewport;
  let o = n.clientWidth, i = n.clientHeight, h = 0, c = 0;
  if (l) {
    o = l.width, i = l.height;
    const y = Pl();
    (!y || y && a === "fixed") && (h = l.offsetLeft, c = l.offsetTop);
  }
  const f = nl(n);
  if (f <= 0) {
    const y = n.ownerDocument, m = y.body, g = getComputedStyle(m), v = y.compatMode === "CSS1Compat" && parseFloat(g.marginLeft) + parseFloat(g.marginRight) || 0, C = Math.abs(n.clientWidth - m.clientWidth - v);
    C <= ar && (o -= C);
  } else f <= ar && (o += f);
  return {
    width: o,
    height: i,
    x: h,
    y: c
  };
}
const ti = /* @__PURE__ */ new Set(["absolute", "fixed"]);
function ai(e, a) {
  const t = na(e, !0, a === "fixed"), n = t.top + e.clientTop, l = t.left + e.clientLeft, o = Dt(e) ? ua(e) : $t(1), i = e.clientWidth * o.x, h = e.clientHeight * o.y, c = l * o.x, f = n * o.y;
  return {
    width: i,
    height: h,
    x: c,
    y: f
  };
}
function nr(e, a, t) {
  let n;
  if (a === "viewport")
    n = ei(e, t);
  else if (a === "document")
    n = _s(zt(e));
  else if (vt(a))
    n = ai(a, t);
  else {
    const l = Wr(e);
    n = {
      x: a.x - l.x,
      y: a.y - l.y,
      width: a.width,
      height: a.height
    };
  }
  return va(n);
}
function Yr(e, a) {
  const t = Kt(e);
  return t === a || !vt(t) || ya(t) ? !1 : yt(t).position === "fixed" || Yr(t, a);
}
function ni(e, a) {
  const t = a.get(e);
  if (t)
    return t;
  let n = ja(e, [], !1).filter((h) => vt(h) && pa(h) !== "body"), l = null;
  const o = yt(e).position === "fixed";
  let i = o ? Kt(e) : e;
  for (; vt(i) && !ya(i); ) {
    const h = yt(i), c = Ol(i);
    !c && h.position === "fixed" && (l = null), (o ? !c && !l : !c && h.position === "static" && !!l && ti.has(l.position) || Ka(i) && !c && Yr(e, i)) ? n = n.filter((y) => y !== i) : l = h, i = Kt(i);
  }
  return a.set(e, n), n;
}
function li(e) {
  let {
    element: a,
    boundary: t,
    rootBoundary: n,
    strategy: l
  } = e;
  const i = [...t === "clippingAncestors" ? tl(a) ? [] : ni(a, this._c) : [].concat(t), n], h = i[0], c = i.reduce((f, y) => {
    const m = nr(a, y, l);
    return f.top = Ct(m.top, f.top), f.right = At(m.right, f.right), f.bottom = At(m.bottom, f.bottom), f.left = Ct(m.left, f.left), f;
  }, nr(a, h, l));
  return {
    width: c.right - c.left,
    height: c.bottom - c.top,
    x: c.left,
    y: c.top
  };
}
function ri(e) {
  const {
    width: a,
    height: t
  } = Nr(e);
  return {
    width: a,
    height: t
  };
}
function oi(e, a, t) {
  const n = Dt(a), l = zt(a), o = t === "fixed", i = na(e, !0, o, a);
  let h = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const c = $t(0);
  function f() {
    c.x = nl(l);
  }
  if (n || !n && !o)
    if ((pa(a) !== "body" || Ka(l)) && (h = al(a)), n) {
      const v = na(a, !0, o, a);
      c.x = v.x + a.clientLeft, c.y = v.y + a.clientTop;
    } else l && f();
  o && !n && l && f();
  const y = l && !n && !o ? qr(l, h) : $t(0), m = i.left + h.scrollLeft - c.x - y.x, g = i.top + h.scrollTop - c.y - y.y;
  return {
    x: m,
    y: g,
    width: i.width,
    height: i.height
  };
}
function cl(e) {
  return yt(e).position === "static";
}
function lr(e, a) {
  if (!Dt(e) || yt(e).position === "fixed")
    return null;
  if (a)
    return a(e);
  let t = e.offsetParent;
  return zt(e) === t && (t = t.ownerDocument.body), t;
}
function jr(e, a) {
  const t = lt(e);
  if (tl(e))
    return t;
  if (!Dt(e)) {
    let l = Kt(e);
    for (; l && !ya(l); ) {
      if (vt(l) && !cl(l))
        return l;
      l = Kt(l);
    }
    return t;
  }
  let n = lr(e, a);
  for (; n && Ws(n) && cl(n); )
    n = lr(n, a);
  return n && ya(n) && cl(n) && !Ol(n) ? t : n || Us(e) || t;
}
const si = async function(e) {
  const a = this.getOffsetParent || jr, t = this.getDimensions, n = await t(e.floating);
  return {
    reference: oi(e.reference, await a(e.floating), e.strategy),
    floating: {
      x: 0,
      y: 0,
      width: n.width,
      height: n.height
    }
  };
};
function ii(e) {
  return yt(e).direction === "rtl";
}
const di = {
  convertOffsetParentRelativeRectToViewportRelativeRect: Xs,
  getDocumentElement: zt,
  getClippingRect: li,
  getOffsetParent: jr,
  getElementRects: si,
  getClientRects: Js,
  getDimensions: ri,
  getScale: ua,
  isElement: vt,
  isRTL: ii
};
function Gr(e, a) {
  return e.x === a.x && e.y === a.y && e.width === a.width && e.height === a.height;
}
function ui(e, a) {
  let t = null, n;
  const l = zt(e);
  function o() {
    var h;
    clearTimeout(n), (h = t) == null || h.disconnect(), t = null;
  }
  function i(h, c) {
    h === void 0 && (h = !1), c === void 0 && (c = 1), o();
    const f = e.getBoundingClientRect(), {
      left: y,
      top: m,
      width: g,
      height: v
    } = f;
    if (h || a(), !g || !v)
      return;
    const C = Ja(m), k = Ja(l.clientWidth - (y + g)), w = Ja(l.clientHeight - (m + v)), x = Ja(y), L = {
      rootMargin: -C + "px " + -k + "px " + -w + "px " + -x + "px",
      threshold: Ct(0, At(1, c)) || 1
    };
    let z = !0;
    function b($) {
      const p = $[0].intersectionRatio;
      if (p !== c) {
        if (!z)
          return i();
        p ? i(!1, p) : n = setTimeout(() => {
          i(!1, 1e-7);
        }, 1e3);
      }
      p === 1 && !Gr(f, e.getBoundingClientRect()) && i(), z = !1;
    }
    try {
      t = new IntersectionObserver(b, {
        ...L,
        // Handle <iframe>s
        root: l.ownerDocument
      });
    } catch {
      t = new IntersectionObserver(b, L);
    }
    t.observe(e);
  }
  return i(!0), o;
}
function ci(e, a, t, n) {
  n === void 0 && (n = {});
  const {
    ancestorScroll: l = !0,
    ancestorResize: o = !0,
    elementResize: i = typeof ResizeObserver == "function",
    layoutShift: h = typeof IntersectionObserver == "function",
    animationFrame: c = !1
  } = n, f = Fl(e), y = l || o ? [...f ? ja(f) : [], ...ja(a)] : [];
  y.forEach((x) => {
    l && x.addEventListener("scroll", t, {
      passive: !0
    }), o && x.addEventListener("resize", t);
  });
  const m = f && h ? ui(f, t) : null;
  let g = -1, v = null;
  i && (v = new ResizeObserver((x) => {
    let [I] = x;
    I && I.target === f && v && (v.unobserve(a), cancelAnimationFrame(g), g = requestAnimationFrame(() => {
      var L;
      (L = v) == null || L.observe(a);
    })), t();
  }), f && !c && v.observe(f), v.observe(a));
  let C, k = c ? na(e) : null;
  c && w();
  function w() {
    const x = na(e);
    k && !Gr(k, x) && t(), k = x, C = requestAnimationFrame(w);
  }
  return t(), () => {
    var x;
    y.forEach((I) => {
      l && I.removeEventListener("scroll", t), o && I.removeEventListener("resize", t);
    }), m?.(), (x = v) == null || x.disconnect(), v = null, c && cancelAnimationFrame(C);
  };
}
const fi = Fs, hi = Is, mi = Es, gi = Vs, vi = Bs, yi = Hs, bi = (e, a, t) => {
  const n = /* @__PURE__ */ new Map(), l = {
    platform: di,
    ...t
  }, o = {
    ...l.platform,
    _c: n
  };
  return Ts(e, a, {
    ...l,
    platform: o
  });
}, Ut = /* @__PURE__ */ te({
  name: "SdsClientOnly",
  __name: "ClientOnly",
  setup(e) {
    const a = E(!1);
    return dt(() => {
      a.value = !0;
    }), (t, n) => r(a) ? P(t.$slots, "default", { key: 0 }) : S("", !0);
  }
});
function pi(e) {
  return { all: e = e || /* @__PURE__ */ new Map(), on: function(a, t) {
    var n = e.get(a);
    n ? n.push(t) : e.set(a, [t]);
  }, off: function(a, t) {
    var n = e.get(a);
    n && (t ? n.splice(n.indexOf(t) >>> 0, 1) : e.set(a, []));
  }, emit: function(a, t) {
    var n = e.get(a);
    n && n.slice().map(function(l) {
      l(t);
    }), (n = e.get("*")) && n.slice().map(function(l) {
      l(a, t);
    });
  } };
}
const wi = { class: "inline-block" }, St = /* @__PURE__ */ te({
  name: "SdsFloatingUi",
  __name: "FloatingUi",
  props: {
    disabled: { type: Boolean, default: !1 },
    placement: { default: "auto" },
    strategy: { default: "absolute" },
    overflowPadding: { default: 5 },
    arrowPadding: { default: 5 },
    offset: { default: 10 },
    inline: { type: Boolean, default: !1 },
    shift: { type: Boolean, default: !1 },
    disableAnimation: { type: Boolean, default: !1 },
    animationEnterActiveClass: { default: "transition duration-75 ease-out" },
    animationEnterFromClass: { default: "transform scale-95 opacity-0" },
    animationEnterToClass: { default: "transform scale-100 opacity-100" },
    animationLeaveActiveClass: { default: "transition duration-50 ease-in" },
    animationLeaveFromClass: { default: "transform scale-100 opacity-100" },
    animationLeaveToClass: { default: "transform scale-95 opacity-0" },
    popperClass: { default: void 0 },
    hideArrow: { type: Boolean, default: !1 },
    arrowClass: { default: void 0 },
    placementTopArrowClass: { default: void 0 },
    placementRightArrowClass: { default: void 0 },
    placementBottomArrowClass: { default: void 0 },
    placementLeftArrowClass: { default: void 0 },
    willOpen: { default: void 0 },
    willClose: { default: void 0 }
  },
  setup(e) {
    const a = e;
    let t = null;
    const n = E(null), l = E(null), o = E(null), i = E(!1), h = E({ left: "0px", top: "0px" }), c = E({ left: "0px", top: "0px" }), f = E(""), y = E(null), m = E(!1), g = M(() => f.value.includes("top") ? a.placementTopArrowClass : f.value.includes("right") ? a.placementRightArrowClass : f.value.includes("bottom") ? a.placementBottomArrowClass : f.value.includes("left") ? a.placementLeftArrowClass : ""), v = (z) => new Promise((b) => (y.value && clearTimeout(y.value), y.value = setTimeout(b, z), y.value)), C = (z) => {
      if (typeof z == "function")
        return new Promise((b, $) => {
          try {
            z(b, $);
          } catch (p) {
            $(p);
          }
        });
    }, k = async (z = 0) => {
      if (!a.disabled)
        try {
          if (m.value = !0, await v(z), m.value) {
            if (await C(a.willOpen), i.value || !m.value) return;
            m.value = !1, i.value = !0;
          }
        } catch {
          m.value = !1;
        }
    }, w = async (z = 0) => {
      try {
        if (m.value = !1, await v(z), await C(a.willClose), !i.value) return;
        i.value = !1;
      } catch {
        return;
      }
    }, x = async (z = 0, b = 0) => {
      i.value ? w(b) : k(z);
    }, I = async () => {
      if (!n.value || !l.value) return;
      const z = {
        middleware: [],
        placement: a.placement,
        strategy: a.strategy
      }, b = a.placement.startsWith("auto");
      a.offset && z.middleware.push(fi(a.offset)), b ? z.middleware.push(hi({
        alignment: a.placement.split("-")[1] ?? ""
      })) : z.placement = a.placement, a.inline && z.middleware.push(yi()), b || z.middleware.push(gi({
        padding: a.overflowPadding
      })), a.shift && z.middleware.push(mi({
        padding: a.overflowPadding
      })), !a.hideArrow && o.value && z.middleware.push(vi({
        element: o.value,
        padding: a.arrowPadding
      }));
      const $ = await bi(n.value, l.value, z), { x: p, y: F, placement: R, middlewareData: T } = $;
      if (h.value = {
        left: p ? `${p}px` : "",
        top: F ? `${F}px` : ""
      }, !a.hideArrow) {
        const { x: j, y: X } = T.arrow;
        f.value = R, c.value = {
          left: j ? `${j}px` : "",
          top: X ? `${X}px` : ""
        };
      }
    }, L = pi();
    return Mo("emitter", L), L.on("floating-ui-toggle", (z) => {
      z ? i.value || k() : i.value && w();
    }), Il(l, (z) => {
      n.value && z.target && n.value?.contains(z.target) || i.value && w();
    }), Ya("Escape", (z) => {
      i.value && (z.preventDefault(), w());
    }), xr(() => {
      y.value && (clearTimeout(y.value), y.value = null);
    }), ye(i, async (z) => {
      z ? (await Ie(), I(), n.value && l.value && (t = ci(n.value, l.value, I))) : t && t();
    }), (z, b) => (s(), u("div", wi, [
      d("div", {
        ref_key: "triggerRef",
        ref: n,
        class: "inline-block w-full"
      }, [
        P(z.$slots, "trigger", {
          isOpen: r(i),
          open: k,
          close: w,
          toggle: x
        })
      ], 512),
      Q(Ut, null, {
        default: U(() => [
          (s(), G(Jn, { to: "body" }, [
            Q(Qe, {
              css: !e.disableAnimation,
              "enter-active-class": e.animationEnterActiveClass,
              "enter-from-class": e.animationEnterFromClass,
              "enter-to-class": e.animationEnterToClass,
              "leave-active-class": e.animationLeaveActiveClass,
              "leave-from-class": e.animationLeaveFromClass,
              "leave-to-class": e.animationLeaveToClass
            }, {
              default: U(() => [
                r(i) ? (s(), u("div", {
                  key: 0,
                  ref_key: "popperRef",
                  ref: l,
                  class: D(e.popperClass),
                  style: st(r(h))
                }, [
                  e.hideArrow ? S("", !0) : (s(), u("div", {
                    key: 0,
                    ref_key: "arrowRef",
                    ref: o,
                    class: D([e.arrowClass, r(g)]),
                    style: st(r(c))
                  }, null, 6)),
                  P(z.$slots, "default", {
                    isOpen: r(i),
                    open: k,
                    close: w,
                    toggle: x
                  })
                ], 6)) : S("", !0)
              ]),
              _: 3
            }, 8, ["css", "enter-active-class", "enter-from-class", "enter-to-class", "leave-active-class", "leave-from-class", "leave-to-class"])
          ]))
        ]),
        _: 3
      })
    ]));
  }
}), xi = ["onMouseover", "onMouseleave"], ki = ["onMouseover", "onMouseout"], it = /* @__PURE__ */ te({
  name: "SdsPopover",
  __name: "Tooltip",
  props: {
    zIndex: { default: "50" },
    type: { default: "dark" },
    openDelay: { default: 0 },
    closeDelay: { default: 0 },
    size: { default: "sm" },
    strategy: { default: "absolute" },
    placement: { default: "top" },
    disabled: { type: Boolean, default: !1 },
    willOpen: { default: void 0 },
    willClose: { default: void 0 }
  },
  setup(e) {
    const a = e, { zIndexClass: t } = _n(() => a.zIndex), n = ot(
      () => a.type,
      {
        light: "bg-gray-25 text-gray-900 border-gray-200",
        dark: "bg-black text-gray-50 border-gray-800 dark:shadow-gray-900"
      },
      "dark"
    ), l = ot(
      () => a.type,
      {
        light: "bg-gray-25 border-gray-200",
        dark: "bg-black border-gray-800"
      },
      "dark"
    ), o = ot(
      () => a.size,
      {
        sm: "w-32",
        md: "w-48",
        lg: "w-56",
        xl: "w-72",
        auto: "w-auto"
      },
      "sm"
    );
    return (i, h) => (s(), G(St, {
      "data-id": "sds-tooltip",
      strategy: e.strategy,
      placement: e.placement,
      disabled: e.disabled,
      "will-open": e.willOpen,
      "will-close": e.willClose,
      "popper-class": `absolute text-xs shadow-sm border rounded-theme-md text-center ${r(n)} ${r(o)} ${r(t)}`,
      "arrow-class": `absolute w-2 h-2 rotate-45 ${r(l)}`,
      "placement-top-arrow-class": "-bottom-1 border-b border-r",
      "placement-right-arrow-class": "-left-1 border-b border-l",
      "placement-bottom-arrow-class": "-top-1 border-t border-l",
      "placement-left-arrow-class": "-right-1 border-t border-r",
      "disable-animation": "",
      shift: ""
    }, {
      trigger: U(({ open: c, close: f }) => [
        d("div", {
          onMouseover: (y) => c(e.openDelay),
          onMouseleave: (y) => f(e.closeDelay)
        }, [
          P(i.$slots, "trigger")
        ], 40, xi)
      ]),
      default: U(({ open: c, close: f, toggle: y, isOpen: m }) => [
        d("div", {
          class: "p-2",
          onMouseover: (g) => c(),
          onMouseout: (g) => f(e.closeDelay)
        }, [
          P(i.$slots, "default", {
            close: f,
            open: c,
            toggle: y,
            isOpen: m
          })
        ], 40, ki)
      ]),
      _: 3
    }, 8, ["strategy", "placement", "disabled", "will-open", "will-close", "popper-class", "arrow-class"]));
  }
}), Ci = ["id", "aria-expanded", "aria-label", "disabled", "onClick"], $i = { class: "sr-only" }, Mi = ["id", "aria-expanded", "aria-label", "disabled", "onClick"], Si = { class: "sr-only" }, Di = ["id", "aria-expanded", "disabled", "onClick"], zi = ["aria-labelledby"], ca = /* @__PURE__ */ te({
  name: "SdsDropdown",
  __name: "Dropdown",
  props: {
    title: { default: "" },
    buttonStyle: { default: "default" },
    iconOnly: { type: Boolean, default: !1 },
    tooltip: { default: "" },
    kind: { default: (e) => e.buttonStyle === "action" ? "ghost" : "secondary" },
    variant: { default: (e) => e.buttonStyle === "action" ? "gray" : "" },
    type: { default: void 0 },
    zIndex: { default: "50" },
    offset: { default: 5 },
    openDelay: { default: 0 },
    closeDelay: { default: 0 },
    size: { default: (e) => e.buttonStyle === "action" ? "sm" : "md" },
    hideArrow: { type: Boolean, default: !1 },
    auto: { type: Boolean, default: !1 },
    strategy: { default: "absolute" },
    placement: { default: "bottom-start" },
    block: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 },
    willOpen: { default: void 0 },
    willClose: { default: void 0 }
  },
  setup(e) {
    const a = e, {
      id: t,
      buttonRef: n,
      zIndexClass: l,
      btnClass: o,
      kindClass: i,
      variantClass: h,
      sizeClass: c,
      disabledClass: f,
      blockClass: y,
      iconOnlyClasses: m,
      iconSizeClasses: g,
      handleClick: v
    } = Sl({
      prefix: a.buttonStyle === "action" ? "action-btn" : "btn",
      kind: () => a.kind,
      variant: () => a.variant,
      size: () => a.size,
      zIndex: () => a.zIndex,
      disabled: () => a.disabled,
      block: () => a.block,
      iconOnly: () => a.iconOnly,
      openDelay: a.openDelay,
      closeDelay: a.closeDelay,
      darkMode: () => a.type === "dark"
    }), C = M(() => a.iconOnly), k = M(() => a.buttonStyle === "action" ? "sds-action-dropdown" : "sds-dropdown"), w = M(() => !a.type || a.type !== "dark" ? "" : a.buttonStyle === "action" ? "action-btn-dark" : "btn-dark");
    return (x, I) => {
      const L = Hr, z = Ua;
      return s(), G(St, {
        "data-id": r(k),
        offset: e.offset,
        strategy: e.strategy,
        placement: e.placement,
        disabled: e.disabled,
        "will-open": e.willOpen,
        "will-close": e.willClose,
        class: D([e.block ? "w-full" : ""]),
        "popper-class": {
          "[.dropdown-dark_&]:border-gray-700 [.dropdown-dark_&]:bg-gray-950 dark:border-gray-700 dark:bg-gray-950": e.type === "dark",
          "bg-white absolute border shadow-lg rounded-theme-md bg-white [.dropdown-dark_&]:border-gray-700 [.dropdown-dark_&]:bg-gray-950 dark:border-gray-700 dark:bg-gray-950": !0,
          [e.auto ? "w-auto" : "w-56"]: !0,
          [r(l)]: !0
        },
        "hide-arrow": "",
        shift: ""
      }, {
        trigger: U(({ open: b, close: $, isOpen: p, toggle: F }) => [
          P(x.$slots, "trigger", {
            open: b,
            close: $,
            isOpen: p,
            toggle: F
          }, () => [
            r(C) && e.tooltip ? (s(), G(it, {
              key: 0,
              disabled: e.disabled,
              size: "auto",
              type: "dark"
            }, {
              trigger: U(() => [
                d("button", {
                  id: r(t),
                  ref_key: "button",
                  ref: n,
                  type: "button",
                  "aria-haspopup": "true",
                  "aria-expanded": p,
                  "aria-label": e.tooltip || e.title,
                  disabled: e.disabled,
                  class: D([
                    r(o),
                    r(i),
                    r(h),
                    r(c),
                    r(f),
                    r(y),
                    r(m),
                    r(w),
                    p && "active"
                  ]),
                  onClick: (R) => r(v)(p, b, $)
                }, [
                  P(x.$slots, "icon", {}, () => [
                    Q(L, {
                      class: D(r(g))
                    }, null, 8, ["class"])
                  ]),
                  d("span", $i, A(e.title), 1)
                ], 10, Ci)
              ]),
              default: U(() => [
                re(" " + A(e.tooltip), 1)
              ]),
              _: 2
            }, 1032, ["disabled"])) : r(C) ? (s(), u("button", {
              key: 1,
              id: r(t),
              ref_key: "button",
              ref: n,
              type: "button",
              "aria-haspopup": "true",
              "aria-expanded": p,
              "aria-label": e.title,
              disabled: e.disabled,
              class: D([
                r(o),
                r(i),
                r(h),
                r(c),
                r(f),
                r(y),
                r(m),
                r(w),
                p && "active"
              ]),
              onClick: (R) => r(v)(p, b, $)
            }, [
              P(x.$slots, "icon", {}, () => [
                Q(L, {
                  class: D(r(g))
                }, null, 8, ["class"])
              ]),
              d("span", Si, A(e.title), 1)
            ], 10, Mi)) : (s(), u("button", {
              key: 2,
              id: r(t),
              ref_key: "button",
              ref: n,
              type: "button",
              class: D(["space-x", [
                r(o),
                r(i),
                r(h),
                r(c),
                r(f),
                r(y),
                r(w),
                p && "active"
              ]]),
              "aria-haspopup": "true",
              "aria-expanded": p,
              disabled: e.disabled,
              onClick: (R) => r(v)(p, b, $)
            }, [
              P(x.$slots, "title", {}, () => [
                re(A(e.title), 1)
              ]),
              e.hideArrow ? S("", !0) : (s(), G(z, {
                key: 0,
                class: D(["inline-block self-center", e.buttonStyle === "action" ? "w-4 h-4" : {
                  "w-4 h-4 -mt-0.5 ml-1 -mr-1": e.size === "sm" || e.size === "",
                  "w-5 h-5 ml-2 -mt-1 -mr-2": e.size !== "sm" && e.size !== ""
                }])
              }, null, 8, ["class"]))
            ], 10, Di))
          ])
        ]),
        default: U(({ open: b, close: $, toggle: p, isOpen: F }) => [
          d("div", {
            class: D([
              "py-2 rounded-theme-sm",
              e.type === "dark" ? "dropdown-dark bg-gray-950" : ""
            ]),
            role: "menu",
            "aria-orientation": "vertical",
            "aria-labelledby": r(n) && r(n).id || void 0
          }, [
            P(x.$slots, "default", {
              close: $,
              open: b,
              toggle: p,
              isOpen: F
            })
          ], 10, zi)
        ]),
        _: 3
      }, 8, ["data-id", "offset", "strategy", "placement", "disabled", "will-open", "will-close", "class", "popper-class"]);
    };
  }
}), fa = /* @__PURE__ */ te({
  name: "SdsActionDropdown",
  __name: "ActionDropdown",
  props: {
    title: {},
    iconOnly: { type: Boolean },
    tooltip: {},
    kind: {},
    variant: {},
    zIndex: {},
    offset: {},
    openDelay: {},
    closeDelay: {},
    size: {},
    hideArrow: { type: Boolean },
    auto: { type: Boolean },
    strategy: {},
    placement: {},
    block: { type: Boolean },
    disabled: { type: Boolean },
    willOpen: {},
    willClose: {}
  },
  setup(e) {
    return (a, t) => (s(), G(ca, en(a.$props, { "button-style": "action" }), kr({ _: 2 }, [
      le(a.$slots, (n, l) => ({
        name: l,
        fn: U((o) => [
          P(a.$slots, l, Cr($r(o || {})))
        ])
      }))
    ]), 1040));
  }
});
fa.install = (e) => {
  e.component(fa.name, fa);
};
const Ti = ["aria-label"], Bi = ["title"], Li = ["title"], ta = /* @__PURE__ */ te({
  name: "SdsAvatar",
  __name: "Avatar",
  props: {
    variant: { default: "gray" },
    position: { default: "center" },
    shape: { default: "portrait" },
    size: { default: "md" },
    name: { default: "" },
    src: { default: "" }
  },
  setup(e) {
    const a = e, t = M(() => {
      const y = (() => {
        switch (a.position) {
          case "bottom":
            return "bg-bottom";
          case "left":
            return "bg-left";
          case "right":
            return "bg-right";
          case "top":
            return "bg-top";
          default:
            return "bg-center";
        }
      })(), m = (() => {
        switch (a.size) {
          case "2xl":
            return "w-44";
          case "xl":
            return "w-[88px]";
          case "md":
            return "w-12";
          case "sm":
            return "w-8";
          case "xs":
            return "w-6";
          case "auto":
            return "w-full";
          default:
            return "w-16";
        }
      })(), g = (() => {
        switch (a.size) {
          case "2xl":
            return "text-6xl font-light";
          case "xl":
            return "text-3xl font-regular";
          case "md":
            return "text-xl font-regular";
          case "sm":
            return "text-sm font-semibold";
          case "xs":
            return "text-xs font-semibold";
          default:
          case "lg":
            return "text-2xl font-regular";
        }
      })(), v = (() => {
        const w = [];
        return a.shape === "circle" && w.push("rounded-full aspect-square"), a.shape === "portrait" && w.push("aspect-[4/5]"), a.shape === "square" && w.push("aspect-square"), (a.shape === "square" || a.shape === "portrait") && (["xs", "sm"].includes(a.size) && w.push("rounded-theme-sm"), ["md", "lg"].includes(a.size) && w.push("rounded-theme-md"), ["xl", "2xl"].includes(a.size) && w.push("rounded-theme-lg")), w.join(" ");
      })(), C = (() => {
        const w = [
          "bg-gray-100 dark:bg-gray-900",
          "bg-red-100 dark:bg-red-900",
          "bg-yellow-25 dark:bg-yellow-900",
          "bg-green-50 dark:bg-green-900",
          "bg-blue-50 dark:bg-blue-900",
          "bg-purple-100 dark:bg-purple-900"
        ];
        return a.variant ? w.filter((x) => x.includes(a.variant))[0] : "";
      })(), k = (() => {
        const w = [
          "dark:text-gray-400",
          "dark:text-red-500",
          "dark:text-yellow-400",
          "dark:text-green-400",
          "dark:text-blue-400",
          "dark:text-purple-400"
        ];
        return a.variant ? w.filter((x) => x.includes(a.variant))[0] : "";
      })();
      return {
        position: y,
        size: m,
        text: g,
        shape: v,
        variantOuter: C,
        variantInner: k
      };
    }), n = M(() => t.value.position), l = M(() => t.value.size), o = M(() => t.value.text), i = M(() => t.value.shape), h = M(() => t.value.variantOuter), c = M(() => t.value.variantInner), f = M(() => {
      if (!a.name)
        return;
      let y = a.name.trim().toUpperCase();
      return y.length > 2 && (y.includes(" ") && (y = y.split(" ").map((m) => m[0]).join("")), y.length > 2) ? y.charAt(0) + y.charAt(y.length - 1) : y.substring(0, 2);
    });
    return (y, m) => (s(), u("div", {
      "data-id": "sds-avatar",
      class: D(["inline-flex items-center justify-center", r(h), r(l), r(i)]),
      role: "img",
      "aria-label": e.name || "Avatar"
    }, [
      e.src ? (s(), u("div", {
        key: 0,
        title: e.name,
        class: D(["bg-cover", r(n), r(l), r(i)]),
        style: st(`background-image: url(${e.src})`)
      }, null, 14, Bi)) : (s(), u("span", {
        key: 1,
        title: e.name,
        class: D(["leading-none text-black cursor-default uppercase", r(o), r(c)])
      }, A(r(f)), 11, Li))
    ], 10, Ti));
  }
});
ta.install = (e) => {
  e.component(ta.name, ta);
};
const Ta = /* @__PURE__ */ te({
  name: "SdsDropdownItem",
  __name: "DropdownItem",
  props: {
    variant: { default: "gray" },
    tag: { default: "a" },
    closeOnClick: { type: Boolean, default: !0 },
    active: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 }
  },
  setup(e) {
    const a = e, t = pr("emitter"), n = M(() => a.disabled ? "disabled" : a.active ? `${a.variant}-active` : a.variant), l = ot(n, {
      disabled: "pointer-events-none text-sm bg-white text-gray-500 [.dropdown-dark_&]:bg-gray-950 [.dropdown-dark_&]:text-gray-500 dark:bg-gray-950 dark:text-gray-500",
      gray: "text-sm bg-white text-gray-900 hover:bg-gray-50 hover:text-gray-900 active:bg-blue-25 active:text-gray-900 [.dropdown-dark_&]:bg-gray-950 [.dropdown-dark_&]:text-gray-100 [.dropdown-dark_&]:hover:bg-gray-850 [.dropdown-dark_&]:hover:text-gray-100 [.dropdown-dark_&]:active:bg-blue-900 [.dropdown-dark_&]:active:text-gray-100 dark:bg-gray-950 dark:text-gray-100 dark:hover:bg-gray-850 dark:hover:text-gray-100 dark:active:bg-blue-900 dark:active:text-gray-100",
      "gray-active": "text-sm border-l-4 border-solid border-blue-600 bg-gray-25 text-gray-900 hover:bg-gray-50 hover:text-gray-900 active:bg-blue-25 active:text-gray-900 [.dropdown-dark_&]:border-blue-300 [.dropdown-dark_&]:bg-gray-900 [.dropdown-dark_&]:text-gray-100 [.dropdown-dark_&]:hover:bg-gray-850 [.dropdown-dark_&]:hover:text-gray-100 [.dropdown-dark_&]:active:bg-blue-900 [.dropdown-dark_&]:active:text-gray-100 dark:border-blue-300 dark:bg-gray-900 dark:text-gray-100 dark:hover:bg-gray-850 dark:hover:text-gray-100 dark:active:bg-blue-900 dark:active:text-gray-100",
      red: "text-sm bg-white text-red-600 hover:bg-gray-50 hover:text-red-600 active:bg-red-25 active:text-red-600 [.dropdown-dark_&]:bg-gray-950 [.dropdown-dark_&]:text-red-300 [.dropdown-dark_&]:hover:bg-gray-850 [.dropdown-dark_&]:hover:text-red-300 [.dropdown-dark_&]:active:bg-red-900 [.dropdown-dark_&]:active:text-red-300 dark:bg-gray-950 dark:text-red-300 dark:hover:bg-gray-850 dark:hover:text-red-300 dark:active:bg-red-900 dark:active:text-red-300",
      "red-active": "text-sm border-l-4 border-solid border-red-600 bg-gray-25 text-red-600 hover:bg-gray-50 hover:text-red-600 active:bg-red-25 active:text-red-600 [.dropdown-dark_&]:border-red-300 [.dropdown-dark_&]:bg-gray-900 [.dropdown-dark_&]:text-red-300 [.dropdown-dark_&]:hover:bg-gray-850 [.dropdown-dark_&]:hover:text-red-300 [.dropdown-dark_&]:active:bg-red-900 [.dropdown-dark_&]:active:text-red-300 dark:border-red-300 dark:bg-gray-900 dark:text-red-300 dark:hover:bg-gray-850 dark:hover:text-red-300 dark:active:bg-red-900 dark:active:text-red-300"
    }, "text-sm bg-white text-gray-900 hover:bg-gray-50 hover:text-gray-900 active:bg-blue-25 active:text-gray-900 [.dropdown-dark_&]:bg-gray-950 [.dropdown-dark_&]:text-gray-100 [.dropdown-dark_&]:hover:bg-gray-850 [.dropdown-dark_&]:hover:text-gray-100 [.dropdown-dark_&]:active:bg-blue-900 [.dropdown-dark_&]:active:text-gray-100 dark:bg-gray-950 dark:text-gray-100 dark:hover:bg-gray-850 dark:hover:text-gray-100 dark:active:bg-blue-900 dark:active:text-gray-100");
    return (o, i) => (s(), G(mt(e.tag), {
      "data-id": "sds-dropdown-item",
      class: D([
        "block w-full select-none px-4 text-sm leading-5 text-left hover:no-underline",
        r(l)
      ]),
      disabled: e.disabled,
      role: "menuitem",
      onClick: i[0] || (i[0] = (h) => e.closeOnClick ? r(t)?.emit("floating-ui-toggle", !1) : null)
    }, {
      default: U(() => [
        d("span", {
          class: D(["flex py-2", e.active && "-ml-2"])
        }, [
          P(o.$slots, "default")
        ], 2)
      ]),
      _: 3
    }, 8, ["class", "disabled"]));
  }
});
function Ii() {
  return "99% 50%";
}
function rr(e, a, t, n = "forge") {
  let i = 0, h = 0, c = 0, f = 0, y = 0;
  switch (e) {
    case "circle":
      switch (a) {
        case "xs":
          f = 1, c = 13.5, y = t === "condensed" ? -11 : -4;
          break;
        case "sm":
          f = 1, c = 17, y = t === "condensed" ? -8 : 0;
          break;
        case "md":
          f = 1, c = 26, y = t === "condensed" ? -12 : 0;
          break;
      }
      i = 1e3 + y, h = 1e3 / 2;
      break;
    case "square":
      switch (a) {
        case "xs":
          f = n === "plaid" ? 0 : 4, c = 26, i = t === "condensed" ? 976 : 983, h = 487;
          break;
        case "sm":
          f = n === "plaid" ? 0 : 4, c = 34, i = t === "condensed" ? 975 : 983, h = 483;
          break;
        case "md":
          f = n === "plaid" ? 0 : 6, c = 50, i = t === "condensed" ? 963 : 975, h = 475;
          break;
      }
      break;
  }
  const m = `url('data:image/svg+xml,<svg viewBox="0 0 1000 1000" xmlns="http://www.w3.org/2000/svg"><circle cx="${i}" cy="${h}" r="${c}" /></svg>'), linear-gradient(#fff, #fff)`, g = `url('data:image/svg+xml,<svg viewBox="0 0 1000 1000" xmlns="http://www.w3.org/2000/svg"><rect x="${i}" y="${h}" width="${c}" height="${c}" rx="${f}" /></svg>'), linear-gradient(#fff, #fff)`;
  return e === "circle" ? m : g;
}
const Vi = ["href", "target", "rel"], Ai = ["onClick"], Hi = { class: "flex flex-row gap-2" }, Oi = { class: "leading-6" }, Pi = /* @__PURE__ */ te({
  name: "SdsAvatarGroup",
  __name: "AvatarGroup",
  props: {
    shape: { default: "circle" },
    size: { default: "md" },
    density: { default: "default" },
    srcset: { default: () => [] }
  },
  setup(e) {
    Mr((y) => ({
      v9a205996: r(c),
      v11b21364: r(h),
      v9909bce4: r(f)
    }));
    const a = e, t = M(() => [
      "flex flex-row",
      '[&_[data-id="sds-dropdown"]]:relative [&_[data-id="sds-dropdown"]_div]:right-0',
      a.size === "md" ? '[&_[data-id="sds-dropdown"]]:size-12 h-12' : "",
      a.size === "sm" ? '[&_[data-id="sds-dropdown"]]:size-8 h-8' : "",
      a.size === "xs" ? '[&_[data-id="sds-dropdown"]]:size-6 h-6' : ""
    ].join(" ")), n = M(() => [
      "relative",
      "z-0",
      "left-0",
      "hover:z-20",
      "focus:z-20",
      a.size === "md" ? "size-12" : "",
      a.size === "sm" ? "size-8" : "",
      a.size === "xs" ? "size-6" : ""
    ].join(" ")), l = M(() => [
      "border-2",
      "border-transparent",
      "cursor-pointer",
      "mask-none!",
      "hover:border-gray-200",
      "focus:border-gray-200",
      "active:bg-gray-200/50",
      "active:border-gray-300",
      "dark:hover:border-gray-800",
      "dark:focus:border-gray-800",
      "dark:active:bg-gray-700",
      "dark:active:border-gray-500",
      "active:shadow-inner"
    ].join(" ")), o = (y, m) => {
      if (y === m)
        return "mask-none";
    }, i = (y, m) => {
      if (y === m)
        return "max-w-fit";
      switch (a.size) {
        default:
        case "md":
          return a.density === "condensed" ? "max-w-6" : "max-w-9";
        case "sm":
          return a.density === "condensed" ? "max-w-5" : "max-w-7";
        case "xs":
          return a.density === "condensed" ? "max-w-3" : "max-w-5";
      }
    }, h = M(() => Ii()), c = M(() => rr(a.shape, a.size, a.density, "forge")), f = M(() => rr(a.shape, a.size, a.density, "plaid"));
    return (y, m) => (s(), u("div", {
      "data-id": "sds-avatargroup",
      class: D(r(t))
    }, [
      (s(!0), u(J, null, le(e.srcset.slice(0, 3), (g, v) => (s(), u(J, null, [
        g.href ? (s(), u("a", {
          key: `${v}-link`,
          href: g.href,
          target: g.target ?? void 0,
          rel: g.target === "_blank" ? "noopener noreferrer" : void 0
        }, [
          Q(it, {
            size: "auto",
            type: "dark",
            class: D(["overflow-x-visible", i(v, e.srcset.length - 1)]),
            disabled: !1
          }, {
            trigger: U(() => [
              (s(), G(ta, {
                key: v,
                shape: e.shape,
                size: e.size,
                variant: g.variant ?? "gray",
                src: g.src ?? "",
                name: g.name ?? "",
                class: D(["relative cursor-pointer [&>span]:cursor-pointer", `${r(n)} ${o(v, e.srcset.length - 1)} ${e.srcset.length - 1 === v && e.srcset.length < 5 ? "mask-none!" : ""}`])
              }, null, 8, ["shape", "size", "variant", "src", "name", "class"]))
            ]),
            default: U(() => [
              re(" " + A(g.name), 1)
            ]),
            _: 2
          }, 1032, ["class"])
        ], 8, Vi)) : (s(), G(it, {
          key: v,
          size: "auto",
          type: "dark",
          class: D(["overflow-x-visible", i(v, e.srcset.length - 1)]),
          disabled: !1
        }, {
          trigger: U(() => [
            Q(ta, {
              shape: e.shape,
              size: e.size,
              variant: g.variant ?? "gray",
              src: g.src ?? "",
              name: g.name ?? "",
              class: D(["relative", `${r(n)} ${o(v, e.srcset.length - 1)} ${e.srcset.length - 1 === v && e.srcset.length < 5 ? "mask-none!" : ""}`])
            }, null, 8, ["shape", "size", "variant", "src", "name", "class"])
          ]),
          default: U(() => [
            re(" " + A(g.name), 1)
          ]),
          _: 2
        }, 1032, ["class"]))
      ], 64))), 256)),
      e.srcset.length >= 4 ? (s(), G(ca, { key: 0 }, {
        trigger: U(({ toggle: g }) => [
          d("button", {
            class: D([
              r(l),
              "bg-gray-100",
              "dark:bg-gray-900",
              "relative flex flex-col justify-center text-center",
              e.shape === "circle" ? "rounded-full" : "",
              e.size === "md" && e.shape === "square" ? "sds-theme-plaid:rounded-none rounded-md" : "",
              e.size === "sm" && e.shape === "square" ? "sds-theme-plaid:rounded-none rounded" : "",
              e.size === "xs" && e.shape === "square" ? "sds-theme-plaid:rounded-none rounded-sm" : "",
              e.size === "md" ? "text-md size-12" : "",
              e.size === "sm" ? "text-sm size-8" : "",
              e.size === "xs" ? "text-xs size-6" : "",
              "font-semibold",
              "text-gray-700 dark:text-gray-200"
            ]),
            onClick: (v) => g()
          }, " +" + A(e.srcset.length - 3), 11, Ai)
        ]),
        default: U(() => [
          (s(!0), u(J, null, le(e.srcset.slice(3), (g, v) => (s(), G(Ta, {
            key: v,
            href: g.href ?? void 0,
            target: g.target ?? void 0,
            rel: g.target === "_blank" ? "noopener noreferrer" : void 0
          }, {
            default: U(() => [
              d("div", Hi, [
                Q(ta, {
                  shape: e.shape,
                  size: "xs",
                  variant: g.variant ?? "gray",
                  src: g.src ?? "",
                  name: g.name ?? ""
                }, null, 8, ["shape", "variant", "src", "name"]),
                d("span", Oi, A(g.name), 1)
              ])
            ]),
            _: 2
          }, 1032, ["href", "target", "rel"]))), 128))
        ]),
        _: 1
      })) : S("", !0)
    ], 2));
  }
}), El = (e, a) => {
  const t = e.__vccOpts || e;
  for (const [n, l] of a)
    t[n] = l;
  return t;
}, an = /* @__PURE__ */ El(Pi, [["__scopeId", "data-v-0ce7048d"]]);
an.install = (e) => {
  e.component(an.name, an);
};
const nn = /* @__PURE__ */ te({
  name: "SdsBadge",
  __name: "Badge",
  props: {
    type: { default: "medium" },
    variant: { default: "gray" }
  },
  setup(e) {
    const a = e, t = M(() => {
      let n = "", l = "", o = "";
      switch (a.type === "light-border" && (o = "border border-current"), a.variant) {
        case "blue":
          a.type === "light-border" || a.type === "light" ? (l = "bg-blue-25 dark:bg-blue-900", n = "text-blue-700 dark:text-blue-300", o = a.type === "light-border" ? o : "border border-blue-25 dark:border-blue-900") : a.type === "medium" ? (l = "bg-blue-500", n = "text-white dark:text-black", o = "border border-blue-500") : a.type === "dark" && (l = "bg-blue-700 dark:bg-blue-800", n = "text-white dark:text-blue-50", o = "border border-blue-700 dark:border-blue-800");
          break;
        case "green":
          a.type === "light-border" || a.type === "light" ? (l = "bg-green-25 dark:bg-green-900", n = "text-green-700 dark:text-green-300", o = a.type === "light-border" ? o : "border border-green-25 dark:border-green-900") : a.type === "medium" ? (l = "bg-green-500", n = "text-white dark:text-black", o = "border border-green-500") : a.type === "dark" && (l = "bg-green-700 dark:bg-green-800", n = "text-white dark:text-green-50", o = "border border-green-700 dark:border-green-800");
          break;
        case "teal":
          a.type === "light-border" || a.type === "light" ? (l = "bg-teal-25 dark:bg-teal-900", n = "text-teal-700 dark:text-teal-300", o = a.type === "light-border" ? o : "border border-teal-25 dark:border-teal-900") : a.type === "medium" ? (l = "bg-teal-500", n = "text-white dark:text-black", o = "border border-teal-500") : a.type === "dark" && (l = "bg-teal-700 dark:bg-teal-800", n = "text-white dark:text-teal-50", o = "border border-teal-700 dark:border-teal-800");
          break;
        case "orange":
          a.type === "light-border" || a.type === "light" ? (l = "bg-orange-25 dark:bg-orange-900", n = "text-orange-900 dark:text-orange-300", o = a.type === "light-border" ? o : "border border-orange-25 dark:border-orange-900") : a.type === "medium" ? (l = "bg-orange-200", n = "text-orange-800 dark:text-black", o = "border border-orange-200") : a.type === "dark" && (l = "bg-orange-500 dark:bg-orange-600", n = "text-white dark:text-orange-50", o = "border border-orange-500 dark:border-orange-600");
          break;
        case "red":
          a.type === "light-border" || a.type === "light" ? (l = "bg-red-25 dark:bg-red-900", n = "text-red-600 dark:text-red-300", o = a.type === "light-border" ? o : "border border-red-25 dark:border-red-900") : a.type === "medium" ? (l = "bg-red-500", n = "text-white dark:text-black", o = "border border-red-500") : a.type === "dark" && (l = "bg-red-700 dark:bg-red-800", n = "text-white dark:text-red-100", o = "border border-red-700 dark:border-red-800");
          break;
        case "tan":
          a.type === "light-border" || a.type === "light" ? (l = "bg-tan-50 dark:bg-tan-900", n = "text-tan-900 dark:text-tan-300", o = a.type === "light-border" ? o : "border border-tan-50 dark:border-tan-900") : a.type === "medium" ? (l = "bg-tan-200", n = "text-tan-900 dark:text-black", o = "border border-tan-200") : a.type === "dark" && (l = "bg-tan-600 dark:bg-tan-700", n = "text-white dark:text-tan-50", o = "border border-tan-600 dark:border-tan-700");
          break;
        case "yellow":
          a.type === "light-border" || a.type === "light" ? (l = "bg-yellow-25 dark:bg-yellow-900", n = "text-yellow-900 dark:text-yellow-300", o = a.type === "light-border" ? o : "border border-yellow-25 dark:border-yellow-900") : a.type === "medium" ? (l = "bg-yellow-100 dark:bg-yellow-200", n = "text-yellow-800 dark:text-black", o = "border border-yellow-100 dark:border-yellow-200") : a.type === "dark" && (l = "bg-yellow-500 dark:bg-yellow-600", n = "text-white dark:text-yellow-25", o = "border border-yellow-500 dark:border-yellow-600");
          break;
        case "purple":
          a.type === "light-border" || a.type === "light" ? (l = "bg-purple-25 dark:bg-purple-900", n = "text-purple-600 dark:text-purple-300", o = a.type === "light-border" ? o : "border border-purple-25 dark:border-purple-900") : a.type === "medium" ? (l = "bg-purple-500", n = "text-white dark:text-black", o = "border border-purple-500") : a.type === "dark" && (l = "bg-purple-700 dark:bg-purple-800", n = "text-white dark:text-purple-50", o = "border border-purple-700 dark:border-purple-800");
          break;
        case "indigo":
          a.type === "light-border" || a.type === "light" ? (l = "bg-indigo-25 dark:bg-indigo-900", n = "text-indigo-600 dark:text-indigo-300", o = a.type === "light-border" ? o : "border border-indigo-25 dark:border-indigo-900") : a.type === "medium" ? (l = "bg-indigo-500", n = "text-white dark:text-black", o = "border border-indigo-500") : a.type === "dark" && (l = "bg-indigo-700 dark:bg-indigo-800", n = "text-white dark:text-indigo-50", o = "border border-indigo-700 dark:border-indigo-800");
          break;
        default:
          a.type === "light-border" || a.type === "light" ? (l = "bg-gray-100 dark:bg-gray-900", n = "text-gray-700 dark:text-gray-300", o = a.type === "light-border" ? o : "border border-gray-100 dark:border-gray-900") : a.type === "medium" ? (l = "bg-gray-500 dark:bg-gray-400", n = "text-white dark:text-black", o = "border border-gray-500 dark:border-blue-400") : a.type === "dark" && (l = "bg-gray-700", n = "text-white dark:text-gray-50", o = "border border-gray-700");
          break;
      }
      return [n, l, o];
    });
    return (n, l) => (s(), u("div", {
      "data-id": "sds-badge",
      role: "status",
      class: D(["inline-flex items-center justify-center gap-1 tracking-wide max-w-full uppercase px-2 py-1 text-xs font-bold text-center text-ellipsis whitespace-nowrap overflow-hidden align-baseline rounded-theme-sm", r(t)])
    }, [
      P(n.$slots, "default")
    ], 2));
  }
});
nn.install = (e) => {
  e.component(nn.name, nn);
};
const Fi = ["data-pending", "type", "disabled", "aria-disabled", "aria-busy"], Ei = {
  key: 0,
  class: "relative"
}, Ri = { class: "absolute inset-0 flex items-center justify-center" }, Ni = { class: "opacity-0" }, ha = /* @__PURE__ */ te({
  name: "SdsButton",
  __name: "Button",
  props: {
    kind: { default: "" },
    variant: { default: "" },
    type: { default: "button" },
    size: { default: "" },
    active: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 },
    block: { type: Boolean, default: !1 },
    pending: { type: Boolean, default: !1 }
  },
  emits: ["click"],
  setup(e, { emit: a }) {
    const t = e, n = a, { btnClass: l, kindClass: o, variantClass: i, sizeClass: h, disabledClass: c, activeClass: f, blockClass: y, pendingClass: m, ctaClass: g } = Ml({
      prefix: "btn",
      kind: () => t.kind,
      variant: () => t.variant,
      size: () => t.size,
      disabled: () => t.disabled,
      active: () => t.active,
      block: () => t.block,
      pending: () => t.pending,
      cta: () => t.type === "cta"
    }), v = M(() => t.type === "submit" ? "submit" : "button"), C = () => {
      t.pending || n("click");
    };
    return (k, w) => (s(), u("button", {
      "data-id": "sds-button",
      "data-pending": e.pending || void 0,
      type: r(v),
      class: D([r(l), r(o), r(i), r(h), r(c), r(f), r(y), r(m), r(g)]),
      disabled: e.disabled,
      "aria-disabled": e.disabled,
      "aria-busy": e.pending,
      onClick: C
    }, [
      e.pending ? (s(), u("span", Ei, [
        d("span", Ri, [
          (s(), u("svg", {
            "data-id": "spinner",
            class: D(["animate-spin text-current", {
              "h-5 w-5": e.size === "lg",
              "h-4 w-4": e.size !== "lg" && e.size !== "xs",
              "h-3 w-3": e.size === "xs"
            }]),
            xmlns: "http://www.w3.org/2000/svg",
            fill: "none",
            viewBox: "0 0 24 24",
            role: "graphics-symbol"
          }, [...w[0] || (w[0] = [
            d("title", null, "Pending", -1),
            d("circle", {
              class: "opacity-25 fill-transparent",
              cx: "12",
              cy: "12",
              r: "10",
              stroke: "currentColor",
              "stroke-width": "4"
            }, null, -1),
            d("path", {
              class: "opacity-75",
              fill: "currentColor",
              d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
            }, null, -1)
          ])], 2))
        ]),
        d("span", Ni, [
          P(k.$slots, "default")
        ])
      ])) : P(k.$slots, "default", { key: 1 })
    ], 10, Fi));
  }
});
ha.install = (e) => {
  e.component(ha.name, ha);
};
const Wi = {
  viewBox: "0 0 640 640",
  "aria-hidden": "true",
  role: "img",
  width: "1.2em",
  height: "1.2em"
};
function qi(e, a) {
  return s(), u("svg", Wi, [...a[0] || (a[0] = [
    d("path", {
      fill: "currentColor",
      d: "M528 320c0 114.9-93.1 208-208 208s-208-93.1-208-208s93.1-208 208-208s208 93.1 208 208m-464 0c0 141.4 114.6 256 256 256s256-114.6 256-256S461.4 64 320 64S64 178.6 64 320m232-136v136c0 8 4 15.5 10.7 20l96 64c11 7.4 25.9 4.4 33.3-6.7s4.4-25.9-6.7-33.3L344 307.2V184c0-13.3-10.7-24-24-24s-24 10.7-24 24"
    }, null, -1)
  ])]);
}
const Ur = $e({ name: "fa7-regular-clock", render: qi }), Yi = {
  viewBox: "0 0 640 640",
  "aria-hidden": "true",
  role: "img",
  width: "1.2em",
  height: "1.2em"
};
function ji(e, a) {
  return s(), u("svg", Yi, [...a[0] || (a[0] = [
    d("path", {
      fill: "currentColor",
      d: "M471.1 297.4c12.5 12.5 12.5 32.8 0 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L403.2 320L233.9 150.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l192 192z"
    }, null, -1)
  ])]);
}
const ll = $e({ name: "fa7-solid-chevron-right", render: ji }), Gi = {
  viewBox: "0 0 640 640",
  "aria-hidden": "true",
  role: "img",
  width: "1.2em",
  height: "1.2em"
};
function Ui(e, a) {
  return s(), u("svg", Gi, [...a[0] || (a[0] = [
    d("path", {
      fill: "currentColor",
      d: "M169.4 297.4c-12.5 12.5-12.5 32.8 0 45.3l192 192c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 320l169.3-169.4c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-192 192z"
    }, null, -1)
  ])]);
}
const Ki = $e({ name: "fa7-solid-chevron-left", render: Ui }), Kr = 6048e5, Zi = 864e5, Qi = 6e4, Xi = 36e5, Ji = 1e3, or = /* @__PURE__ */ Symbol.for("constructDateFrom");
function De(e, a) {
  return typeof e == "function" ? e(a) : e && typeof e == "object" && or in e ? e[or](a) : e instanceof Date ? new e.constructor(a) : new Date(a);
}
function _i(e) {
  return De(e, Date.now());
}
function Zr(e, ...a) {
  const t = De.bind(
    null,
    a.find((n) => typeof n == "object")
  );
  return a.map(t);
}
function he(e, a) {
  return De(a || e, e);
}
function Un(e, a) {
  const t = he(e, a?.in);
  return t.setHours(0, 0, 0, 0), t;
}
function Yt(e, a, t) {
  const [n, l] = Zr(
    t?.in,
    e,
    a
  );
  return +Un(n) == +Un(l);
}
function Wt(e, a) {
  return Yt(
    De(e, e),
    _i(e)
  );
}
function ed(e, a, t) {
  const n = +he(e, t?.in), [l, o] = [
    +he(a.start, t?.in),
    +he(a.end, t?.in)
  ].sort((i, h) => i - h);
  return n >= l && n <= o;
}
function Ma(e, a) {
  return +he(e) < +he(a);
}
function Gt(e, a) {
  return +he(e) > +he(a);
}
function Qr(e, a) {
  return +he(e) == +he(a);
}
function _e(e) {
  return e instanceof Date || typeof e == "object" && Object.prototype.toString.call(e) === "[object Date]";
}
function Sa(e, a) {
  let t, n = a?.in;
  return e.forEach((l) => {
    !n && typeof l == "object" && (n = De.bind(null, l));
    const o = he(l, n);
    (!t || t > o || isNaN(+o)) && (t = o);
  }), De(n, t || NaN);
}
function Da(e, a) {
  let t, n = a?.in;
  return e.forEach((l) => {
    !n && typeof l == "object" && (n = De.bind(null, l));
    const o = he(l, n);
    (!t || t < o || isNaN(+o)) && (t = o);
  }), De(n, t || NaN);
}
function sr(e, a) {
  const t = he(e, a?.in), n = t.getFullYear(), l = t.getMonth(), o = De(t, 0);
  return o.setFullYear(n, l + 1, 0), o.setHours(0, 0, 0, 0), o.getDate();
}
function ia(e, a) {
  const t = he(e, a?.in);
  return t.setDate(1), t.setHours(0, 0, 0, 0), t;
}
function ir(e, a) {
  return he(e, a?.in).getDay();
}
function Lt(e, a) {
  return he(e, a?.in).getHours();
}
function ze(e, a, t) {
  const n = he(e, t?.in);
  return n.setDate(a), n;
}
function Ae(e, a, t) {
  const n = he(e, t?.in);
  return n.setHours(a), n;
}
function Re(e, a, t) {
  const n = he(e, t?.in);
  return n.setMinutes(a), n;
}
function Ue(e, a, t) {
  const n = he(e, t?.in);
  return n.setSeconds(a), n;
}
function Ke(e, a, t) {
  const n = he(e, t?.in);
  return n.setMilliseconds(a), n;
}
function jt(e, a, t) {
  const n = he(e, t?.in);
  if (isNaN(a)) return De(e, NaN);
  if (!a)
    return n;
  const l = n.getDate(), o = De(e, n.getTime());
  o.setMonth(n.getMonth() + a + 1, 0);
  const i = o.getDate();
  return l >= i ? o : (n.setFullYear(
    o.getFullYear(),
    o.getMonth(),
    l
  ), n);
}
function dr(e, a, t) {
  return jt(e, -1, t);
}
const td = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
}, ad = (e, a, t) => {
  let n;
  const l = td[e];
  return typeof l == "string" ? n = l : a === 1 ? n = l.one : n = l.other.replace("{{count}}", a.toString()), t?.addSuffix ? t.comparison && t.comparison > 0 ? "in " + n : n + " ago" : n;
};
function fl(e) {
  return (a = {}) => {
    const t = a.width ? String(a.width) : e.defaultWidth;
    return e.formats[t] || e.formats[e.defaultWidth];
  };
}
const nd = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, ld = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, rd = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, od = {
  date: fl({
    formats: nd,
    defaultWidth: "full"
  }),
  time: fl({
    formats: ld,
    defaultWidth: "full"
  }),
  dateTime: fl({
    formats: rd,
    defaultWidth: "full"
  })
}, sd = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
}, id = (e, a, t, n) => sd[e];
function Ca(e) {
  return (a, t) => {
    const n = t?.context ? String(t.context) : "standalone";
    let l;
    if (n === "formatting" && e.formattingValues) {
      const i = e.defaultFormattingWidth || e.defaultWidth, h = t?.width ? String(t.width) : i;
      l = e.formattingValues[h] || e.formattingValues[i];
    } else {
      const i = e.defaultWidth, h = t?.width ? String(t.width) : e.defaultWidth;
      l = e.values[h] || e.values[i];
    }
    const o = e.argumentCallback ? e.argumentCallback(a) : a;
    return l[o];
  };
}
const dd = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
}, ud = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
}, cd = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
  ],
  wide: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ]
}, fd = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday"
  ]
}, hd = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
}, md = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
}, gd = (e, a) => {
  const t = Number(e), n = t % 100;
  if (n > 20 || n < 10)
    switch (n % 10) {
      case 1:
        return t + "st";
      case 2:
        return t + "nd";
      case 3:
        return t + "rd";
    }
  return t + "th";
}, vd = {
  ordinalNumber: gd,
  era: Ca({
    values: dd,
    defaultWidth: "wide"
  }),
  quarter: Ca({
    values: ud,
    defaultWidth: "wide",
    argumentCallback: (e) => e - 1
  }),
  month: Ca({
    values: cd,
    defaultWidth: "wide"
  }),
  day: Ca({
    values: fd,
    defaultWidth: "wide"
  }),
  dayPeriod: Ca({
    values: hd,
    defaultWidth: "wide",
    formattingValues: md,
    defaultFormattingWidth: "wide"
  })
};
function $a(e) {
  return (a, t = {}) => {
    const n = t.width, l = n && e.matchPatterns[n] || e.matchPatterns[e.defaultMatchWidth], o = a.match(l);
    if (!o)
      return null;
    const i = o[0], h = n && e.parsePatterns[n] || e.parsePatterns[e.defaultParseWidth], c = Array.isArray(h) ? bd(h, (m) => m.test(i)) : (
      // [TODO] -- I challenge you to fix the type
      yd(h, (m) => m.test(i))
    );
    let f;
    f = e.valueCallback ? e.valueCallback(c) : c, f = t.valueCallback ? (
      // [TODO] -- I challenge you to fix the type
      t.valueCallback(f)
    ) : f;
    const y = a.slice(i.length);
    return { value: f, rest: y };
  };
}
function yd(e, a) {
  for (const t in e)
    if (Object.prototype.hasOwnProperty.call(e, t) && a(e[t]))
      return t;
}
function bd(e, a) {
  for (let t = 0; t < e.length; t++)
    if (a(e[t]))
      return t;
}
function pd(e) {
  return (a, t = {}) => {
    const n = a.match(e.matchPattern);
    if (!n) return null;
    const l = n[0], o = a.match(e.parsePattern);
    if (!o) return null;
    let i = e.valueCallback ? e.valueCallback(o[0]) : o[0];
    i = t.valueCallback ? t.valueCallback(i) : i;
    const h = a.slice(l.length);
    return { value: i, rest: h };
  };
}
const wd = /^(\d+)(th|st|nd|rd)?/i, xd = /\d+/i, kd = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
}, Cd = {
  any: [/^b/i, /^(a|c)/i]
}, $d = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
}, Md = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, Sd = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
}, Dd = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^may/i,
    /^jun/i,
    /^jul/i,
    /^au/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
}, zd = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
}, Td = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, Bd = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, Ld = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, Id = {
  ordinalNumber: pd({
    matchPattern: wd,
    parsePattern: xd,
    valueCallback: (e) => parseInt(e, 10)
  }),
  era: $a({
    matchPatterns: kd,
    defaultMatchWidth: "wide",
    parsePatterns: Cd,
    defaultParseWidth: "any"
  }),
  quarter: $a({
    matchPatterns: $d,
    defaultMatchWidth: "wide",
    parsePatterns: Md,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: $a({
    matchPatterns: Sd,
    defaultMatchWidth: "wide",
    parsePatterns: Dd,
    defaultParseWidth: "any"
  }),
  day: $a({
    matchPatterns: zd,
    defaultMatchWidth: "wide",
    parsePatterns: Td,
    defaultParseWidth: "any"
  }),
  dayPeriod: $a({
    matchPatterns: Bd,
    defaultMatchWidth: "any",
    parsePatterns: Ld,
    defaultParseWidth: "any"
  })
}, Xr = {
  code: "en-US",
  formatDistance: ad,
  formatLong: od,
  formatRelative: id,
  localize: vd,
  match: Id,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
let Vd = {};
function wa() {
  return Vd;
}
function Kn(e) {
  const a = he(e), t = new Date(
    Date.UTC(
      a.getFullYear(),
      a.getMonth(),
      a.getDate(),
      a.getHours(),
      a.getMinutes(),
      a.getSeconds(),
      a.getMilliseconds()
    )
  );
  return t.setUTCFullYear(a.getFullYear()), +e - +t;
}
function Ad(e, a, t) {
  const [n, l] = Zr(
    t?.in,
    e,
    a
  ), o = Un(n), i = Un(l), h = +o - Kn(o), c = +i - Kn(i);
  return Math.round((h - c) / Zi);
}
function Hd(e, a) {
  const t = he(e, a?.in);
  return t.setFullYear(t.getFullYear(), 0, 1), t.setHours(0, 0, 0, 0), t;
}
function Od(e, a) {
  const t = he(e, a?.in);
  return Ad(t, Hd(t)) + 1;
}
function Zt(e, a) {
  const t = wa(), n = a?.weekStartsOn ?? a?.locale?.options?.weekStartsOn ?? t.weekStartsOn ?? t.locale?.options?.weekStartsOn ?? 0, l = he(e, a?.in), o = l.getDay(), i = (o < n ? 7 : 0) + o - n;
  return l.setDate(l.getDate() - i), l.setHours(0, 0, 0, 0), l;
}
function ba(e, a) {
  return Zt(e, { ...a, weekStartsOn: 1 });
}
function Jr(e, a) {
  const t = he(e, a?.in), n = t.getFullYear(), l = De(t, 0);
  l.setFullYear(n + 1, 0, 4), l.setHours(0, 0, 0, 0);
  const o = ba(l), i = De(t, 0);
  i.setFullYear(n, 0, 4), i.setHours(0, 0, 0, 0);
  const h = ba(i);
  return t.getTime() >= o.getTime() ? n + 1 : t.getTime() >= h.getTime() ? n : n - 1;
}
function Pd(e, a) {
  const t = Jr(e, a), n = De(e, 0);
  return n.setFullYear(t, 0, 4), n.setHours(0, 0, 0, 0), ba(n);
}
function _r(e, a) {
  const t = he(e, a?.in), n = +ba(t) - +Pd(t);
  return Math.round(n / Kr) + 1;
}
function Rl(e, a) {
  const t = he(e, a?.in), n = t.getFullYear(), l = wa(), o = a?.firstWeekContainsDate ?? a?.locale?.options?.firstWeekContainsDate ?? l.firstWeekContainsDate ?? l.locale?.options?.firstWeekContainsDate ?? 1, i = De(a?.in || e, 0);
  i.setFullYear(n + 1, 0, o), i.setHours(0, 0, 0, 0);
  const h = Zt(i, a), c = De(a?.in || e, 0);
  c.setFullYear(n, 0, o), c.setHours(0, 0, 0, 0);
  const f = Zt(c, a);
  return +t >= +h ? n + 1 : +t >= +f ? n : n - 1;
}
function Fd(e, a) {
  const t = wa(), n = a?.firstWeekContainsDate ?? a?.locale?.options?.firstWeekContainsDate ?? t.firstWeekContainsDate ?? t.locale?.options?.firstWeekContainsDate ?? 1, l = Rl(e, a), o = De(a?.in || e, 0);
  return o.setFullYear(l, 0, n), o.setHours(0, 0, 0, 0), Zt(o, a);
}
function eo(e, a) {
  const t = he(e, a?.in), n = +Zt(t, a) - +Fd(t, a);
  return Math.round(n / Kr) + 1;
}
function Ce(e, a) {
  const t = e < 0 ? "-" : "", n = Math.abs(e).toString().padStart(a, "0");
  return t + n;
}
const qt = {
  // Year
  y(e, a) {
    const t = e.getFullYear(), n = t > 0 ? t : 1 - t;
    return Ce(a === "yy" ? n % 100 : n, a.length);
  },
  // Month
  M(e, a) {
    const t = e.getMonth();
    return a === "M" ? String(t + 1) : Ce(t + 1, 2);
  },
  // Day of the month
  d(e, a) {
    return Ce(e.getDate(), a.length);
  },
  // AM or PM
  a(e, a) {
    const t = e.getHours() / 12 >= 1 ? "pm" : "am";
    switch (a) {
      case "a":
      case "aa":
        return t.toUpperCase();
      case "aaa":
        return t;
      case "aaaaa":
        return t[0];
      default:
        return t === "am" ? "a.m." : "p.m.";
    }
  },
  // Hour [1-12]
  h(e, a) {
    return Ce(e.getHours() % 12 || 12, a.length);
  },
  // Hour [0-23]
  H(e, a) {
    return Ce(e.getHours(), a.length);
  },
  // Minute
  m(e, a) {
    return Ce(e.getMinutes(), a.length);
  },
  // Second
  s(e, a) {
    return Ce(e.getSeconds(), a.length);
  },
  // Fraction of second
  S(e, a) {
    const t = a.length, n = e.getMilliseconds(), l = Math.trunc(
      n * Math.pow(10, t - 3)
    );
    return Ce(l, a.length);
  }
}, da = {
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
}, ur = {
  // Era
  G: function(e, a, t) {
    const n = e.getFullYear() > 0 ? 1 : 0;
    switch (a) {
      // AD, BC
      case "G":
      case "GG":
      case "GGG":
        return t.era(n, { width: "abbreviated" });
      // A, B
      case "GGGGG":
        return t.era(n, { width: "narrow" });
      default:
        return t.era(n, { width: "wide" });
    }
  },
  // Year
  y: function(e, a, t) {
    if (a === "yo") {
      const n = e.getFullYear(), l = n > 0 ? n : 1 - n;
      return t.ordinalNumber(l, { unit: "year" });
    }
    return qt.y(e, a);
  },
  // Local week-numbering year
  Y: function(e, a, t, n) {
    const l = Rl(e, n), o = l > 0 ? l : 1 - l;
    if (a === "YY") {
      const i = o % 100;
      return Ce(i, 2);
    }
    return a === "Yo" ? t.ordinalNumber(o, { unit: "year" }) : Ce(o, a.length);
  },
  // ISO week-numbering year
  R: function(e, a) {
    const t = Jr(e);
    return Ce(t, a.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function(e, a) {
    const t = e.getFullYear();
    return Ce(t, a.length);
  },
  // Quarter
  Q: function(e, a, t) {
    const n = Math.ceil((e.getMonth() + 1) / 3);
    switch (a) {
      // 1, 2, 3, 4
      case "Q":
        return String(n);
      // 01, 02, 03, 04
      case "QQ":
        return Ce(n, 2);
      // 1st, 2nd, 3rd, 4th
      case "Qo":
        return t.ordinalNumber(n, { unit: "quarter" });
      // Q1, Q2, Q3, Q4
      case "QQQ":
        return t.quarter(n, {
          width: "abbreviated",
          context: "formatting"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "QQQQQ":
        return t.quarter(n, {
          width: "narrow",
          context: "formatting"
        });
      default:
        return t.quarter(n, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone quarter
  q: function(e, a, t) {
    const n = Math.ceil((e.getMonth() + 1) / 3);
    switch (a) {
      // 1, 2, 3, 4
      case "q":
        return String(n);
      // 01, 02, 03, 04
      case "qq":
        return Ce(n, 2);
      // 1st, 2nd, 3rd, 4th
      case "qo":
        return t.ordinalNumber(n, { unit: "quarter" });
      // Q1, Q2, Q3, Q4
      case "qqq":
        return t.quarter(n, {
          width: "abbreviated",
          context: "standalone"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "qqqqq":
        return t.quarter(n, {
          width: "narrow",
          context: "standalone"
        });
      default:
        return t.quarter(n, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Month
  M: function(e, a, t) {
    const n = e.getMonth();
    switch (a) {
      case "M":
      case "MM":
        return qt.M(e, a);
      // 1st, 2nd, ..., 12th
      case "Mo":
        return t.ordinalNumber(n + 1, { unit: "month" });
      // Jan, Feb, ..., Dec
      case "MMM":
        return t.month(n, {
          width: "abbreviated",
          context: "formatting"
        });
      // J, F, ..., D
      case "MMMMM":
        return t.month(n, {
          width: "narrow",
          context: "formatting"
        });
      default:
        return t.month(n, { width: "wide", context: "formatting" });
    }
  },
  // Stand-alone month
  L: function(e, a, t) {
    const n = e.getMonth();
    switch (a) {
      // 1, 2, ..., 12
      case "L":
        return String(n + 1);
      // 01, 02, ..., 12
      case "LL":
        return Ce(n + 1, 2);
      // 1st, 2nd, ..., 12th
      case "Lo":
        return t.ordinalNumber(n + 1, { unit: "month" });
      // Jan, Feb, ..., Dec
      case "LLL":
        return t.month(n, {
          width: "abbreviated",
          context: "standalone"
        });
      // J, F, ..., D
      case "LLLLL":
        return t.month(n, {
          width: "narrow",
          context: "standalone"
        });
      default:
        return t.month(n, { width: "wide", context: "standalone" });
    }
  },
  // Local week of year
  w: function(e, a, t, n) {
    const l = eo(e, n);
    return a === "wo" ? t.ordinalNumber(l, { unit: "week" }) : Ce(l, a.length);
  },
  // ISO week of year
  I: function(e, a, t) {
    const n = _r(e);
    return a === "Io" ? t.ordinalNumber(n, { unit: "week" }) : Ce(n, a.length);
  },
  // Day of the month
  d: function(e, a, t) {
    return a === "do" ? t.ordinalNumber(e.getDate(), { unit: "date" }) : qt.d(e, a);
  },
  // Day of year
  D: function(e, a, t) {
    const n = Od(e);
    return a === "Do" ? t.ordinalNumber(n, { unit: "dayOfYear" }) : Ce(n, a.length);
  },
  // Day of week
  E: function(e, a, t) {
    const n = e.getDay();
    switch (a) {
      // Tue
      case "E":
      case "EE":
      case "EEE":
        return t.day(n, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "EEEEE":
        return t.day(n, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "EEEEEE":
        return t.day(n, {
          width: "short",
          context: "formatting"
        });
      default:
        return t.day(n, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Local day of week
  e: function(e, a, t, n) {
    const l = e.getDay(), o = (l - n.weekStartsOn + 8) % 7 || 7;
    switch (a) {
      // Numerical value (Nth day of week with current locale or weekStartsOn)
      case "e":
        return String(o);
      // Padded numerical value
      case "ee":
        return Ce(o, 2);
      // 1st, 2nd, ..., 7th
      case "eo":
        return t.ordinalNumber(o, { unit: "day" });
      case "eee":
        return t.day(l, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "eeeee":
        return t.day(l, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "eeeeee":
        return t.day(l, {
          width: "short",
          context: "formatting"
        });
      default:
        return t.day(l, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone local day of week
  c: function(e, a, t, n) {
    const l = e.getDay(), o = (l - n.weekStartsOn + 8) % 7 || 7;
    switch (a) {
      // Numerical value (same as in `e`)
      case "c":
        return String(o);
      // Padded numerical value
      case "cc":
        return Ce(o, a.length);
      // 1st, 2nd, ..., 7th
      case "co":
        return t.ordinalNumber(o, { unit: "day" });
      case "ccc":
        return t.day(l, {
          width: "abbreviated",
          context: "standalone"
        });
      // T
      case "ccccc":
        return t.day(l, {
          width: "narrow",
          context: "standalone"
        });
      // Tu
      case "cccccc":
        return t.day(l, {
          width: "short",
          context: "standalone"
        });
      default:
        return t.day(l, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // ISO day of week
  i: function(e, a, t) {
    const n = e.getDay(), l = n === 0 ? 7 : n;
    switch (a) {
      // 2
      case "i":
        return String(l);
      // 02
      case "ii":
        return Ce(l, a.length);
      // 2nd
      case "io":
        return t.ordinalNumber(l, { unit: "day" });
      // Tue
      case "iii":
        return t.day(n, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "iiiii":
        return t.day(n, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "iiiiii":
        return t.day(n, {
          width: "short",
          context: "formatting"
        });
      default:
        return t.day(n, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM or PM
  a: function(e, a, t) {
    const l = e.getHours() / 12 >= 1 ? "pm" : "am";
    switch (a) {
      case "a":
      case "aa":
        return t.dayPeriod(l, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return t.dayPeriod(l, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return t.dayPeriod(l, {
          width: "narrow",
          context: "formatting"
        });
      default:
        return t.dayPeriod(l, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM, PM, midnight, noon
  b: function(e, a, t) {
    const n = e.getHours();
    let l;
    switch (n === 12 ? l = da.noon : n === 0 ? l = da.midnight : l = n / 12 >= 1 ? "pm" : "am", a) {
      case "b":
      case "bb":
        return t.dayPeriod(l, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return t.dayPeriod(l, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return t.dayPeriod(l, {
          width: "narrow",
          context: "formatting"
        });
      default:
        return t.dayPeriod(l, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function(e, a, t) {
    const n = e.getHours();
    let l;
    switch (n >= 17 ? l = da.evening : n >= 12 ? l = da.afternoon : n >= 4 ? l = da.morning : l = da.night, a) {
      case "B":
      case "BB":
      case "BBB":
        return t.dayPeriod(l, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return t.dayPeriod(l, {
          width: "narrow",
          context: "formatting"
        });
      default:
        return t.dayPeriod(l, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Hour [1-12]
  h: function(e, a, t) {
    if (a === "ho") {
      let n = e.getHours() % 12;
      return n === 0 && (n = 12), t.ordinalNumber(n, { unit: "hour" });
    }
    return qt.h(e, a);
  },
  // Hour [0-23]
  H: function(e, a, t) {
    return a === "Ho" ? t.ordinalNumber(e.getHours(), { unit: "hour" }) : qt.H(e, a);
  },
  // Hour [0-11]
  K: function(e, a, t) {
    const n = e.getHours() % 12;
    return a === "Ko" ? t.ordinalNumber(n, { unit: "hour" }) : Ce(n, a.length);
  },
  // Hour [1-24]
  k: function(e, a, t) {
    let n = e.getHours();
    return n === 0 && (n = 24), a === "ko" ? t.ordinalNumber(n, { unit: "hour" }) : Ce(n, a.length);
  },
  // Minute
  m: function(e, a, t) {
    return a === "mo" ? t.ordinalNumber(e.getMinutes(), { unit: "minute" }) : qt.m(e, a);
  },
  // Second
  s: function(e, a, t) {
    return a === "so" ? t.ordinalNumber(e.getSeconds(), { unit: "second" }) : qt.s(e, a);
  },
  // Fraction of second
  S: function(e, a) {
    return qt.S(e, a);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(e, a, t) {
    const n = e.getTimezoneOffset();
    if (n === 0)
      return "Z";
    switch (a) {
      // Hours and optional minutes
      case "X":
        return fr(n);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XX`
      case "XXXX":
      case "XX":
        return ea(n);
      // Hours and minutes with `:` delimiter
      default:
        return ea(n, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(e, a, t) {
    const n = e.getTimezoneOffset();
    switch (a) {
      // Hours and optional minutes
      case "x":
        return fr(n);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xx`
      case "xxxx":
      case "xx":
        return ea(n);
      // Hours and minutes with `:` delimiter
      default:
        return ea(n, ":");
    }
  },
  // Timezone (GMT)
  O: function(e, a, t) {
    const n = e.getTimezoneOffset();
    switch (a) {
      // Short
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + cr(n, ":");
      default:
        return "GMT" + ea(n, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(e, a, t) {
    const n = e.getTimezoneOffset();
    switch (a) {
      // Short
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + cr(n, ":");
      default:
        return "GMT" + ea(n, ":");
    }
  },
  // Seconds timestamp
  t: function(e, a, t) {
    const n = Math.trunc(+e / 1e3);
    return Ce(n, a.length);
  },
  // Milliseconds timestamp
  T: function(e, a, t) {
    return Ce(+e, a.length);
  }
};
function cr(e, a = "") {
  const t = e > 0 ? "-" : "+", n = Math.abs(e), l = Math.trunc(n / 60), o = n % 60;
  return o === 0 ? t + String(l) : t + String(l) + a + Ce(o, 2);
}
function fr(e, a) {
  return e % 60 === 0 ? (e > 0 ? "-" : "+") + Ce(Math.abs(e) / 60, 2) : ea(e, a);
}
function ea(e, a = "") {
  const t = e > 0 ? "-" : "+", n = Math.abs(e), l = Ce(Math.trunc(n / 60), 2), o = Ce(n % 60, 2);
  return t + l + a + o;
}
const hr = (e, a) => {
  switch (e) {
    case "P":
      return a.date({ width: "short" });
    case "PP":
      return a.date({ width: "medium" });
    case "PPP":
      return a.date({ width: "long" });
    default:
      return a.date({ width: "full" });
  }
}, to = (e, a) => {
  switch (e) {
    case "p":
      return a.time({ width: "short" });
    case "pp":
      return a.time({ width: "medium" });
    case "ppp":
      return a.time({ width: "long" });
    default:
      return a.time({ width: "full" });
  }
}, Ed = (e, a) => {
  const t = e.match(/(P+)(p+)?/) || [], n = t[1], l = t[2];
  if (!l)
    return hr(e, a);
  let o;
  switch (n) {
    case "P":
      o = a.dateTime({ width: "short" });
      break;
    case "PP":
      o = a.dateTime({ width: "medium" });
      break;
    case "PPP":
      o = a.dateTime({ width: "long" });
      break;
    default:
      o = a.dateTime({ width: "full" });
      break;
  }
  return o.replace("{{date}}", hr(n, a)).replace("{{time}}", to(l, a));
}, bl = {
  p: to,
  P: Ed
}, Rd = /^D+$/, Nd = /^Y+$/, Wd = ["D", "DD", "YY", "YYYY"];
function ao(e) {
  return Rd.test(e);
}
function no(e) {
  return Nd.test(e);
}
function pl(e, a, t) {
  const n = qd(e, a, t);
  if (console.warn(n), Wd.includes(e)) throw new RangeError(n);
}
function qd(e, a, t) {
  const n = e[0] === "Y" ? "years" : "days of the month";
  return `Use \`${e.toLowerCase()}\` instead of \`${e}\` (in \`${a}\`) for formatting ${n} to the input \`${t}\`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md`;
}
function lo(e) {
  return !(!_e(e) && typeof e != "number" || isNaN(+he(e)));
}
const Yd = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, jd = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, Gd = /^'([^]*?)'?$/, Ud = /''/g, Kd = /[a-zA-Z]/;
function Ye(e, a, t) {
  const n = wa(), l = t?.locale ?? n.locale ?? Xr, o = t?.firstWeekContainsDate ?? t?.locale?.options?.firstWeekContainsDate ?? n.firstWeekContainsDate ?? n.locale?.options?.firstWeekContainsDate ?? 1, i = t?.weekStartsOn ?? t?.locale?.options?.weekStartsOn ?? n.weekStartsOn ?? n.locale?.options?.weekStartsOn ?? 0, h = he(e, t?.in);
  if (!lo(h))
    throw new RangeError("Invalid time value");
  let c = a.match(jd).map((y) => {
    const m = y[0];
    if (m === "p" || m === "P") {
      const g = bl[m];
      return g(y, l.formatLong);
    }
    return y;
  }).join("").match(Yd).map((y) => {
    if (y === "''")
      return { isToken: !1, value: "'" };
    const m = y[0];
    if (m === "'")
      return { isToken: !1, value: Zd(y) };
    if (ur[m])
      return { isToken: !0, value: y };
    if (m.match(Kd))
      throw new RangeError(
        "Format string contains an unescaped latin alphabet character `" + m + "`"
      );
    return { isToken: !1, value: y };
  });
  l.localize.preprocessor && (c = l.localize.preprocessor(h, c));
  const f = {
    firstWeekContainsDate: o,
    weekStartsOn: i,
    locale: l
  };
  return c.map((y) => {
    if (!y.isToken) return y.value;
    const m = y.value;
    (!t?.useAdditionalWeekYearTokens && no(m) || !t?.useAdditionalDayOfYearTokens && ao(m)) && pl(m, a, String(e));
    const g = ur[m[0]];
    return g(h, m, l.localize, f);
  }).join("");
}
function Zd(e) {
  const a = e.match(Gd);
  return a ? a[1].replace(Ud, "'") : e;
}
const Qd = {
  "data-id": "sds-calendar",
  class: "select-none"
}, Xd = { key: 0 }, Jd = ["disabled"], _d = { class: "grow" }, eu = {
  key: 0,
  class: "hidden grow sm:block"
}, tu = ["disabled"], au = { class: "flex flex-col sm:flex-row sm:gap-8" }, nu = { class: "grid grid-cols-7 w-56 h-60 place-content-start" }, lu = ["disabled", "title", "onClick"], ru = {
  key: 0,
  class: "hidden sm:grid grid-cols-7 w- place-content-start"
}, ou = ["disabled", "title", "onClick"], su = { class: "mt-1" }, iu = { class: "text-sm text-gray-600 dark:text-gray-400 mb-2" }, du = { class: "flex gap-1" }, uu = { class: "w-full" }, cu = ["disabled"], fu = { class: "w-full" }, hu = ["disabled"], mu = { class: "w-full" }, gu = ["disabled"], vu = {
  key: 0,
  class: "border-t my-2 pt-2 dark:border-gray-700 w-56"
}, yu = { class: "text-sm text-gray-600 dark:text-gray-400 mb-2" }, bu = { class: "flex gap-1" }, pu = { class: "w-full" }, wu = ["disabled"], xu = { class: "w-full" }, ku = ["disabled"], Cu = { class: "w-full" }, $u = ["disabled"], Ba = /* @__PURE__ */ te({
  name: "SdsCalendar",
  __name: "Calendar",
  props: /* @__PURE__ */ xe({
    mode: { default: "date" },
    min: { default: null },
    max: { default: null },
    useCurrentTimeForToday: { type: Boolean, default: !1 },
    inputToChange: { default: void 0 }
  }, {
    modelValue: {
      type: [Object, Date],
      default: /* @__PURE__ */ new Date()
    },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(e) {
    const a = e, t = Te(e, "modelValue"), n = E(/* @__PURE__ */ new Date()), l = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"], o = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"], i = [...Array(200).keys()].map((ne) => ne + 1900), h = M(() => Ye(n.value, "MMMM")), c = M(() => Ye(n.value, "yyyy")), f = M(() => ir(ia(n.value)) + 1), y = M(() => sr(n.value)), m = E(jt(n.value, 1)), g = M(() => Ye(m.value, "MMMM")), v = M(() => Ye(m.value, "yyyy")), C = M(() => ir(ia(m.value)) + 1), k = M(() => sr(m.value)), w = E("days"), x = E(null), I = E(null), L = () => {
      x.value = Ye(n.value, "MMMM"), I.value = Ye(n.value, "yyyy");
    };
    ye(() => w.value, () => {
      L();
    });
    const z = M(() => a.mode === "date" || a.mode === "dateTime"), b = M(() => a.mode === "dateTime" || a.mode === "time"), $ = E(null), p = E(null), F = E(null), R = E(null), T = E(null), j = E(null);
    dt(async () => {
      X(), pe(), await Ie(), H();
    }), ye(() => t.value, () => {
      H();
    }, { deep: !0 });
    const X = () => {
      if (a.mode === "time" && (!t.value || !(t.value instanceof Date) && (!t.value.start || !t.value.end))) {
        const ne = Ae(Re(Ue(Ke(/* @__PURE__ */ new Date(), 0), 0), 0), 0);
        be.value ? t.value = {
          start: ne,
          end: ne
        } : t.value = ne;
      }
    }, pe = () => {
      t.value && !(t.value instanceof Date) && t.value.start instanceof Date ? n.value = t.value.start : t.value && t.value instanceof Date ? n.value = t.value : a.min && a.min instanceof Date && Gt(a.min, /* @__PURE__ */ new Date()) && (n.value = a.min), m.value = jt(n.value, 1);
    }, H = () => {
      be.value ? (t.value && !(t.value instanceof Date) && t.value.start instanceof Date ? ($.value = Xe(t.value.start, "hh"), p.value = Xe(t.value.start, "mm"), F.value = Lt(t.value.start) > 11 ? "pm" : "am") : ($.value = null, p.value = null, F.value = null), t.value && !(t.value instanceof Date) && t.value.end instanceof Date ? (R.value = Xe(t.value.end, "hh"), T.value = Xe(t.value.end, "mm"), j.value = Lt(t.value.end) > 11 ? "pm" : "am") : (R.value = null, T.value = null, j.value = null)) : t.value instanceof Date ? ($.value = Xe(t.value, "hh"), p.value = Xe(t.value, "mm"), F.value = Lt(t.value) > 11 ? "pm" : "am") : ($.value = null, p.value = null, F.value = null);
    }, Y = (ne, N, ue = !1) => {
      switch (ne) {
        case "hour":
          if (be.value) {
            if (!ue && t.value && !(t.value instanceof Date) && t.value.start instanceof Date) {
              const ge = Lt(t.value.start) > 12 ? parseInt(N) + 12 : parseInt(N);
              t.value.start = Ae(t.value.start, ge);
            } else if (ue && t.value && !(t.value instanceof Date) && t.value.end instanceof Date) {
              const ge = Lt(t.value.end) > 12 ? parseInt(N) + 12 : parseInt(N);
              t.value.end = Ae(t.value.end, ge);
            }
          } else if (t.value instanceof Date) {
            const ge = Lt(t.value) > 12 ? parseInt(N) + 12 : parseInt(N);
            t.value = Ae(t.value, ge);
          }
          break;
        case "minutes":
          be.value ? !ue && t.value && !(t.value instanceof Date) && t.value.start instanceof Date ? t.value.start = Re(t.value.start, parseInt(N)) : ue && t.value && !(t.value instanceof Date) && t.value.end instanceof Date && (t.value.end = Re(t.value.end, parseInt(N))) : t.value instanceof Date && (t.value = Re(t.value, parseInt(N)));
          break;
        case "meridian":
          if (be.value) {
            if (!ue && t.value && !(t.value instanceof Date) && t.value.start instanceof Date) {
              const ie = Lt(t.value.start), ge = N === "am" && ie >= 12 ? ie - 12 : N === "pm" && ie < 12 ? ie + 12 : ie;
              t.value.start = Ae(t.value.start, ge);
            } else if (ue && t.value && !(t.value instanceof Date) && t.value.end instanceof Date) {
              const ie = Lt(t.value.end), ge = N === "am" && ie >= 12 ? ie - 12 : N === "pm" && ie < 12 ? ie + 12 : ie;
              t.value.end = Ae(t.value.end, ge);
            }
          } else if (t.value instanceof Date) {
            const ie = Lt(t.value), ge = N === "am" && ie >= 12 ? ie - 12 : N === "pm" && ie < 12 ? ie + 12 : ie;
            t.value = Ae(t.value, ge);
          }
          break;
      }
      be.value && t.value && !(t.value instanceof Date) && t.value.start instanceof Date && t.value.end instanceof Date && (t.value = {
        start: Sa([t.value.start, t.value.end]),
        end: Da([t.value.start, t.value.end])
      });
    }, O = M(() => [...Array(12).keys()].map((N) => (N + 1).toLocaleString("en-US", {
      minimumIntegerDigits: 2,
      useGrouping: !1
    }))), _ = M(() => [...Array(60).keys()].map((N) => N.toLocaleString("en-US", {
      minimumIntegerDigits: 2,
      useGrouping: !1
    }))), oe = M(() => ["am", "pm"]), K = () => {
      n.value = dr(n.value), m.value = dr(m.value);
    }, de = () => {
      n.value = jt(n.value, 1), m.value = jt(m.value, 1);
    }, Me = () => {
      if (!x.value || !I.value) return;
      const ne = o.findIndex((N) => N === x.value) + 1;
      typeof ne == "number" && (n.value = new Date(parseInt(I.value), ne, 0, 0, 0, 0, 0), m.value = jt(n.value, 1), w.value = "days");
    }, Le = () => {
      n.value = /* @__PURE__ */ new Date(), m.value = jt(n.value, 1), w.value = "days";
    }, Ge = M(() => a.min instanceof Date ? Ma(ia(a.min), ia(n.value)) : !0), Fe = M(() => a.max instanceof Date ? Gt(ia(a.max), ia(n.value)) : !0), Xe = (ne, N) => Ye(ne, N), be = M(() => t.value && !_e(t.value)), Jt = async (ne, N = !1) => {
      const ue = N ? m.value : n.value;
      if (be.value && t.value && !(t.value instanceof Date))
        if (!t.value.start && !t.value.end)
          t.value = {
            start: a.useCurrentTimeForToday && Wt(ze(ue, ne)) ? /* @__PURE__ */ new Date() : Ae(Re(Ue(Ke(ze(ue, ne), 0), 0), 0), 0),
            end: null
          };
        else if (!t.value.start && t.value.end) {
          const ie = a.useCurrentTimeForToday && Wt(ze(ue, ne)) ? /* @__PURE__ */ new Date() : Ae(Re(Ue(Ke(ze(ue, ne), 0), 0), 0), 0);
          let ge = null, q = null;
          t.value.end && Ma(t.value.end, ie) ? (ge = t.value.end, q = ie) : (ge = ie, q = t.value.end), t.value = {
            start: ge,
            end: q
          };
        } else if (t.value.start && !t.value.end) {
          const ie = t.value.start;
          Yt(ie, ze(ue, ne)) ? t.value = {
            start: ie,
            end: Ae(Re(Ue(Ke(ze(ue, ne), 0), 0), 59), 23)
          } : t.value = {
            start: ie,
            end: a.useCurrentTimeForToday && Wt(ze(ue, ne)) ? /* @__PURE__ */ new Date() : Ae(Re(Ue(Ke(ze(ue, ne), 0), 0), 0), 0)
          };
        } else if (_e(t.value.start) && t.value.start instanceof Date && _e(t.value.end) && t.value.end instanceof Date) {
          const ie = Sa([t.value.start, t.value.end]), ge = Da([t.value.start, t.value.end]), q = Ae(Re(Ue(Ke(ie, 0), 0), 0), 0), Pt = Ae(Re(Ue(Ke(ge, 0), 0), 0), 0), bt = ze(ue, ne), Z = Ae(Re(Ue(Ke(bt, 0), 0), 0), 0);
          if (Z.valueOf() === Pt.valueOf())
            t.value = {
              start: ie,
              end: null
            };
          else if (Z.valueOf() === q.valueOf())
            t.value = {
              start: null,
              end: ge
            };
          else if (Ma(bt, ie))
            t.value = {
              start: a.useCurrentTimeForToday && Wt(ze(ue, ne)) ? /* @__PURE__ */ new Date() : Z,
              end: ge
            };
          else if (Gt(bt, ie))
            if (a.inputToChange === "start") {
              const se = a.useCurrentTimeForToday && Wt(ze(ue, ne)) ? /* @__PURE__ */ new Date() : Z;
              if (Gt(se, t.value.end)) {
                const Ee = t.value.start;
                t.value = {
                  start: Ee,
                  end: se
                };
              } else {
                const Ee = t.value.end;
                t.value = {
                  start: Sa([se, Ee]),
                  end: Da([se, Ee])
                };
              }
            } else
              t.value = {
                start: ie,
                end: a.useCurrentTimeForToday && Wt(ze(ue, ne)) ? /* @__PURE__ */ new Date() : Z
              };
          else
            t.value = {
              start: ie,
              end: a.useCurrentTimeForToday && Wt(ze(ue, ne)) ? /* @__PURE__ */ new Date() : Z
            };
        } else {
          const ie = t.value.start;
          t.value = {
            start: ie,
            end: Ae(Re(Ue(Ke(ze(ue, ne), 0), 0), 0), 0)
          };
        }
      else
        t.value = a.useCurrentTimeForToday && Wt(ze(ue, ne)) ? /* @__PURE__ */ new Date() : Ae(Re(Ue(Ke(ze(ue, ne), 0), 0), 0), 0);
      if (await Ie(), !(t.value instanceof Date) && t.value.start instanceof Date && t.value.end instanceof Date) {
        const ie = Sa([t.value.start, t.value.end]), ge = Da([t.value.start, t.value.end]);
        t.value.start = ie, t.value.end = ge;
      }
    }, ra = (ne, N = !1) => {
      if (!(a.min instanceof Date)) return !1;
      const ue = N ? m.value : n.value;
      return Ma(ze(ue, ne), Ae(Re(Ue(Ke(a.min, 0), 0), 0), 0));
    }, at = (ne, N = !1) => {
      if (!(a.max instanceof Date)) return !1;
      const ue = N ? m.value : n.value, ie = ze(ue, ne - 1), ge = Ae(Re(Ue(Ke(a.max, 0), 0), 0), 0);
      return Gt(ie, ge) || Qr(ie, ge);
    }, ut = (ne, N = !1) => ra(ne, N) || at(ne, N), qe = (ne, N = !1) => {
      const ue = N ? m.value : n.value;
      return t.value && !(t.value instanceof Date) && _e(t.value.start) && t.value.start instanceof Date && _e(t.value.end) && t.value.end instanceof Date ? ed(
        ze(ue, ne),
        { start: t.value.start, end: t.value.end }
      ) : !1;
    }, Je = (ne, N = !1) => {
      const ue = N ? m.value : n.value;
      return t.value && !(t.value instanceof Date) && _e(t.value.start) && t.value.start instanceof Date && _e(t.value.end) && t.value.end instanceof Date ? Yt(ze(ue, ne), t.value.start) : !1;
    }, Ht = (ne, N = !1) => {
      const ue = N ? m.value : n.value;
      return t.value && !(t.value instanceof Date) && _e(t.value.start) && t.value.start instanceof Date && _e(t.value.end) && t.value.end instanceof Date ? Yt(ze(ue, ne), t.value.end) : !1;
    }, rt = (ne, N = !1) => {
      if (t.value) {
        if (_e(t.value) && t.value instanceof Date) {
          const ue = N ? m.value : n.value;
          return Yt(ze(ue, ne), t.value);
        } else if (!(t.value instanceof Date) && (_e(t.value.start) && t.value.start instanceof Date || _e(t.value.end) && t.value.end instanceof Date)) {
          const ue = N ? m.value : n.value;
          return _e(t.value.start) && t.value.start instanceof Date && Yt(ze(ue, ne), t.value.start) || _e(t.value.end) && t.value.end instanceof Date && Yt(ze(ue, ne), t.value.end);
        }
      } else return !1;
    }, Ot = (ne, N = !1) => {
      const ue = N ? m.value : n.value;
      return Yt(ze(ue, ne), /* @__PURE__ */ new Date());
    };
    return (ne, N) => {
      const ue = Ki, ie = ll, ge = Ur;
      return s(), u("div", Qd, [
        r(z) ? (s(), u("div", Xd, [
          r(w) === "days" ? (s(), u(J, { key: 0 }, [
            d("div", {
              class: D(["flex relative gap-1 mb-2 w-56", { "sm:w-120": r(be) }])
            }, [
              d("button", {
                class: "absolute left-0 top-0 text-gray-700 dark:text-gray-300 p-1 hover:bg-gray-100 dark:hover:bg-gray-750 rounded-sm disabled:pointer-events-none disabled:opacity-50",
                type: "button",
                tabindex: "-1",
                disabled: !r(Ge),
                onClick: K
              }, [
                N[19] || (N[19] = d("span", { class: "sr-only" }, "Go to previous month", -1)),
                Q(ue, { class: "w-5 h-5" })
              ], 8, Jd),
              d("div", _d, [
                d("button", {
                  class: "m-auto text-lg font-semibold flex gap-1 text-gray-900 hover:text-gray-500 dark:text-gray-100",
                  type: "button",
                  tabindex: "-1",
                  onClick: N[0] || (N[0] = (q) => w.value = "years")
                }, [
                  d("span", null, A(r(h)) + " " + A(r(c)), 1)
                ])
              ]),
              r(be) ? (s(), u("div", eu, [
                d("button", {
                  class: "m-auto text-lg font-semibold flex gap-1 text-gray-900 hover:text-gray-500 dark:text-gray-100",
                  type: "button",
                  tabindex: "-1",
                  onClick: N[1] || (N[1] = (q) => w.value = "years")
                }, [
                  d("span", null, A(r(g)) + " " + A(r(v)), 1)
                ])
              ])) : S("", !0),
              d("button", {
                class: "absolute right-0 top-0 text-gray-700 dark:text-gray-300 p-1 hover:bg-gray-100 dark:hover:bg-gray-750 rounded-sm disabled:pointer-events-none disabled:opacity-50",
                type: "button",
                tabindex: "-1",
                disabled: !r(Fe),
                onClick: de
              }, [
                N[20] || (N[20] = d("span", { class: "sr-only" }, "Go to next month", -1)),
                Q(ie, { class: "w-5 h-5" })
              ], 8, tu)
            ], 2),
            d("div", au, [
              d("div", nu, [
                (s(), u(J, null, le(l, (q) => d("div", {
                  key: q,
                  class: "text-sm font-bold text-gray-400 text-center uppercase mb-1"
                }, A(q.charAt(0)), 1)), 64)),
                (s(!0), u(J, null, le(r(y), (q) => (s(), u("div", {
                  key: q,
                  class: D([
                    "w-8 h-8 mb-1",
                    q === 1 ? `col-start-${r(f)}` : "",
                    qe(q) ? "bg-blue-25 dark:bg-blue-900" : "",
                    Je(q) ? "bg-blue-25 dark:bg-blue-900 rounded-l-full" : "",
                    Ht(q) ? "bg-blue-25 dark:bg-blue-900 rounded-r-full" : ""
                  ])
                }, [
                  d("button", {
                    class: D(["disabled:pointer-events-none disabled:opacity-25", {
                      "px-2 py-1 w-8 h-8 rounded-full sds-theme-plaid:rounded-none text-sm": !0,
                      "hover:bg-gray-100 dark:hover:bg-gray-750": !rt(q),
                      "font-bold bg-blue-500 dark:bg-blue-700 text-white": rt(q),
                      "font-bold text-blue-500 bg-gray-100 dark:text-blue-100 dark:bg-gray-850": Ot(q) && !rt(q) && !qe(q),
                      "font-semibold text-blue-900 dark:text-blue-100": qe(q) && !rt(q)
                    }]),
                    type: "button",
                    tabindex: "-1",
                    disabled: ut(q),
                    title: Ot(q) ? "Today" : "",
                    onClick: (Pt) => Jt(q)
                  }, A(q), 11, lu)
                ], 2))), 128))
              ]),
              r(be) ? (s(), u("div", ru, [
                (s(), u(J, null, le(l, (q) => d("div", {
                  key: q,
                  class: "text-sm font-bold text-gray-400 text-center uppercase mb-1"
                }, A(q.charAt(0)), 1)), 64)),
                (s(!0), u(J, null, le(r(k), (q) => (s(), u("div", {
                  key: q,
                  class: D([
                    "w-8 h-8 mb-1",
                    q === 1 ? `col-start-${r(C)}` : "",
                    qe(q, !0) ? "bg-blue-25 dark:bg-blue-900" : "",
                    Je(q, !0) ? "bg-blue-25 dark:bg-blue-900 rounded-l-full" : "",
                    Ht(q, !0) ? "bg-blue-25 dark:bg-blue-900 rounded-r-full" : ""
                  ])
                }, [
                  d("button", {
                    class: D(["disabled:pointer-events-none disabled:opacity-25", {
                      "px-2 py-1 w-8 h-8 rounded-full sds-theme-plaid:rounded-none text-sm": !0,
                      "hover:bg-gray-100 dark:hover:bg-gray-750": !rt(q, !0),
                      "font-bold bg-blue-500 dark:bg-blue-700 text-white": rt(q, !0),
                      "font-bold text-blue-500 bg-gray-100 dark:text-blue-400 dark:bg-gray-100": Ot(q, !0) && !rt(q, !0) && !qe(q, !0),
                      "font-semibold text-blue-900 dark:text-blue-100": qe(q, !0) && !rt(q, !0)
                    }]),
                    type: "button",
                    tabindex: "-1",
                    disabled: ut(q, !0),
                    title: Ot(q, !0) ? "Today" : "",
                    onClick: (Pt) => Jt(q, !0)
                  }, A(q), 11, ou)
                ], 2))), 128))
              ])) : S("", !0)
            ])
          ], 64)) : (s(), u("div", {
            key: 1,
            class: D(["grid gap-1 w-56", { "sm:w-120": r(be) }])
          }, [
            d("div", null, [
              N[22] || (N[22] = d("div", { class: "mb-1 text-sm uppercase font-semibold text-gray-500" }, " Month ", -1)),
              d("label", null, [
                N[21] || (N[21] = d("span", { class: "sr-only" }, "Month", -1)),
                Ze(d("select", {
                  "onUpdate:modelValue": N[2] || (N[2] = (q) => Ne(x) ? x.value = q : null),
                  class: "form-control form-control-sm"
                }, [
                  (s(), u(J, null, le(o, (q) => d("option", { key: q }, A(q), 1)), 64))
                ], 512), [
                  [It, r(x)]
                ])
              ])
            ]),
            d("div", su, [
              N[24] || (N[24] = d("div", { class: "mb-1 text-sm uppercase font-semibold text-gray-500" }, " Year ", -1)),
              d("label", null, [
                N[23] || (N[23] = d("span", { class: "sr-only" }, "Year", -1)),
                Ze(d("select", {
                  "onUpdate:modelValue": N[3] || (N[3] = (q) => Ne(I) ? I.value = q : null),
                  class: "form-control form-control-sm"
                }, [
                  (s(!0), u(J, null, le(r(i), (q) => (s(), u("option", { key: q }, A(q), 1))), 128))
                ], 512), [
                  [It, r(I)]
                ])
              ])
            ]),
            d("button", {
              class: "mt-2 btn btn-primary btn-sm",
              type: "button",
              tabindex: "-1",
              onClick: N[4] || (N[4] = (q) => Me())
            }, " Go to Date "),
            d("button", {
              class: "mt-2 btn btn-secondary btn-sm",
              type: "button",
              tabindex: "-1",
              onClick: N[5] || (N[5] = (q) => Le())
            }, " Go to Today "),
            N[25] || (N[25] = d("hr", { class: "my-2" }, null, -1)),
            d("button", {
              class: "btn btn-secondary btn-sm",
              type: "button",
              tabindex: "-1",
              onClick: N[6] || (N[6] = (q) => w.value = "days")
            }, " Cancel ")
          ], 2))
        ])) : S("", !0),
        r(b) && r(w) === "days" ? (s(), u("div", {
          key: 1,
          class: D({ "sm:flex sm:gap-8 sm:w-120": r(z) && r(be) })
        }, [
          d("div", {
            class: D(["w-56", { "border-t my-2 pt-2 dark:border-gray-700": r(z) }])
          }, [
            d("div", iu, [
              t.value && t.value instanceof Date ? (s(), u(J, { key: 0 }, [
                re(A(Xe(t.value, "eeee, MMM dd, yyyy")), 1)
              ], 64)) : t.value && !(t.value instanceof Date) && t.value.start instanceof Date ? (s(), u(J, { key: 1 }, [
                re(A(Xe(t.value.start, "eeee, MMM dd, yyyy")), 1)
              ], 64)) : (s(), u(J, { key: 2 }, [
                re(" -- ")
              ], 64))
            ]),
            d("div", du, [
              Q(ge, { class: "-ml-0.5 my-auto shrink-0 w-5 h-5 text-gray-700 dark:text-gray-300" }),
              d("label", uu, [
                N[26] || (N[26] = d("span", { class: "sr-only" }, "Hour", -1)),
                Ze(d("select", {
                  "onUpdate:modelValue": N[7] || (N[7] = (q) => Ne($) ? $.value = q : null),
                  disabled: !r($),
                  class: "form-control form-control-sm",
                  onChange: N[8] || (N[8] = (q) => Y("hour", q.target.value))
                }, [
                  (s(!0), u(J, null, le(r(O), (q) => (s(), u("option", { key: q }, A(q), 1))), 128))
                ], 40, cu), [
                  [It, r($)]
                ])
              ]),
              N[29] || (N[29] = d("span", { class: "my-auto" }, ":", -1)),
              d("label", fu, [
                N[27] || (N[27] = d("span", { class: "sr-only" }, "Minutes", -1)),
                Ze(d("select", {
                  "onUpdate:modelValue": N[9] || (N[9] = (q) => Ne(p) ? p.value = q : null),
                  disabled: !r(p),
                  class: "form-control form-control-sm",
                  onChange: N[10] || (N[10] = (q) => Y("minutes", q.target.value))
                }, [
                  (s(!0), u(J, null, le(r(_), (q) => (s(), u("option", { key: q }, A(q), 1))), 128))
                ], 40, hu), [
                  [It, r(p)]
                ])
              ]),
              d("label", mu, [
                N[28] || (N[28] = d("span", { class: "sr-only" }, "Meridian", -1)),
                Ze(d("select", {
                  "onUpdate:modelValue": N[11] || (N[11] = (q) => Ne(F) ? F.value = q : null),
                  disabled: !r(F),
                  class: "form-control form-control-sm",
                  onChange: N[12] || (N[12] = (q) => Y("meridian", q.target.value))
                }, [
                  (s(!0), u(J, null, le(r(oe), (q) => (s(), u("option", { key: q }, A(q), 1))), 128))
                ], 40, gu), [
                  [It, r(F)]
                ])
              ])
            ])
          ], 2),
          r(be) ? (s(), u("div", vu, [
            d("div", yu, [
              t.value && !(t.value instanceof Date) && t.value.end instanceof Date ? (s(), u(J, { key: 0 }, [
                re(A(Xe(t.value.end, "eeee, MMM dd, yyyy")), 1)
              ], 64)) : (s(), u(J, { key: 1 }, [
                re(" -- ")
              ], 64))
            ]),
            d("div", bu, [
              Q(ge, { class: "-ml-0.5 my-auto shrink-0 w-5 h-5 text-gray-700 dark:text-gray-300" }),
              d("label", pu, [
                N[30] || (N[30] = d("span", { class: "sr-only" }, "Hour", -1)),
                Ze(d("select", {
                  "onUpdate:modelValue": N[13] || (N[13] = (q) => Ne(R) ? R.value = q : null),
                  disabled: !r(R),
                  class: "form-control form-control-sm",
                  onChange: N[14] || (N[14] = (q) => Y("hour", q.target.value, !0))
                }, [
                  (s(!0), u(J, null, le(r(O), (q) => (s(), u("option", { key: q }, A(q), 1))), 128))
                ], 40, wu), [
                  [It, r(R)]
                ])
              ]),
              N[33] || (N[33] = d("span", { class: "my-auto" }, ":", -1)),
              d("label", xu, [
                N[31] || (N[31] = d("span", { class: "sr-only" }, "Minute", -1)),
                Ze(d("select", {
                  "onUpdate:modelValue": N[15] || (N[15] = (q) => Ne(T) ? T.value = q : null),
                  disabled: !r(T),
                  class: "form-control form-control-sm",
                  onChange: N[16] || (N[16] = (q) => Y("minutes", q.target.value, !0))
                }, [
                  (s(!0), u(J, null, le(r(_), (q) => (s(), u("option", { key: q }, A(q), 1))), 128))
                ], 40, ku), [
                  [It, r(T)]
                ])
              ]),
              d("label", Cu, [
                N[32] || (N[32] = d("span", { class: "sr-only" }, "Meridian", -1)),
                Ze(d("select", {
                  "onUpdate:modelValue": N[17] || (N[17] = (q) => Ne(j) ? j.value = q : null),
                  disabled: !r(j),
                  class: "form-control form-control-sm",
                  onChange: N[18] || (N[18] = (q) => Y("meridian", q.target.value, !0))
                }, [
                  (s(!0), u(J, null, le(r(oe), (q) => (s(), u("option", { key: q }, A(q), 1))), 128))
                ], 40, $u), [
                  [It, r(j)]
                ])
              ])
            ])
          ])) : S("", !0)
        ], 2)) : S("", !0)
      ]);
    };
  }
});
Ba.install = (e) => {
  e.component(Ba.name, Ba);
};
const Mu = {
  viewBox: "0 0 640 640",
  "aria-hidden": "true",
  role: "img",
  width: "1.2em",
  height: "1.2em"
};
function Su(e, a) {
  return s(), u("svg", Mu, [...a[0] || (a[0] = [
    d("path", {
      fill: "currentColor",
      d: "M183.1 137.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L275.2 320L137.9 457.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l137.3-137.4l137.4 137.3c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L365.8 320l137.3-137.4c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L320.5 274.7z"
    }, null, -1)
  ])]);
}
const xa = $e({ name: "fa7-solid-xmark", render: Su }), Du = { class: "flex items-top space-x-2" }, zu = { key: 0 }, Tu = { class: "flex flex-col" }, Bu = { class: "[&_a:not([class*='no-underline'])]:underline" }, Lu = {
  key: 1,
  class: "text-xs leading-4 opacity-90 italic"
}, Iu = {
  key: 1,
  class: "absolute top-2 right-2"
}, ln = /* @__PURE__ */ te({
  name: "SdsCallout",
  __name: "Callout",
  props: /* @__PURE__ */ xe({
    type: { default: "subtle" },
    variant: { default: "gray" },
    size: { default: "md" },
    title: { default: null },
    description: { default: null },
    timestamp: { default: null },
    dismissable: { type: Boolean, default: !1 },
    inset: { type: Boolean, default: !1 }
  }, {
    modelValue: { type: Boolean, type: Boolean, default: !1 },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(e) {
    const a = e, t = Te(e, "modelValue"), n = Qt(), l = M(() => {
      switch (a.variant) {
        case "gray":
          return a.type === "bold" ? "bg-gray-100 text-gray-900 dark:bg-gray-700 dark:text-white" : a.type === "outline" ? "bg-white border border-gray-900 text-gray-900 dark:bg-black dark:border-gray-300 dark:text-gray-300" : "border border-gray-900 bg-gray-25 text-gray-900 dark:border-gray-300 dark:bg-gray-900 dark:text-gray-300";
        case "orange":
          return a.type === "bold" ? "bg-orange-200 text-black dark:bg-orange-200 dark:text-black" : a.type === "outline" ? "bg-white border border-orange-300 text-orange-600 dark:bg-black dark:border-orange-300 dark:text-orange-300" : "border border-orange-300 bg-orange-25/40 text-orange-600 dark:border-orange-300 dark:bg-orange-900 dark:text-orange-300";
        case "red":
          return a.type === "bold" ? "bg-red-600 text-white dark:bg-red-500 dark:text-black" : a.type === "outline" ? "bg-white border border-red-600 text-red-600 dark:bg-black dark:border-red-300 dark:text-red-300" : "border border-red-600 bg-red-25 text-red-600 dark:border-red-300 dark:bg-red-950 dark:text-red-300";
        case "purple":
          return a.type === "bold" ? "bg-purple-600 text-white dark:bg-purple-500 dark:text-black" : a.type === "outline" ? "bg-white border border-purple-600 text-purple-600 dark:bg-black dark:border-purple-300 dark:text-purple-300" : "border border-purple-600 bg-purple-25/60 text-purple-600 dark:border-purple-300 dark:bg-purple-950 dark:text-purple-300";
        case "indigo":
          return a.type === "bold" ? "bg-indigo-600 text-white dark:bg-indigo-500 dark:text-black" : a.type === "outline" ? "bg-white border border-indigo-600 text-indigo-600 dark:bg-black dark:border-indigo-300 dark:text-indigo-300" : "border border-indigo-600 bg-indigo-25/60 text-indigo-600 dark:border-indigo-300 dark:bg-indigo-950 dark:text-indigo-300";
        case "blue":
          return a.type === "bold" ? "bg-blue-600 text-white dark:bg-blue-500 dark:text-black" : a.type === "outline" ? "bg-white border border-blue-600 text-blue-600 dark:bg-black dark:border-blue-300 dark:text-blue-300" : "border border-blue-600 bg-blue-25 text-blue-600 dark:border-blue-300 dark:bg-blue-950 dark:text-blue-300";
        case "teal":
          return a.type === "bold" ? "bg-teal-600 text-white dark:bg-teal-500 dark:text-black" : a.type === "outline" ? "bg-white border border-teal-600 text-teal-600 dark:bg-black dark:border-teal-300 dark:text-teal-300" : "border border-teal-600 bg-teal-25/60 text-teal-600 dark:border-teal-300 dark:bg-teal-900 dark:text-teal-300";
        case "green":
          return a.type === "bold" ? "bg-green-600 text-white dark:bg-green-500 dark:text-black" : a.type === "outline" ? "bg-white border border-green-600 text-green-600 dark:bg-black dark:border-green-300 dark:text-green-300" : "border border-green-600 bg-green-25/60 text-green-600 dark:border-green-300 dark:bg-green-900 dark:text-green-300";
        default:
          return a.type === "bold" ? "bg-gray-900 text-white dark:bg-gray-200 dark:text-black" : a.type === "outline" ? "bg-white border border-gray-900 text-gray-900 dark:bg-black dark:border-gray-300 dark:text-gray-300" : "border border-gray-900 bg-gray-25 text-gray-900 dark:border-gray-300 dark:bg-gray-900 dark:text-gray-300";
      }
    }), o = M(() => {
      switch (a.variant) {
        case "gray":
          return a.type === "bold" ? "fill-gray-900 dark:fill-white" : "fill-gray-900 dark:fill-gray-300";
        case "orange":
          return a.type === "bold" ? "fill-black dark:fill-black" : "fill-orange-600 dark:fill-orange-300";
        case "red":
          return a.type === "bold" ? "fill-white dark:fill-black" : "fill-red-600 dark:fill-red-300";
        case "purple":
          return a.type === "bold" ? "fill-white dark:fill-black" : "fill-purple-600 dark:fill-purple-300";
        case "indigo":
          return a.type === "bold" ? "fill-white dark:fill-black" : "fill-indigo-600 dark:fill-indigo-300";
        case "blue":
          return a.type === "bold" ? "fill-white dark:fill-black" : "fill-blue-600 dark:fill-blue-300";
        case "teal":
          return a.type === "bold" ? "fill-white dark:fill-black" : "fill-teal-600 dark:fill-teal-300";
        case "green":
          return a.type === "bold" ? "fill-white dark:fill-black" : "fill-green-600 dark:fill-green-300";
        default:
          return a.type === "bold" ? "fill-white dark:fill-black" : "fill-gray-900 dark:fill-gray-300";
      }
    });
    return (i, h) => {
      const c = xa;
      return t.value ? S("", !0) : (s(), u("div", {
        key: 0,
        class: D([
          r(l),
          {
            relative: !0,
            "p-2": e.size === "xs",
            "p-3": e.size === "sm",
            "p-4": e.size === "md" || e.size === "lg",
            "rounded-none": e.inset,
            "rounded-lg sds-theme-plaid:rounded-none": !e.inset
          }
        ])
      }, [
        d("div", Du, [
          n.leftIcon ? (s(), u("div", zu, [
            P(i.$slots, "leftIcon")
          ])) : S("", !0),
          d("div", Tu, [
            e.title ? (s(), u("span", {
              key: 0,
              class: D({
                "text-xs leading-4 font-semibold": e.size === "xs",
                "text-sm leading-5 font-semibold": e.size === "sm",
                "text-md leading-5.5 font-semibold": e.size === "md",
                "text-lg leading-6.5 font-semibold": e.size === "lg",
                "pb-1": e.description,
                "pb-2": !e.description && e.timestamp
              })
            }, A(e.title), 3)) : S("", !0),
            d("div", {
              class: D(["opacity-90", {
                "text-xs leading-4": e.size === "xs",
                "text-sm leading-5": e.size === "sm",
                "text-md leading-6": e.size === "md",
                "text-lg leading-7": e.size === "lg",
                "pb-2": e.timestamp
              }])
            }, [
              d("div", Bu, [
                P(i.$slots, "default", {}, () => [
                  re(A(e.description), 1)
                ])
              ])
            ], 2),
            e.timestamp ? (s(), u("span", Lu, A(r(Ye)(e.timestamp, "MMM dd, yyyy 'at' hh:mm aaa")), 1)) : S("", !0),
            n.buttons ? (s(), u("div", {
              key: 2,
              class: D(["justify-center space-x-2", e.size !== "xs" ? "pt-4" : "pt-3"])
            }, [
              P(i.$slots, "buttons")
            ], 2)) : S("", !0),
            h[1] || (h[1] = d("div", null, null, -1))
          ]),
          e.dismissable ? (s(), u("div", Iu, [
            d("button", {
              "aria-label": "Dismiss",
              onClick: h[0] || (h[0] = (f) => t.value = !0)
            }, [
              Q(c, {
                class: D([r(o), e.size === "xs" ? "w-3 h-3" : "w-4 h-4"])
              }, null, 8, ["class"])
            ])
          ])) : S("", !0)
        ])
      ], 2));
    };
  }
});
ln.install = (e) => {
  e.component(ln.name, ln);
};
const Vu = ["id"], Au = ["id", "value", "name", "required", "disabled", "readonly", "onClick"], Hu = ["for"], rn = /* @__PURE__ */ te({
  name: "SdsCheckboxGroup",
  __name: "CheckboxGroup",
  props: /* @__PURE__ */ xe({
    name: { default: null },
    options: { default: () => [] },
    stacked: { type: Boolean, default: !1 },
    labelKey: { default: "text" },
    valueKey: { default: "value" },
    disabled: { type: Boolean, default: !1 },
    readonly: { type: Boolean, default: !1 },
    required: { type: Boolean, default: !1 },
    valid: { type: Boolean, default: !1 },
    invalid: { type: Boolean, default: !1 }
  }, {
    modelValue: { type: Array, default: () => [] },
    modelModifiers: {}
  }),
  emits: /* @__PURE__ */ xe(["change"], ["update:modelValue"]),
  setup(e, { emit: a }) {
    const t = tt(), n = e, l = Te(e, "modelValue"), o = a, { validationClasses: i } = Xt(n), h = E(), c = (f) => {
      o("change", f);
    };
    return (f, y) => (s(), u("div", {
      id: r(t),
      ref_key: "root",
      ref: h,
      "data-id": "sds-checkbox-group",
      class: D(["flex", {
        "flex-col gap-2": e.stacked,
        "gap-4": !e.stacked
      }])
    }, [
      (s(!0), u(J, null, le(e.options, (m, g) => (s(), u("div", {
        key: `${r(h)?.id}_${JSON.stringify(m)}`,
        class: "flex gap-2 items-start"
      }, [
        Ze(d("input", {
          id: `${r(h)?.id}__option_${g}`,
          "onUpdate:modelValue": y[0] || (y[0] = (v) => l.value = v),
          type: "checkbox",
          class: D(["relative top-1", r(i)]),
          value: m[e.valueKey],
          name: e.name ? e.name : `${r(h)?.id}__option`,
          required: e.required && l.value.length < 1 || void 0,
          disabled: e.disabled || void 0,
          readonly: e.readonly || void 0,
          onClick: (v) => c(m[e.valueKey])
        }, null, 10, Au), [
          [So, l.value]
        ]),
        P(f.$slots, "label", {
          optionId: `${r(h)?.id}__option_${g}`,
          option: m
        }, () => [
          d("label", {
            for: `${r(h)?.id}__option_${g}`,
            class: D({
              "opacity-50 pointer-events-none select-none": e.disabled || e.readonly
            })
          }, [
            d("span", null, A(m[e.labelKey]), 1)
          ], 10, Hu)
        ])
      ]))), 128))
    ], 10, Vu));
  }
});
rn.install = (e) => {
  e.component(rn.name, rn);
};
Ut.install = (e) => {
  e.component(Ut.name, Ut);
};
const Ou = {
  viewBox: "0 0 640 640",
  "aria-hidden": "true",
  role: "img",
  width: "1.2em",
  height: "1.2em"
};
function Pu(e, a) {
  return s(), u("svg", Ou, [...a[0] || (a[0] = [
    d("path", {
      fill: "currentColor",
      d: "M88 256h144c9.7 0 18.5-5.8 22.2-14.8s1.7-19.3-5.2-26.2l-46.7-46.7c75.3-58.6 184.3-53.3 253.5 15.9c75 75 75 196.5 0 271.5s-196.5 75-271.5 0c-10.2-10.2-19-21.3-26.4-33c-9.5-14.9-29.3-19.3-44.2-9.8s-19.3 29.3-9.8 44.2c9.8 15.6 21.5 30.4 35.1 43.9c100 100 262 100 362 0s100-262 0-362c-94.2-94.3-243.7-99.7-344.3-16.2L105 71c-6.9-6.8-17.2-8.9-26.2-5.2S64 78.3 64 88v144c0 13.3 10.7 24 24 24"
    }, null, -1)
  ])]);
}
const Fu = $e({ name: "fa7-solid-rotate-left", render: Pu }), Eu = {
  viewBox: "0 0 640 640",
  "aria-hidden": "true",
  role: "img",
  width: "1.2em",
  height: "1.2em"
};
function Ru(e, a) {
  return s(), u("svg", Eu, [...a[0] || (a[0] = [
    d("path", {
      fill: "currentColor",
      d: "M566.6 342.6c12.5-12.5 12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L466.7 288H96c-17.7 0-32 14.3-32 32s14.3 32 32 32h370.7L361.3 457.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l160-160z"
    }, null, -1)
  ])]);
}
const Nl = $e({ name: "fa7-solid-arrow-right", render: Ru }), Nu = {
  viewBox: "0 0 640 640",
  "aria-hidden": "true",
  role: "img",
  width: "1.2em",
  height: "1.2em"
};
function Wu(e, a) {
  return s(), u("svg", Nu, [...a[0] || (a[0] = [
    d("path", {
      fill: "currentColor",
      d: "M73.4 297.4c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L173.3 352H544c17.7 0 32-14.3 32-32s-14.3-32-32-32H173.3l105.4-105.4c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-160 160z"
    }, null, -1)
  ])]);
}
const ro = $e({ name: "fa7-solid-arrow-left", render: Wu }), qu = {
  viewBox: "0 0 640 640",
  "aria-hidden": "true",
  role: "img",
  width: "1.2em",
  height: "1.2em"
};
function Yu(e, a) {
  return s(), u("svg", qu, [...a[0] || (a[0] = [
    d("path", {
      fill: "currentColor",
      d: "M297.4 566.6c12.5 12.5 32.8 12.5 45.3 0l160-160c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L352 466.7V96c0-17.7-14.3-32-32-32s-32 14.3-32 32v370.7L182.6 361.3c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l160 160z"
    }, null, -1)
  ])]);
}
const Wl = $e({ name: "fa7-solid-arrow-down", render: Yu }), ju = {
  viewBox: "0 0 640 640",
  "aria-hidden": "true",
  role: "img",
  width: "1.2em",
  height: "1.2em"
};
function Gu(e, a) {
  return s(), u("svg", ju, [...a[0] || (a[0] = [
    d("path", {
      fill: "currentColor",
      d: "M342.6 73.4c-12.5-12.5-32.8-12.5-45.3 0l-160 160c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L288 173.3V544c0 17.7 14.3 32 32 32s32-14.3 32-32V173.3l105.4 105.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-160-160z"
    }, null, -1)
  ])]);
}
const ql = $e({ name: "fa7-solid-arrow-up", render: Gu }), Uu = {
  viewBox: "0 0 640 640",
  "aria-hidden": "true",
  role: "img",
  width: "1.2em",
  height: "1.2em"
};
function Ku(e, a) {
  return s(), u("svg", Uu, [...a[0] || (a[0] = [
    d("path", {
      fill: "currentColor",
      d: "M352 128c0-17.7-14.3-32-32-32s-32 14.3-32 32v160H128c-17.7 0-32 14.3-32 32s14.3 32 32 32h160v160c0 17.7 14.3 32 32 32s32-14.3 32-32V352h160c17.7 0 32-14.3 32-32s-14.3-32-32-32H352z"
    }, null, -1)
  ])]);
}
const Zu = $e({ name: "fa7-solid-plus", render: Ku }), Qu = {
  viewBox: "0 0 640 640",
  "aria-hidden": "true",
  role: "img",
  width: "1.2em",
  height: "1.2em"
};
function Xu(e, a) {
  return s(), u("svg", Qu, [...a[0] || (a[0] = [
    d("path", {
      fill: "currentColor",
      d: "M530.8 134.1c14.3 10.4 17.5 30.4 7.1 44.7l-256 352c-5.5 7.6-14 12.3-23.4 13.1s-18.5-2.7-25.1-9.3l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l101.5 101.5l234-321.7c10.4-14.3 30.4-17.5 44.7-7.1z"
    }, null, -1)
  ])]);
}
const Ju = $e({ name: "fa7-solid-check", render: Xu }), _u = {
  viewBox: "0 0 640 640",
  "aria-hidden": "true",
  role: "img",
  width: "1.2em",
  height: "1.2em"
};
function ec(e, a) {
  return s(), u("svg", _u, [...a[0] || (a[0] = [
    d("path", {
      fill: "currentColor",
      d: "M480 272c0 45.9-14.9 88.3-40 122.7l126.6 126.7c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L394.7 440c-34.4 25.1-76.8 40-122.7 40c-114.9 0-208-93.1-208-208S157.1 64 272 64s208 93.1 208 208M272 416c79.5 0 144-64.5 144-144s-64.5-144-144-144s-144 64.5-144 144s64.5 144 144 144"
    }, null, -1)
  ])]);
}
const oo = $e({ name: "fa7-solid-magnifying-glass", render: ec }), tc = {
  "data-id": "sds-scroll-area",
  class: "scroll-area"
}, La = /* @__PURE__ */ te({
  name: "SdsScrollArea",
  __name: "ScrollArea",
  setup(e) {
    return (a, t) => (s(), u("div", tc, [
      P(a.$slots, "default")
    ]));
  }
});
function mr(e, a = 16, t = 0) {
  return (e / a).toFixed(t);
}
const ac = ["id"], nc = {
  role: "tablist",
  class: "flex whitespace-nowrap z-10"
}, lc = {
  key: 0,
  class: "tab-count"
}, rc = ["id", "aria-labelledby"], Ia = /* @__PURE__ */ te({
  name: "SdsTabs",
  __name: "Tabs",
  props: /* @__PURE__ */ xe({
    size: { default: "sm" },
    type: { default: "folder" },
    variant: { default: "red" },
    willChangeTab: { default: void 0 }
  }, {
    modelValue: { type: Array, default: [] },
    modelModifiers: {}
  }),
  emits: /* @__PURE__ */ xe(["update:modelValue", "change"], ["update:modelValue"]),
  setup(e, { emit: a }) {
    const t = e, n = Te(e, "modelValue"), l = a, o = ["ArrowLeft", "ArrowRight", "Home", "End"], i = tt(), h = E(), c = M({
      get() {
        return n.value;
      },
      set(L) {
        l("update:modelValue", L);
      }
    }), f = M(() => c.value.find(({ active: L }) => L) ?? c.value[0]), y = M(() => {
      if (h.value && !(!document || !document?.querySelector))
        return document.querySelector(`#sds-tabs-${h.value.id}__${f.value.key}__tab`);
    }), m = M(() => {
      if (!y.value) return;
      const L = y.value.offsetLeft, z = y.value.getBoundingClientRect().width;
      return { left: L, width: z };
    }), g = ot(() => t.variant, {
      blue: "tab-indicator-blue",
      gray: "tab-indicator-gray",
      red: "tab-indicator-red"
    }, "tab-indicator-red"), v = ot(() => t.size, {
      lg: "tab-lg",
      sm: "tab-sm"
    }, "tab-sm"), C = ot(() => t.type, {
      block: "tab-block",
      underline: "tab-underline",
      folder: "tab-folder"
    }, "tab-folder"), k = ot(() => t.variant, {
      blue: "tab-blue",
      gray: "tab-gray",
      red: "tab-red"
    }, "tab-red"), w = async (L, z) => {
      if (typeof z == "function")
        return new Promise((b, $) => {
          try {
            z(L, b, $);
          } catch (p) {
            $(p);
          }
        });
    }, x = async (L) => {
      if (L.tag === "a" && L.href)
        return !0;
      t.willChangeTab && await w(L, t.willChangeTab), c.value = c.value.map((z) => (z.active = L.key === z.key, z)), l("change", L);
    }, I = async (L, z) => {
      const b = L.key;
      if (!o.includes(b)) return;
      L.preventDefault();
      const $ = c.value.filter((T) => !T.disabled), p = $.findIndex((T) => T.key === z.key);
      if (p === -1) return;
      let F = p;
      switch (b) {
        case "ArrowLeft":
          F = (p - 1 + $.length) % $.length;
          break;
        case "ArrowRight":
          F = (p + 1) % $.length;
          break;
        case "Home":
          F = 0;
          break;
        case "End":
          F = $.length - 1;
          break;
      }
      const R = $[F];
      x(R), await Ie(() => {
        if (typeof document > "u") return;
        const T = document.querySelector(`#sds-tabs-${h.value?.id}__${R.key}__tab`);
        T && T.focus();
      });
    };
    return (L, z) => (s(), u("div", {
      id: r(i),
      ref_key: "root",
      ref: h,
      "data-id": "sds-tabs",
      class: "tabs"
    }, [
      d("div", {
        class: D(["overflow-x-auto", {
          relative: t.type === "underline"
        }])
      }, [
        d("ul", nc, [
          (s(!0), u(J, null, le(r(c), (b) => (s(), u("li", {
            key: b.key,
            role: "presentation",
            class: D({
              "mr-auto": b.align === "left",
              "ml-auto": b.align === "right",
              "mx-auto": b.align === "center"
            })
          }, [
            (s(), G(mt(b.tag || "button"), {
              id: `sds-tabs-${r(h)?.id}__${b.key}__tab`,
              class: D(["tab", [
                r(v),
                r(C),
                t.type === "underline" ? "tab-underline-no-rule" : "",
                r(k),
                b.active ? "active" : "",
                b.disabled ? "disabled" : ""
              ]]),
              href: b.tag === "a" && b.href || void 0,
              target: b.tag === "a" && b.href && b.external ? "_blank" : void 0,
              rel: b.tag === "a" && b.href && b.external ? "noopener noreferrer" : void 0,
              type: b.tag === "button" ? "button" : void 0,
              disabled: b.disabled,
              "aria-disabled": b.disabled,
              tabindex: b.disabled || !b.active ? -1 : 0,
              "aria-selected": b.active ? "true" : "false",
              "aria-controls": `sds-tabs-${r(h)?.id}__${b.key}__tab-content`,
              "data-active": b.active ? !0 : void 0,
              role: "tab",
              onClick: ($) => x(b),
              onKeydown: ($) => I($, b)
            }, {
              default: U(() => [
                P(L.$slots, `tabIconLeft(${b.key})`),
                P(L.$slots, `tab(${b.key})`, {}, () => [
                  re(A(b.title), 1)
                ]),
                P(L.$slots, `tabIconRight(${b.key})`),
                typeof b.count < "u" && b.count >= 0 ? (s(), u("span", lc, A(b.count), 1)) : S("", !0)
              ]),
              _: 2
            }, 1064, ["id", "class", "href", "target", "rel", "type", "disabled", "aria-disabled", "tabindex", "aria-selected", "aria-controls", "data-active", "onClick", "onKeydown"]))
          ], 2))), 128))
        ]),
        Q(Qe, null, {
          default: U(() => [
            t.type === "underline" ? (s(), u("div", {
              key: 0,
              class: D(["tab-indicator", [
                r(g),
                t.size === "lg" ? "tab-indicator-lg" : "tab-indicator-sm"
              ]]),
              style: st(`left: ${r(mr)(r(m)?.left ?? 0, void 0, 4)}rem; width: ${r(mr)(r(m)?.width ?? 0, void 0, 4)}rem;`),
              role: "presentation"
            }, null, 6)) : S("", !0)
          ]),
          _: 1
        })
      ], 2),
      (s(!0), u(J, null, le(r(c), (b) => (s(), u(J, null, [
        b.active ? (s(), u("div", {
          id: `sds-tabs-${r(h)?.id}__${b.key}__tab-content`,
          key: b.key,
          "aria-labelledby": `sds-tabs-${r(h)?.id}__${b.key}__tab`,
          role: "tabpanel",
          tabindex: "0"
        }, [
          b.active ? P(L.$slots, `panel(${b.key})`, { key: 0 }, () => [
            P(L.$slots, "panel", { item: b })
          ]) : S("", !0)
        ], 8, rc)) : S("", !0)
      ], 64))), 256))
    ], 8, ac));
  }
}), oc = ["id", "value", "multiple", "placeholder", "disabled", "readonly", "maxlength", "required", "onKeyup"], sc = ["value", "required"], ic = {
  key: 3,
  class: "input-group-addon"
}, dc = {
  key: 0,
  "data-id": "sds-combo-box-dropdown",
  class: "absolute z-50 w-full p-0 mt-1 bg-white border rounded-theme-sm shadow-lg dark:border-gray-700 dark:bg-gray-850"
}, uc = {
  key: 0,
  class: "overflow-x-auto overflow-y-hidden flex after:w-full after:h-full after:content-[''] after:mt-auto after:border-b after:border-b-gray-100 dark:after:border-b-gray-800"
}, cc = ["aria-selected", "data-active", "onKeydown"], fc = ["checked", "indeterminate"], hc = {
  key: 0,
  class: "border-gray-100 dark:border-gray-700"
}, mc = ["checked", "onChange"], gc = ["tabindex", "checked", "onChange"], vc = {
  key: 2,
  class: "border-gray-100 dark:border-gray-700"
}, yc = {
  key: 3,
  class: "py-2"
}, bc = {
  key: 0,
  class: "px-3 text-sm"
}, pc = ["aria-selected", "data-active"], wc = {
  key: 1,
  class: "border-t rounded-b-theme-sm border-gray-100 dark:border-gray-700 bg-gray-25 dark:bg-gray-800 px-4 py-2 flex gap-6 items-center text-sm text-gray-700 dark:text-gray-300"
}, xc = { class: "ml-auto flex items-center gap-1.5" }, kc = { class: "flex gap-1 p-1 border border-gray-100 dark:border-gray-500 rounded-theme-sm shadow-inner" }, Cc = {
  key: 0,
  class: "flex items-center gap-1.5"
}, $c = { class: "flex gap-1 p-1 border border-gray-100 dark:border-gray-500 rounded-theme-sm shadow-inner" }, Mc = { class: "flex items-center gap-1.5" }, Sc = { class: "inline-block p-1 border border-gray-100 dark:border-gray-500 rounded-theme-sm shadow-inner" }, _a = "__cbxIdx", Va = /* @__PURE__ */ te({
  name: "SdsComboBox",
  __name: "ComboBox",
  props: /* @__PURE__ */ xe({
    autofocus: { type: Boolean, default: !1 },
    clickToSelect: { type: Boolean, default: !1 },
    debounceComplete: { default: 250 },
    disableGroupTabs: { type: Boolean, default: !1 },
    enableSelectAll: { type: Boolean, default: !1 },
    maxlength: { default: void 0 },
    multiple: { type: Boolean, default: !1 },
    id: { default: void 0 },
    focusOnKeyPress: { type: Boolean, default: !1 },
    filterSuggestions: { type: Boolean, default: !1 },
    hideFocusIndicator: { type: Boolean, default: !1 },
    hideEmptyGroups: { type: Boolean, default: !1 },
    optionLabel: { default: void 0 },
    optionGroupLabel: { default: void 0 },
    optionGroupChildren: { default: void 0 },
    optionType: { default: "button" },
    pending: { type: Boolean, default: !1 },
    placeholder: { default: void 0 },
    size: { default: void 0 },
    suggestions: { default: () => [] },
    type: { default: "text" },
    disabled: { type: Boolean, default: !1 },
    readonly: { type: Boolean, default: !1 },
    required: { type: Boolean, default: !1 },
    valid: { type: Boolean, default: !1 },
    invalid: { type: Boolean, default: !1 }
  }, {
    modelValue: { type: String, default: "" },
    modelModifiers: {},
    selected: { type: Array, default: () => [] },
    selectedModifiers: {}
  }),
  emits: /* @__PURE__ */ xe(["update:modelValue", "complete", "enter", "result"], ["update:modelValue", "update:selected"]),
  setup(e, { emit: a }) {
    const t = e, n = a, l = E(), o = E(), i = E(), h = E(), c = E(), f = E(t.readonly), { validationClasses: y } = Xt(t), m = Te(e, "modelValue"), g = Te(e, "selected"), v = E(!1), C = E(!1), k = E(-1), w = E(!1), x = E("label"), I = E(), L = E(), z = E(-1), b = E(), $ = E(), p = E(0), F = E(), R = E(), T = E(), j = E(), X = M({
      get() {
        return I.value ? I.value.map((B) => ({
          key: String(B.key),
          title: B.label,
          count: B.count,
          active: String(B.key) === String(z.value) && B.count > 0,
          disabled: B.count < 1
        })) : [];
      },
      set(B) {
        const V = B.find((W) => W.active);
        V && (z.value = Number(V.key));
      }
    }), pe = M(() => t.disabled || t.readonly ? !1 : at.value !== "" || t.type !== "text" && g.value.length > 0), H = () => I.value && !Fe.value && z.value !== -1 && R.value ? R.value.flatMap((B) => typeof B == "object" && t.optionGroupChildren && Array.isArray(B[t.optionGroupChildren]) ? B[t.optionGroupChildren] : [B]) : $.value ? $.value.flatMap((B) => typeof B == "object" && t.optionGroupChildren && Array.isArray(B[t.optionGroupChildren]) ? B[t.optionGroupChildren] : [B]) : [], Y = () => {
      t.readonly || t.disabled || t.clickToSelect && (v.value = !v.value);
    }, O = M(() => {
      const B = H();
      return B.length ? B.every((V) => {
        const W = String(typeof V == "object" ? t.optionLabel ? V[t.optionLabel] : V[x.value] : V);
        return Z(W);
      }) : !1;
    }), _ = M(() => {
      const B = H();
      if (!B.length) return !1;
      const V = B.filter((W) => {
        const ee = String(typeof W == "object" ? t.optionLabel ? W[t.optionLabel] : W[x.value] : W);
        return Z(ee);
      }).length;
      return V > 0 && V < B.length;
    }), oe = () => {
      const B = H();
      if (!B.length) return;
      B.every((W) => {
        const ee = String(typeof W == "object" ? t.optionLabel ? W[t.optionLabel] : W[x.value] : W);
        return Z(ee);
      }) ? B.forEach((W) => {
        const ee = String(typeof W == "object" ? t.optionLabel ? W[t.optionLabel] : W[x.value] : W), ce = g.value.findIndex((Be) => ue(Be) === ee);
        ce !== -1 && g.value.splice(ce, 1);
      }) : B.forEach((W) => {
        const ee = String(typeof W == "object" ? t.optionLabel ? W[t.optionLabel] : W[x.value] : W);
        if (!Z(ee)) {
          const ce = N(ee) ?? W;
          ce && g.value.push(ie(ce));
        }
      });
    }, K = (B) => {
      if (typeof document > "u") return B;
      const V = document.createElement("div");
      return V.innerHTML = B, V.textContent || V.innerText || "";
    }, de = (B) => (B ?? "").toString().trim().toLowerCase(), Me = M(() => t.suggestions.flatMap((B) => B && t.optionGroupChildren && typeof B == "object" ? B[t.optionGroupChildren] : typeof B == "string" ? B : []).map((B) => B && typeof B == "object" ? String(t.optionLabel ? B[t.optionLabel] : B[x.value]) : typeof B == "string" ? B : "").filter((B) => typeof B == "string" && B.length > 0)), Le = (B) => {
      if (!Array.isArray(B)) return [];
      const V = Me.value.map(de);
      let W = de(m.value).length && t.type === "taggable-select" && !V.includes(de(m.value)) ? 1 : 0;
      return B.map((ee) => (typeof ee != "string" && (t.optionGroupChildren && ee[t.optionGroupChildren] ? ee[t.optionGroupChildren] = ee[t.optionGroupChildren].map((ce) => (typeof ce != "string" && (ce[_a] = W, W++), ce)) : (ee[_a] = W, W++)), ee));
    }, Ge = (B) => {
      if (!Array.isArray(B)) return [];
      const V = B.reduce((W, ee) => {
        if (typeof ee != "string") {
          const ce = { ...ee };
          t.optionGroupChildren && ee[t.optionGroupChildren] ? (ce[t.optionGroupChildren] = Ge(ee[t.optionGroupChildren]), t.hideEmptyGroups ? ce[t.optionGroupChildren].length && W.push(ce) : W.push(ce)) : K(ce[t.optionLabel ? t.optionLabel : x.value]).toLowerCase().includes(m.value.toLowerCase()) && W.push(ce);
        }
        return W;
      }, []);
      return Le(V);
    }, Fe = M(() => {
      if (!I.value?.length) return !0;
      let B = 0;
      for (const V of I.value)
        V.count > 0 && B++;
      return B <= 1;
    }), Xe = (B) => {
      let V = (t.type === "taggable-select" || t.type === "select") && t.multiple && p.value > 1 && t.enableSelectAll ? 1 : 0;
      const W = T.value;
      if (!W) return null;
      for (const ee of W)
        if (typeof ee == "object" && t.optionGroupChildren && Array.isArray(ee[t.optionGroupChildren]))
          for (const ce of ee[t.optionGroupChildren]) {
            if (ce === B) return V;
            V++;
          }
        else {
          if (ee === B) return V;
          V++;
        }
      return t.type === "taggable-select" && Et.value && B && typeof B == "object" && B.__cbxIdx === "add" ? V : null;
    }, be = (B) => {
      if (typeof B != "object" || B === null) return !1;
      if (t.type === "taggable-select" && Et.value && B && typeof B == "object" && B.__cbxIdx === "add") {
        const W = T.value;
        let ee = t.type === "taggable-select" && t.multiple ? 1 : 0;
        if (W)
          for (const ce of W)
            typeof ce == "object" && t.optionGroupChildren && Array.isArray(ce[t.optionGroupChildren]) ? ee += ce[t.optionGroupChildren].length : ee++;
        return k.value === ee;
      }
      const V = Xe(B);
      return V === null ? !1 : k.value === V;
    };
    function Jt(B, V) {
      if (typeof B == "object" && B !== null && t.optionGroupChildren && Array.isArray(B[t.optionGroupChildren]))
        return B[t.optionGroupChildren].some((ee) => Jt(ee, V));
      let W = "";
      return typeof B == "object" && B !== null ? W = String(t.optionLabel ? B[t.optionLabel] : B[x.value] ?? "") : typeof B == "string" && (W = B), de(W) === de(V);
    }
    const ra = M(() => {
      if (t.type === "taggable-select")
        return t.suggestions.some((V) => Jt(V, m.value));
      const B = de(m.value);
      return Me.value.map(de).includes(B);
    }), at = M(() => {
      if (k.value !== -1 && !w.value && T.value && T.value.length > 0) {
        const B = bt();
        if (B) {
          let V = "";
          return typeof B == "object" ? V = String(t.optionLabel ? B[t.optionLabel] : B[x.value] ?? "") : V = String(B), K(V);
        }
      }
      if (g.value.length > 0 && m.value === "" && !t.multiple) {
        const B = g.value[0];
        return String(typeof B == "object" ? t.optionLabel ? B[t.optionLabel] : B[x.value] ?? "" : B);
      }
      return K(m.value);
    });
    let ut = !1, qe = !1, Je = !1;
    const Ht = E(!1);
    ye(m, () => {
      Ht.value = !0;
    }), qo(m, async () => {
      await Ie();
      let B = !1;
      Je && t.type === "text" && (B = !0, Je = !1), m.value !== "" && !B && (v.value = !0), !ut && !qe && n("complete", m.value), ut = !1, qe = !1, Ht.value = !1;
    }, { debounce: t.debounceComplete }), dt(() => {
      t.autofocus && i.value.focus();
    }), Ya("Escape", (B) => {
      B.preventDefault(), v.value || i.value.blur(), v.value = !1;
    }), gl(l, () => v.value = !1), Ya("/", (B) => {
      if (!t.focusOnKeyPress || !B.target) return;
      const V = B.target.tagName.toLowerCase();
      ["textarea", "input", "select"].includes(V) || (B.preventDefault(), i.value.focus());
    });
    const rt = async () => {
      if (await Ie(), !o.value) return;
      const B = o.value.$el;
      if (!B) return;
      const V = B.querySelector('[data-active="true"]');
      if (!V) return;
      const W = B.getBoundingClientRect(), ee = V.getBoundingClientRect();
      if (!(ee.top >= W.top && ee.bottom <= W.top + B.clientHeight)) {
        const Be = ee.top - W.top, pt = ee.bottom - W.bottom;
        B.scrollTop += Math.abs(Be) < Math.abs(pt) ? Be : pt;
      }
    }, Ot = () => {
      if (ut = !0, at.value !== "" && (m.value = "", i.value.value = "", t.multiple && (t.type === "select" || t.type === "taggable-select"))) {
        f.value = t.readonly || !1, v.value = !1, i.value.focus();
        return;
      }
      (t.type === "select" || t.type === "taggable-select" || t.type === "text") && (g.value = []), f.value = t.readonly || !1, v.value = !1, i.value.focus();
    }, ne = () => {
      i.value.classList.add("animate-shake"), setTimeout(() => i.value.classList.remove("animate-shake"), 500);
    }, N = (B) => {
      if (t.suggestions)
        return t.suggestions.find((V) => typeof V == "object" ? (t.optionLabel ? V[t.optionLabel] : V[x.value]) === B : V === B);
    }, ue = (B) => String(typeof B == "object" && B !== null ? t.optionLabel ? B[t.optionLabel] : B[x.value] ?? "" : B), ie = (B) => {
      if (typeof B == "object" && B !== null) {
        const { [_a]: V, ...W } = B;
        return { ...W };
      }
      return B;
    }, ge = async () => {
      if (!m.value) return;
      let B = N(m.value);
      !B && m.value !== "" && (B = t.type === "text" ? m.value : {
        [t.optionLabel ? t.optionLabel : x.value]: m.value
      });
      const V = ie(B ?? {}), W = g.value.findIndex((ee) => ue(ee) === m.value);
      if (W !== -1) {
        g.value.splice(W, 1), ne();
        return;
      }
      if (g.value.push(V), i.value.focus(), !t.multiple && (t.type === "select" || t.type === "taggable-select") || t.type === "text") {
        v.value = !1;
        const ee = ue(V);
        t.type === "text" && m.value !== ee && (Je = !0), qe = !0, m.value = ee;
      }
      await Ie(), k.value = -1;
    }, q = (B) => {
      g.value.length && (B < 0 ? g.value.splice(g.value.length - 1, 1) : B >= 0 && B < g.value.length && g.value.splice(B, 1), g.value.length === 0 && (m.value = "", i.value && (i.value.value = ""), f.value = t.readonly || !1), i.value && i.value.focus());
    }, Pt = () => {
      if (g.value.length && t.type === "text" && g.value.pop(), g.value.length && !t.multiple && (t.type === "select" || t.type === "taggable-select")) {
        q(-1), m.value = "", i.value && (i.value.value = ""), f.value = t.readonly || !1;
        return;
      }
      g.value.length && i.value.value === "" && q(-1);
    }, bt = () => {
      if (t.type === "taggable-select" && t.multiple && Et.value && k.value === 0 && (!T.value || T.value.length === 0))
        return {
          label: m.value,
          name: m.value,
          value: m.value,
          __cbxIdx: "add"
        };
      if ((t.type === "taggable-select" || t.type === "select") && t.multiple && t.enableSelectAll && k.value === 0 && p.value > 1)
        return null;
      if (t.type === "taggable-select" && Et.value && k.value === Za())
        return {
          label: m.value,
          name: m.value,
          value: m.value,
          __cbxIdx: "add"
        };
      let B;
      const V = T.value;
      if (!V) return;
      let ee = (t.type === "taggable-select" || t.type === "select") && t.multiple && t.enableSelectAll && p.value > 1 ? 1 : 0;
      return V.forEach((ce) => {
        if (typeof ce != "string")
          if (t.optionGroupChildren && ce[t.optionGroupChildren]) {
            const Be = ce[t.optionGroupChildren].find((pt) => typeof pt != "string" && k.value === ee++);
            Be && (B = Be);
          } else
            k.value === ee && (B = ce), ee++;
      }), B;
    }, Z = (B) => g.value.some((V) => typeof V == "object" ? (t.optionLabel ? V[t.optionLabel] : V[x.value]) === B : V === B), se = /* @__PURE__ */ Ko(), Ee = M(() => !se.value || !i.value ? !1 : se.value === i.value);
    ye(C, (B) => {
      B && (v.value = !0, C.value = !1);
    });
    const ve = () => {
      t.type === "text" ? n("enter", m.value) : n("enter", g.value.length ? g.value : m.value), ut = !1, qe = !1;
    };
    ye([m, at, () => g.value.length, () => t.multiple, () => t.disabled, () => t.type], () => {
      /<[^>]*(>|$)/.test(m.value) && (m.value = K(m.value));
    });
    const Tt = (B) => {
      const V = B.target;
      if (!t.multiple && (t.type === "select" || t.type === "taggable-select") && g.value.length > 0) {
        g.value = [], f.value = t.readonly || !1, V.value = V.value.slice(-1), m.value = V.value, Ft();
        return;
      }
      m.value = V.value, Ft();
    }, Ft = async () => {
      Je = !1, await Ie(), v.value && (k.value = sl.value, w.value = !0);
    }, _t = () => {
      g.value = g.value.length ? g.value : [m.value], v.value = !1, ve();
    }, Bt = async (B) => {
      let V = B, W;
      if (typeof B == "object" && B !== null) {
        const Be = t.optionLabel ? B[t.optionLabel] : B[x.value];
        if (W = N(Be), typeof W == "string")
          V = W;
        else {
          const { [_a]: pt, ...il } = B;
          V = { ...il };
        }
      } else
        W = N(B);
      if (t.type === "text") {
        qe = !0, Je = !0;
        let Be = "";
        typeof V == "object" && V !== null ? Be = String(t.optionLabel ? V[t.optionLabel] : V[x.value] ?? "") : typeof V == "string" && (Be = V), m.value = Be;
      }
      const ee = g.value.findIndex((Be) => typeof Be == "object" && typeof V == "object" ? (t.optionLabel ? Be[t.optionLabel] : Be[x.value]) === (t.optionLabel ? V[t.optionLabel] : V[x.value]) : Be === V);
      ee !== -1 ? g.value.splice(ee, 1) : !t.multiple && (t.type === "select" || t.type === "taggable-select") ? g.value.splice(0, g.value.length, V) : g.value.push(V);
      let ce = W !== void 0 ? W : B;
      if (typeof ce == "object" && ce !== null && "__cbxIdx" in ce) {
        const { __cbxIdx: Be, ...pt } = ce;
        ce = pt;
      }
      await Ie(), n("result", ce), v.value = !1, ut = !0, t.type !== "text" && (m.value = ""), i.value.focus();
    }, ol = async (B) => {
      if (t.disabled) return;
      if (t.type === "select" && at.value !== "" && !bt()) {
        k.value === 0 && t.enableSelectAll ? oe() : ne();
        return;
      }
      if (t.type === "taggable-select" && !v.value) {
        g.value.length > 0 ? ve() : ne();
        return;
      }
      if (t.type !== "text" && k.value === -1 && at.value !== "") {
        ne();
        return;
      }
      j.value = m.value;
      let V = bt();
      if (V === null) {
        oe();
        return;
      }
      if (V && typeof V == "object" && V.__cbxIdx === "add") {
        await Bt(V);
        return;
      }
      !V && m.value && (V = N(m.value) || {
        [t.optionLabel ? t.optionLabel : x.value]: m.value
      });
      let W;
      if (V && typeof V == "object") {
        const ee = V;
        t.type === "text" && m.value !== (t.optionLabel ? ee[t.optionLabel] : ee[x.value]) && (Je = !0), qe = !0, m.value = t.optionLabel ? ee[t.optionLabel] : ee[x.value];
        const ce = t.optionLabel ? ee[t.optionLabel] : ee[x.value], Be = N(ce);
        W = Be !== void 0 ? Be : ee;
      } else if (V && typeof V == "string") {
        const ee = N(V);
        t.type === "text" && m.value !== V && (Je = !0), qe = !0, m.value = V, W = ee !== void 0 ? ee : V;
      } else t.type === "text" && (W = m.value);
      if (typeof W == "object" && W !== null && "__cbxIdx" in W) {
        const { __cbxIdx: ee, ...ce } = W;
        W = ce;
      }
      switch (await Ie(), k.value === -1 && B instanceof KeyboardEvent || (await Ie(), W !== void 0 && n("result", W)), v.value = !1, t.type) {
        case "text": {
          k.value === -1 ? _t() : (q(0), ge()), j.value = "";
          break;
        }
        case "select":
        case "taggable-select": {
          const ee = g.value.findIndex((ce) => typeof ce == "object" ? (t.optionLabel ? ce[t.optionLabel] : ce[x.value]) === m.value : !1);
          ee !== -1 ? q(ee) : ge(), t.multiple ? (g.value.length && m.value === "" && !j.value.length && _t(), (j.value.length && !m.value.length || !m.value.length && g.value.length === 0) && ne()) : (g.value.length === 1 && m.value === "" && !j.value.length && _t(), (j.value.length && !m.value.length || !m.value.length) && ne()), j.value = "", ut = !0, m.value = "";
          break;
        }
      }
    }, Et = M(() => m.value !== "" && t.type === "taggable-select" && !ra.value), Za = () => {
      let B = 0;
      (t.type === "taggable-select" || t.type === "select") && t.multiple && p.value > 1 && t.enableSelectAll && (B += 1);
      const V = T.value;
      return B += Rt(V), Et.value && (B += 1), B - 1;
    }, oa = M(() => !I.value?.length || Fe.value || t.disableGroupTabs ? !1 : p.value > 1);
    function Rt(B) {
      if (!B || !Array.isArray(B)) return 0;
      let V = 0;
      for (const W of B)
        typeof W == "object" && t.optionGroupChildren && Array.isArray(W[t.optionGroupChildren]) ? V += Rt(W[t.optionGroupChildren]) : V++;
      return V;
    }
    const Gl = M(() => {
      const B = T.value, V = Rt(B);
      return t.type === "select" ? V > 0 : t.type === "taggable-select" && Et.value ? !0 : V > 0;
    }), Nt = async (B, V) => {
      const W = l.value?.querySelector('button.tab[data-active="true"]') || null;
      if (B === "tabsUp" || B === "tabsDown") {
        if (B === "tabsUp") {
          V.preventDefault(), i.value.focus();
          return;
        }
        if (B === "tabsDown") {
          V.preventDefault(), i.value.focus(), oa.value && Rt(T.value) === 1 && t.multiple && t.enableSelectAll && k.value++, k.value++;
          return;
        }
      }
      if ((B === "up" || B === "down") && !v.value && Gl.value) {
        i.value.readOnly || (V.preventDefault(), v.value = !0, oa.value && W?.focus()), k.value = -1, W?.blur(), z.value = -2;
        return;
      }
      switch (B) {
        case "down": {
          if (w.value = !1, oa.value && k.value === -1 && typeof document < "u" && document.activeElement !== W) {
            k.value = -1, W?.focus();
            return;
          }
          const ee = Za();
          k.value < ee ? k.value++ : k.value = -1;
          break;
        }
        case "up": {
          if (w.value = !1, oa.value && k.value === 0 && typeof document < "u" && document.activeElement !== W) {
            k.value = -1, W?.focus();
            return;
          }
          const ee = Za();
          k.value > -1 ? (k.value === 1 && oa.value && Rt(T.value) === 1 && t.enableSelectAll && (k.value--, W?.focus()), k.value--) : k.value = ee;
          break;
        }
        // Allow left/right arrow navigation only if categories are shown and input is not focused
        case "left":
          if (k.value > -1) {
            z.value === -1 ? z.value = X.value ? X.value.length - 2 : -1 : z.value--, await Ie();
            const ee = l.value?.querySelector('button.tab[data-active="true"]');
            ee?.focus(), ee?.scrollIntoView(), k.value = -1;
          }
          break;
        case "right":
          if (k.value > -1) {
            z.value === X.value.length - 2 ? z.value = -1 : z.value++, await Ie();
            const ee = l.value?.querySelector('button.tab[data-active="true"]');
            ee?.focus(), ee?.scrollIntoView({ block: "nearest", inline: "nearest" }), k.value = -1;
          }
          break;
      }
    };
    ye(k, (B, V) => {
      B !== V && v.value && rt();
    }), Xn(() => {
      b.value = t.suggestions?.map((W) => (typeof W != "object" && (W = { [t.optionLabel ? t.optionLabel : x.value]: W }), W)), $.value = t.filterSuggestions && b.value ? Ge(b.value) : b.value && Le(b.value);
      let B = 0;
      $.value?.forEach((W) => {
        typeof W != "string" && t.optionGroupChildren && W[t.optionGroupChildren] ? B += W[t.optionGroupChildren].length : B += 1;
      }), p.value = B;
      let V = -1;
      I.value = $.value ? [
        { index: -1, key: V, label: "All", count: p.value },
        ...$.value.map((W, ee) => {
          const ce = typeof W != "string" && t.optionGroupChildren && W[t.optionGroupChildren].length || 0;
          return ce > 0 && (V = V + 1), {
            index: ee,
            key: V,
            label: typeof W != "string" && W[t.optionGroupLabel ? t.optionGroupLabel : x.value],
            count: ce
          };
        }).filter((W) => typeof W != "string" && W && t.hideEmptyGroups ? W.count > 0 : !0)
      ] : [], L.value = I.value?.find((W) => typeof W != "string" && W?.key === z.value), F.value = t.suggestions?.filter((W) => typeof W != "string" && t.optionGroupChildren && W[t.optionGroupLabel ? t.optionGroupLabel : x.value] === L.value?.label), R.value = t.filterSuggestions && F.value ? Ge(F.value) : F.value && Le(F.value), T.value = z.value === -1 ? $.value : R.value;
    });
    const Ul = M(() => !(t.disabled || t.pending || Ht.value || !v.value || !Gl.value || t.type !== "text" && g.value.length === 1 && !t.multiple && !t.clickToSelect)), sl = M(() => (t.type === "taggable-select" || t.type === "select") && t.multiple && t.enableSelectAll && p.value > 1 ? 1 : 0);
    return ye(Ul, async (B) => {
      await Ie(), B ? (k.value = sl.value, w.value = !0) : (k.value = -1, w.value = !1), z.value = -1;
    }), ye(z, () => {
      k.value = sl.value, w.value = !0;
    }), (B, V) => {
      const W = Wn("SdsTag"), ee = oo, ce = Wn("SdsLoadingSpinner"), Be = xa, pt = Ju, il = Zu, vo = ql, yo = Wl, bo = ro, po = Nl, wo = Fu;
      return s(), u("div", {
        ref_key: "root",
        ref: l,
        "data-id": "sds-combo-box",
        class: "relative"
      }, [
        d("div", {
          class: D(["input-group flex flex-col", [
            r(y),
            {
              "input-group-sm": e.size === "sm",
              "bg-gray-50 dark:bg-gray-950": e.readonly
            }
          ]])
        }, [
          (e.type === "taggable-select" || e.type === "select") && e.multiple && Array.isArray(g.value) && g.value.length > 0 ? (s(), u("div", {
            key: 0,
            class: D(["flex flex-row flex-wrap rounded-t-sm gap-1 p-2 mr-auto justify-start w-full", {
              "bg-gray-50": e.readonly,
              "bg-gray-25 dark:bg-gray-950": !e.disabled,
              "bg-gray-100 dark:bg-gray-850": e.disabled
            }])
          }, [
            (s(!0), u(J, null, le(g.value, (ae, sa) => (s(), G(W, {
              key: sa,
              disabled: e.disabled,
              readonly: e.readonly || e.disabled,
              size: e.size === "sm" || e.size === "md" ? e.size : "md",
              action: "remove",
              class: "grow-0",
              label: String(typeof ae == "object" ? ae[e.optionLabel] ?? ae[r(x)] ?? "" : ae),
              onRemove: (we) => q(sa)
            }, null, 8, ["disabled", "readonly", "size", "label", "onRemove"]))), 128))
          ], 2)) : S("", !0),
          d("div", {
            class: D(["flex flex-row", {
              "h-7": e.size === "sm",
              "h-10": e.size !== "sm"
            }])
          }, [
            d("div", {
              class: D(["input-group-addon absolute z-0", {
                "py-1.75": e.size === "sm",
                "py-3": e.size !== "sm"
              }])
            }, [
              V[18] || (V[18] = d("span", { class: "sr-only" }, "Combo box", -1)),
              e.pending ? (s(), G(ce, {
                key: 1,
                size: "sm"
              })) : (s(), G(ee, {
                key: 0,
                class: D({
                  "-mt-px": !0,
                  "w-4 h-4": e.size === "sm",
                  "w-5 h-5": e.size !== "sm"
                })
              }, null, 8, ["class"]))
            ], 2),
            !e.multiple && (e.type === "select" || e.type === "taggable-select") && g.value.length ? (s(), u("span", {
              key: 0,
              class: D(["input-group-addon text-black absolute z-0 block! overflow-x-hidden text-ellipsis text-nowrap", {
                "py-1 left-7": e.size === "sm",
                "py-2 left-8": e.size !== "sm",
                "max-w-[calc(100%-3.5rem)]": r(pe) || r(Ee),
                "max-w-[calc(100%-5.5rem)]": e.focusOnKeyPress && !e.hideFocusIndicator && !r(Ee) && !e.disabled
              }])
            }, A(typeof g.value[0] == "object" ? String(g.value[0][e.optionLabel] ?? g.value[0][r(x)] ?? "") : String(g.value[0])), 3)) : S("", !0),
            d("input", {
              id: e.id,
              ref_key: "inputField",
              ref: i,
              value: r(at),
              type: "text",
              multiple: e.multiple || void 0,
              autocapitalize: "off",
              autocomplete: "off",
              spellcheck: "false",
              autocorrect: "off",
              class: D(["form-control border-none focus-visible:ring-0 z-1", {
                "opacity-0": !e.multiple && (e.type === "select" || e.type === "taggable-select") && g.value.length,
                "pl-8": e.size === "sm",
                "pl-10": e.size !== "sm",
                "absolute block left-0 w-[calc(100%-4rem)]": !r(v) && g.value.length && !e.multiple
              }]),
              placeholder: e.placeholder || void 0,
              disabled: e.disabled || void 0,
              readonly: r(f) || void 0,
              maxlength: e.maxlength !== void 0 ? e.maxlength : void 0,
              required: e.required && !(e.type === "select" || e.type === "taggable-select") || void 0,
              onInput: Tt,
              onClick: fe(Y, ["prevent"]),
              onKeydown: [
                Se(Pt, ["delete"]),
                V[0] || (V[0] = Se((ae) => v.value = !1, ["tab"])),
                V[1] || (V[1] = Se(fe((ae) => Nt("up", ae), ["prevent"]), ["up"])),
                V[2] || (V[2] = Se(fe((ae) => Nt("down", ae), ["prevent"]), ["down"])),
                V[3] || (V[3] = Se((ae) => Nt("left", ae), ["left"])),
                V[4] || (V[4] = Se((ae) => Nt("right", ae), ["right"])),
                V[5] || (V[5] = Se(fe(() => {
                }, ["prevent", "self"]), ["enter"]))
              ],
              onKeyup: Se(fe(ol, ["prevent", "self"]), ["enter"])
            }, null, 42, oc),
            e.type === "select" || e.type === "taggable-select" ? (s(), u("input", {
              key: 1,
              type: "text",
              value: g.value.length > 0 ? "selected" : "",
              required: e.required || void 0,
              tabindex: "-1",
              class: "absolute h-px p-0 m-0 overflow-hidden whitespace-nowrap border-0 left-1/2 -translate-x-1/2 -translate-y-1/2 top-full w-full",
              style: { clip: "rect(0, 0, 0, 0)" },
              onInput: V[6] || (V[6] = fe(() => {
              }, ["prevent"])),
              onKeydown: V[7] || (V[7] = fe(() => {
              }, ["prevent"]))
            }, null, 40, sc)) : S("", !0),
            r(pe) ? (s(), u("button", {
              key: 2,
              tabindex: "-1",
              type: "button",
              class: D(["btn-sm my-auto py-0 ml-auto btn text-gray-500 hover:text-gray-900 dark:hover:text-gray-100", {
                "px-2": e.size === "sm",
                "px-3": e.size !== "sm"
              }]),
              onMousedown: fe(Ot, ["prevent"])
            }, [
              V[19] || (V[19] = d("span", { class: "sr-only" }, "Clear query", -1)),
              Q(Be)
            ], 34)) : S("", !0),
            e.focusOnKeyPress && !e.hideFocusIndicator && !r(Ee) && !e.disabled ? (s(), u("div", ic, [
              Q(it, null, {
                trigger: U(() => [...V[20] || (V[20] = [
                  d("div", { class: "border dark:border-gray-700 rounded-theme-sm shadow-sm px-1.5 py-1 leading-2.5 cursor-default" }, [
                    d("span", null, "/")
                  ], -1)
                ])]),
                default: U(() => [
                  V[21] || (V[21] = d("p", null, ' Press "/" to focus ', -1))
                ]),
                _: 1
              })
            ])) : S("", !0),
            P(B.$slots, "default")
          ], 2)
        ], 2),
        r(Ul) ? (s(), u("div", dc, [
          r(I)?.length && !e.disableGroupTabs && !r(Fe) ? (s(), u("div", uc, [
            r(oa) ? (s(), G(Ia, {
              key: 0,
              ref: "tabs",
              modelValue: r(X),
              "onUpdate:modelValue": V[8] || (V[8] = (ae) => Ne(X) ? X.value = ae : null),
              type: "underline",
              variant: "blue",
              class: "[&>div:first-of-type]:flex [&>div:first-of-type]:flex-row [&>div:first-of-type:before]:block [&>div:first-of-type:before]:content-[''] [&>div:first-of-type:before]:w-4 [&>div:first-of-type:before]:h-12 [&>div:first-of-type:after]:block [&>div:first-of-type:after]:content-[''] [&>div:first-of-type:after]:w-4 [&>div:first-of-type:after]:h-12",
              onClick: fe(ol, ["prevent", "self"]),
              onKeydown: [
                V[9] || (V[9] = Se(fe(() => {
                }, ["prevent", "self"]), ["enter"])),
                V[10] || (V[10] = Se(fe((ae) => Nt("tabsUp", ae), ["prevent"]), ["up"])),
                V[11] || (V[11] = Se(fe((ae) => Nt("tabsDown", ae), ["prevent"]), ["down"]))
              ],
              onKeyup: Se(fe(ol, ["prevent", "self"]), ["enter"])
            }, null, 8, ["modelValue", "onKeyup"])) : S("", !0)
          ])) : S("", !0),
          Q(La, {
            ref_key: "scrollArea",
            ref: o,
            class: D(["max-h-72", {
              "py-0 flex flex-col": e.optionType !== "custom",
              "pt-2": !r(Fe) && r(p) > 1 && Rt(r(T)) > 0 && e.type !== "text" && e.enableSelectAll
            }])
          }, {
            default: U(() => [
              (e.type === "taggable-select" || e.type === "select") && e.enableSelectAll && e.multiple && r(p) > 1 && Rt(r(T)) > 1 ? (s(), u(J, { key: 0 }, [
                d("button", {
                  ref_key: "selectAllRef",
                  ref: h,
                  type: "button",
                  class: D(["flex items-center py-2 px-2 text-sm text-gray-600 dark:text-gray-300 mb-2 focus:outline-none sds-theme-forge:mx-2 sds-theme-plaid:px-4 sds-theme-forge:max-w-[calc(100%-1rem)] sds-theme-forge:rounded w-full text-left cursor-pointer hover:bg-gray-25 dark:hover:bg-gray-750", {
                    "mt-2": r(Fe),
                    "text-black dark:text-white bg-gray-25 dark:bg-gray-750": r(k) === 0
                  }]),
                  "aria-selected": r(k) === 0 ? "true" : "false",
                  "data-active": r(k) === 0 ? "true" : "false",
                  tabindex: "-1",
                  role: "option",
                  onClick: oe,
                  onKeydown: Se(fe(oe, ["prevent"]), ["enter"])
                }, [
                  d("input", {
                    id: "select-all",
                    type: "checkbox",
                    checked: r(O),
                    indeterminate: r(_),
                    "aria-label": "Select all",
                    class: "mr-2 pointer-events-none",
                    tabindex: "-1"
                  }, null, 8, fc),
                  V[22] || (V[22] = d("label", {
                    for: "select-all",
                    class: "cursor-pointer select-none pointer-events-none"
                  }, [
                    d("span", null, "Select all")
                  ], -1))
                ], 42, cc),
                (e.type === "taggable-select" || e.type === "select") && e.multiple && r(Fe) ? (s(), u("hr", hc)) : S("", !0)
              ], 64)) : S("", !0),
              (s(!0), u(J, null, le(r(T), (ae, sa) => (s(), u(J, {
                key: `${ae}_${sa}`
              }, [
                e.optionGroupChildren && ae[e.optionGroupChildren]?.length ? (s(), u("div", {
                  key: 0,
                  class: D(["flex flex-col gap-y-1 pb-2 mb-0", {
                    "first:[&>div]:border-t-0": !e.multiple,
                    "border-t border-gray-50 dark:border-gray-800 pt-2": r(L).label !== "All" && e.multiple && Rt(ae[e.optionGroupChildren]) > 1 && e.enableSelectAll
                  }])
                }, [
                  r(z) === -1 ? (s(), u("div", {
                    key: 0,
                    class: D(["flex w-full px-4 py-2 text-sm text-left text-black list-none dark:text-white font-semibold", {
                      "border-t border-gray-50 dark:border-gray-800": r(L).label === "All"
                    }])
                  }, [
                    P(B.$slots, "optionGroup", {
                      option: ae,
                      label: e.optionGroupLabel ? ae[e.optionGroupLabel] : ae
                    }, () => [
                      re(A(e.optionGroupLabel ? ae[e.optionGroupLabel] : ae), 1)
                    ])
                  ], 2)) : S("", !0),
                  (s(!0), u(J, null, le(ae[e.optionGroupChildren], (we, xo) => (s(), u(J, {
                    key: `${ae}_${we}_${xo}`
                  }, [
                    e.optionType !== "custom" ? (s(), G(mt(e.optionType), {
                      key: 0,
                      ref_for: !0,
                      ref_key: "dropdownOption",
                      ref: c,
                      tabindex: "-1",
                      href: e.optionType === "a" ? we.href : void 0,
                      class: D(["flex flex-row w-full p-2 sds-theme-forge:mx-2 sds-theme-plaid:px-4 sds-theme-forge:max-w-[calc(100%-1rem)] sds-theme-forge:rounded text-sm text-left list-none cursor-pointer hover:text-black dark:hover:text-white hover:bg-gray-25 dark:hover:bg-gray-750", {
                        "text-gray-700 dark:text-gray-300": !be(we),
                        "text-black dark:text-white bg-gray-25 dark:bg-gray-750": be(we),
                        "text-black dark:text-white font-semibold": Z(e.optionLabel ? we[e.optionLabel] : we[r(x)]) && e.type !== "text"
                      }]),
                      "data-active": be(we),
                      type: e.optionType === "button" ? "button" : void 0,
                      onClick: fe((Kl) => Bt(we), ["prevent"])
                    }, {
                      default: U(() => [
                        (e.type === "taggable-select" || e.type === "select") && e.multiple ? (s(), u("input", {
                          key: 0,
                          type: "checkbox",
                          class: "mr-2 my-auto",
                          tabindex: "-1",
                          "aria-label": "Select option",
                          checked: Z(e.optionLabel ? we[e.optionLabel] : we[r(x)]),
                          onChange: fe((Kl) => Bt(we), ["stop"])
                        }, null, 40, mc)) : S("", !0),
                        P(B.$slots, "option", {
                          option: we,
                          label: e.optionLabel ? we[e.optionLabel] : we[r(x)]
                        }, () => [
                          re(A(e.optionLabel ? we[e.optionLabel] : we[r(x)]), 1)
                        ]),
                        Z(e.optionLabel ? we[e.optionLabel] : we[r(x)]) && e.type !== "text" && !e.multiple ? (s(), G(pt, {
                          key: 1,
                          class: "text-blue-700 dark:text-blue-400 ml-auto my-auto w-3 h-3"
                        })) : S("", !0)
                      ]),
                      _: 2
                    }, 1032, ["href", "class", "data-active", "type", "onClick"])) : (s(), u("div", {
                      key: 1,
                      ref_for: !0,
                      ref_key: "dropdownOption",
                      ref: c,
                      class: "first:mt-2 last:mb-2"
                    }, [
                      P(B.$slots, "customOption", {
                        href: we.href,
                        classList: {
                          "flex w-full sds-theme-forge:mx-2 sds-theme-plaid:px-4 p-2 sds-theme-forge:max-w-[calc(100%-1rem)] sds-theme-forge:rounded text-sm text-left list-none cursor-pointer hover:text-black dark:hover:text-white hover:bg-gray-50 dark:hover:bg-gray-800": !0,
                          "text-gray-700 dark:text-gray-300": !be(we),
                          "text-black dark:text-white bg-gray-50 dark:bg-gray-800": be(we)
                        },
                        dataActive: be(we),
                        tabindex: r(k) === 0 ? 0 : -1,
                        option: we,
                        label: e.optionLabel ? we[e.optionLabel] : we[r(x)],
                        onClick: fe((Kl) => Bt(we), ["prevent"])
                      }, () => [
                        re(A(e.optionLabel ? we[e.optionLabel] : we[r(x)]), 1)
                      ])
                    ], 512))
                  ], 64))), 128))
                ], 2)) : S("", !0)
              ], 64))), 128)),
              !e.optionGroupChildren && r(T).length ? (s(), u("div", {
                key: 1,
                class: D(["flex flex-col gap-y-1", {
                  "py-2": e.optionType !== "custom"
                }])
              }, [
                (s(!0), u(J, null, le(r(T), (ae, sa) => (s(), u(J, {
                  key: `${ae}_${sa}`
                }, [
                  e.optionType !== "custom" ? (s(), G(mt(e.optionType), {
                    key: 0,
                    ref_for: !0,
                    ref_key: "dropdownOption",
                    ref: c,
                    href: e.optionType === "a" ? ae.href : void 0,
                    class: D(["flex w-full sds-theme-forge:mx-2 sds-theme-plaid:px-4 p-2 sds-theme-forge:max-w-[calc(100%-1rem)] sds-theme-forge:rounded text-sm text-left list-none cursor-pointer hover:text-black dark:hover:text-white hover:bg-gray-25 dark:hover:bg-gray-750", {
                      "text-gray-700 dark:text-gray-300": !be(ae),
                      "text-black dark:text-white font-semibold": Z(e.optionLabel ? ae[e.optionLabel] : ae[r(x)]) && e.type !== "text",
                      "text-black dark:text-white bg-gray-25 dark:bg-gray-750": be(ae),
                      "last:mb-2": r(I).length < 2
                    }]),
                    "data-active": be(ae),
                    type: e.optionType === "button" ? "button" : void 0,
                    tabindex: "-1",
                    onClick: fe((we) => Bt(ae), ["prevent"])
                  }, {
                    default: U(() => [
                      (e.type === "taggable-select" || e.type === "select") && e.multiple ? (s(), u("input", {
                        key: 0,
                        type: "checkbox",
                        class: "mr-2 my-auto",
                        "aria-label": "Select option",
                        tabindex: r(k) === 0 ? 0 : -1,
                        checked: Z(e.optionLabel ? ae[e.optionLabel] : ae[r(x)]),
                        onChange: fe((we) => Bt(ae), ["stop"])
                      }, null, 40, gc)) : S("", !0),
                      P(B.$slots, "option", {
                        option: ae,
                        label: e.optionLabel ? ae[e.optionLabel] : ae[r(x)]
                      }, () => [
                        re(A(e.optionLabel ? ae[e.optionLabel] : ae[r(x)]), 1)
                      ]),
                      Z(e.optionLabel ? ae[e.optionLabel] : ae[r(x)]) && e.type !== "text" && !e.multiple ? (s(), G(pt, {
                        key: 1,
                        class: "text-blue-700 dark:text-blue-400 ml-auto my-auto w-3 h-3"
                      })) : S("", !0)
                    ]),
                    _: 2
                  }, 1032, ["href", "class", "data-active", "type", "onClick"])) : (s(), u("div", {
                    key: 1,
                    ref_for: !0,
                    ref_key: "dropdownOption",
                    ref: c,
                    class: "first:mt-2 last:mb-2"
                  }, [
                    P(B.$slots, "customOption", {
                      classList: {
                        "flex w-full sds-theme-forge:mx-2 sds-theme-plaid:px-4 p-2 sds-theme-forge:max-w-[calc(100%-1rem)] sds-theme-forge:rounded text-sm text-left list-none cursor-pointer hover:text-black dark:hover:text-white hover:bg-gray-50 dark:hover:bg-gray-800": !0,
                        "text-gray-700 dark:text-gray-300": !be(ae),
                        "text-black dark:text-white bg-gray-50 dark:bg-gray-800": be(ae)
                      },
                      dataActive: be(ae),
                      href: ae.href,
                      tabindex: r(k) === 0 ? 0 : -1,
                      option: ae,
                      label: e.optionLabel ? ae[e.optionLabel] : ae[r(x)],
                      onClick: fe((we) => Bt(ae), ["prevent"])
                    }, () => [
                      re(A(e.optionLabel ? ae[e.optionLabel] : ae[r(x)]), 1)
                    ])
                  ], 512))
                ], 64))), 128))
              ], 2)) : S("", !0),
              r(Et) && e.type === "taggable-select" && r(p) ? (s(), u("hr", vc)) : S("", !0),
              r(Et) ? (s(), u("div", yc, [
                Z(m.value) ? (s(), u("p", bc, [
                  V[23] || (V[23] = d("i", { class: "text-gray-600" }, "Already added", -1)),
                  re(' "' + A(m.value) + '" ', 1)
                ])) : (s(), u("button", {
                  key: 1,
                  ref_key: "dropdownOption",
                  ref: c,
                  class: D(["flex flex-row w-full sds-theme-forge:mx-2 sds-theme-plaid:px-4 p-2 sds-theme-forge:max-w-[calc(100%-1rem)] sds-theme-forge:rounded text-sm text-left list-none cursor-pointer hover:text-black dark:hover:text-white hover:bg-gray-25 dark:hover:bg-gray-750", {
                    "text-gray-700 dark:text-gray-300": !be({ __cbxIdx: "add" }),
                    "text-black dark:text-white bg-gray-50 dark:bg-gray-800": Z(m.value) && !be({ __cbxIdx: "add" }),
                    "text-black dark:text-white bg-gray-25 dark:bg-gray-750": be({ __cbxIdx: "add" }) || r(k) === Za()
                  }]),
                  "aria-selected": r(k) === 0 ? "true" : "false",
                  "data-active": be({ __cbxIdx: "add" }),
                  tabindex: "-1",
                  onInput: Tt,
                  onClick: V[12] || (V[12] = fe((ae) => v.value = e.readonly || e.disabled ? !1 : !r(v), ["prevent"])),
                  onKeydown: [
                    Se(Pt, ["delete"]),
                    V[13] || (V[13] = Se((ae) => v.value = !1, ["tab"])),
                    V[14] || (V[14] = Se(fe((ae) => Nt("left", ae), ["prevent", "stop"]), ["left"])),
                    V[15] || (V[15] = Se(fe((ae) => Nt("right", ae), ["prevent", "stop"]), ["right"])),
                    V[16] || (V[16] = Se(fe((ae) => Bt({
                      label: m.value,
                      name: m.value,
                      value: m.value,
                      __cbxIdx: "add"
                    }), ["prevent"]), ["enter"]))
                  ],
                  onMousedown: V[17] || (V[17] = fe((ae) => Bt({
                    label: m.value,
                    name: m.value,
                    value: m.value,
                    __cbxIdx: "add"
                  }), ["prevent"]))
                }, [
                  P(B.$slots, "option", {
                    option: {
                      label: m.value,
                      name: m.value,
                      value: m.value,
                      index: "add"
                    },
                    label: m.value
                  }, () => [
                    Q(il, { class: "w-3 h-3 my-auto ml-1 mr-2" }),
                    re(' Add "' + A(m.value) + '" ', 1)
                  ])
                ], 42, pc))
              ])) : S("", !0)
            ]),
            _: 3
          }, 8, ["class"]),
          Z(m.value) ? S("", !0) : (s(), u("div", wc, [
            d("div", xc, [
              d("div", kc, [
                Q(vo, { class: "w-3 h-3" }),
                Q(yo, { class: "w-3 h-3" })
              ]),
              V[24] || (V[24] = d("span", { class: "sr-only" }, "Up, down", -1)),
              V[25] || (V[25] = re(" to navigate ", -1))
            ]),
            !r(Fe) && r(I).length > 1 ? (s(), u("div", Cc, [
              d("div", $c, [
                Q(bo, { class: "w-3 h-3" }),
                Q(po, { class: "w-3 h-3" })
              ]),
              V[26] || (V[26] = d("span", { class: "sr-only" }, "Left, right", -1)),
              V[27] || (V[27] = re(" to switch tabs ", -1))
            ])) : S("", !0),
            d("div", Mc, [
              d("div", Sc, [
                Q(wo, { class: "w-3 h-3" })
              ]),
              V[28] || (V[28] = d("span", { class: "sr-only" }, "Enter", -1)),
              V[29] || (V[29] = re(" to select ", -1))
            ])
          ]))
        ])) : S("", !0)
      ], 512);
    };
  }
});
Va.install = (e) => {
  e.component(Va.name, Va);
};
const Dc = {
  key: 0,
  class: "text-base"
}, zc = { class: "flex gap-2" }, Tc = {
  key: 0,
  class: "text-base mt-auto"
}, on = /* @__PURE__ */ te({
  name: "SdsDatapoint",
  __name: "Datapoint",
  props: /* @__PURE__ */ xe({
    label: { default: null },
    context: { default: null },
    size: { default: "md" },
    variant: { default: null }
  }, {
    modelValue: { type: [String, Number], default: null },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(e) {
    const a = e, t = Te(e, "modelValue"), n = M(() => typeof t.value == "number" ? t.value.toLocaleString() : t.value), l = M(() => {
      let i = "";
      switch (a.size) {
        case "sm":
          i = "text-lg";
          break;
        case "md":
          i = "text-3xl";
          break;
        default:
          i = "text-5xl";
      }
      return i;
    }), o = M(() => {
      let i = "";
      switch (a.variant) {
        case "blue":
          i = "text-blue-600 dark:text-blue-400";
          break;
        case "green":
          i = "text-green-600 dark:text-green-400";
          break;
        case "teal":
          i = "text-teal-600 dark:text-teal-400";
          break;
        case "orange":
          a.size === "lg" ? i = "text-orange-400 dark:text-orange-300" : a.size === "md" ? i = "text-orange-500 dark:text-orange-300" : i = "text-orange-600 dark:text-orange-300";
          break;
        case "red":
          i = "text-red-600 dark:text-red-400";
          break;
        case "tan":
          i = "text-tan-600 dark:text-tan-400";
          break;
        case "yellow":
          a.size === "sm" ? i = "text-yellow-600 dark:text-yellow-300" : i = "text-yellow-500 dark:text-yellow-300";
          break;
        case "purple":
          i = "text-purple-600 dark:text-purple-400";
          break;
        case "indigo":
          i = "text-indigo-600 dark:text-indigo-400";
          break;
        case "gray":
          i = "text-gray-600 dark:text-gray-300";
          break;
        default:
          i = "text-black dark:text-white";
          break;
      }
      return i;
    });
    return (i, h) => (s(), u("div", null, [
      i.$slots.label || e.label ? (s(), u("div", Dc, [
        P(i.$slots, "label", {}, () => [
          re(A(e.label), 1)
        ])
      ])) : S("", !0),
      d("div", zc, [
        d("div", {
          class: D(["font-bold", [r(l), r(o)]])
        }, [
          P(i.$slots, "default", {}, () => [
            re(A(r(n)), 1)
          ])
        ], 2),
        i.$slots.context || e.context ? (s(), u("div", Tc, [
          P(i.$slots, "context", {}, () => [
            re(A(e.context), 1)
          ])
        ])) : S("", !0)
      ])
    ]));
  }
});
on.install = (e) => {
  e.component(on.name, on);
};
const Bc = {
  viewBox: "0 0 640 640",
  "aria-hidden": "true",
  role: "img",
  width: "1.2em",
  height: "1.2em"
};
function Lc(e, a) {
  return s(), u("svg", Bc, [...a[0] || (a[0] = [
    d("path", {
      fill: "currentColor",
      d: "M216 64c13.3 0 24 10.7 24 24v40h160V88c0-13.3 10.7-24 24-24s24 10.7 24 24v40h32c35.3 0 64 28.7 64 64v288c0 35.3-28.7 64-64 64H160c-35.3 0-64-28.7-64-64V192c0-35.3 28.7-64 64-64h32V88c0-13.3 10.7-24 24-24m0 112h-56c-8.8 0-16 7.2-16 16v48h352v-48c0-8.8-7.2-16-16-16zm-72 112v192c0 8.8 7.2 16 16 16h320c8.8 0 16-7.2 16-16V288z"
    }, null, -1)
  ])]);
}
const Ic = $e({ name: "fa7-regular-calendar", render: Lc });
function Vc() {
  return Object.assign({}, wa());
}
function Ac(e, a) {
  const t = Hc(a) ? new a(0) : De(a, 0);
  return t.setFullYear(e.getFullYear(), e.getMonth(), e.getDate()), t.setHours(
    e.getHours(),
    e.getMinutes(),
    e.getSeconds(),
    e.getMilliseconds()
  ), t;
}
function Hc(e) {
  return typeof e == "function" && e.prototype?.constructor === e;
}
const Oc = 10;
class so {
  subPriority = 0;
  validate(a, t) {
    return !0;
  }
}
class Pc extends so {
  constructor(a, t, n, l, o) {
    super(), this.value = a, this.validateValue = t, this.setValue = n, this.priority = l, o && (this.subPriority = o);
  }
  validate(a, t) {
    return this.validateValue(a, this.value, t);
  }
  set(a, t, n) {
    return this.setValue(a, t, this.value, n);
  }
}
class Fc extends so {
  priority = Oc;
  subPriority = -1;
  constructor(a, t) {
    super(), this.context = a || ((n) => De(t, n));
  }
  set(a, t) {
    return t.timestampIsSet ? a : De(a, Ac(a, this.context));
  }
}
class ke {
  run(a, t, n, l) {
    const o = this.parse(a, t, n, l);
    return o ? {
      setter: new Pc(
        o.value,
        this.validate,
        this.set,
        this.priority,
        this.subPriority
      ),
      rest: o.rest
    } : null;
  }
  validate(a, t, n) {
    return !0;
  }
}
class Ec extends ke {
  priority = 140;
  parse(a, t, n) {
    switch (t) {
      // AD, BC
      case "G":
      case "GG":
      case "GGG":
        return n.era(a, { width: "abbreviated" }) || n.era(a, { width: "narrow" });
      // A, B
      case "GGGGG":
        return n.era(a, { width: "narrow" });
      default:
        return n.era(a, { width: "wide" }) || n.era(a, { width: "abbreviated" }) || n.era(a, { width: "narrow" });
    }
  }
  set(a, t, n) {
    return t.era = n, a.setFullYear(n, 0, 1), a.setHours(0, 0, 0, 0), a;
  }
  incompatibleTokens = ["R", "u", "t", "T"];
}
const Oe = {
  month: /^(1[0-2]|0?\d)/,
  // 0 to 12
  date: /^(3[0-1]|[0-2]?\d)/,
  // 0 to 31
  dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
  // 0 to 366
  week: /^(5[0-3]|[0-4]?\d)/,
  // 0 to 53
  hour23h: /^(2[0-3]|[0-1]?\d)/,
  // 0 to 23
  hour24h: /^(2[0-4]|[0-1]?\d)/,
  // 0 to 24
  hour11h: /^(1[0-1]|0?\d)/,
  // 0 to 11
  hour12h: /^(1[0-2]|0?\d)/,
  // 0 to 12
  minute: /^[0-5]?\d/,
  // 0 to 59
  second: /^[0-5]?\d/,
  // 0 to 59
  singleDigit: /^\d/,
  // 0 to 9
  twoDigits: /^\d{1,2}/,
  // 0 to 99
  threeDigits: /^\d{1,3}/,
  // 0 to 999
  fourDigits: /^\d{1,4}/,
  // 0 to 9999
  anyDigitsSigned: /^-?\d+/,
  singleDigitSigned: /^-?\d/,
  // 0 to 9, -0 to -9
  twoDigitsSigned: /^-?\d{1,2}/,
  // 0 to 99, -0 to -99
  threeDigitsSigned: /^-?\d{1,3}/,
  // 0 to 999, -0 to -999
  fourDigitsSigned: /^-?\d{1,4}/
  // 0 to 9999, -0 to -9999
}, wt = {
  basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
  basic: /^([+-])(\d{2})(\d{2})|Z/,
  basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
  extended: /^([+-])(\d{2}):(\d{2})|Z/,
  extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};
function Pe(e, a) {
  return e && {
    value: a(e.value),
    rest: e.rest
  };
}
function Ve(e, a) {
  const t = a.match(e);
  return t ? {
    value: parseInt(t[0], 10),
    rest: a.slice(t[0].length)
  } : null;
}
function xt(e, a) {
  const t = a.match(e);
  if (!t)
    return null;
  if (t[0] === "Z")
    return {
      value: 0,
      rest: a.slice(1)
    };
  const n = t[1] === "+" ? 1 : -1, l = t[2] ? parseInt(t[2], 10) : 0, o = t[3] ? parseInt(t[3], 10) : 0, i = t[5] ? parseInt(t[5], 10) : 0;
  return {
    value: n * (l * Xi + o * Qi + i * Ji),
    rest: a.slice(t[0].length)
  };
}
function io(e) {
  return Ve(Oe.anyDigitsSigned, e);
}
function He(e, a) {
  switch (e) {
    case 1:
      return Ve(Oe.singleDigit, a);
    case 2:
      return Ve(Oe.twoDigits, a);
    case 3:
      return Ve(Oe.threeDigits, a);
    case 4:
      return Ve(Oe.fourDigits, a);
    default:
      return Ve(new RegExp("^\\d{1," + e + "}"), a);
  }
}
function Zn(e, a) {
  switch (e) {
    case 1:
      return Ve(Oe.singleDigitSigned, a);
    case 2:
      return Ve(Oe.twoDigitsSigned, a);
    case 3:
      return Ve(Oe.threeDigitsSigned, a);
    case 4:
      return Ve(Oe.fourDigitsSigned, a);
    default:
      return Ve(new RegExp("^-?\\d{1," + e + "}"), a);
  }
}
function Yl(e) {
  switch (e) {
    case "morning":
      return 4;
    case "evening":
      return 17;
    case "pm":
    case "noon":
    case "afternoon":
      return 12;
    default:
      return 0;
  }
}
function uo(e, a) {
  const t = a > 0, n = t ? a : 1 - a;
  let l;
  if (n <= 50)
    l = e || 100;
  else {
    const o = n + 50, i = Math.trunc(o / 100) * 100, h = e >= o % 100;
    l = e + i - (h ? 100 : 0);
  }
  return t ? l : 1 - l;
}
function co(e) {
  return e % 400 === 0 || e % 4 === 0 && e % 100 !== 0;
}
class Rc extends ke {
  priority = 130;
  incompatibleTokens = ["Y", "R", "u", "w", "I", "i", "e", "c", "t", "T"];
  parse(a, t, n) {
    const l = (o) => ({
      year: o,
      isTwoDigitYear: t === "yy"
    });
    switch (t) {
      case "y":
        return Pe(He(4, a), l);
      case "yo":
        return Pe(
          n.ordinalNumber(a, {
            unit: "year"
          }),
          l
        );
      default:
        return Pe(He(t.length, a), l);
    }
  }
  validate(a, t) {
    return t.isTwoDigitYear || t.year > 0;
  }
  set(a, t, n) {
    const l = a.getFullYear();
    if (n.isTwoDigitYear) {
      const i = uo(
        n.year,
        l
      );
      return a.setFullYear(i, 0, 1), a.setHours(0, 0, 0, 0), a;
    }
    const o = !("era" in t) || t.era === 1 ? n.year : 1 - n.year;
    return a.setFullYear(o, 0, 1), a.setHours(0, 0, 0, 0), a;
  }
}
class Nc extends ke {
  priority = 130;
  parse(a, t, n) {
    const l = (o) => ({
      year: o,
      isTwoDigitYear: t === "YY"
    });
    switch (t) {
      case "Y":
        return Pe(He(4, a), l);
      case "Yo":
        return Pe(
          n.ordinalNumber(a, {
            unit: "year"
          }),
          l
        );
      default:
        return Pe(He(t.length, a), l);
    }
  }
  validate(a, t) {
    return t.isTwoDigitYear || t.year > 0;
  }
  set(a, t, n, l) {
    const o = Rl(a, l);
    if (n.isTwoDigitYear) {
      const h = uo(
        n.year,
        o
      );
      return a.setFullYear(
        h,
        0,
        l.firstWeekContainsDate
      ), a.setHours(0, 0, 0, 0), Zt(a, l);
    }
    const i = !("era" in t) || t.era === 1 ? n.year : 1 - n.year;
    return a.setFullYear(i, 0, l.firstWeekContainsDate), a.setHours(0, 0, 0, 0), Zt(a, l);
  }
  incompatibleTokens = [
    "y",
    "R",
    "u",
    "Q",
    "q",
    "M",
    "L",
    "I",
    "d",
    "D",
    "i",
    "t",
    "T"
  ];
}
class Wc extends ke {
  priority = 130;
  parse(a, t) {
    return Zn(t === "R" ? 4 : t.length, a);
  }
  set(a, t, n) {
    const l = De(a, 0);
    return l.setFullYear(n, 0, 4), l.setHours(0, 0, 0, 0), ba(l);
  }
  incompatibleTokens = [
    "G",
    "y",
    "Y",
    "u",
    "Q",
    "q",
    "M",
    "L",
    "w",
    "d",
    "D",
    "e",
    "c",
    "t",
    "T"
  ];
}
class qc extends ke {
  priority = 130;
  parse(a, t) {
    return Zn(t === "u" ? 4 : t.length, a);
  }
  set(a, t, n) {
    return a.setFullYear(n, 0, 1), a.setHours(0, 0, 0, 0), a;
  }
  incompatibleTokens = ["G", "y", "Y", "R", "w", "I", "i", "e", "c", "t", "T"];
}
class Yc extends ke {
  priority = 120;
  parse(a, t, n) {
    switch (t) {
      // 1, 2, 3, 4
      case "Q":
      case "QQ":
        return He(t.length, a);
      // 1st, 2nd, 3rd, 4th
      case "Qo":
        return n.ordinalNumber(a, { unit: "quarter" });
      // Q1, Q2, Q3, Q4
      case "QQQ":
        return n.quarter(a, {
          width: "abbreviated",
          context: "formatting"
        }) || n.quarter(a, {
          width: "narrow",
          context: "formatting"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "QQQQQ":
        return n.quarter(a, {
          width: "narrow",
          context: "formatting"
        });
      default:
        return n.quarter(a, {
          width: "wide",
          context: "formatting"
        }) || n.quarter(a, {
          width: "abbreviated",
          context: "formatting"
        }) || n.quarter(a, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  validate(a, t) {
    return t >= 1 && t <= 4;
  }
  set(a, t, n) {
    return a.setMonth((n - 1) * 3, 1), a.setHours(0, 0, 0, 0), a;
  }
  incompatibleTokens = [
    "Y",
    "R",
    "q",
    "M",
    "L",
    "w",
    "I",
    "d",
    "D",
    "i",
    "e",
    "c",
    "t",
    "T"
  ];
}
class jc extends ke {
  priority = 120;
  parse(a, t, n) {
    switch (t) {
      // 1, 2, 3, 4
      case "q":
      case "qq":
        return He(t.length, a);
      // 1st, 2nd, 3rd, 4th
      case "qo":
        return n.ordinalNumber(a, { unit: "quarter" });
      // Q1, Q2, Q3, Q4
      case "qqq":
        return n.quarter(a, {
          width: "abbreviated",
          context: "standalone"
        }) || n.quarter(a, {
          width: "narrow",
          context: "standalone"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "qqqqq":
        return n.quarter(a, {
          width: "narrow",
          context: "standalone"
        });
      default:
        return n.quarter(a, {
          width: "wide",
          context: "standalone"
        }) || n.quarter(a, {
          width: "abbreviated",
          context: "standalone"
        }) || n.quarter(a, {
          width: "narrow",
          context: "standalone"
        });
    }
  }
  validate(a, t) {
    return t >= 1 && t <= 4;
  }
  set(a, t, n) {
    return a.setMonth((n - 1) * 3, 1), a.setHours(0, 0, 0, 0), a;
  }
  incompatibleTokens = [
    "Y",
    "R",
    "Q",
    "M",
    "L",
    "w",
    "I",
    "d",
    "D",
    "i",
    "e",
    "c",
    "t",
    "T"
  ];
}
class Gc extends ke {
  incompatibleTokens = [
    "Y",
    "R",
    "q",
    "Q",
    "L",
    "w",
    "I",
    "D",
    "i",
    "e",
    "c",
    "t",
    "T"
  ];
  priority = 110;
  parse(a, t, n) {
    const l = (o) => o - 1;
    switch (t) {
      // 1, 2, ..., 12
      case "M":
        return Pe(
          Ve(Oe.month, a),
          l
        );
      // 01, 02, ..., 12
      case "MM":
        return Pe(He(2, a), l);
      // 1st, 2nd, ..., 12th
      case "Mo":
        return Pe(
          n.ordinalNumber(a, {
            unit: "month"
          }),
          l
        );
      // Jan, Feb, ..., Dec
      case "MMM":
        return n.month(a, {
          width: "abbreviated",
          context: "formatting"
        }) || n.month(a, { width: "narrow", context: "formatting" });
      // J, F, ..., D
      case "MMMMM":
        return n.month(a, {
          width: "narrow",
          context: "formatting"
        });
      default:
        return n.month(a, { width: "wide", context: "formatting" }) || n.month(a, {
          width: "abbreviated",
          context: "formatting"
        }) || n.month(a, { width: "narrow", context: "formatting" });
    }
  }
  validate(a, t) {
    return t >= 0 && t <= 11;
  }
  set(a, t, n) {
    return a.setMonth(n, 1), a.setHours(0, 0, 0, 0), a;
  }
}
class Uc extends ke {
  priority = 110;
  parse(a, t, n) {
    const l = (o) => o - 1;
    switch (t) {
      // 1, 2, ..., 12
      case "L":
        return Pe(
          Ve(Oe.month, a),
          l
        );
      // 01, 02, ..., 12
      case "LL":
        return Pe(He(2, a), l);
      // 1st, 2nd, ..., 12th
      case "Lo":
        return Pe(
          n.ordinalNumber(a, {
            unit: "month"
          }),
          l
        );
      // Jan, Feb, ..., Dec
      case "LLL":
        return n.month(a, {
          width: "abbreviated",
          context: "standalone"
        }) || n.month(a, { width: "narrow", context: "standalone" });
      // J, F, ..., D
      case "LLLLL":
        return n.month(a, {
          width: "narrow",
          context: "standalone"
        });
      default:
        return n.month(a, { width: "wide", context: "standalone" }) || n.month(a, {
          width: "abbreviated",
          context: "standalone"
        }) || n.month(a, { width: "narrow", context: "standalone" });
    }
  }
  validate(a, t) {
    return t >= 0 && t <= 11;
  }
  set(a, t, n) {
    return a.setMonth(n, 1), a.setHours(0, 0, 0, 0), a;
  }
  incompatibleTokens = [
    "Y",
    "R",
    "q",
    "Q",
    "M",
    "w",
    "I",
    "D",
    "i",
    "e",
    "c",
    "t",
    "T"
  ];
}
function Kc(e, a, t) {
  const n = he(e, t?.in), l = eo(n, t) - a;
  return n.setDate(n.getDate() - l * 7), he(n, t?.in);
}
class Zc extends ke {
  priority = 100;
  parse(a, t, n) {
    switch (t) {
      case "w":
        return Ve(Oe.week, a);
      case "wo":
        return n.ordinalNumber(a, { unit: "week" });
      default:
        return He(t.length, a);
    }
  }
  validate(a, t) {
    return t >= 1 && t <= 53;
  }
  set(a, t, n, l) {
    return Zt(Kc(a, n, l), l);
  }
  incompatibleTokens = [
    "y",
    "R",
    "u",
    "q",
    "Q",
    "M",
    "L",
    "I",
    "d",
    "D",
    "i",
    "t",
    "T"
  ];
}
function Qc(e, a, t) {
  const n = he(e, t?.in), l = _r(n, t) - a;
  return n.setDate(n.getDate() - l * 7), n;
}
class Xc extends ke {
  priority = 100;
  parse(a, t, n) {
    switch (t) {
      case "I":
        return Ve(Oe.week, a);
      case "Io":
        return n.ordinalNumber(a, { unit: "week" });
      default:
        return He(t.length, a);
    }
  }
  validate(a, t) {
    return t >= 1 && t <= 53;
  }
  set(a, t, n) {
    return ba(Qc(a, n));
  }
  incompatibleTokens = [
    "y",
    "Y",
    "u",
    "q",
    "Q",
    "M",
    "L",
    "w",
    "d",
    "D",
    "e",
    "c",
    "t",
    "T"
  ];
}
const Jc = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], _c = [
  31,
  29,
  31,
  30,
  31,
  30,
  31,
  31,
  30,
  31,
  30,
  31
];
class e0 extends ke {
  priority = 90;
  subPriority = 1;
  parse(a, t, n) {
    switch (t) {
      case "d":
        return Ve(Oe.date, a);
      case "do":
        return n.ordinalNumber(a, { unit: "date" });
      default:
        return He(t.length, a);
    }
  }
  validate(a, t) {
    const n = a.getFullYear(), l = co(n), o = a.getMonth();
    return l ? t >= 1 && t <= _c[o] : t >= 1 && t <= Jc[o];
  }
  set(a, t, n) {
    return a.setDate(n), a.setHours(0, 0, 0, 0), a;
  }
  incompatibleTokens = [
    "Y",
    "R",
    "q",
    "Q",
    "w",
    "I",
    "D",
    "i",
    "e",
    "c",
    "t",
    "T"
  ];
}
class t0 extends ke {
  priority = 90;
  subpriority = 1;
  parse(a, t, n) {
    switch (t) {
      case "D":
      case "DD":
        return Ve(Oe.dayOfYear, a);
      case "Do":
        return n.ordinalNumber(a, { unit: "date" });
      default:
        return He(t.length, a);
    }
  }
  validate(a, t) {
    const n = a.getFullYear();
    return co(n) ? t >= 1 && t <= 366 : t >= 1 && t <= 365;
  }
  set(a, t, n) {
    return a.setMonth(0, n), a.setHours(0, 0, 0, 0), a;
  }
  incompatibleTokens = [
    "Y",
    "R",
    "q",
    "Q",
    "M",
    "L",
    "w",
    "I",
    "d",
    "E",
    "i",
    "e",
    "c",
    "t",
    "T"
  ];
}
function rl(e, a, t) {
  const n = he(e, t?.in);
  return isNaN(a) ? De(t?.in || e, NaN) : (a && n.setDate(n.getDate() + a), n);
}
function jl(e, a, t) {
  const n = wa(), l = t?.weekStartsOn ?? t?.locale?.options?.weekStartsOn ?? n.weekStartsOn ?? n.locale?.options?.weekStartsOn ?? 0, o = he(e, t?.in), i = o.getDay(), c = (a % 7 + 7) % 7, f = 7 - l, y = a < 0 || a > 6 ? a - (i + f) % 7 : (c + f) % 7 - (i + f) % 7;
  return rl(o, y, t);
}
class a0 extends ke {
  priority = 90;
  parse(a, t, n) {
    switch (t) {
      // Tue
      case "E":
      case "EE":
      case "EEE":
        return n.day(a, {
          width: "abbreviated",
          context: "formatting"
        }) || n.day(a, { width: "short", context: "formatting" }) || n.day(a, { width: "narrow", context: "formatting" });
      // T
      case "EEEEE":
        return n.day(a, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "EEEEEE":
        return n.day(a, { width: "short", context: "formatting" }) || n.day(a, { width: "narrow", context: "formatting" });
      default:
        return n.day(a, { width: "wide", context: "formatting" }) || n.day(a, {
          width: "abbreviated",
          context: "formatting"
        }) || n.day(a, { width: "short", context: "formatting" }) || n.day(a, { width: "narrow", context: "formatting" });
    }
  }
  validate(a, t) {
    return t >= 0 && t <= 6;
  }
  set(a, t, n, l) {
    return a = jl(a, n, l), a.setHours(0, 0, 0, 0), a;
  }
  incompatibleTokens = ["D", "i", "e", "c", "t", "T"];
}
class n0 extends ke {
  priority = 90;
  parse(a, t, n, l) {
    const o = (i) => {
      const h = Math.floor((i - 1) / 7) * 7;
      return (i + l.weekStartsOn + 6) % 7 + h;
    };
    switch (t) {
      // 3
      case "e":
      case "ee":
        return Pe(He(t.length, a), o);
      // 3rd
      case "eo":
        return Pe(
          n.ordinalNumber(a, {
            unit: "day"
          }),
          o
        );
      // Tue
      case "eee":
        return n.day(a, {
          width: "abbreviated",
          context: "formatting"
        }) || n.day(a, { width: "short", context: "formatting" }) || n.day(a, { width: "narrow", context: "formatting" });
      // T
      case "eeeee":
        return n.day(a, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "eeeeee":
        return n.day(a, { width: "short", context: "formatting" }) || n.day(a, { width: "narrow", context: "formatting" });
      default:
        return n.day(a, { width: "wide", context: "formatting" }) || n.day(a, {
          width: "abbreviated",
          context: "formatting"
        }) || n.day(a, { width: "short", context: "formatting" }) || n.day(a, { width: "narrow", context: "formatting" });
    }
  }
  validate(a, t) {
    return t >= 0 && t <= 6;
  }
  set(a, t, n, l) {
    return a = jl(a, n, l), a.setHours(0, 0, 0, 0), a;
  }
  incompatibleTokens = [
    "y",
    "R",
    "u",
    "q",
    "Q",
    "M",
    "L",
    "I",
    "d",
    "D",
    "E",
    "i",
    "c",
    "t",
    "T"
  ];
}
class l0 extends ke {
  priority = 90;
  parse(a, t, n, l) {
    const o = (i) => {
      const h = Math.floor((i - 1) / 7) * 7;
      return (i + l.weekStartsOn + 6) % 7 + h;
    };
    switch (t) {
      // 3
      case "c":
      case "cc":
        return Pe(He(t.length, a), o);
      // 3rd
      case "co":
        return Pe(
          n.ordinalNumber(a, {
            unit: "day"
          }),
          o
        );
      // Tue
      case "ccc":
        return n.day(a, {
          width: "abbreviated",
          context: "standalone"
        }) || n.day(a, { width: "short", context: "standalone" }) || n.day(a, { width: "narrow", context: "standalone" });
      // T
      case "ccccc":
        return n.day(a, {
          width: "narrow",
          context: "standalone"
        });
      // Tu
      case "cccccc":
        return n.day(a, { width: "short", context: "standalone" }) || n.day(a, { width: "narrow", context: "standalone" });
      default:
        return n.day(a, { width: "wide", context: "standalone" }) || n.day(a, {
          width: "abbreviated",
          context: "standalone"
        }) || n.day(a, { width: "short", context: "standalone" }) || n.day(a, { width: "narrow", context: "standalone" });
    }
  }
  validate(a, t) {
    return t >= 0 && t <= 6;
  }
  set(a, t, n, l) {
    return a = jl(a, n, l), a.setHours(0, 0, 0, 0), a;
  }
  incompatibleTokens = [
    "y",
    "R",
    "u",
    "q",
    "Q",
    "M",
    "L",
    "I",
    "d",
    "D",
    "E",
    "i",
    "e",
    "t",
    "T"
  ];
}
function r0(e, a) {
  const t = he(e, a?.in).getDay();
  return t === 0 ? 7 : t;
}
function o0(e, a, t) {
  const n = he(e, t?.in), l = r0(n, t), o = a - l;
  return rl(n, o, t);
}
class s0 extends ke {
  priority = 90;
  parse(a, t, n) {
    const l = (o) => o === 0 ? 7 : o;
    switch (t) {
      // 2
      case "i":
      case "ii":
        return He(t.length, a);
      // 2nd
      case "io":
        return n.ordinalNumber(a, { unit: "day" });
      // Tue
      case "iii":
        return Pe(
          n.day(a, {
            width: "abbreviated",
            context: "formatting"
          }) || n.day(a, {
            width: "short",
            context: "formatting"
          }) || n.day(a, {
            width: "narrow",
            context: "formatting"
          }),
          l
        );
      // T
      case "iiiii":
        return Pe(
          n.day(a, {
            width: "narrow",
            context: "formatting"
          }),
          l
        );
      // Tu
      case "iiiiii":
        return Pe(
          n.day(a, {
            width: "short",
            context: "formatting"
          }) || n.day(a, {
            width: "narrow",
            context: "formatting"
          }),
          l
        );
      default:
        return Pe(
          n.day(a, {
            width: "wide",
            context: "formatting"
          }) || n.day(a, {
            width: "abbreviated",
            context: "formatting"
          }) || n.day(a, {
            width: "short",
            context: "formatting"
          }) || n.day(a, {
            width: "narrow",
            context: "formatting"
          }),
          l
        );
    }
  }
  validate(a, t) {
    return t >= 1 && t <= 7;
  }
  set(a, t, n) {
    return a = o0(a, n), a.setHours(0, 0, 0, 0), a;
  }
  incompatibleTokens = [
    "y",
    "Y",
    "u",
    "q",
    "Q",
    "M",
    "L",
    "w",
    "d",
    "D",
    "E",
    "e",
    "c",
    "t",
    "T"
  ];
}
class i0 extends ke {
  priority = 80;
  parse(a, t, n) {
    switch (t) {
      case "a":
      case "aa":
      case "aaa":
        return n.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        }) || n.dayPeriod(a, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaaa":
        return n.dayPeriod(a, {
          width: "narrow",
          context: "formatting"
        });
      default:
        return n.dayPeriod(a, {
          width: "wide",
          context: "formatting"
        }) || n.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        }) || n.dayPeriod(a, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  set(a, t, n) {
    return a.setHours(Yl(n), 0, 0, 0), a;
  }
  incompatibleTokens = ["b", "B", "H", "k", "t", "T"];
}
class d0 extends ke {
  priority = 80;
  parse(a, t, n) {
    switch (t) {
      case "b":
      case "bb":
      case "bbb":
        return n.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        }) || n.dayPeriod(a, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbbb":
        return n.dayPeriod(a, {
          width: "narrow",
          context: "formatting"
        });
      default:
        return n.dayPeriod(a, {
          width: "wide",
          context: "formatting"
        }) || n.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        }) || n.dayPeriod(a, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  set(a, t, n) {
    return a.setHours(Yl(n), 0, 0, 0), a;
  }
  incompatibleTokens = ["a", "B", "H", "k", "t", "T"];
}
class u0 extends ke {
  priority = 80;
  parse(a, t, n) {
    switch (t) {
      case "B":
      case "BB":
      case "BBB":
        return n.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        }) || n.dayPeriod(a, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBBB":
        return n.dayPeriod(a, {
          width: "narrow",
          context: "formatting"
        });
      default:
        return n.dayPeriod(a, {
          width: "wide",
          context: "formatting"
        }) || n.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        }) || n.dayPeriod(a, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  set(a, t, n) {
    return a.setHours(Yl(n), 0, 0, 0), a;
  }
  incompatibleTokens = ["a", "b", "t", "T"];
}
class c0 extends ke {
  priority = 70;
  parse(a, t, n) {
    switch (t) {
      case "h":
        return Ve(Oe.hour12h, a);
      case "ho":
        return n.ordinalNumber(a, { unit: "hour" });
      default:
        return He(t.length, a);
    }
  }
  validate(a, t) {
    return t >= 1 && t <= 12;
  }
  set(a, t, n) {
    const l = a.getHours() >= 12;
    return l && n < 12 ? a.setHours(n + 12, 0, 0, 0) : !l && n === 12 ? a.setHours(0, 0, 0, 0) : a.setHours(n, 0, 0, 0), a;
  }
  incompatibleTokens = ["H", "K", "k", "t", "T"];
}
class f0 extends ke {
  priority = 70;
  parse(a, t, n) {
    switch (t) {
      case "H":
        return Ve(Oe.hour23h, a);
      case "Ho":
        return n.ordinalNumber(a, { unit: "hour" });
      default:
        return He(t.length, a);
    }
  }
  validate(a, t) {
    return t >= 0 && t <= 23;
  }
  set(a, t, n) {
    return a.setHours(n, 0, 0, 0), a;
  }
  incompatibleTokens = ["a", "b", "h", "K", "k", "t", "T"];
}
class h0 extends ke {
  priority = 70;
  parse(a, t, n) {
    switch (t) {
      case "K":
        return Ve(Oe.hour11h, a);
      case "Ko":
        return n.ordinalNumber(a, { unit: "hour" });
      default:
        return He(t.length, a);
    }
  }
  validate(a, t) {
    return t >= 0 && t <= 11;
  }
  set(a, t, n) {
    return a.getHours() >= 12 && n < 12 ? a.setHours(n + 12, 0, 0, 0) : a.setHours(n, 0, 0, 0), a;
  }
  incompatibleTokens = ["h", "H", "k", "t", "T"];
}
class m0 extends ke {
  priority = 70;
  parse(a, t, n) {
    switch (t) {
      case "k":
        return Ve(Oe.hour24h, a);
      case "ko":
        return n.ordinalNumber(a, { unit: "hour" });
      default:
        return He(t.length, a);
    }
  }
  validate(a, t) {
    return t >= 1 && t <= 24;
  }
  set(a, t, n) {
    const l = n <= 24 ? n % 24 : n;
    return a.setHours(l, 0, 0, 0), a;
  }
  incompatibleTokens = ["a", "b", "h", "H", "K", "t", "T"];
}
class g0 extends ke {
  priority = 60;
  parse(a, t, n) {
    switch (t) {
      case "m":
        return Ve(Oe.minute, a);
      case "mo":
        return n.ordinalNumber(a, { unit: "minute" });
      default:
        return He(t.length, a);
    }
  }
  validate(a, t) {
    return t >= 0 && t <= 59;
  }
  set(a, t, n) {
    return a.setMinutes(n, 0, 0), a;
  }
  incompatibleTokens = ["t", "T"];
}
class v0 extends ke {
  priority = 50;
  parse(a, t, n) {
    switch (t) {
      case "s":
        return Ve(Oe.second, a);
      case "so":
        return n.ordinalNumber(a, { unit: "second" });
      default:
        return He(t.length, a);
    }
  }
  validate(a, t) {
    return t >= 0 && t <= 59;
  }
  set(a, t, n) {
    return a.setSeconds(n, 0), a;
  }
  incompatibleTokens = ["t", "T"];
}
class y0 extends ke {
  priority = 30;
  parse(a, t) {
    const n = (l) => Math.trunc(l * Math.pow(10, -t.length + 3));
    return Pe(He(t.length, a), n);
  }
  set(a, t, n) {
    return a.setMilliseconds(n), a;
  }
  incompatibleTokens = ["t", "T"];
}
class b0 extends ke {
  priority = 10;
  parse(a, t) {
    switch (t) {
      case "X":
        return xt(
          wt.basicOptionalMinutes,
          a
        );
      case "XX":
        return xt(wt.basic, a);
      case "XXXX":
        return xt(
          wt.basicOptionalSeconds,
          a
        );
      case "XXXXX":
        return xt(
          wt.extendedOptionalSeconds,
          a
        );
      default:
        return xt(wt.extended, a);
    }
  }
  set(a, t, n) {
    return t.timestampIsSet ? a : De(
      a,
      a.getTime() - Kn(a) - n
    );
  }
  incompatibleTokens = ["t", "T", "x"];
}
class p0 extends ke {
  priority = 10;
  parse(a, t) {
    switch (t) {
      case "x":
        return xt(
          wt.basicOptionalMinutes,
          a
        );
      case "xx":
        return xt(wt.basic, a);
      case "xxxx":
        return xt(
          wt.basicOptionalSeconds,
          a
        );
      case "xxxxx":
        return xt(
          wt.extendedOptionalSeconds,
          a
        );
      default:
        return xt(wt.extended, a);
    }
  }
  set(a, t, n) {
    return t.timestampIsSet ? a : De(
      a,
      a.getTime() - Kn(a) - n
    );
  }
  incompatibleTokens = ["t", "T", "X"];
}
class w0 extends ke {
  priority = 40;
  parse(a) {
    return io(a);
  }
  set(a, t, n) {
    return [De(a, n * 1e3), { timestampIsSet: !0 }];
  }
  incompatibleTokens = "*";
}
class x0 extends ke {
  priority = 20;
  parse(a) {
    return io(a);
  }
  set(a, t, n) {
    return [De(a, n), { timestampIsSet: !0 }];
  }
  incompatibleTokens = "*";
}
const k0 = {
  G: new Ec(),
  y: new Rc(),
  Y: new Nc(),
  R: new Wc(),
  u: new qc(),
  Q: new Yc(),
  q: new jc(),
  M: new Gc(),
  L: new Uc(),
  w: new Zc(),
  I: new Xc(),
  d: new e0(),
  D: new t0(),
  E: new a0(),
  e: new n0(),
  c: new l0(),
  i: new s0(),
  a: new i0(),
  b: new d0(),
  B: new u0(),
  h: new c0(),
  H: new f0(),
  K: new h0(),
  k: new m0(),
  m: new g0(),
  s: new v0(),
  S: new y0(),
  X: new b0(),
  x: new p0(),
  t: new w0(),
  T: new x0()
}, C0 = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, $0 = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, M0 = /^'([^]*?)'?$/, S0 = /''/g, D0 = /\S/, z0 = /[a-zA-Z]/;
function hl(e, a, t, n) {
  const l = () => De(t, NaN), o = Vc(), i = o.locale ?? Xr, h = o.firstWeekContainsDate ?? o.locale?.options?.firstWeekContainsDate ?? 1, c = o.weekStartsOn ?? o.locale?.options?.weekStartsOn ?? 0;
  if (!a)
    return e ? l() : he(t, n?.in);
  const f = {
    firstWeekContainsDate: h,
    weekStartsOn: c,
    locale: i
  }, y = [new Fc(n?.in, t)], m = a.match($0).map((w) => {
    const x = w[0];
    if (x in bl) {
      const I = bl[x];
      return I(w, i.formatLong);
    }
    return w;
  }).join("").match(C0), g = [];
  for (let w of m) {
    no(w) && pl(w, a, e), ao(w) && pl(w, a, e);
    const x = w[0], I = k0[x];
    if (I) {
      const { incompatibleTokens: L } = I;
      if (Array.isArray(L)) {
        const b = g.find(
          ($) => L.includes($.token) || $.token === x
        );
        if (b)
          throw new RangeError(
            `The format string mustn't contain \`${b.fullToken}\` and \`${w}\` at the same time`
          );
      } else if (I.incompatibleTokens === "*" && g.length > 0)
        throw new RangeError(
          `The format string mustn't contain \`${w}\` and any other token at the same time`
        );
      g.push({ token: x, fullToken: w });
      const z = I.run(
        e,
        w,
        i.match,
        f
      );
      if (!z)
        return l();
      y.push(z.setter), e = z.rest;
    } else {
      if (x.match(z0))
        throw new RangeError(
          "Format string contains an unescaped latin alphabet character `" + x + "`"
        );
      if (w === "''" ? w = "'" : x === "'" && (w = T0(w)), e.indexOf(w) === 0)
        e = e.slice(w.length);
      else
        return l();
    }
  }
  if (e.length > 0 && D0.test(e))
    return l();
  const v = y.map((w) => w.priority).sort((w, x) => x - w).filter((w, x, I) => I.indexOf(w) === x).map(
    (w) => y.filter((x) => x.priority === w).sort((x, I) => I.subPriority - x.subPriority)
  ).map((w) => w[0]);
  let C = he(t, n?.in);
  if (isNaN(+C)) return l();
  const k = {};
  for (const w of v) {
    if (!w.validate(C, f))
      return l();
    const x = w.set(C, k, f);
    Array.isArray(x) ? (C = x[0], Object.assign(k, x[1])) : C = x;
  }
  return C;
}
function T0(e) {
  return e.match(M0)[1].replace(S0, "'");
}
function ml(e, a, t) {
  return rl(e, -1, t);
}
function gr(e, a, t) {
  return jt(e, a * 12, t);
}
const B0 = ["disabled", "onClick"], L0 = ["title", "placeholder", "readonly", "disabled", "required", "pattern", "onFocusin", "onKeydown", "onMousedown", "onKeyup"], I0 = ["disabled", "onClick"], V0 = ["title", "placeholder", "readonly", "disabled", "required", "pattern", "onFocusin", "onKeydown", "onMousedown", "onKeyup"], A0 = { class: "p-4" }, sn = /* @__PURE__ */ te({
  name: "SdsDatepicker",
  __name: "Datepicker",
  props: /* @__PURE__ */ xe({
    zIndex: { default: "50" },
    hideArrow: { type: Boolean, default: !1 },
    size: { default: "" },
    mode: { default: "date" },
    placement: { default: "bottom" },
    max: { default: null },
    min: { default: null },
    useCurrentTimeForToday: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 },
    readonly: { type: Boolean, default: !1 },
    required: { type: Boolean, default: !1 },
    valid: { type: Boolean, default: !1 },
    invalid: { type: Boolean, default: !1 }
  }, {
    modelValue: {
      type: [Object, Date],
      default: null
    },
    modelModifiers: {}
  }),
  emits: /* @__PURE__ */ xe(["update:modelValue"], ["update:modelValue"]),
  setup(e, { emit: a }) {
    const t = e, n = Te(e, "modelValue"), l = a, { validationClasses: o } = Xt(t), i = E({ start: "", end: "" }), h = E(), c = E(), f = M(() => {
      switch (t.zIndex) {
        case "0":
          return "z-0";
        case "10":
          return "z-10";
        case "20":
          return "z-20";
        case "30":
          return "z-30";
        case "40":
          return "z-40";
        case "50":
          return "z-50";
        case "auto":
          return "z-auto";
        default:
          return "";
      }
    }), y = M(() => n.value && !(n.value instanceof Date)), m = M(() => {
      switch (t.mode) {
        case "date":
          return "mm/dd/yyyy";
        case "time":
          return "hh:mm am/pm";
        case "dateTime":
          return "mm/dd/yyyy hh:mm am/pm";
        default:
          return "mm/dd/yyyy";
      }
    }), g = M(() => {
      switch (t.mode) {
        case "date":
          return "MM/dd/yyyy";
        case "time":
          return "hh:mm aaa";
        case "dateTime":
          return "MM/dd/yyyy hh:mm aaa";
        default:
          return "MM/dd/yyyy";
      }
    }), v = M(() => {
      switch (t.mode) {
        case "date":
          return "[0-9]{2}/[0-9]{2}/[0-9]{4}";
        case "time":
          return "[0-9]{2}:[0-9]{2} [am|pm]";
        case "dateTime":
          return "[0-9]{2}/[0-9]{2}/[0-9]{4} [0-9]{2}:[0-9]{2} [am|pm]";
        default:
          return "[0-9]{2}/[0-9]{2}/[0-9]{4}";
      }
    }), C = M({
      get() {
        return n.value;
      },
      set(z) {
        l("update:modelValue", z);
      }
    }), k = E(), w = E(), x = (z) => {
      if (z === "now") {
        const p = /* @__PURE__ */ new Date();
        return { date: p, text: Ye(p, g.value) };
      } else if (z === "today") {
        const p = Ae(Re(Ue(Ke(/* @__PURE__ */ new Date(), 0), 0), 0), 0);
        return { date: p, text: Ye(p, g.value) };
      } else if (z === "tomorrow") {
        const p = rl(Ae(Re(Ue(Ke(/* @__PURE__ */ new Date(), 0), 0), 0), 0), 1);
        return { date: p, text: Ye(p, g.value) };
      } else if (z === "yesterday") {
        const p = ml(Ae(Re(Ue(Ke(/* @__PURE__ */ new Date(), 0), 0), 0), 0));
        return { date: p, text: Ye(p, g.value) };
      }
      const $ = [
        "MM/dd/yyyy hh:mm aaa",
        "MM/dd/yyyy hh:mm a",
        "MM/dd/yyyy h:mm aaa",
        "MM/dd/yyyy h:mm a",
        "MM/dd/yyyy hh:mmaaa",
        "MM/dd/yyyy hh:mma",
        "MM/dd/yyyy h:mmaaa",
        "MM/dd/yyyy h:mma",
        "MM/dd/yyyy H:mm",
        "MM/dd/yyyy HH:mm",
        "MM/dd/yyyy HH:mm:ss",
        "MM-dd-yyyy hh:mm aaa",
        "MM-dd-yyyy hh:mm a",
        "MM-dd-yyyy h:mm aaa",
        "MM-dd-yyyy h:mm a",
        "MM-dd-yyyy ha",
        "MM-dd-yyyy haaa",
        "MM-dd-yyyy hh:mmaaa",
        "MM-dd-yyyy hh:mma",
        "MM-dd-yyyy h:mmaaa",
        "MM-dd-yyyy h:mma",
        "MM-dd-yyyy H:mm",
        "MM-dd-yyyy HH:mm",
        "MM-dd-yyyy HH:mm:ss",
        "yyyy-MM-dd hh:mm aaa",
        "yyyy-MM-dd hh:mm a",
        "yyyy-MM-dd h:mm aaa",
        "yyyy-MM-dd h:mm a",
        "yyyy-MM-dd hh:mma",
        "yyyy-MM-dd h:mmaaa",
        "yyyy-MM-dd h:mma",
        "yyyy-MM-dd H:mm",
        "yyyy-MM-dd HH:mm",
        "yyyy-MM-dd HH:mm:ss",
        "MM/dd/yyyy",
        "MM-dd-yyyy",
        "MMddyyyy",
        "yyyy-MM-dd",
        "M/d",
        "MM/dd",
        "MM/yyyy",
        "M-d",
        "MM-dd",
        "MM-yyyy",
        "yyyy/MM",
        "yyyy-MM",
        "M/dd/yyyy hh:mm aaa",
        "M/dd/yyyy hh:mm a",
        "M/dd/yyyy h:mm aaa",
        "M/dd/yyyy h:mm a",
        "M/dd/yyyy ha",
        "M/dd/yyyy haaa",
        "M/dd/yyyy hh:mmaaa",
        "M/dd/yyyy hh:mma",
        "M/dd/yyyy h:mmaaa",
        "M/dd/yyyy h:mma",
        "M/dd/yyyy H:mm",
        "M/dd/yyyy HH:mm",
        "M/dd/yyyy HH:mm:ss",
        "M-dd-yyyy hh:mm aaa",
        "M-dd-yyyy hh:mm a",
        "M-dd-yyyy h:mm aaa",
        "M-dd-yyyy h:mm a",
        "M-dd-yyyy hh:mmaaa",
        "M-dd-yyyy hh:mma",
        "M-dd-yyyy h:mmaaa",
        "M-dd-yyyy h:mma",
        "M-dd-yyyy H:mm",
        "M-dd-yyyy HH:mm",
        "M-dd-yyyy HH:mm:ss",
        "yyyy-M-dd hh:mm aaa",
        "yyyy-M-dd hh:mm a",
        "yyyy-M-dd h:mm aaa",
        "yyyy-M-dd h:mm a",
        "yyyy-M-dd hh:mma",
        "yyyy-M-dd h:mmaaa",
        "yyyy-M-dd h:mma",
        "yyyy-M-dd H:mm",
        "yyyy-M-dd HH:mm",
        "yyyy-M-dd HH:mm:ss",
        "yyyy-M-dd",
        "M/yyyy",
        "M-yyyy",
        "M/yyyy haaa",
        "M-yyyy haaa",
        "M/yyyy ha",
        "M/yyyy HH:mm:ss",
        "M-yyyy HH:mm:ss",
        "M.yyyy HH:mm:ss",
        "M-yyyy ha",
        "M/yyyy h:mmaaa",
        "M-yyyy h:mmaaa",
        "M/yyyy h:mma",
        "M-yyyy h:mma",
        "M/yyyy h:mm aaa",
        "M-yyyy h:mm aaa",
        "M/yyyy h:mm a",
        "M-yyyy h:mm a",
        "yyyy/M",
        "yyyy-M",
        "yyyy",
        "EEE",
        "EEEE",
        "LLL",
        "LLLL",
        "LLL yyyy",
        "LLLL yyyy",
        "LLL dd yyyy",
        "LLLL dd yyyy",
        "hh:mm aaa",
        "hh:mm a",
        "h:mm aaa",
        "h:mm a",
        "hh:mmaaa",
        "hh:mma",
        "h:mmaaa",
        "h:mma",
        "HH:mm:ss",
        "H:mm",
        "HH:mm",
        "QQQ",
        "QQQQ",
        "QQQ yyyy",
        "QQQQ yyyy",
        "PP",
        "PPP",
        "PPPP",
        "bbb",
        "h BBB",
        "h:mm BBB",
        "hh BBB",
        "hh:mm BBB",
        "hBBB",
        "h:mmBBB",
        "hhBBB",
        "hh:mmBBB"
      ].filter((p) => lo(hl(z, p, /* @__PURE__ */ new Date())));
      if ($.length > 0) {
        let p = hl(z, $[0], /* @__PURE__ */ new Date());
        t.mode === "date" ? p = Ae(Re(Ue(Ke(p, 0), 0), 0), 0) : t.mode === "time" && (p = hl(Ye(p, "yyyy-MM-dd HH:mm:ss"), "yyyy-MM-dd HH:mm:ss", /* @__PURE__ */ new Date()));
        const F = p.getFullYear();
        F < 41 ? p = gr(p, 2e3) : F >= 41 && F < 99 && (p = gr(p, 1900));
        const R = t.min ? Ma(p, t.min) : !1, T = t.max ? Gt(ml(p), t.max) : !1, j = t.max ? Qr(ml(p), t.max) : !1;
        if (!R && !T && !j)
          return { date: p, text: Ye(p, g.value) };
      }
      return { date: null, text: "" };
    };
    ye(C, (z, b) => {
      if (w.value = b, y.value) {
        const $ = z && z.start && x(Ye(z.start, "yyyy-MM-dd HH:mm:ss")) || { date: null, text: "" }, p = z.end && x(Ye(z.end, "yyyy-MM-dd HH:mm:ss")) || { date: null, text: "" };
        $.date && p.date && Gt($.date, p.date) ? i.value = {
          start: p.text,
          end: $.text
        } : i.value = {
          start: $.text,
          end: p.text
        };
      } else {
        const $ = z && x(Ye(z, "yyyy-MM-dd HH:mm:ss")) || { text: "" };
        i.value = {
          start: $.text,
          end: ""
        };
      }
    }, { deep: !0, immediate: !0 });
    const I = async (z) => {
      await Ie(), C.value instanceof Date || !C.value ? h.value.focus() : typeof C.value == "object" && typeof w.value == "object" && !(w.value instanceof Date) && (k.value === "start" ? h.value.focus() : k.value === "end" || C.value?.start !== w.value?.start && C.value?.end !== w.value?.end ? c.value.focus() : C.value?.start !== w.value?.start ? h.value.focus() : c.value.focus()), t.mode === "date" && (y.value && i.value.start && i.value.end || !y.value && i.value.start) && z();
    }, L = (z = null) => {
      if (y.value) {
        const b = x(i.value.start), $ = x(i.value.end);
        C.value = {
          start: b.date && $.date && Sa([b.date, $.date]) || b.date,
          end: b.date && $.date && Da([b.date, $.date]) || $.date
        }, b.date && $.date && Gt(b.date, $.date) ? i.value = {
          start: $.text,
          end: b.text
        } : i.value = {
          start: b.text,
          end: $.text
        };
      } else {
        const b = x(i.value.start);
        C.value = b.date, i.value = {
          start: b.text,
          end: ""
        };
      }
      !t.readonly && z && z();
    };
    return (z, b) => {
      const $ = Ur, p = Ic, F = Nl;
      return s(), G(St, {
        "data-id": "sds-datepicker",
        class: "w-full",
        placement: e.placement,
        disabled: e.disabled,
        "popper-class": `absolute bg-white border dark:text-gray-50 dark:bg-gray-850 dark:border-gray-700 shadow-lg rounded-theme-md w-auto ${r(f)}`,
        "arrow-class": "absolute bg-white border dark:bg-gray-850 dark:border-gray-700 w-3 h-3 rotate-45",
        "placement-top-arrow-class": "-bottom-1.5 border-t-0 border-l-0",
        "placement-right-arrow-class": "-left-1.5 border-t-0 border-r-0",
        "placement-bottom-arrow-class": "-top-1.5 border-b-0 border-r-0",
        "placement-left-arrow-class": "-right-1.5 border-b-0 border-l-0"
      }, {
        trigger: U(({ open: R, close: T, toggle: j }) => [
          d("div", {
            class: D(["flex w-full", { "gap-1": e.size === "sm", "gap-2": e.size !== "sm" }])
          }, [
            d("div", {
              class: D(["w-full input-group", {
                "input-group-sm": e.size === "sm",
                ...r(o)
              }])
            }, [
              d("button", {
                type: "button",
                tabindex: "-1",
                class: D(["input-group-addon fill-current", {
                  "pointer-events-none text-gray-300 border-gray-200": e.disabled || e.readonly,
                  "border-none": e.disabled
                }]),
                disabled: e.disabled || e.readonly || void 0,
                onClick: (X) => {
                  j(), z.$refs.startDateInput.focus();
                }
              }, [
                e.mode === "time" ? (s(), G($, {
                  key: 0,
                  class: D({ "w-5 h-5": e.size !== "sm", "w-4 h-4": e.size === "sm" })
                }, null, 8, ["class"])) : (s(), G(p, {
                  key: 1,
                  class: D({ "w-5 h-5": e.size !== "sm", "w-4 h-4": e.size === "sm" })
                }, null, 8, ["class"])),
                b[9] || (b[9] = d("span", { class: "sr-only" }, "Select a date", -1))
              ], 10, B0),
              Ze(d("input", {
                ref_key: "startDateInput",
                ref: h,
                "onUpdate:modelValue": b[0] || (b[0] = (X) => r(i).start = X),
                "aria-label": "Start date",
                type: "text",
                class: "form-control",
                title: `${r(m)}`,
                placeholder: r(m) || void 0,
                readonly: e.readonly || void 0,
                disabled: e.disabled || void 0,
                required: e.required || void 0,
                pattern: r(v),
                onFocusin: (X) => e.readonly ? void 0 : R(),
                onMouseup: b[1] || (b[1] = (X) => k.value = "start"),
                onKeyup: [
                  b[2] || (b[2] = (X) => k.value = "start"),
                  Se((X) => T(), ["up"]),
                  Se((X) => e.readonly ? void 0 : R(), ["down"])
                ],
                onKeydown: [
                  Se((X) => L(T), ["tab"]),
                  Se(fe((X) => L(j), ["prevent"]), ["enter"])
                ],
                onMousedown: fe((X) => e.readonly ? void 0 : j(), ["stop"]),
                onChange: b[3] || (b[3] = (X) => L())
              }, null, 40, L0), [
                [qn, r(i).start]
              ])
            ], 2),
            r(y) ? (s(), u(J, { key: 0 }, [
              e.hideArrow ? S("", !0) : (s(), u("div", {
                key: 0,
                class: D(["flex my-auto shrink-0", {
                  "opacity-50": e.disabled || e.readonly
                }])
              }, [
                Q(F, {
                  class: D(["text-gray-700", { "w-5 h-5": e.size !== "sm", "w-4 h-4": e.size === "sm" }])
                }, null, 8, ["class"])
              ], 2)),
              d("div", {
                class: D(["w-full input-group", {
                  "input-group-sm": e.size === "sm",
                  disabled: e.disabled,
                  readonly: e.readonly,
                  valid: e.valid,
                  invalid: e.invalid
                }])
              }, [
                d("button", {
                  type: "button",
                  tabindex: "-1",
                  class: D(["input-group-addon fill-current", {
                    "pointer-events-none opacity-50": e.disabled || e.readonly
                  }]),
                  disabled: e.disabled || e.readonly || void 0,
                  onClick: (X) => {
                    j(), z.$refs.endDateInput.focus();
                  }
                }, [
                  e.mode === "time" ? (s(), G($, {
                    key: 0,
                    class: D({ "w-5 h-5": e.size !== "sm", "w-4 h-4": e.size === "sm" })
                  }, null, 8, ["class"])) : (s(), G(p, {
                    key: 1,
                    class: D({ "w-5 h-5": e.size !== "sm", "w-4 h-4": e.size === "sm" })
                  }, null, 8, ["class"])),
                  b[10] || (b[10] = d("span", { class: "sr-only" }, "Select a date", -1))
                ], 10, I0),
                Ze(d("input", {
                  ref_key: "endDateInput",
                  ref: c,
                  "onUpdate:modelValue": b[4] || (b[4] = (X) => r(i).end = X),
                  "aria-label": "End date",
                  type: "text",
                  class: "form-control",
                  title: `${r(m)}`,
                  placeholder: r(m) || void 0,
                  readonly: e.readonly || void 0,
                  disabled: e.disabled || void 0,
                  required: e.required || void 0,
                  pattern: r(v),
                  onFocusin: (X) => e.readonly ? void 0 : R(),
                  onMouseup: b[5] || (b[5] = (X) => k.value = "end"),
                  onKeyup: [
                    b[6] || (b[6] = (X) => k.value = "end"),
                    Se((X) => T(), ["up"]),
                    Se((X) => e.readonly ? void 0 : R(), ["down"])
                  ],
                  onKeydown: [
                    Se((X) => L(T), ["tab"]),
                    Se(fe((X) => L(j), ["prevent"]), ["enter"])
                  ],
                  onMousedown: fe((X) => e.readonly ? void 0 : j(), ["stop"]),
                  onChange: b[7] || (b[7] = (X) => L())
                }, null, 40, V0), [
                  [qn, r(i).end]
                ])
              ], 2)
            ], 64)) : S("", !0)
          ], 2)
        ]),
        default: U(({ close: R }) => [
          d("div", A0, [
            Q(Ba, {
              modelValue: r(C),
              "onUpdate:modelValue": [
                b[8] || (b[8] = (T) => Ne(C) ? C.value = T : null),
                (T) => I(R)
              ],
              min: e.min,
              max: e.max,
              mode: e.mode,
              "use-current-time-for-today": e.useCurrentTimeForToday,
              "input-to-change": r(k)
            }, null, 8, ["modelValue", "min", "max", "mode", "use-current-time-for-today", "input-to-change", "onUpdate:modelValue"])
          ])
        ]),
        _: 1
      }, 8, ["placement", "disabled", "popper-class"]);
    };
  }
});
sn.install = (e) => {
  e.component(sn.name, sn);
};
const H0 = {
  viewBox: "0 0 640 640",
  "aria-hidden": "true",
  role: "img",
  width: "1.2em",
  height: "1.2em"
};
function O0(e, a) {
  return s(), u("svg", H0, [...a[0] || (a[0] = [
    d("path", {
      fill: "currentColor",
      d: "M64 128c-12.9 0-24.6 7.8-29.6 19.8s-2.2 25.7 7 34.8L224 365.3V480c0 8.5 3.4 16.6 9.4 22.6l64 64c2.5 2.5 5.3 4.5 8.3 6c-21.2-30.9-33.6-68.3-33.6-108.6c0-99.4 75.5-181.1 172.3-191l90.4-90.4c9.2-9.2 11.9-22.9 6.9-34.9S524.9 128 512 128zm400 480c79.5 0 144-64.5 144-144s-64.5-144-144-144s-144 64.5-144 144s64.5 144 144 144m59.3-180.7L486.6 464l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L464 486.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l36.7-36.7l-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l36.7 36.7l36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6"
    }, null, -1)
  ])]);
}
const P0 = $e({ name: "fa7-solid-filter-circle-xmark", render: O0 }), F0 = {
  viewBox: "0 0 640 640",
  "aria-hidden": "true",
  role: "img",
  width: "1.2em",
  height: "1.2em"
};
function E0(e, a) {
  return s(), u("svg", F0, [...a[0] || (a[0] = [
    d("path", {
      fill: "currentColor",
      d: "M96 128c-12.9 0-24.6 7.8-29.6 19.8s-2.2 25.7 7 34.8L256 365.3V480c0 8.5 3.4 16.6 9.4 22.6l64 64c9.2 9.2 22.9 11.9 34.9 6.9S384 556.9 384 544V365.3l182.6-182.6c9.2-9.2 11.9-22.9 6.9-34.9S556.9 128 544 128z"
    }, null, -1)
  ])]);
}
const R0 = $e({ name: "fa7-solid-filter", render: E0 });
function N0(e, a, t, n) {
  let i = 0, h = 0, c = 0, f = 0;
  switch (e) {
    case "xs":
      f = t === "circle" ? -3 : -2, c = 5;
      break;
    case "sm":
      f = t === "circle" ? -5 : -2, c = 7.5;
      break;
    case "md":
      f = -4, c = 10;
      break;
    case "lg":
      f = t === "circle" ? -7 : -4, c = 15;
      break;
    case "xl":
      f = t === "circle" ? -8 : -4, c = 19.5;
      break;
    case "2xl":
      f = t === "circle" ? 1 : -2, c = 25;
      break;
  }
  if (t === "circle")
    switch (a) {
      case "top-left":
        i = c + f, h = c + f;
        break;
      case "top-right":
        i = 1e3 - c - f, h = c + f;
        break;
      case "bottom-right":
        i = 1e3 - c - f, h = 1e3 - c - f;
        break;
      case "bottom-left":
        i = c + f, h = 1e3 - c - f;
    }
  else if (t === "square")
    switch (a) {
      case "top-left":
        i = c / 2 + f, h = c / 2 + f;
        break;
      case "top-right":
        i = 1e3 - c / 2 - f, h = c / 2 + f;
        break;
      case "bottom-right":
        i = 1e3 - c / 2 - f, h = 1e3 - c / 2 - f;
        break;
      case "bottom-left":
        i = c / 2 + f, h = 1e3 - c / 2 - f;
    }
  else
    switch (a) {
      case "top-left":
        i = c / 2 + f, h = c / 2 + f;
        break;
      case "top-right":
        i = 1e3 - c / 2 - f, h = c / 2 + f;
        break;
      case "bottom-right":
        i = 1e3 - c / 2 - f, h = 1e3 - c / 2 - f;
        break;
      case "bottom-left":
        i = c / 2 + f, h = 1e3 - c / 2 - f;
    }
  return n ? "none" : `url('data:image/svg+xml,<svg viewBox="0 0 1000 1000" xmlns="http://www.w3.org/2000/svg"><circle cx="${i}" cy="${h}" r="${c}" /></svg>'), linear-gradient(#fff, #fff)`;
}
function W0(e) {
  switch (e) {
    case "top-left":
      return "0 0";
    case "top-right":
      return "100% 0";
    case "bottom-right":
      return "100% 100%";
    case "bottom-left":
      return "0 100%";
    default:
      return null;
  }
}
const q0 = {
  "data-id": "sds-indicator",
  class: "inline-block"
}, Y0 = { class: "flex items-start relative" }, j0 = {
  key: 0,
  class: "sr-only"
}, G0 = /* @__PURE__ */ te({
  name: "SdsIndicator",
  __name: "Indicator",
  props: {
    hideIndicator: { type: Boolean, default: !1 },
    placement: { default: "top-right" },
    placementOver: { default: "portrait" },
    size: { default: "md" },
    status: { default: null },
    variant: { default: "blue" }
  },
  setup(e) {
    Mr((h) => ({
      v4f94fb01: r(o),
      bbea0702: r(i)
    }));
    const a = e, t = M(() => {
      switch (a.size) {
        case "xs":
          switch (a.placement) {
            case "top-right":
              return a.placementOver === "circle" ? "-top-0.5 -right-0.5" : "-top-1 -right-1";
            case "top-left":
              return a.placementOver === "circle" ? "-top-0.5 -left-0.5" : "-top-1 -left-1";
            case "bottom-right":
              return a.placementOver === "circle" ? "-bottom-0.5 -right-0.5" : "-bottom-1 -right-1";
            case "bottom-left":
              return a.placementOver === "circle" ? "-bottom-0.5 -left-0.5" : "-bottom-1 -left-1";
            default:
              return null;
          }
        case "sm":
          switch (a.placement) {
            case "top-right":
              return a.placementOver === "circle" ? "-top-0.5 -right-0.5" : "-top-0.75 -right-0.75";
            case "top-left":
              return a.placementOver === "circle" ? "-top-0.5 -left-0.5" : "-top-0.75 -left-0.75";
            case "bottom-right":
              return a.placementOver === "circle" ? "-bottom-0.5 -right-0.5" : "-bottom-0.75 -right-0.75";
            case "bottom-left":
              return a.placementOver === "circle" ? "-bottom-0.5 -left-0.5" : "-bottom-0.75 -left-0.75";
            default:
              return null;
          }
        case "lg":
          switch (a.placement) {
            case "top-right":
              return a.placementOver === "circle" ? "-top-1 -right-1" : "-top-2 -right-2";
            case "top-left":
              return a.placementOver === "circle" ? "-top-1 -left-1" : "-top-2 -left-2";
            case "bottom-right":
              return a.placementOver === "circle" ? "-bottom-1 -right-1" : "-bottom-2 -right-2";
            case "bottom-left":
              return a.placementOver === "circle" ? "-bottom-1 -left-1" : "-bottom-2 -left-2";
            default:
              return null;
          }
        case "xl":
          switch (a.placement) {
            case "top-right":
              return a.placementOver === "circle" ? "-top-1 -right-1" : "-top-2.5 -right-2.5";
            case "top-left":
              return a.placementOver === "circle" ? "-top-1 -left-1" : "-top-2.5 -left-2.5";
            case "bottom-right":
              return a.placementOver === "circle" ? "-bottom-1 -right-1" : "-bottom-2.5 -right-2.5";
            case "bottom-left":
              return a.placementOver === "circle" ? "-bottom-1 -left-1" : "-bottom-2.5 -left-2.5";
            default:
              return null;
          }
        case "2xl":
          switch (a.placement) {
            case "top-right":
              return a.placementOver === "circle" ? "top-1.5 right-1.5" : "-top-2.5 -right-2.5";
            case "top-left":
              return a.placementOver === "circle" ? "top-1.5 left-1.5" : "-top-2.5 -left-2.5";
            case "bottom-right":
              return a.placementOver === "circle" ? "bottom-1.5 right-1.5" : "-bottom-2.5 -right-2.5";
            case "bottom-left":
              return a.placementOver === "circle" ? "bottom-1.5 left-1.5" : "-bottom-2.5 -left-2.5";
            default:
              return null;
          }
        default:
          switch (a.placement) {
            case "top-right":
              return a.placementOver === "circle" ? "-top-0.5 -right-0.5" : "-top-1.75 -right-1.75";
            case "top-left":
              return a.placementOver === "circle" ? "-top-0.5 -left-0.5" : "-top-1.75 -left-1.75";
            case "bottom-right":
              return a.placementOver === "circle" ? "-bottom-0.5 -right-0.5" : "-bottom-1.75 -right-1.75";
            case "bottom-left":
              return a.placementOver === "circle" ? "-bottom-0.5 -left-0.5" : "-bottom-1.75 -left-1.75";
            default:
              return null;
          }
      }
    }), n = M(() => {
      switch (a.size) {
        case "xs":
          return "h-2 w-2";
        case "sm":
          return "h-2.5 w-2.5";
        case "lg":
          return "h-6 w-6";
        case "xl":
          return "h-8 w-8";
        case "2xl":
          return "h-10 w-10";
        default:
          return "h-4 w-4";
      }
    }), l = M(() => {
      switch (a.variant) {
        case "gray":
          return "bg-gray-300";
        case "green":
          return "bg-green-500 dark:bg-green-300";
        case "orange":
          return "bg-orange-500 dark:bg-orange-300";
        case "red":
          return "bg-red-600 dark:bg-red-400";
        default:
          return "bg-blue-600 dark:bg-blue-400";
      }
    }), o = M(
      () => N0(a.size, a.placement, a.placementOver, a.hideIndicator)
    ), i = M(
      () => W0(a.placement)
    );
    return (h, c) => (s(), u("div", q0, [
      d("div", Y0, [
        P(h.$slots, "default"),
        e.hideIndicator ? S("", !0) : (s(), u("div", {
          key: 0,
          role: "status",
          class: D(["absolute rounded-full", [r(t), r(n), r(l)]])
        }, [
          e.status ? (s(), u("span", j0, A(e.status), 1)) : S("", !0)
        ], 2))
      ])
    ]));
  }
}), aa = /* @__PURE__ */ El(G0, [["__scopeId", "data-v-290659f9"]]), U0 = ["aria-checked"], K0 = ["for"], Z0 = ["id", "checked", "value", "disabled", ".indeterminate"], Q0 = { class: "text-gray-900 hover:text-black dark:text-gray-50 dark:hover:text-white block w-full" }, wl = /* @__PURE__ */ te({
  name: "SdsDropdownCheckboxItem",
  __name: "DropdownCheckboxItem",
  props: {
    modelValue: { type: Boolean },
    label: { default: "" },
    id: { default: void 0 },
    value: { default: void 0 },
    indeterminate: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: a }) {
    const t = e, n = a, l = tt(), o = M(() => t.id || l), i = () => {
      t.disabled || n("update:modelValue", !t.modelValue);
    };
    return (h, c) => (s(), u("div", {
      "data-id": "sds-dropdown-checkbox-item",
      class: "leading-5 px-2 mx-2 py-1.5 rounded-lg sds-theme-plaid:rounded-none hover:bg-gray-50 dark:hover:bg-gray-700",
      role: "menuitemcheckbox",
      "aria-checked": e.modelValue
    }, [
      d("label", {
        for: r(o),
        class: D(["flex gap-2 items-start cursor-pointer", { "cursor-not-allowed opacity-50": e.disabled }])
      }, [
        d("input", {
          id: r(o),
          checked: e.modelValue,
          type: "checkbox",
          class: "focus:ring-0 mt-0.5",
          value: e.value,
          disabled: e.disabled,
          ".indeterminate": e.indeterminate,
          onChange: i
        }, null, 40, Z0),
        d("span", Q0, [
          P(h.$slots, "default", {}, () => [
            re(A(e.label), 1)
          ])
        ])
      ], 10, K0)
    ], 8, U0));
  }
}), X0 = {
  "data-id": "sds-dropdown-input-item",
  class: "px-4 pt-4 pb-2.5"
}, J0 = ["for"], _0 = ["id", "value", "placeholder", "aria-label"], xl = /* @__PURE__ */ te({
  name: "SdsDropdownInputItem",
  __name: "DropdownInputItem",
  props: {
    modelValue: {},
    placeholder: { default: "Type to filter" },
    label: { default: "" },
    id: { default: void 0 },
    ariaLabel: { default: void 0 },
    autofocus: { type: Boolean, default: !1 },
    size: { default: "sm" }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: a }) {
    const t = e, n = a, l = E(), o = tt(), i = M(() => t.id || o), h = (f) => {
      const y = f.target;
      n("update:modelValue", y.value);
    }, c = ot(() => t.size, {
      sm: "input-group-sm",
      md: "input-group-md"
    }, "input-group-sm");
    return dt(() => {
      t.autofocus && l.value && setTimeout(() => {
        l.value?.focus();
      }, 0);
    }), (f, y) => (s(), u("div", X0, [
      e.label ? (s(), u("label", {
        key: 0,
        for: r(i),
        class: "sr-only"
      }, A(e.label), 9, J0)) : S("", !0),
      d("div", {
        class: D(["input-group", r(c)])
      }, [
        d("input", {
          id: r(i),
          ref_key: "inputRef",
          ref: l,
          value: e.modelValue,
          type: "text",
          class: "form-control",
          placeholder: e.placeholder,
          "aria-label": e.ariaLabel || e.label || e.placeholder || void 0,
          onInput: h
        }, null, 40, _0)
      ], 2)
    ]));
  }
}), e1 = {
  key: 0,
  class: "block text-xs font-semibold text-gray-500 dark:text-gray-400 mb-1 px-2",
  role: "heading",
  "aria-level": "2"
}, t1 = {
  key: 0,
  class: "flex flex-col"
}, Ga = /* @__PURE__ */ te({
  name: "SdsDropdownSection",
  __name: "DropdownSection",
  props: {
    title: { default: void 0 },
    divider: { type: Boolean, default: !1 },
    scrollable: { type: Boolean, default: !1 },
    maxHeight: { default: void 0 }
  },
  setup(e) {
    return (a, t) => (s(), u("div", {
      "data-id": "sds-dropdown-section",
      class: D([
        e.divider && !e.title ? "border-b border-gray-100 dark:border-gray-700 pb-2" : "",
        e.divider && e.title ? "border-t border-gray-100 dark:border-gray-700" : "",
        e.title ? "px-2 pt-4 pb-2" : "py-2"
      ])
    }, [
      e.title ? (s(), u("span", e1, A(e.title), 1)) : S("", !0),
      d("div", {
        class: D([
          e.scrollable ? "scroll-area" : "",
          e.scrollable && e.maxHeight ? "" : e.scrollable ? "max-h-56" : ""
        ]),
        style: st(e.scrollable && e.maxHeight ? { maxHeight: e.maxHeight } : void 0)
      }, [
        !e.scrollable || e.title ? (s(), u("ul", t1, [
          P(a.$slots, "default")
        ])) : P(a.$slots, "default", { key: 1 })
      ], 6)
    ], 2));
  }
}), fo = /* @__PURE__ */ te({
  name: "SdsDropdownFooter",
  __name: "DropdownFooter",
  props: {
    divider: { type: Boolean, default: !1 }
  },
  setup(e) {
    return (a, t) => (s(), u("div", {
      "data-id": "sds-dropdown-footer",
      class: D(["px-4 pt-2.5 pb-2 space-y-2", { "border-t border-gray-100 dark:border-gray-700": e.divider }])
    }, [
      P(a.$slots, "default")
    ], 2));
  }
}), a1 = { class: "sr-only" }, n1 = { class: "sr-only" }, l1 = ["aria-labelledby"], Aa = /* @__PURE__ */ te({
  name: "SdsFilterByDropdown",
  __name: "FilterByDropdown",
  props: /* @__PURE__ */ xe({
    kind: { default: "ghost" },
    variant: { default: "gray" },
    size: { default: "sm" },
    zIndex: { default: "50" },
    title: { default: "Filter" },
    iconOnly: { type: Boolean, default: !1 },
    tooltip: { default: "" },
    enableFilter: { type: Boolean, default: !1 },
    enableSortOptions: { type: Boolean, default: !1 },
    placement: { default: "bottom-start" },
    disabled: { type: Boolean, default: !1 },
    showCount: { type: Boolean, default: !1 },
    offset: { default: 5 },
    openDelay: { default: 0 },
    closeDelay: { default: 0 },
    block: { type: Boolean, default: !1 }
  }, {
    modelValue: { type: Array, default: () => [] },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(e) {
    const a = e, t = Te(e, "modelValue"), {
      id: n,
      buttonRef: l,
      zIndexClass: o,
      iconOnlyClasses: i,
      iconSizeClasses: h
    } = Sl({
      prefix: "action-btn",
      kind: () => a.kind,
      variant: () => a.variant,
      size: () => a.size,
      zIndex: () => a.zIndex,
      disabled: () => a.disabled,
      block: () => a.block,
      iconOnly: () => a.iconOnly,
      openDelay: a.openDelay,
      closeDelay: a.closeDelay
    }), c = E(""), f = E([]), y = M(() => t.value.filter((b) => b.selected).length), m = M(() => f.value.every((b) => b.selected)), g = M(() => f.value.some((b) => b.selected)), v = M(() => g.value && !m.value), C = M(() => f.value.filter(
      (b) => b.text && b.text.toLowerCase().includes(c.value.toLowerCase())
    )), k = () => {
      m.value ? L() : z();
    }, w = () => {
      t.value = f.value;
    }, x = () => {
      I();
    }, I = () => {
      const b = JSON.parse(JSON.stringify(t.value));
      a.enableSortOptions ? f.value = b.sort(($, p) => $.text.toLowerCase() < p.text.toLowerCase() ? -1 : $.text.toLowerCase() > p.text.toLowerCase() ? 1 : 0).sort(($, p) => $.selected > p.selected ? -1 : $.selected < p.selected ? 1 : 0) : f.value = b, c.value = "";
    }, L = () => {
      f.value.forEach((b) => {
        b.selected = !1;
      });
    }, z = () => {
      f.value.forEach((b) => {
        b.selected = !0;
      });
    };
    return (b, $) => {
      const p = R0, F = Ua;
      return s(), G(St, {
        "data-id": "sds-filter-by-dropdown",
        offset: e.offset,
        placement: e.placement,
        "popper-class": `absolute border shadow-lg rounded-theme-md bg-white border-gray-200 dark:border-gray-700 dark:bg-gray-850 w-56 ${r(o)}`,
        "hide-arrow": "",
        shift: ""
      }, {
        trigger: U(({ isOpen: R, toggle: T }) => [
          e.iconOnly && e.tooltip ? (s(), G(it, {
            key: 0,
            disabled: e.disabled,
            size: "auto",
            type: "dark"
          }, {
            trigger: U(() => [
              Q(aa, {
                "hide-indicator": !(e.showCount && r(y) > 0),
                variant: "red",
                placement: "top-right",
                "placement-over": "circle",
                size: e.size,
                status: r(y) > 0 ? `${r(y)} items selected` : null
              }, {
                default: U(() => [
                  Q(je, {
                    id: r(n),
                    ref_key: "button",
                    ref: l,
                    kind: e.kind,
                    variant: e.variant,
                    size: e.size,
                    active: R,
                    disabled: e.disabled,
                    block: e.block,
                    class: D(r(i)),
                    "aria-haspopup": "true",
                    "aria-expanded": R,
                    "aria-label": e.tooltip || e.title,
                    onClick: (j) => {
                      T(), I();
                    }
                  }, {
                    default: U(() => [
                      Q(p, {
                        class: D(r(h))
                      }, null, 8, ["class"]),
                      d("span", a1, A(e.title), 1)
                    ]),
                    _: 1
                  }, 8, ["id", "kind", "variant", "size", "active", "disabled", "block", "class", "aria-expanded", "aria-label", "onClick"])
                ]),
                _: 2
              }, 1032, ["hide-indicator", "size", "status"])
            ]),
            default: U(() => [
              re(" " + A(e.tooltip), 1)
            ]),
            _: 2
          }, 1032, ["disabled"])) : e.iconOnly ? (s(), G(aa, {
            key: 1,
            "hide-indicator": !(e.showCount && r(y) > 0),
            variant: "red",
            placement: "top-right",
            "placement-over": "circle",
            size: e.size,
            status: r(y) > 0 ? `${r(y)} items selected` : null
          }, {
            default: U(() => [
              Q(je, {
                id: r(n),
                ref_key: "button",
                ref: l,
                kind: e.kind,
                variant: e.variant,
                size: e.size,
                active: R,
                disabled: e.disabled,
                block: e.block,
                class: D(r(i)),
                "aria-haspopup": "true",
                "aria-expanded": R,
                "aria-label": e.title,
                onClick: (j) => {
                  T(), I();
                }
              }, {
                default: U(() => [
                  Q(p, {
                    class: D(r(h))
                  }, null, 8, ["class"]),
                  d("span", n1, A(e.title), 1)
                ]),
                _: 1
              }, 8, ["id", "kind", "variant", "size", "active", "disabled", "block", "class", "aria-expanded", "aria-label", "onClick"])
            ]),
            _: 2
          }, 1032, ["hide-indicator", "size", "status"])) : (s(), G(je, {
            key: 2,
            id: r(n),
            ref_key: "button",
            ref: l,
            kind: e.kind,
            variant: e.variant,
            size: e.size,
            active: R,
            disabled: e.disabled,
            block: e.block,
            "aria-haspopup": "true",
            "aria-expanded": R,
            onClick: (j) => {
              T(), I();
            }
          }, {
            default: U(() => [
              P(b.$slots, "title", {}, () => [
                d("span", null, A(e.title + (a.showCount ? ` (${r(y)})` : "")), 1)
              ]),
              Q(F, { class: "inline-block self-center w-4 h-4" })
            ]),
            _: 3
          }, 8, ["id", "kind", "variant", "size", "active", "disabled", "block", "aria-expanded", "onClick"]))
        ]),
        default: U(({ close: R }) => [
          d("div", {
            role: "menu",
            "aria-orientation": "vertical",
            "aria-labelledby": r(l) && r(l).id || void 0
          }, [
            e.enableFilter ? (s(), G(xl, {
              key: 0,
              modelValue: r(c),
              "onUpdate:modelValue": $[0] || ($[0] = (T) => Ne(c) ? c.value = T : null),
              placeholder: "Type to filter",
              autofocus: ""
            }, null, 8, ["modelValue"])) : S("", !0),
            e.enableFilter ? S("", !0) : (s(), G(Ga, {
              key: 1,
              divider: ""
            }, {
              default: U(() => [
                Q(wl, {
                  id: "filter_by_dropdown_select_all",
                  modelValue: r(m),
                  "onUpdate:modelValue": [
                    $[1] || ($[1] = (T) => Ne(m) ? m.value = T : null),
                    k
                  ],
                  label: "Select all",
                  indeterminate: r(v)
                }, null, 8, ["modelValue", "indeterminate"])
              ]),
              _: 1
            })),
            Q(Ga, {
              scrollable: "",
              "max-height": "14rem"
            }, {
              default: U(() => [
                (s(!0), u(J, null, le(r(C), (T) => (s(), u("li", {
                  key: T.id
                }, [
                  Q(wl, {
                    id: `filter_by_dropdown_selection_list_${T.id}`,
                    modelValue: T.selected,
                    "onUpdate:modelValue": (j) => T.selected = j,
                    label: T.text,
                    value: T.id
                  }, null, 8, ["id", "modelValue", "onUpdate:modelValue", "label", "value"])
                ]))), 128))
              ]),
              _: 1
            }),
            Q(fo, { divider: "" }, {
              default: U(() => [
                Q(ha, {
                  kind: "primary",
                  size: "sm",
                  block: "",
                  onClick: (T) => {
                    w(), R();
                  }
                }, {
                  default: U(() => [...$[2] || ($[2] = [
                    re(" Apply filter ", -1)
                  ])]),
                  _: 1
                }, 8, ["onClick"]),
                Q(ha, {
                  kind: "ghost",
                  size: "sm",
                  block: "",
                  onClick: (T) => {
                    x(), R();
                  }
                }, {
                  default: U(() => [...$[3] || ($[3] = [
                    re(" Cancel ", -1)
                  ])]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              _: 2
            }, 1024)
          ], 8, l1)
        ]),
        _: 3
      }, 8, ["offset", "placement", "popper-class"]);
    };
  }
}), r1 = ["id", "disabled", "readonly", "required", "name"], o1 = ["value"], Ha = /* @__PURE__ */ te({
  name: "SdsSelect",
  __name: "Select",
  props: /* @__PURE__ */ xe({
    id: { default: void 0 },
    name: { default: null },
    options: { default: () => [] },
    size: { default: "" },
    labelKey: { default: "text" },
    valueKey: { default: "value" },
    disabled: { type: Boolean, default: !1 },
    readonly: { type: Boolean, default: !1 },
    required: { type: Boolean, default: !1 },
    valid: { type: Boolean, default: !1 },
    invalid: { type: Boolean, default: !1 }
  }, {
    modelValue: { type: [Boolean, String, Number, null], type: [Boolean, String, Number, Array, Object], default: null },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(e) {
    const a = e, t = Te(e, "modelValue"), { validationClasses: n } = Xt(a);
    return (l, o) => Ze((s(), u("select", {
      id: e.id,
      "onUpdate:modelValue": o[0] || (o[0] = (i) => t.value = i),
      "data-id": "sds-select",
      disabled: e.disabled || void 0,
      readonly: e.readonly || void 0,
      required: e.required || void 0,
      name: e.name ? e.name : void 0,
      class: D(["form-control", { "form-control-sm": e.size === "sm", ...r(n) }])
    }, [
      o[1] || (o[1] = d("option", {
        disabled: "",
        value: ""
      }, null, -1)),
      (s(!0), u(J, null, le(e.options, (i) => (s(), u("option", {
        key: `${e.id}_${JSON.stringify(i)}`,
        value: i[e.valueKey]
      }, A(i[e.labelKey]), 9, o1))), 128))
    ], 10, r1)), [
      [It, t.value]
    ]);
  }
}), s1 = ["width", "height", "viewBox"], i1 = ["d", "fill"], We = /* @__PURE__ */ te({
  name: "SdsSvgIcon",
  __name: "SvgIcon",
  props: {
    color: { default: "currentColor" },
    height: { default: 16 },
    path: {},
    viewBox: { default: "0 0 16 16" },
    width: { default: 16 }
  },
  setup(e) {
    return (a, t) => (s(), u("svg", {
      width: e.width,
      height: e.height,
      viewBox: e.viewBox,
      xmlns: "http://www.w3.org/2000/svg"
    }, [
      d("path", {
        d: e.path,
        fill: e.color
      }, null, 8, i1)
    ], 8, s1));
  }
}), d1 = {
  key: 0,
  "data-id": "sds-paginator",
  class: "paginator",
  "aria-label": "Page navigation"
}, u1 = {
  class: "flex gap-x-2",
  role: "list"
}, c1 = {
  class: "flex items-center grow-0 shrink-0",
  role: "listitem"
}, f1 = ["disabled", "aria-disabled"], h1 = ["disabled", "aria-disabled", "aria-label", "onClick"], m1 = {
  class: "px-4",
  role: "menuitem"
}, g1 = { class: "flex flex-row flex-nowrap items-center gap-x-2" }, v1 = ["for"], y1 = ["id"], b1 = ["disabled", "aria-disabled", "aria-current", "aria-label", "onClick"], p1 = {
  class: "flex md:hidden",
  role: "listitem"
}, w1 = { class: "flex flew-nowrap items-center gap-x-2 m-auto" }, x1 = ["for"], k1 = {
  class: "flex grow-0 shrink-0",
  role: "listitem"
}, C1 = ["disabled", "aria-disabled"], Oa = /* @__PURE__ */ te({
  name: "SdsPaginator",
  __name: "Paginator",
  props: {
    currentPage: { default: 1 },
    totalPages: { default: 0 },
    loading: { type: Boolean, default: !1 },
    threshold: { default: 5 }
  },
  emits: ["go-to-page"],
  setup(e, { emit: a }) {
    const t = e, n = Object.freeze({
      "chevron-left": {
        height: 13,
        path: "M0.871094 6.14844L6.12109 0.898438C6.44922 0.542969 7.02344 0.542969 7.35156 0.898438C7.70703 1.22656 7.70703 1.80078 7.35156 2.12891L2.73047 6.75L7.35156 11.3984C7.70703 11.7266 7.70703 12.3008 7.35156 12.6289C7.02344 12.9844 6.44922 12.9844 6.12109 12.6289L0.871094 7.37891C0.515625 7.05078 0.515625 6.47656 0.871094 6.14844Z",
        viewBox: "0 0 8 13",
        width: 8
      },
      "chevron-right": {
        height: 13,
        path: "M7.10156 6.14844C7.45703 6.47656 7.45703 7.05078 7.10156 7.37891L1.85156 12.6289C1.52344 12.9844 0.949219 12.9844 0.621094 12.6289C0.265625 12.3008 0.265625 11.7266 0.621094 11.3984L5.24219 6.75L0.621094 2.12891C0.265625 1.80078 0.265625 1.22656 0.621094 0.898438C0.949219 0.542969 1.52344 0.542969 1.85156 0.898438L7.10156 6.14844Z",
        viewBox: "0 0 8 13",
        width: 8
      },
      ellipsis: {
        height: 4,
        path: "M3.15625 1.75C3.15625 2.59766 2.44531 3.28125 1.625 3.28125C0.777344 3.28125 0.09375 2.59766 0.09375 1.75C0.09375 0.929688 0.777344 0.21875 1.625 0.21875C2.44531 0.21875 3.15625 0.929688 3.15625 1.75ZM7.53125 1.75C7.53125 2.59766 6.82031 3.28125 6 3.28125C5.15234 3.28125 4.46875 2.59766 4.46875 1.75C4.46875 0.929688 5.15234 0.21875 6 0.21875C6.82031 0.21875 7.53125 0.929688 7.53125 1.75ZM8.84375 1.75C8.84375 0.929688 9.52734 0.21875 10.375 0.21875C11.1953 0.21875 11.9062 0.929688 11.9062 1.75C11.9062 2.59766 11.1953 3.28125 10.375 3.28125C9.52734 3.28125 8.84375 2.59766 8.84375 1.75Z",
        viewBox: "0 0 12 4",
        width: 12
      }
    }), l = a, o = tt(), i = E(), h = E(
      Array.from({ length: t.totalPages }, (x, I) => ({ value: I + 1, text: I + 1 }))
    ), c = tt(), f = E(t.currentPage), y = M(() => {
      const x = typeof i.value > "u" ? void 0 : parseInt(i.value, 10), I = v.value[v.value.length - 1];
      return typeof x > "u" ? !1 : x < 1 || x > parseInt(`${I}`, 10);
    }), m = M(() => t.currentPage <= 1 || t.loading), g = M(() => t.currentPage >= t.totalPages || t.loading), v = M(() => {
      if (t.totalPages <= t.threshold)
        return [...Array(t.totalPages)].map((x, I) => I + 1);
      if (t.currentPage < t.threshold)
        return [...Array(t.threshold)].map((I, L) => L + 1).concat(["...", t.totalPages]);
      if (t.currentPage > t.totalPages - t.threshold + 1)
        return [1, "..."].concat(
          [...Array(t.threshold)].map((I, L) => t.totalPages - t.threshold + L + 1)
        );
      {
        let x = [1, "..."];
        return x = x.concat(
          [...Array(t.threshold - 3)].map((I, L) => t.currentPage + L - t.threshold + 3)
        ), x.push(t.currentPage), x = x.concat(
          [...Array(t.threshold - 3)].map((I, L) => t.currentPage + L + 1)
        ), x.concat(["...", t.totalPages]);
      }
    }), C = (x, I) => {
      l("go-to-page", { page: x, event: I });
    }, k = (x) => {
      C(f.value, x);
    }, w = (x) => {
      if (x.key === "Enter") {
        const I = typeof i.value > "u" ? void 0 : parseInt(i.value, 10);
        if (!I || I === t.currentPage || y.value) return;
        i.value = void 0, C(I, x);
      }
    };
    return ye(() => t.currentPage, (x) => {
      f.value = x;
    }, { immediate: !0 }), (x, I) => e.totalPages > 1 ? (s(), u("nav", d1, [
      d("ul", u1, [
        d("li", c1, [
          d("button", {
            disabled: r(m),
            "aria-disabled": r(m),
            "aria-label": "Previous page",
            type: "button",
            class: "flex items-center justify-center grow-0 shrink-0 bg-white dark:bg-gray-950 hover:not-disabled:bg-gray-600/10 dark:hover:not-disabled:bg-gray-400/10 border rounded-theme-sm border-gray-600/20 dark:border-gray-400/20 disabled:border-gray-600/10 dark:disabled:border-gray-400/10 w-8.5 h-8.5 p-2",
            onClick: I[0] || (I[0] = fe((L) => C(e.currentPage - 1, L), ["prevent"]))
          }, [
            Q(We, {
              "aria-hidden": "true",
              class: D(["w-2 h-[0.813rem] relative right-px pointer-events-none", {
                "text-gray-600/50 dark:text-gray-400/50": r(m),
                "text-gray-600 dark:text-gray-400": !r(m)
              }]),
              fill: "none",
              preserveAspectRatio: "xMidYMid meet",
              role: "img",
              height: r(n)["chevron-left"].height,
              path: r(n)["chevron-left"].path,
              "view-box": r(n)["chevron-left"].viewBox,
              width: r(n)["chevron-left"].width
            }, null, 8, ["class", "height", "path", "view-box", "width"])
          ], 8, f1)
        ]),
        (s(!0), u(J, null, le(r(v), (L, z) => (s(), u("li", {
          key: z,
          class: "hidden md:flex grow-0 shrink-0",
          role: "listitem"
        }, [
          L.toLocaleString() === "..." ? (s(), G(fa, {
            key: 0,
            placement: "bottom",
            auto: "",
            "hide-arrow": ""
          }, {
            trigger: U(({ isOpen: b, toggle: $ }) => [
              d("button", {
                disabled: e.loading,
                "aria-disabled": e.loading,
                "aria-label": `${b ? "Collapse" : "Expand"} Go to page menu`,
                type: "button",
                class: D(["flex items-center justify-center grow-0 shrink-0 bg-white/0 hover:bg-gray-600/10 dark:hover:bg-gray-400/10 rounded-theme-sm w-8.5 h-8.5 disabled:pointer-events-none", {
                  "bg-gray-700/10 dark:bg-gray-300/10": b
                }]),
                onClick: $
              }, [
                Q(We, {
                  "aria-hidden": "true",
                  class: D(["pointer-events-none", {
                    "text-gray-600/50 dark:text-gray-400/50": e.loading,
                    "text-gray-600 dark:text-gray-400": !e.loading
                  }]),
                  fill: "none",
                  preserveAspectRatio: "xMidYMid meet",
                  role: "img",
                  height: r(n).ellipsis.height,
                  path: r(n).ellipsis.path,
                  "view-box": r(n).ellipsis.viewBox,
                  width: r(n).ellipsis.width
                }, null, 8, ["class", "height", "path", "view-box", "width"])
              ], 10, h1)
            ]),
            default: U(() => [
              d("div", m1, [
                d("form", {
                  onSubmit: I[3] || (I[3] = fe(() => {
                  }, ["prevent"]))
                }, [
                  d("fieldset", g1, [
                    I[8] || (I[8] = d("span", { class: "text-gray-900 dark:text-white text-sm" }, "Go to", -1)),
                    d("label", { for: r(o) }, [
                      I[7] || (I[7] = d("span", { class: "sr-only" }, "Page number", -1)),
                      Ze(d("input", {
                        id: r(o),
                        "onUpdate:modelValue": I[1] || (I[1] = (b) => Ne(i) ? i.value = b : null),
                        type: "number",
                        class: D(["form-control form-control-sm max-w-8.5 min-w-8.5 [-moz-appearance:textfield] [&::-webkit-inner-spin-button]:appearance-none [&::-webkit-outer-spin-button]:appearance-none", {
                          "invalid animate-shake": r(y)
                        }]),
                        onKeyup: I[2] || (I[2] = Se((b) => w(b), ["enter"]))
                      }, null, 42, y1), [
                        [qn, r(i)]
                      ])
                    ], 8, v1),
                    I[9] || (I[9] = d("span", { class: "text-gray-900 dark-text-white text-sm" }, "page", -1))
                  ])
                ], 32)
              ])
            ]),
            _: 1
          })) : (s(), u("button", {
            key: 1,
            disabled: L === e.currentPage || e.loading,
            "aria-disabled": L === e.currentPage || e.loading,
            "aria-current": L === e.currentPage ? "page" : void 0,
            "aria-label": L === e.currentPage ? `Current page, page ${L}` : `Go to page ${L}`,
            type: "button",
            class: D(["flex items-center justify-center grow-0 shrink-0 bg-white dark:bg-gray-950 hover:not-disabled:bg-gray-600/10 dark:hover:not-disabled:bg-gray-400/10 border rounded-theme-sm border-gray-600/20 dark:border-gray-600/20 text-gray-600 dark:text-gray-400 font-semibold min-w-8.5 h-8.5 p-2", {
              // Active state
              "disabled:bg-blue-50 dark:disabled:bg-blue-900 disabled:border-blue-600 dark:disabled:border-blue-400 shadow-inner shadow-blue-600/15 dark:shadow-blue-400/15": L === e.currentPage && !e.loading,
              // Disabled state
              "disabled:text-gray-600/50 dark:disabled:text-gray-400/50 disabled:border-gray-600/10 dark:disabled:border-gray-600/10": e.loading
            }]),
            onClick: fe((b) => C(L, b), ["prevent"])
          }, A(L.toLocaleString()), 11, b1))
        ]))), 128)),
        d("li", p1, [
          d("div", w1, [
            d("label", {
              for: r(c),
              class: "sr-only"
            }, "Page", 8, x1),
            Q(Ha, {
              id: r(c),
              modelValue: r(f),
              "onUpdate:modelValue": I[4] || (I[4] = (L) => Ne(f) ? f.value = L : null),
              options: r(h),
              class: "h-8.5 w-auto",
              size: "sm",
              onChange: I[5] || (I[5] = (L) => k(L))
            }, null, 8, ["id", "modelValue", "options"])
          ])
        ]),
        d("li", k1, [
          d("button", {
            disabled: r(g),
            "aria-disabled": r(g),
            type: "button",
            "aria-label": "Next page",
            class: "flex items-center justify-center grow-0 shrink-0 bg-white dark:bg-gray-950 hover:not-disabled:bg-gray-600/10 dark:hover:not-disabled:bg-gray-400/10 border rounded-theme-sm border-gray-600/20 dark:border-gray-400/20 disabled:border-gray-600/10 dark:disabled:border-gray-400/10 w-8.5 h-8.5 p-2",
            onClick: I[6] || (I[6] = fe((L) => C(e.currentPage + 1, L), ["prevent"]))
          }, [
            Q(We, {
              "aria-hidden": "true",
              class: D(["w-2 h-[0.813rem] relative left-px pointer-events-none", {
                "text-gray-600/50 dark:text-gray-400/50": r(g),
                "text-gray-600 dark:text-gray-400": !r(g)
              }]),
              fill: "none",
              preserveAspectRatio: "xMidYMid meet",
              role: "img",
              height: r(n)["chevron-right"].height,
              path: r(n)["chevron-right"].path,
              "view-box": r(n)["chevron-right"].viewBox,
              width: r(n)["chevron-right"].width
            }, null, 8, ["class", "height", "path", "view-box", "width"])
          ], 8, C1)
        ])
      ])
    ])) : S("", !0);
  }
}), $1 = {
  "data-id": "sds-paginator-range",
  "aria-live": "polite",
  "aria-atomic": "true"
}, M1 = { class: "text-sm text-gray-800 dark:text-gray-600" }, S1 = { class: "font-semibold" }, D1 = { class: "font-semibold" }, Pa = /* @__PURE__ */ te({
  name: "SdsPaginatorRange",
  __name: "PaginatorRange",
  props: {
    currentPage: { default: 0 },
    totalResultsPerPage: { default: 0 },
    totalResults: { default: 0 },
    totalPages: { default: 0 }
  },
  setup(e) {
    const a = e, t = M(() => a.currentPage), n = M(() => a.totalResultsPerPage), l = M(() => a.totalResults), o = M(() => a.totalPages), { start: i, end: h, total: c } = ss(
      t,
      n,
      l,
      o
    );
    return (f, y) => (s(), u("p", $1, [
      P(f.$slots, "default", {
        start: r(i),
        end: r(h),
        total: r(c)
      }, () => [
        d("span", M1, [
          y[0] || (y[0] = re(" Showing ", -1)),
          d("span", S1, A(r(i) !== r(h) ? `${r(i)}-${r(h)}` : r(i)), 1),
          y[1] || (y[1] = re(" of ", -1)),
          d("span", D1, A(r(c)), 1)
        ])
      ])
    ]));
  }
}), z1 = {
  viewBox: "0 0 640 640",
  "aria-hidden": "true",
  role: "img",
  width: "1.2em",
  height: "1.2em"
};
function T1(e, a) {
  return s(), u("svg", z1, [...a[0] || (a[0] = [
    d("path", {
      fill: "currentColor",
      d: "m470.6 566.6l96-96c9.2-9.2 11.9-22.9 6.9-34.9S556.9 416 544 416h-64V96c0-17.7-14.3-32-32-32s-32 14.3-32 32v320h-64c-12.9 0-24.6 7.8-29.6 19.8s-2.2 25.7 6.9 34.9l96 96c12.5 12.5 32.8 12.5 45.3 0zm-256-493.2c-12.5-12.5-32.8-12.5-45.3 0l-96 96c-9.2 9.2-11.9 22.9-6.9 34.9S83.1 224 96 224h64v320c0 17.7 14.3 32 32 32s32-14.3 32-32V224h64c12.9 0 24.6-7.8 29.6-19.8s2.2-25.7-6.9-34.9l-96-96z"
    }, null, -1)
  ])]);
}
const ho = $e({ name: "fa7-solid-up-down", render: T1 });
We.install = (e) => {
  e.component(We.name, We);
};
const B1 = ["id"], L1 = { key: 0 }, I1 = {
  key: 0,
  class: "in-[.table-prose_&]:px-2 w-10"
}, V1 = { class: "sr-only" }, A1 = {
  key: 0,
  class: "sr-only"
}, H1 = ["onClick"], O1 = {
  key: 0,
  class: "sr-only"
}, P1 = ["onClick"], F1 = ["id", "onMouseover", "onMouseleave"], E1 = ["aria-label"], R1 = ["onClick"], N1 = { class: "sr-only" }, W1 = ["id"], q1 = ["id"], Y1 = ["colspan"], j1 = { key: 1 }, G1 = ["colspan"], Fa = /* @__PURE__ */ te({
  name: "SdsTable",
  __name: "Table",
  props: {
    id: { default: void 0 },
    items: {},
    fields: {},
    sortBy: { default: void 0 },
    sortDesc: { type: Boolean, default: !1 },
    caption: { default: void 0 },
    sortedColumnClass: { default: void 0 },
    enableDrawer: { type: Boolean, default: !1 },
    onSort: { default: void 0 },
    density: { default: void 0 },
    rowHighlight: { type: Boolean, default: void 0 }
  },
  emits: [
    "open-drawer",
    "open-all-drawers"
  ],
  setup(e, { emit: a }) {
    const t = e, n = a, l = ["comfortable", "condensed"], o = Object.freeze({
      "angle-down": {
        height: 6,
        path: "M9.59375 1.71094L5.4375 5.62109C5.30078 5.75781 5.13672 5.8125 5 5.8125C4.83594 5.8125 4.67188 5.75781 4.53516 5.64844L0.378906 1.71094C0.105469 1.46484 0.105469 1.05469 0.351562 0.78125C0.597656 0.507812 1.00781 0.507812 1.28125 0.753906L5 4.25391L8.69141 0.753906C8.96484 0.507812 9.375 0.507812 9.62109 0.78125C9.86719 1.05469 9.86719 1.46484 9.59375 1.71094Z",
        viewBox: "0 0 10 6",
        width: 10
      },
      "angle-up": {
        height: 6,
        path: "M0.378906 4.81641L4.53516 0.90625C4.67188 0.769531 4.83594 0.6875 5 0.6875C5.13672 0.6875 5.30078 0.769531 5.4375 0.878906L9.59375 4.78906C9.86719 5.03516 9.86719 5.44531 9.62109 5.71875C9.375 5.99219 8.96484 5.99219 8.69141 5.74609L4.97266 2.24609L1.28125 5.74609C1.00781 5.99219 0.597656 5.99219 0.351562 5.71875C0.105469 5.47266 0.105469 5.0625 0.378906 4.81641Z",
        viewBox: "0 0 10 6",
        width: 10
      }
    }), i = E(!1), h = E(t.enableDrawer), c = E(t.sortBy ?? ""), f = E(t.sortDesc ? -1 : 1), y = E(/* @__PURE__ */ new Set()), m = E(/* @__PURE__ */ new Set()), g = M(() => t.fields.flatMap((H) => H.fields ? H.fields : H)), v = (H) => h.value || !!H.enableDrawer, C = (H) => m.value.has(H.id), k = M(() => t.items.filter((H) => v(H)).length > 0), w = M(() => t.onSort ? t.items : [...t.items].sort((H, Y) => R(H, Y, c.value))), x = M(() => t.fields.filter((H) => !H.hidden)), I = M(() => Object.entries(x.value).map(([, H]) => H.key)), L = M(() => {
      const { density: H } = t;
      switch (H) {
        case l[0]:
          return "table-prose-lg";
        case l[1]:
          return "table-prose-sm";
        default:
          return "";
      }
    }), z = (H) => {
      const Y = t.fields.find((O) => O.key === H);
      return Y && Y.header ? "th" : "td";
    }, b = (H, Y = "") => {
      const O = g.value.find((_) => _.key === Y);
      return O && O.format ? O.format(H[Y]) : H[Y];
    }, $ = (H) => {
      t.onSort ? t.onSort({
        field: H,
        sortBy: H.key,
        sortDesc: f.value === 0 ? !1 : f.value === 1
      }) : (c.value = H.key, f.value = f.value === 0 ? 1 : f.value === 1 ? -1 : 1);
    }, p = (H) => y.value.add(H.id), F = (H) => y.value.delete(H.id), R = (H, Y, O) => {
      const _ = H[O], oe = Y[O];
      return typeof _ == "number" && typeof oe == "number" || _ instanceof Date && oe instanceof Date ? (_ < oe ? -1 : _ > oe ? 1 : 0) * f.value : X(_).localeCompare(X(oe)) * f.value;
    }, T = (H) => {
      m.value.has(H.id) ? m.value.delete(H.id) : (m.value.add(H.id), n("open-drawer", H));
    }, j = () => {
      i.value = !i.value, i.value ? t.items.forEach((H) => {
        v(H) && m.value.add(H.id);
      }) : m.value.clear(), n("open-all-drawers", t.items);
    }, X = (H) => H === null || typeof H > "u" ? "" : H instanceof Object ? Object.keys(H).sort().map((Y) => X(H[Y])).join(" ") : String(H);
    ye(() => t.enableDrawer, (H) => {
      h.value = H;
    }), ye(() => t.items, (H) => {
      H.forEach((Y) => {
        Y.toggled && !m.value.has(Y.id) && m.value.add(Y.id);
      });
    }, { immediate: !0 }), ye(() => t.sortBy, (H) => {
      H && (c.value = H);
    }), ye(() => t.sortDesc, (H) => {
      f.value = H ? -1 : 1;
    });
    const pe = M(() => t.items.filter((H) => v(H)).length);
    return ye([m, pe], ([H, Y]) => {
      i.value = Y > 0 && H.size === Y;
    }, { deep: !0, immediate: !0 }), (H, Y) => {
      const O = ho, _ = ql, oe = Wl;
      return s(), u("table", {
        id: e.id || "sds-table",
        "data-id": "sds-table",
        class: D(["table-prose dark:table-prose-invert", [r(L)]])
      }, [
        H.$slots.caption || e.caption ? (s(), u("caption", L1, [
          P(H.$slots, "caption", {}, () => [
            re(A(e.caption), 1)
          ])
        ])) : S("", !0),
        d("colgroup", null, [
          (s(!0), u(J, null, le(r(x), (K) => P(H.$slots, `col(${K.key})`, {
            active: r(c) === K.key,
            activeClass: e.sortedColumnClass
          }, () => [
            (s(), u("col", {
              key: K.key,
              class: D({
                [e.sortedColumnClass || ""]: r(c) === K.key
              })
            }, null, 2))
          ])), 256))
        ]),
        d("thead", null, [
          d("tr", null, [
            r(k) ? (s(), u("th", I1, [
              d("button", {
                class: "flex items-center justify-center w-6 h-6",
                type: "button",
                onClick: j
              }, [
                r(i) ? (s(), G(r(We), {
                  key: 0,
                  "aria-hidden": "true",
                  class: "text-gray-600 dark:text-gray-400 hover:text-blue-500 dark:hover:text-blue-400",
                  fill: "none",
                  preserveAspectRatio: "xMidYMid meet",
                  role: "img",
                  height: r(o)["angle-up"].height,
                  path: r(o)["angle-up"].path,
                  "view-box": r(o)["angle-up"].viewBox,
                  width: r(o)["angle-up"].width
                }, null, 8, ["height", "path", "view-box", "width"])) : (s(), G(r(We), {
                  key: 1,
                  "aria-hidden": "true",
                  class: "text-gray-600 dark:text-gray-400 hover:text-blue-500 dark:hover:text-blue-400",
                  fill: "none",
                  preserveAspectRatio: "xMidYMid meet",
                  role: "img",
                  height: r(o)["angle-down"].height,
                  path: r(o)["angle-down"].path,
                  "view-box": r(o)["angle-down"].viewBox,
                  width: r(o)["angle-down"].width
                }, null, 8, ["height", "path", "view-box", "width"])),
                d("span", V1, A(r(i) ? "Collapse all drawers" : "Expand all drawers"), 1)
              ])
            ])) : S("", !0),
            (s(!0), u(J, null, le(r(x), (K) => (s(), u(J, null, [
              K.fields ? (s(), u("th", {
                key: K.key,
                class: D([{
                  [e.sortedColumnClass || ""]: r(c) === K.key,
                  "text-left": !K.align || K.align === "left",
                  "text-center": K.align === "center",
                  "text-right": K.align === "right"
                }, "whitespace-nowrap select-none group"])
              }, [
                K.srOnly ? (s(), u("span", A1, A(K.label), 1)) : (s(!0), u(J, { key: 1 }, le(K.fields, (de, Me) => (s(), u("button", {
                  key: de.key,
                  type: "button",
                  class: D(["inline-flex items-center align-middle after:content-['/'] after:font-normal after:inline-block after:ml-0.5 last:after:hidden", {
                    "cursor-default after:mr-0.5": !de.sortable,
                    "after:mr-4": de.sortable,
                    "flex-row-reverse": K.align === "right"
                  }]),
                  onClick: (Le) => de.sortable ? $(de) : void 0
                }, [
                  P(H.$slots, `head(${de.key})`, {
                    field: de,
                    active: r(c) === de.key
                  }, () => [
                    d("span", {
                      class: D({
                        "text-gray-900 dark:text-gray-100 font-bold": r(c) === de.key,
                        "font-normal": r(c) !== de.key && Me !== 0
                      })
                    }, A(de.label), 3),
                    de.sortable ? (s(), u(J, { key: 0 }, [
                      r(c) !== de.key ? (s(), G(O, {
                        key: 0,
                        class: D(["inline-block text-gray-900 dark:text-gray-100", {
                          "opacity-100": r(c) === de.key,
                          "opacity-0 group-hover:opacity-50": r(c) !== de.key,
                          "ml-2": de.align !== "right",
                          "mr-2": de.align === "right"
                        }])
                      }, null, 8, ["class"])) : r(f) > 0 ? (s(), G(_, {
                        key: 1,
                        class: D(["inline-block text-gray-900 dark:text-gray-100", {
                          "opacity-100": r(c) === de.key,
                          "opacity-0 group-hover:opacity-50": r(c) !== de.key,
                          "ml-2": de.align !== "right",
                          "mr-2": de.align === "right"
                        }])
                      }, null, 8, ["class"])) : (s(), G(oe, {
                        key: 2,
                        class: D(["inline-block text-gray-900 dark:text-gray-100", {
                          "opacity-100": r(c) === de.key,
                          "opacity-0 group-hover:opacity-50": r(c) !== de.key,
                          "ml-2": de.align !== "right",
                          "mr-2": de.align === "right"
                        }])
                      }, null, 8, ["class"]))
                    ], 64)) : S("", !0)
                  ])
                ], 10, H1))), 128))
              ], 2)) : (s(), u("th", {
                key: K.key,
                class: D([{
                  [e.sortedColumnClass || ""]: r(c) === K.key,
                  "text-left": !K.align || K.align === "left",
                  "text-center": K.align === "center",
                  "text-right": K.align === "right"
                }, "whitespace-nowrap space-x-1 select-none group"])
              }, [
                K.srOnly ? (s(), u("span", O1, A(K.label), 1)) : (s(), u("button", {
                  key: 1,
                  class: D(["inline-flex items-center align-middle", {
                    "cursor-default": !K.sortable,
                    "flex-row-reverse": K.align === "right"
                  }]),
                  type: "button",
                  onClick: (de) => K.sortable ? $(K) : void 0
                }, [
                  P(H.$slots, `head(${K.key})`, {
                    field: K,
                    active: r(c) === K.key
                  }, () => [
                    d("span", {
                      class: D({
                        "text-gray-900 dark:text-gray-100 font-bold": r(c) === K.key
                      })
                    }, A(K.label), 3),
                    K.sortable ? (s(), u(J, { key: 0 }, [
                      r(c) !== K.key ? (s(), G(O, {
                        key: 0,
                        class: D(["inline-block text-gray-900 dark:text-gray-100", {
                          "opacity-100": r(c) === K.key,
                          "opacity-0 group-hover:opacity-50": r(c) !== K.key,
                          "ml-2": K.align !== "right",
                          "mr-2": K.align === "right"
                        }])
                      }, null, 8, ["class"])) : r(f) > 0 ? (s(), G(_, {
                        key: 1,
                        class: D(["inline-block text-gray-900 dark:text-gray-100", {
                          "opacity-100": r(c) === K.key,
                          "opacity-0 group-hover:opacity-50": r(c) !== K.key,
                          "ml-2": K.align !== "right",
                          "mr-2": K.align === "right"
                        }])
                      }, null, 8, ["class"])) : (s(), G(oe, {
                        key: 2,
                        class: D(["inline-block text-gray-900 dark:text-gray-100", {
                          "opacity-100": r(c) === K.key,
                          "opacity-0 group-hover:opacity-50": r(c) !== K.key,
                          "ml-2": K.align !== "right",
                          "mr-2": K.align === "right"
                        }])
                      }, null, 8, ["class"]))
                    ], 64)) : S("", !0)
                  ])
                ], 10, P1))
              ], 2))
            ], 64))), 256))
          ])
        ]),
        d("tbody", null, [
          (s(!0), u(J, null, le(r(w), (K, de) => (s(), u(J, {
            key: K.id
          }, [
            d("tr", {
              id: `${e.id || "sds-table"}_tr_${K.id || de}`,
              class: D({
                "hover:[.table-prose_tbody_&]:bg-gray-25 dark:hover:[.table-prose_tbody_&]:bg-gray-900/85": e.rowHighlight,
                "peer has-[+tr[data-drawer]:hover]:bg-gray-25 dark:has-[+tr[data-drawer]:hover]:bg-gray-900/85": C(K) && !K.nestedRows && e.rowHighlight
              }),
              onMouseover: (Me) => p(K),
              onMouseleave: (Me) => F(K)
            }, [
              r(k) ? (s(), u("td", {
                key: 0,
                class: D(["[.table-prose_tbody_&]:px-2 w-10", {
                  "border-b-0": C(K)
                }]),
                "aria-label": r(k) ? void 0 : "No value"
              }, [
                v(K) ? (s(), u("button", {
                  key: 0,
                  type: "button",
                  class: "flex items-center justify-center w-6 h-6",
                  onClick: (Me) => T(K)
                }, [
                  C(K) ? (s(), G(r(We), {
                    key: 0,
                    "aria-hidden": "true",
                    class: "text-gray-600 dark:text-gray-400 hover:text-blue-500 dark:hover:text-blue-400",
                    fill: "none",
                    preserveAspectRatio: "xMidYMid meet",
                    role: "img",
                    height: r(o)["angle-up"].height,
                    path: r(o)["angle-up"].path,
                    "view-box": r(o)["angle-up"].viewBox,
                    width: r(o)["angle-up"].width
                  }, null, 8, ["height", "path", "view-box", "width"])) : (s(), G(r(We), {
                    key: 1,
                    "aria-hidden": "true",
                    class: "text-gray-600 dark:text-gray-400 hover:text-blue-500 dark:hover:text-blue-400",
                    fill: "none",
                    preserveAspectRatio: "xMidYMid meet",
                    role: "img",
                    height: r(o)["angle-down"].height,
                    path: r(o)["angle-down"].path,
                    "view-box": r(o)["angle-down"].viewBox,
                    width: r(o)["angle-down"].width
                  }, null, 8, ["height", "path", "view-box", "width"])),
                  d("span", N1, A(C(K) ? "Collapse drawer" : "Expand drawer"), 1)
                ], 8, R1)) : S("", !0)
              ], 10, E1)) : S("", !0),
              (s(!0), u(J, null, le(r(I), (Me) => (s(), G(mt(z(Me)), {
                key: Me,
                class: D({
                  "text-left": r(x).find((Le) => Le.key === Me)?.align === "left",
                  "text-center": r(x).find((Le) => Le.key === Me)?.align === "center",
                  "text-right": r(x).find((Le) => Le.key === Me)?.align === "right",
                  "border-b-0": C(K)
                })
              }, {
                default: U(() => [
                  P(H.$slots, `cell(${Me})`, {
                    value: b(K, Me),
                    item: K,
                    format: (Le) => b(K, Le)
                  }, () => [
                    re(A(b(K, Me)), 1)
                  ])
                ]),
                _: 2
              }, 1032, ["class"]))), 128))
            ], 42, F1),
            K.nestedRows && K.nestedRows.length ? (s(!0), u(J, { key: 0 }, le(K.nestedRows, (Me, Le) => (s(), u(J, null, [
              v(K) && C(K) ? (s(), u("tr", {
                id: `${e.id || "sds-table"}_tr_${Me.id || Le}`,
                key: Le,
                class: D({
                  "hover:[.table-prose_tbody_&]:bg-gray-25 dark:hover:[.table-prose_tbody_&]:bg-gray-900/85": e.rowHighlight
                })
              }, [
                d("td", {
                  "aria-label": "No value",
                  class: D(["[.table-prose_tbody_&]:px-2 w-10", {
                    "border-b-0": Le !== K.nestedRows.length - 1
                  }])
                }, null, 2),
                (s(!0), u(J, null, le(r(I), (Ge) => (s(), G(mt(z(Ge)), {
                  key: Ge,
                  class: D({
                    "text-left": r(x).find((Fe) => Fe.key === Ge)?.align === "left",
                    "text-center": r(x).find((Fe) => Fe.key === Ge)?.align === "center",
                    "text-right": r(x).find((Fe) => Fe.key === Ge)?.align === "right",
                    "border-b-0": Le !== K.nestedRows.length - 1
                  })
                }, {
                  default: U(() => [
                    P(H.$slots, `cell(${Ge})`, {
                      value: b(Me, Ge),
                      item: Me,
                      format: (Fe) => b(Me, Fe)
                    }, () => [
                      re(A(b(Me, Ge)), 1)
                    ])
                  ]),
                  _: 2
                }, 1032, ["class"]))), 128))
              ], 10, W1)) : S("", !0)
            ], 64))), 256)) : (s(), u(J, { key: 1 }, [
              v(K) && C(K) ? (s(), u("tr", {
                key: 0,
                id: `${e.id || "sds-table"}_tr_${K.id || de}_drawer`,
                "data-drawer": "true",
                class: D({
                  "hover:[.table-prose_tbody_&]:bg-gray-25 dark:hover:[.table-prose_tbody_&]:bg-gray-900/85": e.rowHighlight,
                  "[.table-prose_tbody_&]:peer-hover:bg-gray-25 dark:[.table-prose_tbody_&]:peer-hover:bg-gray-900/85": e.rowHighlight && r(y).has(K.id)
                })
              }, [
                d("td", {
                  colspan: r(I).length + 1
                }, [
                  P(H.$slots, "drawer", { item: K })
                ], 8, Y1)
              ], 10, q1)) : S("", !0)
            ], 64))
          ], 64))), 128))
        ]),
        H.$slots.footer ? (s(), u("tfoot", j1, [
          d("tr", null, [
            d("td", {
              colspan: r(I).length + 1
            }, [
              P(H.$slots, "footer")
            ], 8, G1)
          ])
        ])) : S("", !0)
      ], 10, B1);
    };
  }
}), U1 = {
  "data-id": "sds-data-table",
  class: "w-full min-w-full"
}, K1 = {
  key: 0,
  class: "bg-white dark:bg-gray-950 border border-b-0 border-gray-100 dark:border-gray-800 rounded-tl-lg rounded-tr-lg sds-theme-plaid:rounded-none min-h-14.5 w-full min-w-full"
}, Z1 = { class: "flex flex-row flex-nowrap items-center gap-x-2 relative min-h-15.5" }, Q1 = {
  key: 0,
  class: "overflow-x-auto flex flex-row flex-nowrap items-center gap-x-2 px-2 py-4"
}, X1 = { class: "overflow-x-auto max-w-full" }, J1 = { class: "flex flex-wrap md:flex-nowrap justify-between items-center gap-4" }, _1 = {
  key: 1,
  class: "bg-white dark:bg-gray-950 border border-t-0 border-gray-100 dark:border-gray-800 rounded-bl-lg rounded-br-lg sds-theme-plaid:rounded-none flex flex-col items-center justify-center px-2 pt-4 pb-8"
}, ef = { class: "mt-4" }, dn = /* @__PURE__ */ te({
  name: "SdsDataTable",
  __name: "DataTable",
  props: {
    data: { default: void 0 },
    pagination: { default: void 0 },
    filters: { default: void 0 },
    filterSearch: { type: Boolean, default: !1 },
    filterSearchQuery: { default: void 0 },
    filterSearchDebounce: { default: 300 },
    loading: { type: Boolean, default: !1 }
  },
  emits: ["update:filters", "update:filterSearchQuery", "update:pagination"],
  setup(e, { emit: a }) {
    const t = e, n = a, l = E(
      t.filters && Array.isArray(t.filters) ? t.filters.map((R) => ({
        ...R,
        segments: R.segments ? [{ label: "All", selected: !0 }, ...R.segments] : void 0,
        options: R.options ? [...R.options] : void 0
      })) : void 0
    ), o = E(!1), i = E(t.filterSearchQuery ?? ""), h = M(() => ({
      items: [],
      fields: [],
      ...t.data
    })), c = M(() => ({
      loading: k.value,
      currentPage: t.pagination?.currentPage ?? 1,
      totalPages: t.pagination?.totalPages ?? 0
    })), f = M(() => ({
      currentPage: t.pagination?.currentPage ?? 1,
      totalResultsPerPage: t.pagination?.totalResultsPerPage ?? 0,
      totalResults: t.pagination?.totalResults ?? 0,
      totalPages: t.pagination?.totalPages ?? 0
    })), y = M(() => [
      { value: 10, text: "10" },
      { value: 25, text: "25" },
      { value: 50, text: "50" }
    ]), m = M(() => `${t.pagination?.totalResultsPerPage ?? 0} rows`), g = M(() => {
      const { filters: R } = t;
      return !!(R && R.length);
    }), v = M(() => !!t.filterSearch), C = M(() => l.value ? l.value.some((R) => x(R) ? R.segments.some(
      (T, j) => j !== 0 && T.selected
    ) : I(R) ? R.options.some((T) => T.selected) : !1) : !1), k = M(() => t.loading ?? !1), w = M(() => k.value && i.value.length > 0);
    function x(R) {
      return R.type === "segment" && Array.isArray(R.segments) && R.segments.length > 0;
    }
    function I(R) {
      return R.type === "dropdown" && Array.isArray(R.options) && R.options.length > 0;
    }
    function L() {
      l.value && l.value.forEach((R) => {
        x(R) ? R.segments.forEach((T, j) => {
          T.selected = j === 0;
        }) : I(R) && R.options.forEach((T) => {
          T.selected = !1;
        });
      }), i.value && i.value.length > 0 && (i.value = ""), n("update:filters", l.value);
    }
    function z(R, T) {
      if (!l.value) return;
      const j = l.value.find((X) => X.key === R);
      j && (x(j) && T && j.segments.forEach((X) => {
        X.selected = X.label === T.label;
      }), n("update:filters", l.value));
    }
    function b({ page: R, event: T }) {
      T.preventDefault();
      const j = typeof R == "string" ? Number(R) : R;
      n("update:pagination", {
        ...c.value,
        currentPage: j,
        totalResults: t.pagination?.totalResults ?? 0,
        totalResultsPerPage: t.pagination?.totalResultsPerPage ?? 0
      });
    }
    function $(R) {
      n("update:pagination", {
        ...c.value,
        currentPage: 1,
        totalResults: t.pagination?.totalResults ?? 0,
        totalResultsPerPage: R
      });
    }
    function p(R) {
      o.value = R, R || (i.value = "");
    }
    const F = Ar((R) => {
      n("update:filterSearchQuery", R);
    }, t.filterSearchDebounce);
    return ye(i, (R) => {
      F(R);
    }), (R, T) => {
      const j = P0, X = oo, pe = Wn("SdsDropdownItem"), H = Wn("SdsButton");
      return s(), u("div", U1, [
        r(g) || r(v) ? (s(), u("div", K1, [
          d("div", Z1, [
            r(g) && !r(o) ? (s(), u("div", Q1, [
              (s(!0), u(J, null, le(r(l), (Y, O) => (s(), u(J, { key: O }, [
                x(Y) ? (s(!0), u(J, { key: 0 }, le(Y.segments, (_, oe) => (s(), G(je, {
                  key: `${O}-${oe}`,
                  active: _.selected,
                  kind: "ghost",
                  variant: "gray",
                  size: "xs",
                  type: "button",
                  onClick: (K) => z(Y.key, _)
                }, {
                  default: U(() => [
                    d("span", null, A(_.label), 1)
                  ]),
                  _: 2
                }, 1032, ["active", "onClick"]))), 128)) : I(Y) ? (s(), G(Aa, {
                  key: 1,
                  modelValue: Y.options,
                  "onUpdate:modelValue": [(_) => Y.options = _, (_) => z(Y.key)],
                  title: Y.label ?? void 0,
                  disabled: Y.disabled ?? void 0,
                  "enable-filter": !0,
                  kind: "ghost",
                  variant: "gray",
                  size: "xs"
                }, null, 8, ["modelValue", "onUpdate:modelValue", "title", "disabled"])) : S("", !0)
              ], 64))), 128)),
              r(C) ? (s(), G(je, {
                key: 0,
                kind: "ghost",
                variant: "red",
                size: "xs",
                type: "button",
                onClick: L
              }, {
                default: U(() => [
                  Q(j, { class: "h-4 w-4" }),
                  T[4] || (T[4] = d("span", null, "Clear filters", -1))
                ]),
                _: 1
              })) : S("", !0)
            ])) : S("", !0),
            r(v) ? (s(), u("div", {
              key: 1,
              class: D(["flex flex-row items-center justify-end gap-x-4 px-2 py-4", {
                "ml-auto w-auto relative": !r(o),
                "absolute top-0 left-0 z-10 w-full": r(o)
              }])
            }, [
              r(o) ? S("", !0) : (s(), G(je, {
                key: 0,
                kind: "secondary",
                variant: "gray",
                size: "sm",
                type: "button",
                onClick: T[0] || (T[0] = (Y) => p(!0))
              }, {
                default: U(() => [
                  Q(X, { class: "h-4 w-4" }),
                  T[5] || (T[5] = d("span", null, "Filter", -1))
                ]),
                _: 1
              })),
              r(o) ? (s(), G(Va, {
                key: 1,
                modelValue: r(i),
                "onUpdate:modelValue": T[1] || (T[1] = (Y) => Ne(i) ? i.value = Y : null),
                autofocus: r(o),
                pending: r(w),
                size: "sm",
                class: "w-full"
              }, null, 8, ["modelValue", "autofocus", "pending"])) : S("", !0),
              r(o) ? (s(), G(je, {
                key: 2,
                kind: "secondary",
                variant: "gray",
                size: "sm",
                type: "button",
                onClick: T[2] || (T[2] = (Y) => p(!1))
              }, {
                default: U(() => [...T[6] || (T[6] = [
                  d("span", null, "Cancel", -1)
                ])]),
                _: 1
              })) : S("", !0)
            ], 2)) : S("", !0)
          ])
        ])) : S("", !0),
        d("div", X1, [
          r(h).items && r(h).items.length ? (s(), G(Fa, en({ key: 0 }, { ...r(h), ...R.$attrs }, { class: "table-prose-td:align-middle w-full min-w-5xl" }), kr({
            footer: U(() => [
              d("div", J1, [
                Q(Pa, en({ ...r(f), ...R.$attrs }, { class: "w-full md:w-auto" }), null, 16),
                Q(Oa, en({ ...r(c), ...R.$attrs }, { onGoToPage: b }), null, 16),
                Q(fa, {
                  modelValue: r(y),
                  "onUpdate:modelValue": T[3] || (T[3] = (Y) => Ne(y) ? y.value = Y : null),
                  "data-id": "sds-data-table-page-size-dropdown",
                  kind: "secondary",
                  variant: "gray",
                  class: "justify-self-end"
                }, {
                  title: U(() => [
                    re(A(r(m)), 1)
                  ]),
                  default: U(() => [
                    (s(!0), u(J, null, le(r(y), (Y) => (s(), G(pe, {
                      key: JSON.stringify(Y),
                      tag: "button",
                      onClick: (O) => $(Y.value)
                    }, {
                      default: U(() => [
                        re(A(Y.text), 1)
                      ]),
                      _: 2
                    }, 1032, ["onClick"]))), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ])
            ]),
            _: 2
          }, [
            le(R.$slots, (Y, O) => ({
              name: O,
              fn: U((_) => [
                P(R.$slots, O, Cr($r(_ ?? {})))
              ])
            }))
          ]), 1040)) : (s(), u("div", _1, [
            T[8] || (T[8] = d("svg", {
              class: "mb-2",
              width: "40",
              height: "40",
              viewBox: "0 0 40 40",
              fill: "currentColor",
              xmlns: "http://www.w3.org/2000/svg",
              role: "presentation"
            }, [
              d("mask", {
                id: "mask0_9148_72736",
                style: { "mask-type": "alpha" },
                maskUnits: "userSpaceOnUse",
                x: "0",
                y: "0",
                width: "40",
                height: "40"
              }, [
                d("rect", {
                  width: "40",
                  height: "40",
                  fill: "#D9D9D9"
                })
              ]),
              d("g", { mask: "url(#mask0_9148_72736)" }, [
                d("path", {
                  d: "M18.7466 22.7786C19.8791 22.7786 20.8342 22.3911 21.612 21.6161C22.3898 20.8414 22.7786 19.8877 22.7786 18.7549C22.7786 17.6224 22.3911 16.6673 21.6161 15.8895C20.8414 15.1117 19.8877 14.7228 18.7549 14.7228C17.6224 14.7228 16.6673 15.1103 15.8895 15.8853C15.1117 16.66 14.7228 17.6138 14.7228 18.7466C14.7228 19.8791 15.1103 20.8342 15.8853 21.612C16.66 22.3898 17.6138 22.7786 18.7466 22.7786ZM26.7924 28.7787L22.4453 24.4311C21.8525 24.8109 21.2436 25.0934 20.6186 25.2786C19.9936 25.4636 19.3753 25.5561 18.7636 25.5561C16.8753 25.5561 15.2668 24.8918 13.9382 23.5632C12.6096 22.2346 11.9453 20.6305 11.9453 18.7507C11.9453 16.871 12.6096 15.2668 13.9382 13.9382C15.2668 12.6096 16.871 11.9453 18.7507 11.9453C20.6305 11.9453 22.2346 12.6096 23.5632 13.9382C24.8918 15.2668 25.5561 16.8753 25.5561 18.7636C25.5561 19.3753 25.4567 19.9936 25.2578 20.6186C25.0586 21.2436 24.7692 21.8525 24.3895 22.4453L28.7786 26.8341L26.7924 28.7787Z",
                  fill: "#007CBA"
                })
              ]),
              d("mask", {
                id: "mask1_9148_72736",
                style: { "mask-type": "alpha" },
                maskUnits: "userSpaceOnUse",
                x: "0",
                y: "0",
                width: "40",
                height: "40"
              }, [
                d("rect", {
                  width: "40",
                  height: "40",
                  fill: "#D9D9D9"
                })
              ]),
              d("g", { mask: "url(#mask1_9148_72736)" }, [
                d("path", {
                  d: "M7.77792 35C7.02792 35 6.37736 34.7246 5.82625 34.1738C5.27542 33.6226 5 32.9721 5 32.2221V25.2221H7.77792V32.2221H14.7779V35H7.77792ZM25.2221 35V32.2221H32.2221V25.2221H35V32.2221C35 32.9721 34.7246 33.6226 34.1738 34.1738C33.6226 34.7246 32.9721 35 32.2221 35H25.2221ZM5 14.7779V7.77792C5 7.02792 5.27542 6.37736 5.82625 5.82625C6.37736 5.27542 7.02792 5 7.77792 5H14.7779V7.77792H7.77792V14.7779H5ZM32.2221 14.7779V7.77792H25.2221V5H32.2221C32.9721 5 33.6226 5.27542 34.1738 5.82625C34.7246 6.37736 35 7.02792 35 7.77792V14.7779H32.2221Z",
                  fill: "#B2D8EA"
                })
              ])
            ], -1)),
            T[9] || (T[9] = d("p", { class: "flex flex-col justify-center items-center gap-y-1 w-full" }, [
              d("span", { class: "block text-black dark:text-white font-semibold text-lg" }, "No Results"),
              d("span", { class: "block text-gray-600 dark:text-gray-400 text-sm" }, " There are no results you can view. ")
            ], -1)),
            d("p", ef, [
              Q(H, {
                kind: "primary",
                variant: "blue",
                size: "sm",
                onClick: L
              }, {
                default: U(() => [...T[7] || (T[7] = [
                  d("span", null, "Clear filters", -1)
                ])]),
                _: 1
              })
            ])
          ]))
        ])
      ]);
    };
  }
});
dn.install = (e) => {
  e.component(dn.name, dn);
};
ca.install = (e) => {
  e.component(ca.name, ca);
};
const tf = {
  "data-id": "sds-dropdown-divider",
  class: "my-2 border-t bg-white border-gray-100 in-[.dropdown-dark]:bg-gray-950 in-[.dropdown-dark]:border-gray-700 dark:bg-gray-950 dark:border-gray-700"
}, un = /* @__PURE__ */ te({
  name: "SdsDropdownDivider",
  __name: "DropdownDivider",
  setup(e) {
    return (a, t) => (s(), u("div", tf));
  }
});
un.install = (e) => {
  e.component(un.name, un);
};
const af = {
  "data-id": "sds-dropdown-header",
  class: "px-4 py-1 text-sm font-semibold leading-5 bg-white text-gray-500 [.dropdown-dark_&]:bg-gray-950 [.dropdown-dark_&]:text-gray-300 dark:bg-gray-950 dark:text-gray-300"
}, cn = /* @__PURE__ */ te({
  name: "SdsDropdownHeader",
  __name: "DropdownHeader",
  setup(e) {
    return (a, t) => (s(), u("div", af, [
      P(a.$slots, "default")
    ]));
  }
});
cn.install = (e) => {
  e.component(cn.name, cn);
};
Ta.install = (e) => {
  e.component(Ta.name, Ta);
};
const nf = ["aria-checked"], lf = ["for"], rf = ["id", "checked", "value", "name", "disabled"], of = { class: "flex items-center gap-1.5 text-sm text-black dark:text-gray-300 group-hover:text-gray-900 group-hover:dark:text-white w-full" }, kl = /* @__PURE__ */ te({
  name: "SdsDropdownRadioItem",
  __name: "DropdownRadioItem",
  props: {
    modelValue: {},
    value: {},
    label: { default: "" },
    name: { default: void 0 },
    id: { default: void 0 },
    disabled: { type: Boolean, default: !1 }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: a }) {
    const t = e, n = a, l = tt(), o = M(() => t.id || l), i = M(() => t.modelValue === t.value), h = () => {
      t.disabled || n("update:modelValue", t.value);
    };
    return (c, f) => (s(), u("li", {
      "data-id": "sds-dropdown-radio-item",
      class: D(["group px-2 py-1.5 rounded-lg hover:bg-gray-25 dark:hover:bg-gray-750", { "opacity-50 cursor-not-allowed": e.disabled }]),
      role: "menuitemradio",
      "aria-checked": r(i)
    }, [
      d("label", {
        for: r(o),
        class: D(["flex flex-row gap-2 items-center cursor-pointer", { "cursor-not-allowed": e.disabled }])
      }, [
        d("input", {
          id: r(o),
          checked: r(i),
          type: "radio",
          class: "cursor-pointer relative top-px",
          value: e.value,
          name: e.name,
          disabled: e.disabled,
          onChange: h
        }, null, 40, rf),
        d("span", of, [
          P(c.$slots, "icon"),
          P(c.$slots, "default", {}, () => [
            re(A(e.label), 1)
          ])
        ])
      ], 10, lf)
    ], 10, nf));
  }
}), sf = ["disabled", "aria-disabled"], fn = /* @__PURE__ */ te({
  name: "SdsExpandCollapse",
  __name: "ExpandCollapse",
  props: /* @__PURE__ */ xe({
    kind: { default: "primary" },
    variant: { default: "blue" },
    expandLabel: { default: "Show more" },
    collapseLabel: { default: "Show less" },
    disabled: { type: Boolean, default: !1 }
  }, {
    modelValue: { type: Boolean, type: Boolean, default: !1 },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(e) {
    const a = Te(e, "modelValue"), t = () => a.value = !a.value;
    return (n, l) => (s(), u("button", {
      "data-id": "sds-expand-collapse",
      type: "button",
      class: D(["link link-cta", {
        disabled: e.disabled,
        "link-cta-up": a.value,
        "link-cta-down": !a.value,
        "link-primary": e.kind === "primary",
        "link-secondary": e.kind === "secondary",
        "link-tertiary": e.kind === "tertiary",
        "link-blue": e.variant === "blue",
        "link-red": e.variant === "red"
      }]),
      disabled: e.disabled,
      "aria-disabled": e.disabled,
      onClick: t
    }, A(a.value ? e.collapseLabel : e.expandLabel), 11, sf));
  }
});
fn.install = (e) => {
  e.component(fn.name, fn);
};
const df = {
  "data-id": "sds-file-uploader",
  class: "bg-white dark:bg-black border border-dashed border-gray-200 dark:border-gray-700 rounded-theme-lg p-3"
}, uf = { class: "group relative" }, cf = ["id", "name", "accept", "multiple", "required", "disabled"], ff = ["for"], hf = {
  key: 0,
  class: "flex flex-col space-y-2 mt-2"
}, mf = { class: "bg-white dark:bg-black dark:hover:bg-gray-900 border border-gray-100 hover:border-gray-200 dark:border-gray-800 dark:hover:border-gray-700 rounded-theme-sm flex flex-row items-center self-stretch gap-2 w-full p-2 shadow-none hover:shadow-lg" }, gf = {
  key: 0,
  class: "flex flex-none w-10 h-10"
}, vf = ["alt", "src"], yf = {
  key: 1,
  class: "flex flex-none justify-center items-center w-10 h-10 p-2 bg-gray-25 dark:bg-gray-900 rounded-theme-sm"
}, bf = { class: "truncate" }, pf = { class: "leading-6" }, wf = { class: "bg-white dark:bg-black border border-gray-100 hover:border-gray-200 dark:border-gray-800 dark:hover:border-gray-700 rounded-theme-sm flex flex-row items-center self-stretch gap-2 w-full p-2 shadow-none hover:shadow-lg" }, xf = { class: "flex flex-none justify-center items-center w-10 h-10 p-2 bg-red-25 dark:bg-red-900 rounded-theme-sm" }, kf = { class: "overflow-hidden" }, Cf = { class: "w-full" }, $f = { class: "truncate" }, Mf = { class: "leading-6" }, Sf = { class: "block text-xs text-red-600 dark:text-red-300 leading-4" }, hn = /* @__PURE__ */ te({
  name: "SdsFileUploader",
  __name: "FileUploader",
  props: /* @__PURE__ */ xe({
    name: { default: "sdsFileUploader" },
    multiple: { type: Boolean, default: !1 },
    required: { type: Boolean, default: !1 },
    accept: { default: void 0 },
    allowedFiletypes: { default: () => [] },
    filesize: { default: 10 },
    maxFilesSize: { default: void 0 },
    helperText: { default: void 0 }
  }, {
    modelValue: { type: Array, default: () => [] },
    modelModifiers: {}
  }),
  emits: /* @__PURE__ */ xe(["add", "remove", "remove-invalid", "total-files-size"], ["update:modelValue"]),
  setup(e, { emit: a }) {
    const t = tt(), n = e, l = Te(e, "modelValue"), o = a, i = E(null), h = E([]), c = E({
      "arrow-up-from-bracket": {
        height: 13,
        path: "M9.5 8.75C9.5 8.35156 9.82812 8 10.25 8C10.6484 8 11 8.35156 11 8.75V10.25C11 11.5156 9.99219 12.5 8.75 12.5H2.75C1.48438 12.5 0.5 11.5156 0.5 10.25V8.75C0.5 8.35156 0.828125 8 1.25 8C1.64844 8 2 8.35156 2 8.75V10.25C2 10.6719 2.32812 11 2.75 11H8.75C9.14844 11 9.5 10.6719 9.5 10.25V8.75ZM5.21094 0.734375C5.49219 0.429688 5.98438 0.429688 6.26562 0.734375L9.26562 3.73438C9.57031 4.01562 9.57031 4.50781 9.26562 4.78906C8.98438 5.09375 8.49219 5.09375 8.21094 4.78906L6.5 3.07812V8C6.5 8.42188 6.14844 8.75 5.75 8.75C5.32812 8.75 5 8.42188 5 8V3.07812L3.26562 4.78906C2.98438 5.09375 2.49219 5.09375 2.21094 4.78906C1.90625 4.50781 1.90625 4.01562 2.21094 3.73438L5.21094 0.734375Z",
        viewBox: "0 0 11 13",
        width: 11
      },
      csv: {
        height: 21,
        path: "M48 448L48 64c0-8.8 7.2-16 16-16l160 0 0 80c0 17.7 14.3 32 32 32l80 0 0 288c0 8.8-7.2 16-16 16L64 464c-8.8 0-16-7.2-16-16zM64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-293.5c0-17-6.7-33.3-18.7-45.3L274.7 18.7C262.7 6.7 246.5 0 229.5 0L64 0zM176 256l0 48-64 0 0-48 64 0zm-64 80l64 0 0 48-64 0 0-48zm96 0l64 0 0 48-64 0 0-48zm-16 80l16 0 64 0c17.7 0 32-14.3 32-32l0-48 0-16 0-16 0-48c0-17.7-14.3-32-32-32l-64 0-16 0-16 0-64 0c-17.7 0-32 14.3-32 32l0 48 0 16 0 16 0 48c0 17.7 14.3 32 32 32l64 0 16 0zm16-112l0-48 64 0 0 48-64 0z",
        viewBox: "0 0 384 512",
        width: 16
      },
      doc: {
        height: 24,
        path: "M18.7578 7.42187C19.2266 7.89062 19.5 8.51562 19.5 9.17969V20C19.5 21.4062 18.3672 22.5 17 22.5H7C5.59375 22.5 4.5 21.4062 4.5 20L4.5 5C4.5 3.63281 5.59375 2.5 7 2.5L12.8203 2.5C13.4844 2.5 14.1094 2.77344 14.5781 3.24219L18.7578 7.42187ZM13.25 3.86719V8.125C13.25 8.47656 13.5234 8.75 13.875 8.75H18.1328C18.0938 8.59375 18.0156 8.4375 17.8594 8.28125L13.7188 4.14062C13.5625 3.98437 13.4062 3.90625 13.25 3.86719ZM18.25 20V10H13.875C12.8203 10 12 9.17969 12 8.125V3.75L7 3.75C6.29688 3.75 5.75 4.33594 5.75 5L5.75 20C5.75 20.7031 6.29688 21.25 7 21.25H17C17.6641 21.25 18.25 20.7031 18.25 20ZM8.25 13.125C8.25 12.8125 8.52344 12.5 8.875 12.5H15.125C15.4375 12.5 15.75 12.8125 15.75 13.125C15.75 13.4766 15.4375 13.75 15.125 13.75H8.875C8.52344 13.75 8.25 13.4766 8.25 13.125ZM15.125 15C15.4375 15 15.75 15.3125 15.75 15.625C15.75 15.9766 15.4375 16.25 15.125 16.25H8.875C8.52344 16.25 8.25 15.9766 8.25 15.625C8.25 15.3125 8.52344 15 8.875 15H15.125ZM15.125 17.5C15.4375 17.5 15.75 17.8125 15.75 18.125C15.75 18.4766 15.4375 18.75 15.125 18.75H8.875C8.52344 18.75 8.25 18.4766 8.25 18.125C8.25 17.8125 8.52344 17.5 8.875 17.5H15.125Z",
        viewBox: "0 0 24 24",
        width: 24
      },
      error: {
        height: 21,
        path: "M10 0.5C15.5078 0.5 20 4.99219 20 10.5C20 16.0469 15.5078 20.5 10 20.5C4.45313 20.5 0 16.0469 0 10.5C0 4.99219 4.45312 0.5 10 0.5ZM10 19.25C14.8047 19.25 18.75 15.3438 18.75 10.5C18.75 5.69531 14.8047 1.75 10 1.75C5.15625 1.75 1.25 5.69531 1.25 10.5C1.25 15.3438 5.15625 19.25 10 19.25ZM10 12.375C9.64844 12.375 9.375 12.1016 9.375 11.75V5.5C9.375 5.1875 9.64844 4.875 10 4.875C10.3125 4.875 10.625 5.1875 10.625 5.5V11.75C10.625 12.1016 10.3125 12.375 10 12.375ZM10 13.9375C10.5078 13.9375 10.9375 14.3672 10.9375 14.875C10.9375 15.4219 10.5078 15.8125 10 15.8125C9.45312 15.8125 9.0625 15.4219 9.0625 14.875C9.0625 14.3672 9.45312 13.9375 10 13.9375Z",
        viewBox: "0 0 20 21",
        width: 20
      },
      generic: {
        height: 21,
        path: "M0.5 3C0.5 1.63281 1.59375 0.5 3 0.5L9.09375 0.5C9.5625 0.5 10.0703 0.734375 10.4219 1.08594L14.9141 5.57812C15.2656 5.92969 15.5 6.4375 15.5 6.90625V18C15.5 19.4062 14.3672 20.5 13 20.5H3C1.59375 20.5 0.5 19.4062 0.5 18L0.5 3ZM14.25 8H9.875C8.82031 8 8 7.17969 8 6.125V1.75L3 1.75C2.29688 1.75 1.75 2.33594 1.75 3L1.75 18C1.75 18.7031 2.29688 19.25 3 19.25H13C13.6641 19.25 14.25 18.7031 14.25 18V8ZM14.0547 6.47656L9.52344 1.94531C9.44531 1.86719 9.32812 1.82812 9.25 1.78906V6.125C9.25 6.47656 9.52344 6.75 9.875 6.75H14.2109C14.1719 6.67188 14.1328 6.55469 14.0547 6.47656Z",
        viewBox: "0 0 16 21",
        width: 16
      },
      pdf: {
        height: 21,
        path: "M15.5 18C15.5 19.4062 14.3672 20.5 13 20.5H3C1.59375 20.5 0.5 19.4062 0.5 18H1.75C1.75 18.7031 2.29688 19.25 3 19.25H13C13.6641 19.25 14.25 18.7031 14.25 18H15.5ZM9.875 8C8.82031 8 8 7.17969 8 6.125V1.75L3 1.75C2.29688 1.75 1.75 2.33594 1.75 3V9.25H0.5V3C0.5 1.63281 1.59375 0.5 3 0.5L9.09375 0.5C9.5625 0.5 10.0703 0.734375 10.4219 1.08594L14.9141 5.57812C15.2656 5.92969 15.5 6.4375 15.5 6.90625V9.25H14.25V8H9.875ZM14.0547 6.47656L9.52344 1.94531C9.44531 1.86719 9.32812 1.82812 9.25 1.78906V6.125C9.25 6.47656 9.52344 6.75 9.875 6.75H14.2109C14.1719 6.67188 14.1328 6.55469 14.0547 6.47656ZM3.9375 10.5C5.10938 10.5 6.125 11.5156 6.125 12.6875C6.125 13.8984 5.10938 14.875 3.9375 14.875H3.625V16.125C3.625 16.4766 3.3125 16.75 3 16.75C2.64844 16.75 2.375 16.4766 2.375 16.125L2.375 11.125C2.375 10.8125 2.64844 10.5 3 10.5H3.9375ZM4.875 12.6875C4.875 12.1797 4.44531 11.75 3.9375 11.75H3.625V13.625H3.9375C4.44531 13.625 4.875 13.2344 4.875 12.6875ZM6.75 11.125C6.75 10.8125 7.02344 10.5 7.375 10.5H8.3125C9.32812 10.5 10.1875 11.3594 10.1875 12.375V14.875C10.1875 15.9297 9.32812 16.75 8.3125 16.75H7.375C7.02344 16.75 6.75 16.4766 6.75 16.125V11.125ZM8 15.5H8.3125C8.625 15.5 8.9375 15.2266 8.9375 14.875V12.375C8.9375 12.0625 8.625 11.75 8.3125 11.75H8V15.5ZM13.625 10.5C13.9375 10.5 14.25 10.8125 14.25 11.125C14.25 11.4766 13.9375 11.75 13.625 11.75H12.375V13H13.625C13.9375 13 14.25 13.3125 14.25 13.625C14.25 13.9766 13.9375 14.25 13.625 14.25H12.375V16.125C12.375 16.4766 12.0625 16.75 11.75 16.75C11.3984 16.75 11.125 16.4766 11.125 16.125V11.125C11.125 10.8125 11.3984 10.5 11.75 10.5H13.625Z",
        viewBox: "0 0 16 21",
        width: 16
      },
      "trash-can": {
        height: 12,
        path: "M3.91406 0.921875C4.03125 0.664062 4.28906 0.5 4.57031 0.5H7.40625C7.6875 0.5 7.94531 0.664062 8.0625 0.921875L8.25 1.25H10.5C10.8984 1.25 11.25 1.60156 11.25 2C11.25 2.42188 10.8984 2.75 10.5 2.75H1.5C1.07812 2.75 0.75 2.42188 0.75 2C0.75 1.60156 1.07812 1.25 1.5 1.25H3.75L3.91406 0.921875ZM1.47656 3.5H10.5V11C10.5 11.8438 9.82031 12.5 9 12.5H2.97656C2.15625 12.5 1.47656 11.8438 1.47656 11V3.5ZM3.35156 5.375V10.625C3.35156 10.8359 3.53906 11 3.72656 11C3.9375 11 4.10156 10.8359 4.10156 10.625V5.375C4.10156 5.1875 3.9375 5 3.72656 5C3.53906 5 3.35156 5.1875 3.35156 5.375ZM5.60156 5.375V10.625C5.60156 10.8359 5.78906 11 5.97656 11C6.1875 11 6.375 10.8359 6.375 10.625V5.375C6.375 5.1875 6.1875 5 5.97656 5C5.78906 5 5.60156 5.1875 5.60156 5.375ZM7.875 5.375V10.625C7.875 10.8359 8.03906 11 8.25 11C8.4375 11 8.625 10.8359 8.625 10.625V5.375C8.625 5.1875 8.4375 5 8.25 5C8.03906 5 7.875 5.1875 7.875 5.375Z",
        viewBox: "0 0 12 13",
        width: 13
      }
    }), f = E([]), y = E(0), m = M(() => !!f.value.filter(($) => !!$.invalidFilesSize).length), g = (b) => {
      if (!i.value) return;
      const $ = new DataTransfer();
      h.value = h.value.filter((F) => !(F.name === b.name && F.lastModified === b.lastModified && F.size === b.size && F.type === b.type)), h.value.forEach((F) => {
        $.items.add(F);
      }), i.value.files = $.files;
      const p = x(b);
      y.value = y.value - p <= 0 ? 0 : y.value - p, o("remove", { files: h.value, invalidFiles: f.value }), l.value = [...h.value, ...f.value], o("total-files-size", y.value);
    }, v = (b) => {
      f.value = f.value.filter((p) => !(p.name === b.name && p.lastModified === b.lastModified && p.size === b.size && p.type === b.type));
      const $ = x(b);
      y.value = y.value - $ <= 0 ? 0 : y.value - $, o("remove-invalid", { files: h.value, invalidFiles: f.value }), l.value = [...h.value, ...f.value], o("total-files-size", y.value);
    }, C = (b) => h.value.find(($) => $.name === b.name && $.lastModified === b.lastModified && $.size === b.size && $.type === b.type), k = (b) => {
      if (!b.target) return;
      const $ = b.target.files;
      Array.from($).forEach((p) => {
        C(p) || w(p);
      }), o("add", { files: h.value, invalidFiles: f.value }), l.value = [...h.value, ...f.value], o("total-files-size", y.value);
    }, w = (b) => {
      if (!i.value) return;
      const $ = new DataTransfer(), p = x(b), F = b.type, R = n.allowedFiletypes.length > 0 && n.allowedFiletypes.includes(F) || n.allowedFiletypes.length < 1, T = !!(!n.maxFilesSize || n.maxFilesSize && y.value + p <= n.maxFilesSize);
      n.multiple && h.value.forEach((j) => {
        $.items.add(j);
      }), p <= n.filesize && R && T ? ($.items.add(b), i.value.files = $.files, h.value = Array.from(i.value.files) || [], y.value += p, n.multiple || (f.value = [])) : p > n.filesize || !T ? (p > n.filesize && (b.invalidSize = !0), T || (b.invalidFilesSize = !0), n.multiple ? (f.value.push(b), f.value = f.value.filter(
        (j, X, pe) => X === pe.findIndex((H) => H.name === j.name && H.lastModified === j.lastModified && H.size === j.size && H.type === j.type)
      ), y.value += p) : (h.value = [], i.value.files = $.files, f.value = [b], y.value += p)) : R || (n.multiple ? (b.invalidType = !0, f.value.push(b), f.value = f.value.filter(
        (j, X, pe) => X === pe.findIndex((H) => H.name === j.name && H.lastModified === j.lastModified && H.size === j.size && H.type === j.type)
      ), y.value += p) : (h.value = [], i.value.files = $.files, b.invalidType = !0, f.value = [b], y.value += p));
    }, x = (b) => parseFloat((b.size / 1024 / 1024).toFixed(4)), I = (b) => {
      const $ = ["b", "kb", "mb", "gb", "tb"];
      if (b <= 0 || b > 999999999999999)
        return "n/a";
      const p = parseInt(`${Math.floor(Math.log(b) / Math.log(1024))}`, 10);
      return p === 0 ? `${b}${$[p]}` : `${Math.ceil(b / 1024 ** p)} ${$[p]}`;
    }, L = (b) => {
      switch (b) {
        case "application/msword":
        case "application/vnd.openxmlformats-officedocument.wordprocessingml.document":
        case "text/plain":
          return "doc";
        case "application/pdf":
          return "pdf";
        case "text/csv":
        case "application/vnd.ms-excel":
        case "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet":
          return "csv";
        default:
          return "generic";
      }
    }, z = (b, $) => {
      if (b && "type" in b && $.includes(b.type))
        return b.type.split("/")[0] === "image" ? URL.createObjectURL(b) : void 0;
    };
    return ye(l, (b) => {
      if (!i.value) return;
      const $ = new DataTransfer();
      b.forEach((p) => $.items.add(p)), i.value.files = $.files, h.value = [], f.value = [], Array.from($.files).forEach((p) => {
        w(p);
      });
    }, { immediate: !0, deep: !0 }), (b, $) => (s(), u("div", df, [
      d("div", uf, [
        d("input", {
          id: r(t),
          ref_key: "fileInput",
          ref: i,
          type: "file",
          name: e.name,
          accept: e.accept,
          multiple: e.multiple || void 0,
          required: e.required || void 0,
          disabled: r(m) || void 0,
          class: D(["absolute inset-0 opacity-0 cursor-pointer", { "pointer-events-none": r(m) }]),
          onChange: k
        }, null, 42, cf),
        d("div", {
          class: D(["flex flex-col items-center space-y-1 rounded-theme-sm p-4 bg-gray-25 dark:bg-gray-900 group-hover:bg-gray-50 dark:group-hover:bg-gray-800", [r(m) ? "bg-transparent group-hover:bg-transparent" : ""]])
        }, [
          d("label", {
            for: r(i)?.id ?? void 0,
            class: D(["action-btn action-btn-ghost action-btn-blue action-btn-sm cursor-pointer font-semibold z-10", { disabled: r(m) }])
          }, [
            Q(r(We), {
              "aria-hidden": "true",
              class: "my-auto",
              preserveAspectRatio: "xMidYMid meet",
              role: "img",
              height: r(c)["arrow-up-from-bracket"].height,
              path: r(c)["arrow-up-from-bracket"].path,
              "view-box": r(c)["arrow-up-from-bracket"].viewBox,
              width: r(c)["arrow-up-from-bracket"].width
            }, null, 8, ["height", "path", "view-box", "width"]),
            re(A(e.multiple ? "Upload files" : "Upload file"), 1)
          ], 10, ff),
          d("p", {
            class: D(["text-xs text-center font-semibold text-gray-900 dark:text-white leading-4", { "opacity-50": r(m) }])
          }, A(e.multiple ? "Click to upload or drag and drop files here" : "Click to upload or drag and drop a file here"), 3),
          d("p", {
            class: D(["text-xs text-center text-gray-600 dark:text-gray-400 leading-4", { "opacity-50": r(m) }])
          }, A(e.helperText ? e.helperText : `Accepts .pdf, .json, .jpg, .jpeg, .png, .doc, .docx, .xls, .xlsx or .csv files under ${e.filesize} MB.`), 3)
        ], 2)
      ]),
      P(b.$slots, "default", {
        files: r(h),
        invalidFiles: r(f),
        removeFile: g,
        removeInvalidFile: v,
        byteToSize: I
      }, () => [
        r(h).length > 0 || r(f).length > 0 ? (s(), u("ul", hf, [
          (s(!0), u(J, null, le(r(h), (p) => (s(), u("li", {
            key: p.name + p.size + p.type + p.lastModified
          }, [
            d("div", mf, [
              z(p, e.allowedFiletypes) ? (s(), u("div", gf, [
                d("img", {
                  class: "w-10 h-10 my-auto object-cover",
                  height: "auto",
                  width: "auto",
                  alt: p.name,
                  src: z(p, e.allowedFiletypes)
                }, null, 8, vf)
              ])) : (s(), u("div", yf, [
                Q(r(We), {
                  "aria-hidden": "true",
                  class: "text-gray-600 dark:text-gray-400",
                  fill: "none",
                  preserveAspectRatio: "xMidYMid meet",
                  role: "img",
                  height: r(c)[L(p.type)].height,
                  path: r(c)[L(p.type)].path,
                  "view-box": r(c)[L(p.type)].viewBox,
                  width: r(c)[L(p.type)].width
                }, null, 8, ["height", "path", "view-box", "width"])
              ])),
              d("div", bf, [
                d("span", pf, A(p.name), 1)
              ]),
              P(b.$slots, "file", { type: p }),
              Q(r(je), {
                kind: "ghost",
                variant: "red",
                size: "md",
                class: "z-10 ml-auto",
                onClick: (F) => g(p)
              }, {
                default: U(() => [
                  Q(r(We), {
                    "aria-hidden": "true",
                    fill: "none",
                    preserveAspectRatio: "xMidYMid meet",
                    role: "img",
                    height: r(c)["trash-can"].height,
                    path: r(c)["trash-can"].path,
                    "view-box": r(c)["trash-can"].viewBox,
                    width: r(c)["trash-can"].width
                  }, null, 8, ["height", "path", "view-box", "width"]),
                  $[0] || ($[0] = d("span", { class: "sr-only" }, "Remove file", -1))
                ]),
                _: 1
              }, 8, ["onClick"])
            ])
          ]))), 128)),
          (s(!0), u(J, null, le(r(f), (p) => (s(), u("li", {
            key: p.name + p.size + p.type + p.lastModified
          }, [
            d("div", wf, [
              d("div", xf, [
                Q(r(We), {
                  "aria-hidden": "true",
                  class: "text-red-600 dark:text-red-300",
                  fill: "none",
                  preserveAspectRatio: "xMidYMid meet",
                  role: "img",
                  height: r(c).error.height,
                  path: r(c).error.path,
                  "view-box": r(c).error.viewBox,
                  width: r(c).error.width
                }, null, 8, ["height", "path", "view-box", "width"])
              ]),
              d("div", kf, [
                d("div", Cf, [
                  d("div", $f, [
                    d("span", Mf, A(p.name), 1)
                  ])
                ]),
                d("span", Sf, [
                  p.invalidType || p.invalidType && p.invalidSize || p.invalidType && p.invalidFilesSize || p.invalidType && p.invalidFilesSize && p.invalidSize ? (s(), u(J, { key: 0 }, [
                    re(" Invalid file type ")
                  ], 64)) : p.invalidFilesSize || p.invalidFilesSize && p.invalidSize ? (s(), u(J, { key: 1 }, [
                    re(A(`Total file size exceeds the ${e.maxFilesSize} MB limit. Reduce files.`), 1)
                  ], 64)) : p.invalidSize ? (s(), u(J, { key: 2 }, [
                    re(A(`File size exceeds the ${e.filesize} MB limit.`), 1)
                  ], 64)) : S("", !0)
                ])
              ]),
              P(b.$slots, "invalidFile", { type: p }),
              Q(r(je), {
                kind: "ghost",
                variant: "red",
                size: "md",
                class: "z-10 ml-auto",
                onClick: (F) => v(p)
              }, {
                default: U(() => [
                  Q(r(We), {
                    "aria-hidden": "true",
                    fill: "none",
                    preserveAspectRatio: "xMidYMid meet",
                    role: "img",
                    height: r(c)["trash-can"].height,
                    path: r(c)["trash-can"].path,
                    "view-box": r(c)["trash-can"].viewBox,
                    width: r(c)["trash-can"].width
                  }, null, 8, ["height", "path", "view-box", "width"]),
                  $[1] || ($[1] = d("span", { class: "sr-only" }, "Remove file", -1))
                ]),
                _: 1
              }, 8, ["onClick"])
            ])
          ]))), 128))
        ])) : S("", !0)
      ])
    ]));
  }
});
hn.install = (e) => {
  e.component(hn.name, hn);
};
Aa.install = (e) => {
  e.component(Aa.name, Aa);
};
const Df = {
  viewBox: "0 0 640 640",
  "aria-hidden": "true",
  role: "img",
  width: "1.2em",
  height: "1.2em"
};
function zf(e, a) {
  return s(), u("svg", Df, [...a[0] || (a[0] = [
    d("path", {
      fill: "currentColor",
      d: "M525.2 82.9C536.7 88 544 99.4 544 112v416c0 12.6-7.3 24-18.8 29.1s-24.8 3.2-34.3-5.1l-46.6-40.7c-43.6-38.1-98.7-60.3-156.4-63V544c0 17.7-14.3 32-32 32h-32c-17.7 0-32-14.3-32-32v-96C121.3 448 64 390.7 64 320s57.3-128 128-128h84.5c61.8-.2 121.4-22.7 167.9-63.3L491 88c9.4-8.3 22.9-10.2 34.3-5.1zM288 384v.2c70.3 2.7 137.8 28.5 192 73.4V182.3c-54.2 44.9-121.7 70.7-192 73.4z"
    }, null, -1)
  ])]);
}
const Tf = $e({ name: "fa7-solid-bullhorn", render: zf }), Bf = { class: "p-4 flex h-screen w-screen" }, Lf = { class: "ml-auto mt-auto relative" }, If = ["id", "aria-expanded"], Vf = { class: "block w-6 h-6" }, Af = { class: "sr-only" }, Hf = ["aria-labelledby"], Of = { class: "grow uppercase font-bold text-lg" }, Pf = { class: "grow mx-6 mt-4 mb-2 overflow-auto text-black dark:text-white" }, Ff = {
  key: 0,
  class: "border-t border-gray-100 dark:border-gray-700 px-6"
}, Ef = { class: "grid grid-flow-col auto-cols-fr" }, Rf = ["onClick"], Nf = {
  key: 0,
  class: "h-4 w-4 mx-auto"
}, Wf = ["src", "alt"], qf = { class: "mx-auto" }, mn = /* @__PURE__ */ te({
  name: "SdsFloatingActionButton",
  __name: "FloatingActionButton",
  props: /* @__PURE__ */ xe({
    variant: { default: "blue" },
    showIndicator: { type: Boolean, default: !1 },
    indicatorVariant: { default: "blue" }
  }, {
    modelValue: {
      type: Array,
      required: !0
    },
    modelModifiers: {}
  }),
  emits: /* @__PURE__ */ xe(["update:modelValue", "open", "close"], ["update:modelValue"]),
  setup(e, { emit: a }) {
    const t = tt(), n = e, l = Te(e, "modelValue"), o = a, i = M(() => n.variant), h = M({
      get() {
        return l.value;
      },
      set(w) {
        o("update:modelValue", w);
      }
    }), c = M(() => h.value.find((w) => w.active) || { key: 0, title: "", tabName: "" }), f = E(), y = E(), m = E(), g = E(!1);
    ye(g, (w) => {
      o(w ? "open" : "close");
    }), Il(y, () => {
      g.value && (g.value = !1);
    }, { ignore: [m] });
    const v = () => {
      g.value = !1;
    }, { trapFocus: C } = Ll(f, {
      enabled: g,
      handleEscape: !0,
      onEscape: v
    }), k = (w) => {
      h.value.map((x) => x.active = w.key === x.key);
    };
    return (w, x) => {
      const I = Ua, L = Tf;
      return s(), G(Ut, null, {
        default: U(() => [
          (s(), G(Jn, { to: "body" }, [
            d("div", {
              ref_key: "container",
              ref: f,
              "data-id": "sds-floating-action-button",
              class: "hidden sm:block fixed inset-0 h-screen w-screen pointer-events-none z-50",
              onKeydown: x[2] || (x[2] = //@ts-ignore
              (...z) => r(C) && r(C)(...z))
            }, [
              d("div", Bf, [
                d("div", Lf, [
                  Q(aa, {
                    "hide-indicator": !e.showIndicator,
                    variant: e.indicatorVariant
                  }, {
                    default: U(() => [
                      d("button", {
                        id: r(t),
                        ref_key: "button",
                        ref: m,
                        type: "button",
                        class: D(["ml-auto mt-auto btn btn-primary rounded-theme-lg p-4 pointer-events-auto", {
                          "btn-blue": r(i) === "blue",
                          "btn-red": r(i) === "red"
                        }]),
                        "aria-haspopup": "true",
                        "aria-expanded": r(g),
                        onClick: x[0] || (x[0] = (z) => g.value = !r(g))
                      }, [
                        d("span", Vf, [
                          r(g) ? (s(), G(I, {
                            key: 0,
                            class: "inline-block h-6 w-6"
                          })) : S("", !0),
                          r(g) ? S("", !0) : P(w.$slots, "trigger-icon", { key: 1 }, () => [
                            Q(L, { class: "inline-block h-6 w-6" })
                          ])
                        ]),
                        d("span", Af, A(r(g) ? "close" : "open"), 1)
                      ], 10, If)
                    ]),
                    _: 3
                  }, 8, ["hide-indicator", "variant"]),
                  Q(Qe, {
                    "enter-active-class": "transition duration-75 ease-out",
                    "enter-from-class": "transform scale-95 opacity-0",
                    "enter-to-class": "transform scale-100 opacity-100",
                    "leave-active-class": "transition duration-50 ease-in",
                    "leave-from-class": "transform scale-100 opacity-100",
                    "leave-to-class": "transform scale-95 opacity-0"
                  }, {
                    default: U(() => [
                      r(g) ? (s(), u("div", {
                        key: 0,
                        ref_key: "modal",
                        ref: y,
                        class: "absolute flex flex-col bottom-20 right-0 pointer-events-auto border border-gray-100 dark:border-gray-700 rounded-theme-lg h-144 max-w-lg w-[calc(100vw-2rem)] sm:w-lg bg-white dark:bg-gray-950 shadow-lg",
                        "aria-orientation": "vertical",
                        "aria-labelledby": r(m) && r(m).id || void 0,
                        role: "dialog"
                      }, [
                        d("div", {
                          class: D(["p-6 rounded-t-theme-lg flex gap-4", {
                            "text-white bg-blue-600 dark:text-gray-950 dark:bg-blue-400": r(i) === "blue",
                            "text-white bg-red-600 dark:text-gray-950 dark:bg-red-400": r(i) === "red"
                          }])
                        }, [
                          d("h2", Of, A(r(c).title), 1),
                          Q(je, {
                            kind: "ghost",
                            size: "sm",
                            variant: "white",
                            onClick: x[1] || (x[1] = (z) => g.value = !1)
                          }, {
                            default: U(() => [
                              Q(I, { class: "inline-block h-5 w-5" }),
                              x[3] || (x[3] = d("span", { class: "sr-only" }, "Close", -1))
                            ]),
                            _: 1
                          })
                        ], 2),
                        d("div", Pf, [
                          r(c) ? P(w.$slots, `tab(${r(c).key})`, {
                            key: 0,
                            tab: r(c)
                          }) : S("", !0)
                        ]),
                        r(h).length > 1 ? (s(), u("div", Ff, [
                          d("nav", Ef, [
                            (s(!0), u(J, null, le(r(h), (z) => (s(), u("button", {
                              key: z.key,
                              class: D([{
                                "border-t-blue-600 hover:border-t-blue-600 text-blue-600 bg-white dark:border-t-blue-400 dark:hover:border-t-blue-400 dark:text-blue-400 dark:bg-gray-950": z.active && r(i) === "blue",
                                "border-t-red-600 hover:border-t-red-600 text-red-600 bg-white dark:border-t-red-400 dark:hover:border-t-red-400 dark:text-red-400 dark:bg-gray-950": z.active && r(i) === "red",
                                "border-t-transparent hover:border-t-gray-100 text-gray-600 bg-white hover:text-black dark:hover:border-t-gray-600 dark:text-gray-400 dark:bg-gray-950 dark:hover:text-white": !z.active
                              }, "flex flex-col gap-2 p-6 pt-4 text-sm font-bold border-t-4 transition-colors duration-200"]),
                              onClick: (b) => k(z)
                            }, [
                              w.$slots[`tab-icon(${z.key})`] || z.iconSrc ? (s(), u("div", Nf, [
                                P(w.$slots, `tab-icon(${z.key})`, {}, () => [
                                  d("img", {
                                    src: z.iconSrc,
                                    alt: z.tabName,
                                    class: "h-4 w-4",
                                    width: "16",
                                    height: "16"
                                  }, null, 8, Wf)
                                ])
                              ])) : S("", !0),
                              d("span", qf, A(z.tabName), 1)
                            ], 10, Rf))), 128))
                          ])
                        ])) : S("", !0)
                      ], 8, Hf)) : S("", !0)
                    ]),
                    _: 3
                  })
                ])
              ])
            ], 544)
          ]))
        ]),
        _: 3
      });
    };
  }
});
mn.install = (e) => {
  e.component(mn.name, mn);
};
St.install = (e) => {
  e.component(St.name, St);
};
const Yf = {
  key: 0,
  class: "sr-only"
}, jf = { class: "grow" }, Gf = { key: 0 }, Uf = ["aria-hidden"], gn = /* @__PURE__ */ te({
  name: "SdsFormGroup",
  __name: "FormGroup",
  props: {
    el: { default: "div" },
    showMarker: { type: Boolean, default: !1 },
    label: { default: null },
    labelFor: { default: null },
    labelAlignment: { default: "left" },
    labelWidth: { default: "auto" },
    labelMargin: { default: null },
    labelPosition: { default: "top" },
    helperText: { default: null },
    validFeedback: { default: null },
    invalidFeedback: { default: null },
    state: { type: [Boolean, null], default: null },
    required: { type: Boolean, default: !1 },
    readonly: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 }
  },
  setup(e) {
    const a = e, t = E(), n = M(() => a.labelFor || tt());
    return (l, o) => (s(), G(mt(e.el), {
      id: r(n),
      ref_key: "root",
      ref: t,
      disabled: e.el === "fieldset" ? e.disabled : void 0,
      "data-id": "sds-form-group",
      class: D(["flex", {
        "flex-col gap-2": e.labelPosition === "top",
        "gap-4": e.labelPosition === "left"
      }])
    }, {
      default: U(() => [
        e.el === "fieldset" ? (s(), u("legend", Yf, [
          d("span", null, A(e.label), 1),
          e.required ? (s(), u("span", {
            key: 0,
            class: D({
              "sr-only": !e.showMarker
            })
          }, "* required", 2)) : S("", !0),
          e.required ? S("", !0) : (s(), u("span", {
            key: 1,
            class: D({
              "sr-only": !e.showMarker
            })
          }, "(optional)", 2))
        ])) : S("", !0),
        (s(), G(mt(e.el === "div" ? "label" : "span"), {
          for: e.el === "div" ? r(n) : void 0,
          "aria-hidden": e.el === "fieldset" ? !0 : void 0,
          class: D(["flex font-semibold text-gray-900 dark:text-gray-50", {
            "opacity-50 pointer-events-none select-none": e.disabled,
            "gap-1 items-center": e.labelPosition === "top",
            "place-content-start": e.labelAlignment === "left" && e.labelPosition === "top",
            "place-content-center": e.labelAlignment === "center" && e.labelPosition === "top",
            "place-content-end": e.labelAlignment === "right" && e.labelPosition === "top",
            "flex-col place-content-start": e.labelPosition === "left",
            "text-left": e.labelAlignment === "left" && e.labelPosition === "left",
            "text-center": e.labelAlignment === "center" && e.labelPosition === "left",
            "text-right": e.labelAlignment === "right" && e.labelPosition === "left",
            "mt-0": e.labelMargin === 0,
            "mt-0.5": e.labelMargin === 0.5,
            "mt-1": e.labelMargin === 1,
            "mt-1.5": e.labelMargin === 1.5,
            "mt-2": e.labelMargin === 2,
            "mt-2.5": e.labelMargin === 2.5,
            "mt-3": e.labelMargin === 3,
            "mt-3.5": e.labelMargin === 3.5,
            "mt-4": e.labelMargin === 4,
            "my-4": e.labelMargin === "auto",
            "w-1/12": e.labelWidth === 1,
            "w-2/12": e.labelWidth === 2,
            "w-3/12": e.labelWidth === 3,
            "w-4/12": e.labelWidth === 4,
            "w-5/12": e.labelWidth === 5,
            "w-6/12": e.labelWidth === 6,
            "w-7/12": e.labelWidth === 7,
            "w-8/12": e.labelWidth === 8,
            "w-9/12": e.labelWidth === 9,
            "w-10/12": e.labelWidth === 10,
            "w-11/12": e.labelWidth === 11,
            "w-auto": e.labelWidth === "auto"
          }])
        }, {
          default: U(() => [
            P(l.$slots, "label", { label: e.label }, () => [
              d("span", null, A(e.label), 1)
            ]),
            e.required ? (s(), u("span", {
              key: 0,
              class: D([{
                "sr-only": !e.showMarker
              }, "font-normal text-red-500 dark:text-red-300 text-xs"])
            }, "* required", 2)) : S("", !0),
            e.required ? S("", !0) : (s(), u("span", {
              key: 1,
              class: D([{
                "sr-only": !e.showMarker
              }, "font-normal italic text-gray-600 dark:text-gray-400 text-xs"])
            }, "(optional)", 2))
          ]),
          _: 3
        }, 8, ["for", "aria-hidden", "class"])),
        d("div", jf, [
          l.$slots.default ? (s(), u("div", Gf, [
            P(l.$slots, "default", {
              id: r(n),
              valid: e.state === !0,
              invalid: e.state === !1,
              disabled: e.disabled,
              required: e.required,
              readonly: e.readonly
            })
          ])) : S("", !0),
          (e.helperText || l.$slots.helperText) && !e.disabled ? (s(), u("p", {
            key: 1,
            "aria-hidden": e.disabled ? !0 : void 0,
            class: "block text-sm italic text-gray-600 dark:text-gray-400 pt-2"
          }, [
            P(l.$slots, "helperText", { helperText: e.helperText }, () => [
              d("span", null, A(e.helperText), 1)
            ])
          ], 8, Uf)) : S("", !0),
          e.state && (e.validFeedback || l.$slots.validFeedback) && !e.disabled ? (s(), u("p", {
            key: 2,
            class: D(["block text-sm italic text-green-700 dark:text-green-300", {
              "pt-1": e.helperText || l.$slots.helperText,
              "pt-2": !(e.helperText || l.$slots.helperText)
            }])
          }, [
            P(l.$slots, "validFeedback", { validFeedback: e.validFeedback }, () => [
              d("span", null, A(e.validFeedback), 1)
            ])
          ], 2)) : S("", !0),
          e.state === !1 && (e.invalidFeedback || l.$slots.invalidFeedback) && !e.disabled ? (s(), u("p", {
            key: 3,
            class: D(["block text-sm italic text-red-500 dark:text-red-300", {
              "pt-1": e.helperText || l.$slots.helperText,
              "pt-2": !(e.helperText || l.$slots.helperText)
            }])
          }, [
            P(l.$slots, "invalidFeedback", { invalidFeedback: e.invalidFeedback }, () => [
              d("span", null, A(e.invalidFeedback), 1)
            ])
          ], 2)) : S("", !0)
        ])
      ]),
      _: 3
    }, 8, ["id", "disabled", "class"]));
  }
});
gn.install = (e) => {
  e.component(gn.name, gn);
};
aa.install = (e) => {
  e.component(aa.name, aa);
};
const mo = /* @__PURE__ */ te({
  name: "SdsCharacterCounter",
  __name: "CharacterCounter",
  props: {
    currentValue: { default: 0 },
    minValue: { default: 0 },
    maxValue: { default: 0 }
  },
  setup(e) {
    const a = e, t = M(() => a.maxValue - a.currentValue);
    return (n, l) => (s(), u("div", {
      "data-id": "sds-character-counter",
      class: D({ "text-red-700 dark:text-red-300": r(t) < 0 || e.currentValue < e.minValue && e.currentValue > 0 })
    }, A(r(t).toLocaleString()), 3));
  }
}), Kf = {
  "data-id": "sds-input",
  class: "w-full relative"
}, Zf = ["id", "type", "maxlength", "placeholder", "autofocus", "disabled", "readonly", "required", "pattern"], vn = /* @__PURE__ */ te({
  name: "SdsInput",
  __name: "Input",
  props: /* @__PURE__ */ xe({
    countCharacters: { type: Boolean, default: !1 },
    maxlength: { default: 524288 },
    id: { default: void 0 },
    placeholder: { default: "" },
    type: { default: "text" },
    size: { default: "" },
    autofocus: { type: Boolean, default: !1 },
    pattern: { default: "" },
    disabled: { type: Boolean, default: !1 },
    readonly: { type: Boolean, default: !1 },
    required: { type: Boolean, default: !1 },
    valid: { type: Boolean, default: !1 },
    invalid: { type: Boolean, default: !1 }
  }, {
    modelValue: { type: String, default: "" },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(e) {
    const a = e, t = Te(e, "modelValue"), { validationClasses: n } = Xt(a);
    return (l, o) => (s(), u("div", Kf, [
      Ze(d("input", {
        id: e.id || void 0,
        "onUpdate:modelValue": o[0] || (o[0] = (i) => t.value = i),
        class: D(["form-control", {
          ...r(n),
          "form-control-sm": e.size === "sm"
        }]),
        type: e.type,
        maxlength: e.maxlength !== void 0 ? e.maxlength : void 0,
        placeholder: e.placeholder || void 0,
        autofocus: e.autofocus || void 0,
        disabled: e.disabled || void 0,
        readonly: e.readonly || void 0,
        required: e.required || void 0,
        pattern: e.pattern || void 0
      }, null, 10, Zf), [
        [Do, t.value]
      ]),
      e.countCharacters ? (s(), G(mo, {
        key: 0,
        class: "absolute right-0 text-gray-600 dark:text-gray-400",
        "current-value": t.value.length,
        "max-value": e.maxlength
      }, null, 8, ["current-value", "max-value"])) : S("", !0)
    ]));
  }
});
vn.install = (e) => {
  e.component(vn.name, vn);
};
const Qf = {
  viewBox: "0 0 640 640",
  "aria-hidden": "true",
  role: "img",
  width: "1.2em",
  height: "1.2em"
};
function Xf(e, a) {
  return s(), u("svg", Qf, [...a[0] || (a[0] = [
    d("path", {
      fill: "currentColor",
      d: "M105.4 297.4c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L173.3 320l137.3-137.4c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-160 160zm352-160l-160 160c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L365.3 320l137.3-137.4c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0z"
    }, null, -1)
  ])]);
}
const Jf = $e({ name: "fa7-solid-angles-left", render: Xf }), _f = {
  viewBox: "0 0 640 640",
  "aria-hidden": "true",
  role: "img",
  width: "1.2em",
  height: "1.2em"
};
function e2(e, a) {
  return s(), u("svg", _f, [...a[0] || (a[0] = [
    d("path", {
      fill: "currentColor",
      d: "M535.1 342.6c12.5-12.5 12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L467.2 320L329.9 457.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l160-160zm-352 160l160-160c12.5-12.5 12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L275.2 320L137.9 457.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0z"
    }, null, -1)
  ])]);
}
const t2 = $e({ name: "fa7-solid-angles-right", render: e2 }), a2 = {
  viewBox: "0 0 640 640",
  "aria-hidden": "true",
  role: "img",
  width: "1.2em",
  height: "1.2em"
};
function n2(e, a) {
  return s(), u("svg", a2, [...a[0] || (a[0] = [
    d("path", {
      fill: "currentColor",
      d: "M288.3 61.5c19.8-11.4 44.2-11.4 64 0L528.2 163c19.8 11.4 32 32.6 32 55.4v203c0 22.9-12.2 44-32 55.4L352.3 578.5a64.16 64.16 0 0 1-64 0L112.5 477c-19.8-11.4-32-32.6-32-55.4v-203c0-22.9 12.2-44 32-55.4zm207.8 360V255.4l-143.8 83v166.1z"
    }, null, -1)
  ])]);
}
const l2 = $e({ name: "fa7-solid-cube", render: n2 }), r2 = {
  viewBox: "0 0 640 640",
  "aria-hidden": "true",
  role: "img",
  width: "1.2em",
  height: "1.2em"
};
function o2(e, a) {
  return s(), u("svg", r2, [...a[0] || (a[0] = [
    d("path", {
      fill: "currentColor",
      d: "M348 62.7c-17.3-10-38.7-10-56 0l-84.2 48.6c-17.3 10-28 28.5-28 48.5v101.9l-88.3 51c-17.3 10-28 28.5-28 48.5v97.3c0 20 10.7 38.5 28 48.5l84.3 48.6c17.3 10 38.7 10 56 0l88.3-51l88.3 51c17.3 10 38.7 10 56 0l84.1-48.6c17.3-10 28-28.5 28-48.5v-97.3c0-20-10.7-38.5-28-48.5l-88.3-51V159.8c0-20-10.7-38.5-28-48.5zm-52 293.9v106.5l-88.3 51c-1.2.7-2.6 1.1-4 1.1V409.9zm231.4.6c.7 1.2 1.1 2.6 1.1 4v97.3c0 2.9-1.5 5.5-4 6.9L440.2 514c-1.2.7-2.6 1.1-4 1.1V409.8zM412.3 159.8v101.9L320 315V208.5l91.2-52.6c.7 1.2 1.1 2.6 1.1 4z"
    }, null, -1)
  ])]);
}
const s2 = $e({ name: "fa7-solid-cubes", render: o2 }), i2 = ["target", "rel", "tabindex"], ma = /* @__PURE__ */ te({
  name: "SdsLink",
  __name: "Link",
  props: {
    kind: { default: "primary" },
    type: { default: "standalone" },
    variant: { default: "blue" },
    decoration: { default: void 0 },
    size: { default: void 0 },
    external: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 }
  },
  setup(e) {
    const a = e, t = M(() => {
      switch (a.kind) {
        case "secondary":
          return "link-secondary";
        case "tertiary":
          return "link-tertiary";
        default:
          return "link-primary";
      }
    }), n = M(() => {
      switch (a.type) {
        case "inline":
          return "link-inline";
        case "cta":
          return "link-cta";
        default:
          return "";
      }
    }), l = M(() => {
      switch (a.variant) {
        case "red":
          return "link-red";
        case "white":
          return "link-white";
        default:
          return "link-blue";
      }
    }), o = M(() => {
      const c = a.decoration, f = a.variant;
      if (c)
        switch (f) {
          case "red":
            return "underline underline-offset-2 decoration-red-500";
          case "white":
            return "underline underline-offset-2 decoration-white";
          default:
            return "underline underline-offset-2 decoration-blue-500";
        }
      return "";
    }), i = M(() => {
      const c = a.size;
      if (c)
        switch (c) {
          case "xs":
            return "text-xs";
          case "sm":
            return "text-sm";
          case "lg":
            return "text-lg";
          case "xl":
            return "text-xl";
          default:
            return "text-base";
        }
      return "";
    }), h = M(() => a.disabled ? "disabled" : "");
    return (c, f) => (s(), u("a", {
      "data-id": "sds-link",
      target: e.external ? "_blank" : void 0,
      rel: e.external ? "noopener noreferrer" : void 0,
      class: D(["link", r(t), r(n), r(l), r(o), r(i), r(h)]),
      tabindex: e.disabled ? -1 : void 0
    }, [
      P(c.$slots, "default")
    ], 10, i2));
  }
}), d2 = {
  id: "Layer_1",
  "data-id": "sds-sei-wordmark",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  "aria-hidden": "true",
  x: "0px",
  y: "0px",
  viewBox: "0 0 851.9 144.2",
  style: { "enable-background": "new 0 0 851.9 144.2" },
  "xml:space": "preserve"
}, ga = /* @__PURE__ */ te({
  name: "SdsSeiWordmark",
  __name: "SeiWordmark",
  setup(e) {
    return (a, t) => (s(), u("svg", d2, [...t[0] || (t[0] = [
      $l(`<g><polygon class="fill-current" points="213.5,18.7 213.5,45.5 218,45.5 218,47.3 200.1,47.3 200.1,45.5 204.6,45.5 204.6,20.6 201.1,20.6 
		201.1,18.7 	"></polygon><path class="fill-current" d="M36.9,1.4h-1.6c-0.1,1.4-0.8,2-2.2,2C30.4,3.4,26.3,0,21.6,0C8.1,0,0,13.3,0,25c0,11.8,7.8,23.4,20.8,23.4
		c7.9,0,10.8-3.7,12.9-3.7c1.4,0,1.6,1.2,1.6,2.7h1.8V31.2h-1.8l-0.4,2.2c-0.9,5.3-5.1,13.2-13.5,13.2c-7.5,0-10.4-6.5-10.4-22.4
		C11,7.4,15,1.8,21.6,1.8c7.5,0,12.6,8.4,13.7,15.1h1.6V1.4z"></path><path class="fill-current" d="M60,39.6c-0.1,3.4-2.1,6.3-5.1,6.3c-4.4,0-4.6-3.7-4.6-6.6c0-3.4,0.4-5.7,4.6-6.2l5.1-0.5V39.6z M71.8,41.7
		c0,1.7-1.1,3.6-1.8,3.6c-1.2,0-1.4-1.2-1.4-3.2V27.2c0-7.4-6.9-9.2-13.6-9.2c-6.5,0-11.2,3.2-11.2,6.8c0,2.3,1.3,4.2,4.2,4.2
		c2.5,0,4-1.6,4-3.9c0-3.3-3.4-3.3-3.4-3.4c0-1.5,3.8-1.9,6-1.9c4.9,0,5.5,1.8,5.5,5.7v5.4l-6.4,0.5c-5.9,0.5-12.3,2-12.3,8.8
		c0,5.6,5.1,7.9,10,7.9c2.5,0,7-1,8.7-4.1c1.2,2.7,3.6,4.1,6.5,4.1c4.2,0,6.9-2.5,6.9-6.3H71.8z"></path><polygon class="fill-current" points="674.5,18.6 674.5,45.4 679,45.4 679,47.2 661.1,47.2 661.1,45.4 665.6,45.4 665.6,20.5 661.1,20.5 
		661.1,18.6 	"></polygon><path class="fill-current" d="M286,32.5l10.7-30.7h14.8l0,1.8h-4.2v42h4.2v1.8h-17.8v-1.8h4.3V4h-0.1l-15.1,43.3H281L265.5,3.2h-0.1V40
		c0,5.2,1.4,5.5,4.9,5.5h0.2v1.8h-11.2v-1.8l0,0c3.7,0,4.4-2.2,4.4-4.9v-37h-4.4V1.7h16.3L286,32.5z"></path><path class="fill-current" d="M321.8,29.9v-4.4c0-4.3,1.9-5.7,4.1-5.7c3.1,0,4.1,2.1,4.1,5.7v4.4H321.8z M321.8,31.6h17.9
		c-0.1-7-6.5-13.7-13.4-13.6c-7.6,0-14.3,6.6-14.3,15.4c0,8.4,6.2,14.7,14.5,14.7c8,0,11.9-4.9,13.4-11.3h-1.8
		c-1.4,6-4.6,9.5-9.6,9.5c-6,0-6.7-4.7-6.7-9.1V31.6z"></path><path class="fill-current" d="M591.1,29.8v-4.4c0-4.3,1.9-5.7,4.1-5.7c3.1,0,4.1,2.1,4.1,5.7v4.4H591.1z M591.1,31.5H609
		c-0.1-7-6.5-13.7-13.4-13.6c-7.6,0-14.3,6.6-14.3,15.4c0,8.4,6.2,14.7,14.5,14.7c8,0,11.9-4.9,13.4-11.3h-1.8
		c-1.4,6-4.6,9.5-9.6,9.5c-6,0-6.7-4.7-6.7-9.1V31.5z"></path><polygon class="fill-current" points="339.8,1.8 339.8,3.4 344.3,3.4 344.3,45.5 339.8,45.5 339.8,47.3 357.7,47.3 357.7,45.5 353.3,45.5 
		353.3,1.8 	"></polygon><polygon class="fill-current" points="359,1.8 359,3.4 363.4,3.4 363.4,45.5 359,45.5 359,47.3 376.9,47.3 376.9,45.5 372.4,45.5 372.4,1.8 
			"></polygon><path class="fill-current" d="M397.4,39.5c0,4.9-2,6.9-5.3,6.9c-3.3,0-5.3-2-5.3-6.9V26.7c0-4.9,2-6.9,5.3-6.9c3.3,0,5.3,2,5.3,6.9V39.5z
		 M407.5,33.1c0-8.9-6.9-15-15.4-15c-8.6,0-15.4,6.2-15.4,15c0,8.9,6.9,15,15.4,15C400.7,48.1,407.5,41.9,407.5,33.1"></path><path class="fill-current" d="M454.1,3.3h4.5v28.8c0,10,6.9,16.1,17.5,16.1c11.9,0,17.1-6.3,17.1-15.8V7.8c0-3.8,1-4.5,3.4-4.5h1.3V1.5
		h-11.4v1.7h0.8c3.3,0,3.8,1,3.8,4.8v25c0,8.8-5.5,12.8-11,12.8c-9.5,0-11.3-6.4-11.9-14.6V3.3h4.2V1.5h-18.3V3.3z"></path><path class="fill-current" d="M566.3,47.9h1.7l9.6-22.7c1.9-4.2,3-4.8,4.5-4.8h0.6v-1.8h-10.1v1.8h1.2c1.9,0,2.7-0.1,2.7,1.6
		c0,1-0.3,2.1-1.1,3.9l-4.4,10.4L564,20.4h3.6v-1.8h-16.3v1.8h3L566.3,47.9z"></path><path class="fill-current" d="M638.6,47.9h1.5c0.3-1,1-1.6,2.3-1.6c1.7,0,3.7,1.6,7.3,1.6c6.2,0,10.4-5.3,10.4-10.6c0-7.9-5.4-8.5-12.4-9.5
		c-3.6-0.5-5.7-1-5.7-3.9c0-3,2.7-4.3,6.2-4.3c4.9,0,6.7,3.2,8.4,7.4h1.5l0-9.2h-1.5c0,0.8-0.7,1.4-1.9,1.4c-2.1,0-3.8-1.4-6.7-1.4
		c-6.5,0-9.7,5.5-9.7,9.7c0,8.4,6.4,9.1,11.3,9.7c4.7,0.6,6.4,0.9,6.4,3.9c0,3.4-2.9,5-6.4,5c-4.9,0-8.3-4.3-9.5-9h-1.5V47.9z"></path><polygon class="fill-current" points="549,18.6 549,45.4 553.5,45.4 553.5,47.2 535.6,47.2 535.6,45.4 540.1,45.4 540.1,20.5 535.6,20.5 
		535.6,18.6 	"></polygon><path class="fill-current" d="M540.1,9.7c0,2.5,2,4.5,4.5,4.5c2.5,0,4.5-2,4.5-4.5c0-2.5-2-4.5-4.5-4.5C542,5.2,540.1,7.2,540.1,9.7"></path><path class="fill-current" d="M665.6,9.7c0,2.5,2,4.5,4.5,4.5c2.5,0,4.5-2,4.5-4.5c0-2.5-2-4.5-4.5-4.5C667.6,5.2,665.6,7.2,665.6,9.7"></path><path class="fill-current" d="M149.8,29.9v-4.4c0-4.3,1.9-5.7,4.1-5.7c3.1,0,4.1,2.1,4.1,5.7v4.4H149.8z M149.8,31.6h17.9
		c-0.1-7-6.5-13.7-13.4-13.6c-7.6,0-14.3,6.6-14.3,15.4c0,8.4,6.2,14.7,14.5,14.7c8,0,11.9-4.9,13.4-11.3h-1.8
		c-1.4,6-4.6,9.5-9.6,9.5c-6,0-6.7-4.7-6.7-9.1V31.6z"></path><path class="fill-current" d="M228,29.9v-4.4c0-4.3,1.9-5.7,4.1-5.7c2.3,0,4.1,1.3,4.1,5.7v4.4H228z M228,31.6h17.9
		c-0.1-7-6.5-13.7-13.4-13.6c-7.6,0-14.3,6.6-14.3,15.4c0,8.4,6.2,14.7,14.5,14.7c8,0,11.9-4.9,13.4-11.3h-1.8
		c-1.4,6-4.6,9.5-9.6,9.5c-6,0-6.7-4.7-6.7-9.1V31.6z"></path><path class="fill-current" d="M529.8,45.5V28c0-7-3-10.3-9.1-10.3c-4.3,0-8.7,2.5-10.5,6.3h0v-5.2h-13.4v1.7h4.5v25h-4.5v1.8H514v-1.8h-3.8
		V28.4c0.6-2.4,3.6-8,7.1-8c2.4,0,3.5,0.8,3.5,5.2v19.9h-3.7v1.8h17.1v-1.8H529.8z"></path><path class="fill-current" d="M420.9,18.8v5.2h0c1.8-3.8,6.2-6.3,10.5-6.3c6.2,0,9.1,3.3,9.1,10.3v17.5h4.5v1.8h-17.1v-1.8h3.7V25.7
		c0-4.3-1.2-5.2-3.5-5.2c-3.5,0-6.6,5.6-7.1,8v17.1h3.8v1.8h-17.2v-1.8h4.5v-25h-4.5v-1.7H420.9z"></path><path class="fill-current" d="M135.5,45.6V28.1c0-7-3-10.3-9.1-10.3c-4.3,0-8.7,2.5-10.5,6.3h0v-5.2h-13.4v1.7h4.5v25h-4.5v1.8h17.2v-1.8
		h-3.8V28.5c0.6-2.4,3.6-8,7.1-8c2.4,0,3.5,0.8,3.5,5.2v19.9h-3.7v1.8H140v-1.8H135.5z"></path><path class="fill-current" d="M204.6,9.8c0,2.5,2,4.5,4.5,4.5c2.5,0,4.5-2,4.5-4.5c0-2.5-2-4.5-4.5-4.5C206.6,5.4,204.6,7.4,204.6,9.8"></path><path class="fill-current" d="M718,18.6v1.9c2.8,0,4,0.3,4,1.5c0,1-0.3,2.1-1.1,3.9l-4.4,10.4l-7-15.8h3.7v-1.9h-22.3V4.7h-1.2
		c0,6.9-4.7,13.9-11.2,13.9v1.9h3.4v20.1c0,6.2,5.3,7.4,7.1,7.4c4,0,6.6-1.6,8.6-5l-1.4-0.8c-0.8,1.2-1.8,2.7-3.4,2.7
		c-1.3,0-2-0.9-2-3.1V20.5h9l11.8,27.3l-4.1,9.7l0,0c0,0,0,0,0,0l0,0c-0.1,0.2-0.3,0.3-0.5,0.3c-0.2,0-0.4-0.2-0.5-0.4c0,0,0,0,0,0
		c-0.5-1.9-2.2-3.2-4.3-3.2c-2.5,0-4.5,2-4.5,4.5c0,1.7,1,3.2,2.4,4c0,0,0,0,0,0c0,0,0.1,0,0.1,0.1c0.1,0,0.2,0.1,0.3,0.1
		c0.5,0.2,1,0.3,1.6,0.3c3.8,0.3,5.7-2.5,7-5.3c0.3-0.6,0.6-1.3,0.8-1.9c0.6-1.4,1.6-3.7,2.7-6.5l0,0l1.1-2.6l0,0l9.1-21.6
		c1.9-4.2,2.7-4.8,5-4.8h0v-1.9H718z"></path><path class="fill-current" d="M95.9,17.7c-4.1,0-7.3,2.9-8.6,6.1h-0.1v-4.9H74v1.8h4.5v24.9H74v1.8h19.4v-1.8h-6v-14c0-4.2,1.1-8.4,3.8-10.8
		c0.2-0.1,0.4-0.1,0.6-0.1c0.2,0.1,0.3,0.3,0.3,0.6l0,0c-0.2,0.5-0.3,1.1-0.3,1.8c-0.1,2.4,1.9,4.2,4.4,4.2c3.1,0,4.9-2.3,4.9-4.7
		C101.1,19.6,99,17.7,95.9,17.7z"></path><path class="fill-current" d="M193.5,19.8c0.1,0,0.3-0.1,0.4,0c0.1,0.1,0.1,0.2,0,0.4l0,0c-0.4,0.7-0.5,1.5-0.2,2.4c0.3,0.9,1.1,1.6,2,1.8
		c1.9,0.4,3.5-0.9,3.5-2.7c0-1.1-0.7-2-1.5-2.5c-0.8-0.5-1.8-0.8-2.9-0.8c-1.7,0-3.5,0.9-4.8,2c0,0,0,0,0,0
		c-0.3-0.2-0.6-0.4-0.9-0.6c-1.8-1-4.1-1.7-7.2-1.7c-5.4,0-11.3,3.6-11.3,9.5c0,3.6,1.9,6.4,5.4,7.9v0.1c-2.5,0.3-6.5,2.1-6.5,7.5
		c0,3.2,1.5,5.7,4.2,6.5v0.1c-2.6,0.7-5.6,3.3-5.6,6.4c0,4.8,5.6,8.5,12.8,8.5c9,0,14.9-6.1,14.9-14c0-6.3-3.1-9.1-9.5-9h-10.8
		c-1.6,0-2.7-0.1-2.7-1.8c0-1.6,2.5-3.4,4.9-3.4c0.4,0,1.1,0.3,1.3,0.4c0.8,0.3,1.6,0.4,2.7,0.4c5.6,0,11.5-3.2,11.5-9.3
		c0-1.9-0.8-4.5-2.4-6.1c-0.1-0.1-0.1-0.2,0-0.3c0.6-0.5,1.3-0.9,1.7-1.1C193,20,193.2,19.9,193.5,19.8L193.5,19.8z M184.9,49.6
		c6.5,0,8.2,0.3,8.2,4.2c0,4.7-5.8,9.1-12.3,9.1c-5.8,0-8.6-3.6-8.8-6.7c0-2.9,1.4-4.7,3.2-6.6H184.9z M186,27.5
		c0,7.5-1.7,7.8-4.1,7.8c-2.6,0-4-0.5-4-8c0-5.3,0.6-7.5,4-7.5C184.9,19.8,185.9,20,186,27.5L186,27.5z"></path><path class="fill-current" d="M631.7,17.5c-4.1,0-7.3,2.9-8.6,6.1H623v-4.9h-13.3v1.8h4.5v24.9h-4.5v1.8h19.4v-1.8h-6v-14
		c0-4.2,1.1-8.4,3.8-10.8c0.2-0.1,0.4-0.1,0.6-0.1c0.2,0.1,0.3,0.3,0.3,0.6l0,0c-0.2,0.5-0.3,1.1-0.3,1.8c-0.1,2.4,1.9,4.2,4.4,4.2
		c3.1,0,4.9-2.3,4.9-4.7C636.8,19.3,634.7,17.5,631.7,17.5z"></path></g><g><path class="fill-current" d="M30.2,116.6c0,3.9-1.4,6.9-4.3,9.2c-2.8,2.3-6.6,3.4-11.3,3.4c-5.7,0-10-0.6-13-1.9v-3.2
		c3.3,1.4,7.6,2.1,12.8,2.1c3.8,0,6.8-0.9,9.1-2.6c2.2-1.7,3.3-4,3.3-6.9c0-1.8-0.4-3.2-1.1-4.4c-0.7-1.2-1.9-2.2-3.6-3.2
		c-1.7-1-4.1-2-7.4-3.1c-4.7-1.6-8-3.4-9.8-5.3c-1.8-1.9-2.7-4.4-2.7-7.6c0-3.5,1.4-6.3,4.1-8.5c2.7-2.2,6.2-3.3,10.5-3.3
		c4.4,0,8.5,0.8,12.3,2.5l-1.2,2.8c-3.9-1.6-7.5-2.4-11-2.4c-3.4,0-6.2,0.8-8.2,2.4s-3,3.7-3,6.5c0,1.7,0.3,3.1,0.9,4.2
		c0.6,1.1,1.6,2.1,3.1,3c1.4,0.9,3.9,1.9,7.3,3.2c3.6,1.2,6.3,2.5,8.2,3.6c1.8,1.2,3.1,2.5,4,4C29.8,112.7,30.2,114.5,30.2,116.6z"></path><path class="fill-current" d="M66.8,111.2c0,5.6-1.4,10-4.1,13.2c-2.7,3.2-6.5,4.7-11.3,4.7c-3,0-5.7-0.7-8-2.2c-2.3-1.5-4.1-3.6-5.3-6.3
		c-1.2-2.7-1.8-5.9-1.8-9.5c0-5.6,1.4-10,4.1-13.2c2.7-3.1,6.5-4.7,11.2-4.7c4.7,0,8.5,1.6,11.2,4.8
		C65.5,101.3,66.8,105.7,66.8,111.2z M39.6,111.2c0,4.7,1,8.4,3.1,11.1c2.1,2.7,5,4,8.8,4s6.8-1.3,8.8-4c2.1-2.7,3.1-6.4,3.1-11.1
		c0-4.8-1.1-8.5-3.2-11.1c-2.1-2.6-5.1-3.9-8.9-3.9s-6.7,1.3-8.8,3.9C40.6,102.8,39.6,106.5,39.6,111.2z"></path><path class="fill-current" d="M88.5,96.8h-8.1v31.8h-3.1V96.8h-6.4v-1.8l6.4-1.2v-2.7c0-4.2,0.8-7.3,2.3-9.3c1.6-2,4.1-3,7.6-3
		c1.9,0,3.8,0.3,5.7,0.9l-0.7,2.7c-1.7-0.5-3.4-0.8-5-0.8c-2.5,0-4.2,0.7-5.2,2.2s-1.5,3.8-1.5,7.1V94h8.1V96.8z"></path><path class="fill-current" d="M106.3,126.4c2,0,3.7-0.2,5.2-0.5v2.5c-1.5,0.5-3.3,0.8-5.3,0.8c-3,0-5.3-0.8-6.7-2.4
		c-1.4-1.6-2.2-4.2-2.2-7.7V96.8h-5.1v-1.8l5.1-1.4l1.6-7.8h1.6V94h10.1v2.7h-10.1v21.8c0,2.6,0.5,4.6,1.4,5.9
		C102.8,125.8,104.3,126.4,106.3,126.4z"></path><path class="fill-current" d="M147.5,128.5l-7.6-23.1c-0.5-1.6-1.1-3.9-1.9-6.9h-0.2l-0.7,2.3l-1.4,4.6l-7.7,23H125L115.1,94h3.4l5.5,20
		c1.3,5,2.1,8.6,2.5,10.9h0.2c1.2-5,2.2-8.2,2.7-9.9l7.1-21h2.9l6.8,21c1.5,5,2.5,8.3,2.8,9.9h0.2c0.2-1.4,1-5.1,2.5-11L157,94h3.2
		l-9.4,34.5H147.5z"></path><path class="fill-current" d="M187,128.5l-0.8-5.5H186c-1.7,2.2-3.5,3.8-5.3,4.7c-1.8,0.9-4,1.4-6.5,1.4c-3.4,0-6-0.9-7.9-2.6
		c-1.9-1.7-2.8-4.1-2.8-7.2c0-3.4,1.4-6,4.2-7.8c2.8-1.9,6.9-2.8,12.2-3l6.6-0.2v-2.3c0-3.3-0.7-5.8-2-7.4c-1.3-1.7-3.5-2.5-6.4-2.5
		c-3.2,0-6.5,0.9-9.9,2.7l-1.2-2.7c3.8-1.8,7.5-2.7,11.2-2.7c3.8,0,6.6,1,8.5,3c1.9,2,2.8,5,2.8,9.2v22.9H187z M174.3,126.3
		c3.7,0,6.6-1.1,8.7-3.2c2.1-2.1,3.2-5,3.2-8.8V111l-6,0.3c-4.8,0.2-8.3,1-10.4,2.3c-2.1,1.3-3.1,3.3-3.1,6c0,2.2,0.7,3.8,2,5
		C170,125.7,171.9,126.3,174.3,126.3z"></path><path class="fill-current" d="M215.1,93.4c1.5,0,3,0.1,4.7,0.4l-0.6,3c-1.4-0.4-2.9-0.5-4.5-0.5c-2.9,0-5.4,1.2-7.2,3.7
		c-1.9,2.5-2.8,5.6-2.8,9.5v19h-3.1V94h2.7l0.3,6.2h0.2c1.4-2.5,2.9-4.3,4.5-5.3C210.8,93.9,212.8,93.4,215.1,93.4z"></path><path class="fill-current" d="M236.6,129.2c-5,0-8.9-1.5-11.7-4.6c-2.8-3.1-4.2-7.4-4.2-13c0-5.5,1.4-9.9,4.1-13.2c2.7-3.3,6.4-5,10.9-5
		c4.1,0,7.3,1.4,9.6,4.3c2.3,2.8,3.5,6.7,3.5,11.6v2.5H224c0,4.7,1.1,8.4,3.3,10.9c2.2,2.5,5.3,3.7,9.3,3.7c2,0,3.7-0.1,5.2-0.4
		c1.5-0.3,3.4-0.9,5.7-1.8v2.9c-1.9,0.8-3.7,1.4-5.4,1.7S238.6,129.2,236.6,129.2z M235.7,96.2c-3.3,0-6,1.1-8,3.3
		c-2,2.2-3.2,5.3-3.5,9.5h21.3c0-4-0.9-7.1-2.6-9.4C241.2,97.3,238.8,96.2,235.7,96.2z"></path><path class="fill-current" d="M300.1,128.5h-25.4V82.1h25.4v3H278v17.6h20.9v3H278v19.9h22.1V128.5z"></path><path class="fill-current" d="M331.6,128.5v-22.4c0-3.5-0.7-6-2.2-7.6c-1.5-1.6-3.7-2.4-6.8-2.4c-4.1,0-7.1,1-9.1,3.1
		c-1.9,2.1-2.9,5.5-2.9,10.1v19h-3.1V94h2.7l0.6,4.7h0.2c2.2-3.6,6.2-5.4,12-5.4c7.8,0,11.7,4.2,11.7,12.6v22.6H331.6z"></path><path class="fill-current" d="M372.3,94v2.2l-7.1,0.4c1.9,2.4,2.9,5,2.9,7.8c0,3.3-1.1,6-3.3,8.1c-2.2,2.1-5.2,3.1-8.9,3.1
		c-1.6,0-2.7-0.1-3.3-0.2c-1.2,0.7-2.2,1.4-2.9,2.3c-0.7,0.9-1,1.8-1,2.8c0,1.1,0.4,1.9,1.3,2.4s2.2,0.8,4.2,0.8h6
		c3.7,0,6.6,0.8,8.6,2.3c2,1.5,3,3.7,3,6.7c0,3.6-1.5,6.4-4.4,8.4c-3,2-7.2,3-12.6,3c-4.3,0-7.7-0.8-10.1-2.5c-2.4-1.7-3.6-4-3.6-7
		c0-2.4,0.7-4.3,2.2-5.9c1.5-1.6,3.5-2.6,6-3.2c-1-0.4-1.9-1.1-2.5-1.9c-0.6-0.8-0.9-1.8-0.9-2.8c0-2.3,1.5-4.3,4.4-6.1
		c-2-0.8-3.6-2.1-4.7-3.9c-1.1-1.8-1.7-3.8-1.7-6.1c0-3.4,1.1-6.2,3.3-8.3c2.2-2.1,5.1-3.1,8.9-3.1c2.3,0,4,0.2,5.3,0.7H372.3z
		 M344.4,134.4c0,4.7,3.5,7.1,10.6,7.1c9.1,0,13.6-2.9,13.6-8.7c0-2.1-0.7-3.6-2.1-4.5c-1.4-0.9-3.7-1.4-6.9-1.4h-5.6
		C347.5,126.9,344.4,129.4,344.4,134.4z M347,104.8c0,2.7,0.8,4.7,2.4,6.2c1.6,1.5,3.8,2.2,6.5,2.2c2.9,0,5.1-0.7,6.6-2.2
		s2.3-3.6,2.3-6.3c0-2.9-0.8-5.1-2.4-6.6s-3.8-2.2-6.6-2.2c-2.8,0-4.9,0.8-6.5,2.4C347.8,99.8,347,102,347,104.8z"></path><path class="fill-current" d="M380.2,84.5c0-2,0.7-3,2-3c0.7,0,1.2,0.3,1.5,0.8c0.4,0.5,0.6,1.3,0.6,2.3c0,1-0.2,1.7-0.6,2.3
		c-0.4,0.6-0.9,0.8-1.5,0.8C380.9,87.5,380.2,86.5,380.2,84.5z M383.8,128.5h-3.1V94h3.1V128.5z"></path><path class="fill-current" d="M420.2,128.5v-22.4c0-3.5-0.7-6-2.2-7.6c-1.5-1.6-3.7-2.4-6.8-2.4c-4.1,0-7.1,1-9.1,3.1
		c-1.9,2.1-2.9,5.5-2.9,10.1v19h-3.1V94h2.7l0.6,4.7h0.2c2.2-3.6,6.2-5.4,12-5.4c7.8,0,11.7,4.2,11.7,12.6v22.6H420.2z"></path><path class="fill-current" d="M446.9,129.2c-5,0-8.9-1.5-11.7-4.6c-2.8-3.1-4.2-7.4-4.2-13c0-5.5,1.4-9.9,4.1-13.2c2.7-3.3,6.4-5,10.9-5
		c4.1,0,7.3,1.4,9.6,4.3c2.3,2.8,3.5,6.7,3.5,11.6v2.5h-24.9c0,4.7,1.1,8.4,3.3,10.9c2.2,2.5,5.3,3.7,9.3,3.7c2,0,3.7-0.1,5.2-0.4
		c1.5-0.3,3.4-0.9,5.7-1.8v2.9c-1.9,0.8-3.7,1.4-5.4,1.7S448.9,129.2,446.9,129.2z M446,96.2c-3.3,0-6,1.1-8,3.3
		c-2,2.2-3.2,5.3-3.5,9.5h21.3c0-4-0.9-7.1-2.6-9.4C451.5,97.3,449.1,96.2,446,96.2z"></path><path class="fill-current" d="M481.4,129.2c-5,0-8.9-1.5-11.7-4.6c-2.8-3.1-4.2-7.4-4.2-13c0-5.5,1.4-9.9,4.1-13.2c2.7-3.3,6.4-5,10.9-5
		c4.1,0,7.3,1.4,9.6,4.3c2.3,2.8,3.5,6.7,3.5,11.6v2.5h-24.9c0,4.7,1.1,8.4,3.3,10.9c2.2,2.5,5.3,3.7,9.3,3.7c2,0,3.7-0.1,5.2-0.4
		c1.5-0.3,3.4-0.9,5.7-1.8v2.9c-1.9,0.8-3.7,1.4-5.4,1.7S483.4,129.2,481.4,129.2z M480.5,96.2c-3.3,0-6,1.1-8,3.3
		c-2,2.2-3.2,5.3-3.5,9.5h21.3c0-4-0.9-7.1-2.6-9.4C486,97.3,483.6,96.2,480.5,96.2z"></path><path class="fill-current" d="M515,93.4c1.5,0,3,0.1,4.7,0.4l-0.6,3c-1.4-0.4-2.9-0.5-4.5-0.5c-2.9,0-5.4,1.2-7.2,3.7
		c-1.9,2.5-2.8,5.6-2.8,9.5v19h-3.1V94h2.7l0.3,6.2h0.2c1.4-2.5,2.9-4.3,4.5-5.3C510.8,93.9,512.7,93.4,515,93.4z"></path><path class="fill-current" d="M524.1,84.5c0-2,0.7-3,2-3c0.7,0,1.2,0.3,1.5,0.8c0.4,0.5,0.6,1.3,0.6,2.3c0,1-0.2,1.7-0.6,2.3
		c-0.4,0.6-0.9,0.8-1.5,0.8C524.7,87.5,524.1,86.5,524.1,84.5z M527.7,128.5h-3.1V94h3.1V128.5z"></path><path class="fill-current" d="M564,128.5v-22.4c0-3.5-0.7-6-2.2-7.6c-1.5-1.6-3.7-2.4-6.8-2.4c-4.1,0-7.1,1-9.1,3.1
		c-1.9,2.1-2.9,5.5-2.9,10.1v19H540V94h2.7l0.6,4.7h0.2c2.2-3.6,6.2-5.4,12-5.4c7.8,0,11.7,4.2,11.7,12.6v22.6H564z"></path><path class="fill-current" d="M605.6,94v2.2l-7.1,0.4c1.9,2.4,2.9,5,2.9,7.8c0,3.3-1.1,6-3.3,8.1c-2.2,2.1-5.2,3.1-8.9,3.1
		c-1.6,0-2.7-0.1-3.3-0.2c-1.2,0.7-2.2,1.4-2.9,2.3c-0.7,0.9-1,1.8-1,2.8c0,1.1,0.4,1.9,1.3,2.4s2.2,0.8,4.2,0.8h6
		c3.7,0,6.6,0.8,8.6,2.3c2,1.5,3,3.7,3,6.7c0,3.6-1.5,6.4-4.4,8.4c-3,2-7.2,3-12.6,3c-4.3,0-7.7-0.8-10.1-2.5c-2.4-1.7-3.6-4-3.6-7
		c0-2.4,0.7-4.3,2.2-5.9c1.5-1.6,3.5-2.6,6-3.2c-1-0.4-1.9-1.1-2.5-1.9c-0.6-0.8-0.9-1.8-0.9-2.8c0-2.3,1.5-4.3,4.4-6.1
		c-2-0.8-3.6-2.1-4.7-3.9c-1.1-1.8-1.7-3.8-1.7-6.1c0-3.4,1.1-6.2,3.3-8.3c2.2-2.1,5.1-3.1,8.9-3.1c2.3,0,4,0.2,5.3,0.7H605.6z
		 M577.7,134.4c0,4.7,3.5,7.1,10.6,7.1c9.1,0,13.6-2.9,13.6-8.7c0-2.1-0.7-3.6-2.1-4.5c-1.4-0.9-3.7-1.4-6.9-1.4h-5.7
		C580.9,126.9,577.7,129.4,577.7,134.4z M580.3,104.8c0,2.7,0.8,4.7,2.4,6.2c1.6,1.5,3.8,2.2,6.5,2.2c2.9,0,5.1-0.7,6.6-2.2
		s2.3-3.6,2.3-6.3c0-2.9-0.8-5.1-2.4-6.6s-3.8-2.2-6.6-2.2c-2.8,0-4.9,0.8-6.5,2.4C581.1,99.8,580.3,102,580.3,104.8z"></path><path class="fill-current" d="M626.5,128.5V82.1h3.2v46.4H626.5z"></path><path class="fill-current" d="M665.9,128.5v-22.4c0-3.5-0.7-6-2.2-7.6c-1.5-1.6-3.7-2.4-6.8-2.4c-4.1,0-7.1,1-9.1,3.1
		c-1.9,2.1-2.9,5.5-2.9,10.1v19h-3.1V94h2.7l0.6,4.7h0.2c2.2-3.6,6.2-5.4,12-5.4c7.8,0,11.7,4.2,11.7,12.6v22.6H665.9z"></path><path class="fill-current" d="M700.9,119.6c0,3.1-1.2,5.5-3.5,7.1c-2.3,1.7-5.7,2.5-10,2.5c-4.6,0-8.3-0.7-11-2.1v-3.4
		c3.5,1.7,7.1,2.6,11,2.6c3.4,0,6-0.6,7.8-1.7c1.8-1.1,2.7-2.6,2.7-4.5c0-1.7-0.7-3.2-2.1-4.4c-1.4-1.2-3.7-2.3-6.9-3.5
		c-3.4-1.2-5.9-2.3-7.3-3.2c-1.4-0.9-2.4-1.9-3.2-3c-0.7-1.1-1.1-2.5-1.1-4.1c0-2.6,1.1-4.6,3.3-6.1c2.2-1.5,5.2-2.3,9.1-2.3
		c3.7,0,7.3,0.7,10.6,2.1l-1.2,2.9c-3.4-1.4-6.5-2.1-9.4-2.1c-2.8,0-5,0.5-6.7,1.4c-1.7,0.9-2.5,2.2-2.5,3.9c0,1.8,0.6,3.2,1.9,4.3
		c1.3,1.1,3.8,2.3,7.5,3.6c3.1,1.1,5.4,2.1,6.8,3c1.4,0.9,2.5,1.9,3.2,3.1S700.9,118,700.9,119.6z"></path><path class="fill-current" d="M719.3,126.4c2,0,3.7-0.2,5.2-0.5v2.5c-1.5,0.5-3.3,0.8-5.3,0.8c-3,0-5.3-0.8-6.7-2.4
		c-1.4-1.6-2.2-4.2-2.2-7.7V96.8h-5.1v-1.8l5.1-1.4l1.6-7.8h1.6V94h10.1v2.7h-10.1v21.8c0,2.6,0.5,4.6,1.4,5.9
		C715.8,125.8,717.3,126.4,719.3,126.4z"></path><path class="fill-current" d="M730.4,84.5c0-2,0.7-3,2-3c0.7,0,1.2,0.3,1.5,0.8c0.4,0.5,0.6,1.3,0.6,2.3c0,1-0.2,1.7-0.6,2.3
		c-0.4,0.6-0.9,0.8-1.5,0.8C731,87.5,730.4,86.5,730.4,84.5z M733.9,128.5h-3.1V94h3.1V128.5z"></path><path class="fill-current" d="M756.2,126.4c2,0,3.7-0.2,5.2-0.5v2.5c-1.5,0.5-3.3,0.8-5.3,0.8c-3,0-5.3-0.8-6.7-2.4
		c-1.4-1.6-2.2-4.2-2.2-7.7V96.8h-5.1v-1.8l5.1-1.4l1.6-7.8h1.6V94h10.1v2.7h-10.1v21.8c0,2.6,0.5,4.6,1.4,5.9
		C752.8,125.8,754.2,126.4,756.2,126.4z"></path><path class="fill-current" d="M769.5,94v22.3c0,3.5,0.7,6,2.2,7.6c1.5,1.6,3.7,2.4,6.8,2.4c4.1,0,7.1-1,9.1-3.1c1.9-2.1,2.9-5.4,2.9-10.1V94
		h3.1v34.5h-2.7l-0.6-4.8h-0.2c-2.2,3.6-6.2,5.4-12,5.4c-7.8,0-11.8-4.2-11.8-12.6V94H769.5z"></path><path class="fill-current" d="M814.8,126.4c2,0,3.7-0.2,5.2-0.5v2.5c-1.5,0.5-3.3,0.8-5.3,0.8c-3,0-5.3-0.8-6.7-2.4
		c-1.4-1.6-2.2-4.2-2.2-7.7V96.8h-5.1v-1.8l5.1-1.4l1.6-7.8h1.6V94h10.1v2.7H809v21.8c0,2.6,0.5,4.6,1.4,5.9
		C811.3,125.8,812.8,126.4,814.8,126.4z"></path><path class="fill-current" d="M839.7,129.2c-5,0-8.9-1.5-11.7-4.6c-2.8-3.1-4.2-7.4-4.2-13c0-5.5,1.4-9.9,4.1-13.2c2.7-3.3,6.4-5,10.9-5
		c4.1,0,7.3,1.4,9.6,4.3c2.3,2.8,3.5,6.7,3.5,11.6v2.5h-24.9c0,4.7,1.1,8.4,3.3,10.9c2.2,2.5,5.3,3.7,9.3,3.7c2,0,3.7-0.1,5.2-0.4
		c1.5-0.3,3.4-0.9,5.7-1.8v2.9c-1.9,0.8-3.7,1.4-5.4,1.7S841.7,129.2,839.7,129.2z M838.8,96.2c-3.3,0-6,1.1-8,3.3
		c-2,2.2-3.2,5.3-3.5,9.5h21.3c0-4-0.9-7.1-2.6-9.4C844.2,97.3,841.8,96.2,838.8,96.2z"></path></g>`, 2)
    ])]));
  }
}), u2 = {
  "data-id": "sds-application",
  class: "flex flex-col h-screen dark:text-gray-50"
}, c2 = { class: "md:hidden my-auto p-3 bg-white dark:bg-gray-950 border-b border-gray-100 dark:border-gray-800" }, f2 = { class: "flex items-center gap-2" }, h2 = {
  key: 0,
  class: "hidden md:block grow"
}, m2 = ["href"], g2 = { class: "text-red-600 dark:text-red-400 font-bold" }, v2 = {
  key: 1,
  class: "flex"
}, y2 = { class: "text-red-600 dark:text-red-400 font-bold" }, b2 = { class: "flex items-center" }, p2 = {
  key: 0,
  class: "text-red-600 dark:text-red-400 font-bold"
}, w2 = { key: 1 }, x2 = { class: "flex grow shrink-0" }, k2 = { class: "h-screen flex flex-col sticky top-0" }, C2 = { class: "overflow-y-auto grow overscroll-contain" }, $2 = {
  key: 0,
  class: "px-3"
}, M2 = { class: "border-b border-gray-100 dark:border-gray-800 mb-3" }, S2 = { class: "flex gap-2 py-3" }, D2 = {
  key: 0,
  class: "flex items-center w-4 h-4 my-auto shrink-0"
}, z2 = ["href"], T2 = ["src", "alt"], B2 = { class: "sr-only" }, L2 = ["src", "alt"], I2 = { class: "sr-only" }, V2 = ["href"], A2 = {
  key: 1,
  class: "my-auto"
}, H2 = {
  key: 1,
  class: "grid grid-cols-1 pb-24",
  "aria-label": "Mobile sidebar"
}, O2 = ["href", "onClick"], P2 = {
  key: 0,
  class: "flex items-center w-4 h-4 my-auto shrink-0"
}, F2 = ["src", "alt"], E2 = { class: "sr-only" }, R2 = { class: "inline-block my-auto text-left" }, N2 = {
  key: 0,
  class: "inline-block my-auto"
}, W2 = { class: "flex items-center justify-center px-2 py-1 text-xs font-bold rounded-full text-white bg-red-600 dark:bg-red-700" }, q2 = ["href", "onClick"], Y2 = { class: "inline-block my-auto text-left" }, j2 = {
  key: 0,
  class: "inline-block my-auto"
}, G2 = { class: "flex items-center justify-center px-2 py-1 text-xs font-bold rounded-full text-white bg-red-600 dark:bg-red-700" }, U2 = {
  key: 1,
  class: "inline-flex gap-1 my-auto ml-auto"
}, K2 = ["innerHTML"], Z2 = ["href", "onClick"], Q2 = {
  key: 0,
  class: "flex items-center w-4 h-4 my-auto shrink-0"
}, X2 = ["src", "alt"], J2 = { class: "sr-only" }, _2 = { class: "inline-block my-auto text-left" }, eh = {
  key: 0,
  class: "inline-block my-auto"
}, th = { class: "flex items-center justify-center px-2 py-1 text-xs font-bold rounded-full text-white bg-red-600 dark:bg-red-700" }, ah = {
  key: 1,
  class: "inline-flex gap-1 my-auto ml-auto"
}, nh = ["innerHTML"], lh = {
  key: 0,
  class: "p-3"
}, rh = { class: "pt-3 border-t border-gray-100 dark:border-gray-800 items-center flex gap-2 shrink-0" }, oh = { class: "h-screen flex flex-col sticky top-0" }, sh = { class: "my-auto px-3" }, ih = { class: "border-b border-gray-100 dark:border-gray-800" }, dh = { class: "flex items-center gap-2 pt-3" }, uh = {
  key: 0,
  class: "hidden md:block grow"
}, ch = ["href"], fh = { class: "text-red-600 dark:text-red-400 font-bold" }, hh = {
  key: 1,
  class: "flex"
}, mh = { class: "text-red-600 dark:text-red-400 font-bold" }, gh = {
  key: 1,
  class: "mx-auto"
}, vh = ["title"], yh = { class: "text-xl leading-6 flex" }, bh = {
  key: 0,
  class: "text-red-600 dark:text-red-400 font-bold"
}, ph = { key: 1 }, wh = {
  key: 1,
  class: "sticky top-0 z-10"
}, xh = {
  key: 0,
  class: "flex gap-2 py-3"
}, kh = ["href"], Ch = ["src", "alt"], $h = { class: "sr-only" }, Mh = ["src", "alt"], Sh = { class: "sr-only" }, Dh = ["href"], zh = { class: "overflow-y-auto grow overscroll-contain pt-3" }, Th = {
  key: 0,
  class: "grid grid-cols-1 pb-24",
  "aria-label": "Sidebar"
}, Bh = ["href", "onClick"], Lh = ["src", "alt"], Ih = { class: "sr-only" }, Vh = {
  key: 0,
  class: "inline-block my-auto text-left"
}, Ah = {
  key: 0,
  class: "flex items-center justify-center px-2 py-1 text-xs font-bold rounded-full text-white bg-red-600 dark:bg-red-700"
}, Hh = {
  key: 1,
  class: "flex justify-center p-1 rounded-full bg-red-600"
}, Oh = { class: "sr-only" }, Ph = ["href", "onClick"], Fh = { class: "inline-block my-auto text-left" }, Eh = {
  key: 0,
  class: "inline-block my-auto"
}, Rh = { class: "flex items-center justify-center px-2 py-1 text-xs font-bold rounded-full text-white bg-red-600 dark:bg-red-700" }, Nh = {
  key: 1,
  class: "inline-flex gap-1 my-auto ml-auto"
}, Wh = ["innerHTML"], qh = ["href", "onClick"], Yh = ["src", "alt"], jh = { class: "sr-only" }, Gh = {
  key: 0,
  class: "inline-block my-auto text-left"
}, Uh = {
  key: 0,
  class: "flex items-center justify-center px-2 py-1 text-xs font-bold rounded-full text-white bg-red-600 dark:bg-red-700"
}, Kh = {
  key: 1,
  class: "flex justify-center p-1 rounded-full bg-red-600 dark:bg-red-700"
}, Zh = { class: "sr-only" }, Qh = {
  key: 2,
  class: "inline-flex gap-1 my-auto ml-auto"
}, Xh = ["innerHTML"], Jh = {
  key: 0,
  class: "items-center flex gap-2 shrink-0 p-3"
}, _h = { class: "bg-gray-25 dark:bg-black flex flex-col items-stretch grow min-w-0" }, em = { class: "grow pb-4" }, tm = {
  key: 0,
  class: "bg-white dark:bg-gray-900 border-b border-gray-200 dark:border-gray-800 px-3 py-3 sticky top-0 z-40 flex flex-col gap-4 md:flex-row"
}, am = { class: "grow my-auto flex flex-row gap-2" }, nm = { class: "text-xl font-light text-gray-900 dark:text-gray-100" }, lm = {
  key: 0,
  class: "shrink-0 my-auto flex flex-col md:flex-row gap-2"
}, rm = { class: "p-4" }, om = {
  key: 0,
  class: "p-4"
}, sm = { class: "text-xs p-4 flex flex-col lg:flex-row gap-4 pt-4" }, im = { class: "shrink-0 flex order-2 lg:order-1" }, dm = {
  key: 0,
  class: "shrink flex lg:mx-auto order-1 lg:order-2"
}, um = { class: "my-auto" }, cm = { class: "shrink-0 flex lg:ml-auto order-3" }, fm = { class: "my-auto" }, hm = { class: "flex flex-col" }, mm = { class: "ml-auto" }, gm = {
  key: 0,
  class: "bg-blue-500 text-white dark:bg-blue-700 p-4 sticky bottom-0 z-40"
}, vm = { class: "flex flex-col md:flex-row gap-2 items-stretch md:items-center" }, yn = /* @__PURE__ */ te({
  name: "SdsApplication",
  __name: "Application",
  props: /* @__PURE__ */ xe({
    sidebarWidth: { default: "w-72" },
    enableCollapsibleSidebar: { type: Boolean, default: !1 },
    appSuitePrefix: { default: "SEI" },
    appSuite: { default: null },
    appSuiteUrl: { default: null },
    appName: { default: null },
    appUrl: { default: null },
    hideAppNameInMobileHeader: { type: Boolean, default: !1 },
    appIconUrl: { default: null },
    pageTitle: { default: null },
    hidePageHeader: { type: Boolean, default: !1 },
    sidebarNavigationItems: { default: () => [] },
    hideAppIcon: { type: Boolean, default: !1 },
    hideSidebarIcons: { type: Boolean, default: !1 },
    hideActionBar: { type: Boolean, default: !1 }
  }, {
    modelValue: { type: Boolean, type: Boolean, default: !1 },
    modelModifiers: {}
  }),
  emits: /* @__PURE__ */ xe(["navigate"], ["update:modelValue"]),
  setup(e, { emit: a }) {
    const t = Qt(), n = e, l = Te(e, "modelValue"), o = a, i = E(!1), h = E(), c = E(), f = E(), y = E([]), m = M(() => (/* @__PURE__ */ new Date()).getFullYear()), g = M(() => n.enableCollapsibleSidebar && l.value ? "w-auto" : n.sidebarWidth);
    ye(i, async (p) => {
      typeof document < "u" && (p ? (document.documentElement.classList.add("application-internal-prevent-scroll"), await Ie(), h.value.focus()) : (document.documentElement.classList.remove("application-internal-prevent-scroll"), c.value.focus()));
    }), ye(l, (p) => {
      p && (y.value = []);
    }), ft(document, "keyup", (p) => {
      if (!p.target) return;
      const F = p.target.tagName.toLowerCase();
      F !== "textarea" && F !== "input" && p.key === "[" && z();
    });
    const C = (p) => {
      if (!p.items)
        return null;
      let F = 0;
      return p.items.forEach((R) => {
        R.badgeCount && (F = F + R.badgeCount);
      }), F;
    }, k = (p) => p.items && p.items.filter((F) => F.active).length, w = (p) => y.value.filter((F) => F.id === p.id).length, x = (p) => {
      l.value = !1, w(p) ? y.value = y.value.filter(
        (F) => F.id !== p.id
      ) : y.value.push(p);
    }, I = (p) => !!t[p], L = (p, F, R) => {
      i.value = !1, o("navigate", { group: p, item: F, event: R });
    }, z = () => {
      n.enableCollapsibleSidebar ? l.value = !l.value : l.value = !1;
    }, b = () => {
      i.value = !1;
    }, { trapFocus: $ } = Ll(f, {
      enabled: i,
      handleEscape: !0,
      onEscape: b
    });
    return (p, F) => {
      const R = Hr, T = s2, j = l2, X = Ua, pe = ll, H = t2, Y = Jf;
      return s(), u("div", u2, [
        d("header", c2, [
          d("div", f2, [
            e.appSuite && !l.value ? (s(), u("h1", h2, [
              e.appSuiteUrl ? (s(), u("a", {
                key: 0,
                href: e.appSuiteUrl,
                class: "flex hover:underline",
                onClick: F[0] || (F[0] = (O) => L(null, { title: e.appSuite, href: e.appSuiteUrl }, O))
              }, [
                d("span", g2, A(e.appSuitePrefix), 1),
                d("span", null, A(e.appSuite), 1)
              ], 8, m2)) : (s(), u("p", v2, [
                d("span", y2, A(e.appSuitePrefix), 1),
                d("span", null, A(e.appSuite), 1)
              ]))
            ])) : S("", !0)
          ]),
          e.appSuite || e.appName ? (s(), u("button", {
            key: 0,
            ref_key: "mobileMenuOpenBtn",
            ref: c,
            "aria-label": "Open mobile menu",
            class: "flex items-center md:hidden gap-1 focus:outline-hidden",
            onClick: F[1] || (F[1] = (O) => i.value = !r(i))
          }, [
            Q(R, { class: "text-black dark:text-white h-6 w-6" }),
            d("span", b2, [
              e.appSuitePrefix ? (s(), u("span", p2, A(e.appSuitePrefix), 1)) : S("", !0),
              e.appSuite ? (s(), u("span", w2, A(e.appSuite), 1)) : S("", !0)
            ])
          ], 512)) : S("", !0)
        ]),
        d("div", x2, [
          Q(Qe, {
            "enter-active-class": "transition-opacity ease-linear duration-150",
            "enter-from-class": "opacity-0",
            "enter-to-class": "opacity-100",
            "leave-active-class": "transition-opacity ease-linear duration-150",
            "leave-from-class": "opacity-100",
            "leave-to-class": "opacity-0"
          }, {
            default: U(() => [
              r(i) ? (s(), u("button", {
                key: 0,
                class: "bg-black/40 fixed inset h-screen w-screen z-50 md:hidden",
                onClick: F[2] || (F[2] = (O) => i.value = !r(i))
              }, [...F[11] || (F[11] = [
                d("span", { class: "sr-only" }, "Toggle mobile menu", -1)
              ])])) : S("", !0)
            ]),
            _: 1
          }),
          Q(Qe, {
            "enter-active-class": "transition-transform ease-linear duration-150",
            "enter-from-class": "-translate-x-full",
            "enter-to-class": "translate-x-0",
            "leave-active-class": "transition-transform ease-linear duration-150",
            "leave-from-class": "translate-x-0",
            "leave-to-class": "-translate-x-full"
          }, {
            default: U(() => [
              r(i) ? (s(), u("aside", {
                key: 0,
                ref_key: "mobileSidebarContainer",
                ref: f,
                "aria-label": "mobile sidebar",
                class: "md:hidden fixed w-2/3 z-50 bg-white dark:bg-gray-950 shrink-0 border-r border-gray-200 dark:border-gray-800",
                onKeydown: F[6] || (F[6] = //@ts-ignore
                (...O) => r($) && r($)(...O))
              }, [
                d("button", {
                  ref_key: "mobileMenuCloseBtn",
                  ref: h,
                  class: "sr-only",
                  onClick: F[3] || (F[3] = (O) => i.value = !r(i))
                }, [...F[12] || (F[12] = [
                  d("span", { class: "sr-only" }, "Toggle mobile menu", -1)
                ])], 512),
                d("div", k2, [
                  d("div", C2, [
                    e.appName ? (s(), u("div", $2, [
                      d("div", M2, [
                        d("p", S2, [
                          P(p.$slots, "app-icon", { classList: "flex items-center w-4 h-4 my-auto shrink-0" }, () => [
                            e.hideAppIcon ? S("", !0) : (s(), u("span", D2, [
                              e.appUrl ? (s(), u("a", {
                                key: 0,
                                href: e.appUrl,
                                onClick: F[4] || (F[4] = (O) => L(null, { title: e.appName, href: e.appUrl }, O))
                              }, [
                                e.appIconUrl ? (s(), u("img", {
                                  key: 0,
                                  src: e.appIconUrl,
                                  alt: e.appName,
                                  class: "w-4 h-4"
                                }, null, 8, T2)) : (s(), G(T, {
                                  key: 1,
                                  class: "w-4 h-4 text-blue-400"
                                })),
                                d("span", B2, A(e.appName), 1)
                              ], 8, z2)) : (s(), u(J, { key: 1 }, [
                                e.appIconUrl ? (s(), u("img", {
                                  key: 0,
                                  src: e.appIconUrl,
                                  alt: e.appName,
                                  class: "w-4 h-4"
                                }, null, 8, L2)) : (s(), G(T, {
                                  key: 1,
                                  class: "w-4 h-4 text-blue-400"
                                })),
                                d("span", I2, A(e.appName), 1)
                              ], 64))
                            ]))
                          ]),
                          e.appUrl && e.appName ? (s(), u("a", {
                            key: 0,
                            href: e.appUrl,
                            class: "my-auto hover:underline",
                            onClick: F[5] || (F[5] = (O) => L(null, { title: e.appName, href: e.appUrl }, O))
                          }, A(e.appName), 9, V2)) : e.appName ? (s(), u("span", A2, A(e.appName), 1)) : S("", !0)
                        ])
                      ])
                    ])) : S("", !0),
                    e.sidebarNavigationItems.length > 0 ? (s(), u("nav", H2, [
                      P(p.$slots, "mobile-sidebar-navigation", {
                        items: e.sidebarNavigationItems,
                        collapsed: l.value
                      }, () => [
                        (s(!0), u(J, null, le(e.sidebarNavigationItems, (O) => (s(), u(J, {
                          key: O.id
                        }, [
                          O.items ? (s(), u(J, { key: 0 }, [
                            d("button", {
                              href: O.href,
                              class: D(["flex items-center relative w-full gap-2 pl-2 px-3 py-2 border-l-4", {
                                "border-transparent text-gray-700 hover:text-gray-900 dark:text-gray-300 dark:hover:text-gray-100 hover:bg-gray-50 dark:hover:bg-gray-800": !k(O) || w(O),
                                "border-red-600 bg-gray-25 dark:bg-gray-900 hover:bg-gray-50 dark:hover:bg-gray-800": k(O) && !w(O)
                              }]),
                              onClick: (_) => x(O)
                            }, [
                              P(p.$slots, "mobile-sidebar-navigation-item-icon", {
                                item: O,
                                classList: "flex items-center w-4 h-4 my-auto shrink-0"
                              }, () => [
                                e.hideSidebarIcons ? S("", !0) : (s(), u("span", P2, [
                                  O.iconUrl ? (s(), u("img", {
                                    key: 0,
                                    src: O.iconUrl,
                                    alt: O.title,
                                    class: "w-4 h-4"
                                  }, null, 8, F2)) : (s(), G(j, {
                                    key: 1,
                                    class: "w-4 h-4"
                                  })),
                                  d("span", E2, A(O.title), 1)
                                ]))
                              ]),
                              d("span", R2, A(O.title), 1),
                              C(O) && !w(O) ? (s(), u("span", N2, [
                                d("span", W2, A(C(O)), 1)
                              ])) : S("", !0),
                              w(O) ? (s(), G(X, {
                                key: 1,
                                class: "shrink-0 w-4 h-4 ml-auto my-auto"
                              })) : (s(), G(pe, {
                                key: 2,
                                class: "shrink-0 w-4 h-4 ml-auto my-auto"
                              }))
                            ], 10, O2),
                            w(O) ? (s(!0), u(J, { key: 0 }, le(O.items, (_) => (s(), u("a", {
                              key: _.id,
                              href: _.href,
                              class: D(["flex relative gap-2 px-3 py-2 border-l-4 group", {
                                "border-transparent text-gray-700 hover:text-gray-900 dark:text-gray-300 dark:hover:text-gray-100 hover:bg-gray-50 dark:hover:bg-gray-800": !_.active,
                                "border-red-600 bg-gray-25 dark:bg-gray-900 hover:bg-gray-50 dark:hover:bg-gray-800": _.active,
                                "pl-8": !e.hideSidebarIcons,
                                "pl-4": e.hideSidebarIcons
                              }]),
                              onClick: (oe) => L(O, _, oe)
                            }, [
                              d("span", Y2, A(_.title), 1),
                              _.badgeCount ? (s(), u("span", j2, [
                                d("span", G2, A(_.badgeCount), 1)
                              ])) : S("", !0),
                              !l.value && _.keyboardShortcut && _.keyboardShortcut?.length ? (s(), u("span", U2, [
                                (s(!0), u(J, null, le(_.keyboardShortcut, (oe, K) => (s(), u("kbd", {
                                  key: K,
                                  class: "inline-block bg-white border border-gray-100 group-hover:border-gray-200 rounded-sm p-1.5 text-xs text-gray-700 group-hover:text-gray-900 font-semibold leading-none",
                                  innerHTML: oe
                                }, null, 8, K2))), 128))
                              ])) : S("", !0)
                            ], 10, q2))), 128)) : S("", !0)
                          ], 64)) : (s(), u("a", {
                            key: 1,
                            href: O.href,
                            class: D(["flex relative gap-2 pl-2 px-3 py-2 border-l-4 group", {
                              "border-transparent hover:bg-gray-50 dark:hover:bg-gray-800": !O.active,
                              "border-red-600 bg-gray-25 dark:bg-gray-900 hover:bg-gray-50 dark:hover:bg-gray-800": O.active
                            }]),
                            onClick: (_) => L(null, O, _)
                          }, [
                            P(p.$slots, "mobile-sidebar-navigation-item-icon", {
                              item: O,
                              classList: "flex items-center w-4 h-4 my-auto shrink-0"
                            }, () => [
                              e.hideSidebarIcons ? S("", !0) : (s(), u("span", Q2, [
                                O.iconUrl ? (s(), u("img", {
                                  key: 0,
                                  src: O.iconUrl,
                                  alt: O.title,
                                  class: "w-4 h-4"
                                }, null, 8, X2)) : (s(), G(j, {
                                  key: 1,
                                  class: "w-4 h-4"
                                })),
                                d("span", J2, A(O.title), 1)
                              ]))
                            ]),
                            d("span", _2, A(O.title), 1),
                            O.badgeCount ? (s(), u("span", eh, [
                              d("span", th, A(O.badgeCount), 1)
                            ])) : S("", !0),
                            !l.value && O.keyboardShortcut && O.keyboardShortcut?.length ? (s(), u("span", ah, [
                              (s(!0), u(J, null, le(O.keyboardShortcut, (_, oe) => (s(), u("kbd", {
                                key: oe,
                                class: "inline-block bg-white border border-gray-100 group-hover:border-gray-200 rounded-sm p-1.5 text-xs text-gray-700 group-hover:text-gray-900 font-semibold leading-none",
                                innerHTML: _
                              }, null, 8, nh))), 128))
                            ])) : S("", !0)
                          ], 10, Z2))
                        ], 64))), 128))
                      ]),
                      I("user-section") ? (s(), u("div", lh, [
                        d("div", rh, [
                          P(p.$slots, "user-section", { collapsed: l.value })
                        ])
                      ])) : S("", !0)
                    ])) : S("", !0)
                  ])
                ])
              ], 544)) : S("", !0)
            ]),
            _: 3
          }),
          d("aside", {
            "aria-label": "desktop sidebar",
            class: D(["hidden md:block bg-white dark:bg-gray-950 border-r border-gray-200 dark:border-gray-800 shrink-0 z-50", [r(g)]])
          }, [
            d("div", oh, [
              d("header", sh, [
                d("div", ih, [
                  d("div", dh, [
                    e.appSuite && !l.value ? (s(), u("h1", uh, [
                      e.appSuiteUrl ? (s(), u("a", {
                        key: 0,
                        href: e.appSuiteUrl,
                        class: "flex hover:underline",
                        onClick: F[7] || (F[7] = (O) => L(null, { title: e.appSuite, href: e.appSuiteUrl }, O))
                      }, [
                        d("span", fh, A(e.appSuitePrefix), 1),
                        d("span", null, A(e.appSuite), 1)
                      ], 8, ch)) : (s(), u("p", hh, [
                        d("span", mh, A(e.appSuitePrefix), 1),
                        d("span", null, A(e.appSuite), 1)
                      ]))
                    ])) : S("", !0),
                    e.enableCollapsibleSidebar ? (s(), u("div", gh, [
                      d("button", {
                        id: "btn-collapse-toggle",
                        title: l.value ? "Expand sidebar ( [ )" : "Collapse sidebar ( [ )",
                        class: D(["btn btn-ghost btn-sm px-1 py-1 text-gray-700 dark:text-gray-300", { "w-full": l.value, "w-auto": !l.value }]),
                        onClick: z
                      }, [
                        l.value ? (s(), G(H, {
                          key: 0,
                          class: "w-4 h-4 mx-auto"
                        })) : (s(), G(Y, {
                          key: 1,
                          class: "w-4 h-4 mx-auto"
                        }))
                      ], 10, vh)
                    ])) : S("", !0)
                  ]),
                  e.appSuite || e.appName ? (s(), u("button", {
                    key: 0,
                    ref_key: "mobileMenuOpenBtn",
                    ref: c,
                    "aria-label": "Open mobile menu",
                    class: "flex md:hidden gap-1 focus:outline-hidden",
                    onClick: F[8] || (F[8] = (O) => i.value = !r(i))
                  }, [
                    Q(R, { class: "text-white h-6 w-6" }),
                    d("span", yh, [
                      e.appSuitePrefix ? (s(), u("span", bh, A(e.appSuitePrefix), 1)) : S("", !0),
                      e.appSuite ? (s(), u("span", ph, A(e.appSuite), 1)) : S("", !0),
                      e.appName && !e.hideAppNameInMobileHeader ? (s(), u("span", {
                        key: 2,
                        class: D(["text-sm text-left font-bold text-gray-200 text-ellipsis overflow-hidden whitespace-nowrap w-40 mt-auto mr-auto", [e.appSuite ? "ml-1" : ""]])
                      }, A(e.appName), 3)) : S("", !0)
                    ])
                  ], 512)) : S("", !0),
                  e.appName ? (s(), u("div", wh, [
                    e.appName ? (s(), u("p", xh, [
                      P(p.$slots, "app-icon", { classList: "flex items-center w-4 h-4 my-auto shrink-0" }, () => [
                        e.hideAppIcon ? S("", !0) : (s(), u("span", {
                          key: 0,
                          class: D(["flex items-center w-4 h-4 my-auto shrink-0", { "mx-auto": l.value }])
                        }, [
                          e.appUrl ? (s(), u("a", {
                            key: 0,
                            href: e.appUrl,
                            onClick: F[9] || (F[9] = (O) => L(null, { title: e.appName, href: e.appUrl }, O))
                          }, [
                            e.appIconUrl ? (s(), u("img", {
                              key: 0,
                              src: e.appIconUrl,
                              alt: e.appName,
                              class: "w-4 h-4"
                            }, null, 8, Ch)) : (s(), G(T, {
                              key: 1,
                              class: "w-4 h-4 text-blue-400"
                            })),
                            d("span", $h, A(e.appName), 1)
                          ], 8, kh)) : (s(), u(J, { key: 1 }, [
                            e.appIconUrl ? (s(), u("img", {
                              key: 0,
                              src: e.appIconUrl,
                              alt: e.appName,
                              class: "w-4 h-4"
                            }, null, 8, Mh)) : (s(), G(T, {
                              key: 1,
                              class: "w-4 h-4 text-blue-400"
                            })),
                            d("span", Sh, A(e.appName), 1)
                          ], 64))
                        ], 2))
                      ]),
                      e.appUrl && e.appName ? (s(), u("a", {
                        key: 0,
                        href: e.appUrl,
                        class: D(["my-auto hover:underline", { "sr-only": e.enableCollapsibleSidebar && l.value }]),
                        onClick: F[10] || (F[10] = (O) => L(null, { title: e.appName, href: e.appUrl }, O))
                      }, A(e.appName), 11, Dh)) : e.appName ? (s(), u("span", {
                        key: 1,
                        class: D(["my-auto", { "sr-only": e.enableCollapsibleSidebar && l.value }])
                      }, A(e.appName), 3)) : S("", !0)
                    ])) : S("", !0)
                  ])) : S("", !0)
                ])
              ]),
              d("div", zh, [
                e.sidebarNavigationItems.length > 0 ? (s(), u("nav", Th, [
                  P(p.$slots, "sidebar-navigation", {
                    items: e.sidebarNavigationItems,
                    collapsed: l.value
                  }, () => [
                    (s(!0), u(J, null, le(e.sidebarNavigationItems, (O) => (s(), u(J, {
                      key: O.id
                    }, [
                      O.items ? (s(), u(J, { key: 0 }, [
                        Q(it, {
                          placement: "right",
                          disabled: !l.value
                        }, {
                          trigger: U(() => [
                            d("button", {
                              href: O.href,
                              class: D(["flex item-center relative w-full gap-2 pl-2 px-3 py-2 border-l-4", {
                                "border-transparent text-gray-700 hover:text-gray-900 dark:text-gray-300 dark:hover:text-gray-100 hover:bg-gray-50 dark:hover:bg-gray-800": !k(O) || w(O),
                                "border-red-600 bg-gray-25 dark:bg-gray-900 hover:bg-gray-50 dark:hover:bg-gray-800": k(O) && (!w(O) || l.value)
                              }]),
                              onClick: (_) => x(O)
                            }, [
                              P(p.$slots, "sidebar-navigation-item-icon", {
                                item: O,
                                classList: "flex items-center w-4 h-4 my-auto shrink-0"
                              }, () => [
                                e.hideSidebarIcons ? S("", !0) : (s(), u("span", {
                                  key: 0,
                                  class: D(["flex items-center w-4 h-4 my-auto shrink-0", { "mx-auto": l.value }])
                                }, [
                                  O.iconUrl ? (s(), u("img", {
                                    key: 0,
                                    src: O.iconUrl,
                                    alt: O.title,
                                    class: "w-4 h-4"
                                  }, null, 8, Lh)) : (s(), G(j, {
                                    key: 1,
                                    class: "w-4 h-4"
                                  })),
                                  d("span", Ih, A(O.title), 1)
                                ], 2))
                              ]),
                              l.value ? S("", !0) : (s(), u("span", Vh, A(O.title), 1)),
                              C(O) && !w(O) ? (s(), u("span", {
                                key: 1,
                                class: D(["inline-block my-auto", {
                                  "absolute bottom-1 right-3": l.value
                                }])
                              }, [
                                l.value ? (s(), u("span", Hh, [
                                  d("span", Oh, A(C(O)), 1)
                                ])) : (s(), u("span", Ah, A(C(O)), 1))
                              ], 2)) : S("", !0),
                              !l.value && w(O) ? (s(), G(X, {
                                key: 2,
                                class: "shrink-0 w-4 h-4 ml-auto my-auto"
                              })) : l.value ? S("", !0) : (s(), G(pe, {
                                key: 3,
                                class: "shrink-0 w-4 h-4 ml-auto my-auto"
                              }))
                            ], 10, Bh)
                          ]),
                          default: U(() => [
                            d("p", null, A(O.title), 1)
                          ]),
                          _: 2
                        }, 1032, ["disabled"]),
                        !l.value && w(O) ? (s(!0), u(J, { key: 0 }, le(O.items, (_) => (s(), u("a", {
                          key: _.id,
                          href: _.href,
                          class: D(["flex relative gap-2 px-3 py-2 border-l-4 group", {
                            "border-transparent text-gray-700 hover:text-gray-900 dark:text-gray-300 dark:hover:text-gray-100 hover:bg-gray-50 dark:hover:bg-gray-800": !_.active,
                            "border-red-600 bg-gray-25 dark:bg-gray-900 hover:bg-gray-50 dark:hover:bg-gray-800": _.active,
                            "pl-8": !e.hideSidebarIcons,
                            "pl-4": e.hideSidebarIcons
                          }]),
                          onClick: (oe) => L(O, _, oe)
                        }, [
                          d("span", Fh, A(_.title), 1),
                          _.badgeCount ? (s(), u("span", Eh, [
                            d("span", Rh, A(_.badgeCount), 1)
                          ])) : S("", !0),
                          !l.value && _.keyboardShortcut && _.keyboardShortcut?.length ? (s(), u("span", Nh, [
                            (s(!0), u(J, null, le(_.keyboardShortcut, (oe, K) => (s(), u("kbd", {
                              key: K,
                              class: "inline-block bg-white border border-gray-100 group-hover:border-gray-200 rounded-sm p-1.5 text-xs text-gray-700 group-hover:text-gray-900 font-semibold leading-none",
                              innerHTML: oe
                            }, null, 8, Wh))), 128))
                          ])) : S("", !0)
                        ], 10, Ph))), 128)) : S("", !0)
                      ], 64)) : (s(), G(it, {
                        key: 1,
                        placement: "right",
                        disabled: !l.value
                      }, {
                        trigger: U(() => [
                          d("a", {
                            href: O.href,
                            class: D(["flex relative gap-2 pl-2 px-3 py-2 border-l-4 group", {
                              "border-transparent text-gray-700 hover:text-gray-900 dark:text-gray-300 dark:hover:text-gray-100 hover:bg-gray-50 dark:hover:bg-gray-800": !O.active,
                              "border-red-600 bg-gray-25 dark:bg-gray-900 hover:bg-gray-50 dark:hover:bg-gray-800": O.active
                            }]),
                            onClick: (_) => L(null, O, _)
                          }, [
                            P(p.$slots, "sidebar-navigation-item-icon", {
                              item: O,
                              classList: "flex items-center w-4 h-4 my-auto shrink-0"
                            }, () => [
                              e.hideSidebarIcons ? S("", !0) : (s(), u("span", {
                                key: 0,
                                class: D(["flex items-center w-4 h-4 my-auto shrink-0", { "mx-auto": l.value }])
                              }, [
                                O.iconUrl ? (s(), u("img", {
                                  key: 0,
                                  src: O.iconUrl,
                                  alt: O.title,
                                  class: "w-4 h-4"
                                }, null, 8, Yh)) : (s(), G(j, {
                                  key: 1,
                                  class: "w-4 h-4"
                                })),
                                d("span", jh, A(O.title), 1)
                              ], 2))
                            ]),
                            l.value ? S("", !0) : (s(), u("span", Gh, A(O.title), 1)),
                            O.badgeCount ? (s(), u("span", {
                              key: 1,
                              class: D(["inline-block my-auto", {
                                "absolute bottom-1 right-3": l.value
                              }])
                            }, [
                              l.value ? (s(), u("span", Kh, [
                                d("span", Zh, A(O.badgeCount), 1)
                              ])) : (s(), u("span", Uh, A(O.badgeCount), 1))
                            ], 2)) : S("", !0),
                            !l.value && O.keyboardShortcut && O.keyboardShortcut?.length ? (s(), u("span", Qh, [
                              (s(!0), u(J, null, le(O.keyboardShortcut, (_, oe) => (s(), u("kbd", {
                                key: oe,
                                class: "inline-block bg-white border border-gray-100 group-hover:border-gray-200 rounded-sm p-1.5 font-sans text-xs text-gray-700 group-hover:text-gray-900 font-semibold leading-none",
                                innerHTML: _
                              }, null, 8, Xh))), 128))
                            ])) : S("", !0)
                          ], 10, qh)
                        ]),
                        default: U(() => [
                          d("p", null, A(O.title), 1)
                        ]),
                        _: 2
                      }, 1032, ["disabled"]))
                    ], 64))), 128))
                  ])
                ])) : S("", !0)
              ]),
              I("user-section") ? (s(), u("div", Jh, [
                P(p.$slots, "user-section", { collapsed: l.value })
              ])) : S("", !0)
            ])
          ], 2),
          d("div", _h, [
            d("main", em, [
              e.hidePageHeader ? S("", !0) : (s(), u("div", tm, [
                d("div", am, [
                  P(p.$slots, "page-title", { classList: "text-xl font-light text-gray-900 dark:text-gray-100" }, () => [
                    d("p", nm, A(e.pageTitle), 1)
                  ])
                ]),
                I("page-header") ? (s(), u("div", lm, [
                  P(p.$slots, "page-header")
                ])) : S("", !0)
              ])),
              d("div", rm, [
                P(p.$slots, "default")
              ])
            ]),
            d("footer", null, [
              I("footer-top") ? (s(), u("div", om, [
                P(p.$slots, "footer-top")
              ])) : S("", !0),
              F[15] || (F[15] = d("hr", { class: "mx-4 border-t border-gray-200 dark:border-gray-800" }, null, -1)),
              d("div", sm, [
                d("div", im, [
                  Q(ma, {
                    href: "https://sei.cmu.edu",
                    title: "Software Engineering Institute",
                    class: "my-auto",
                    external: ""
                  }, {
                    default: U(() => [
                      Q(ga, { class: "h-10 text-black dark:text-white" }),
                      F[13] || (F[13] = d("span", { class: "sr-only" }, "Software Engineering Institute", -1))
                    ]),
                    _: 1
                  })
                ]),
                I("footer-middle") ? (s(), u("div", dm, [
                  d("div", um, [
                    P(p.$slots, "footer-middle")
                  ])
                ])) : S("", !0),
                d("div", cm, [
                  d("div", fm, [
                    P(p.$slots, "footer-right", { year: r(m) }, () => [
                      d("div", hm, [
                        d("p", mm, " © " + A(r(m)) + " Carnegie Mellon University ", 1),
                        F[14] || (F[14] = d("p", { class: "ml-auto" }, " Proprietary. SEI Internal Use Only ", -1))
                      ])
                    ])
                  ])
                ])
              ])
            ]),
            Q(Qe, {
              "enter-active-class": "transition-transform ease-in-out delay-250 duration-250",
              "enter-from-class": "translate-y-full",
              "enter-to-class": "translate-y-0",
              appear: ""
            }, {
              default: U(() => [
                !e.hideActionBar && I("action-bar") ? (s(), u("aside", gm, [
                  d("div", vm, [
                    P(p.$slots, "action-bar")
                  ])
                ])) : S("", !0)
              ]),
              _: 3
            })
          ])
        ])
      ]);
    };
  }
});
yn.install = (e) => {
  e.component(yn.name, yn);
};
const ym = {
  "data-id": "sds-simple-application",
  class: "flex flex-col h-screen dark:text-gray-50"
}, bm = { class: "bg-white dark:bg-gray-950 border-b border-gray-100 dark:border-gray-800 px-4 py-2 flex shrink-0" }, pm = { class: "my-auto" }, wm = {
  key: 0,
  class: "block"
}, xm = ["href"], km = { class: "text-red-600 dark:text-red-400 font-bold" }, Cm = {
  key: 1,
  class: "flex"
}, $m = { class: "text-red-600 dark:text-red-400 font-bold" }, Mm = { class: "ml-auto my-auto items-center flex gap-2 shrink-0" }, Sm = { class: "flex grow shrink-0" }, Dm = { class: "bg-gray-25 dark:bg-black flex flex-col items-stretch grow min-w-0" }, zm = { class: "grow pb-4" }, Tm = {
  key: 0,
  class: "bg-white dark:bg-gray-900 border-b border-gray-200 dark:border-gray-800 px-4 py-3 sticky top-0 z-40 flex flex-col gap-4 md:flex-row"
}, Bm = { class: "grow my-auto flex flex-row gap-2" }, Lm = { class: "text-xl font-light text-gray-900 dark:text-gray-100" }, Im = {
  key: 0,
  class: "shrink-0 my-auto flex flex-col md:flex-row gap-2"
}, Vm = { class: "p-4" }, Am = {
  key: 0,
  class: "p-4"
}, Hm = { class: "text-xs p-4 flex flex-col lg:flex-row gap-4 pt-4" }, Om = { class: "shrink-0 flex order-2 lg:order-1" }, Pm = {
  key: 0,
  class: "shrink flex lg:mx-auto order-1 lg:order-2"
}, Fm = { class: "my-auto" }, Em = { class: "shrink-0 flex lg:ml-auto order-3" }, Rm = { class: "my-auto" }, Nm = { class: "flex flex-col" }, Wm = { class: "ml-auto" }, qm = {
  key: 0,
  class: "bg-blue-500 text-white dark:bg-blue-700 p-4 sticky bottom-0 z-40"
}, Ym = { class: "flex flex-col md:flex-row gap-2 items-stretch md:items-center" }, bn = /* @__PURE__ */ te({
  name: "SdsSimpleApplication",
  __name: "SimpleApplication",
  props: {
    appSuitePrefix: { default: "SEI" },
    appSuite: { default: null },
    appSuiteUrl: { default: null },
    appName: { default: null },
    pageTitle: { default: null },
    hidePageHeader: { type: Boolean, default: !1 },
    hideActionBar: { type: Boolean, default: !1 }
  },
  emits: ["navigate"],
  setup(e, { emit: a }) {
    const t = Qt(), n = a, l = M(() => (/* @__PURE__ */ new Date()).getFullYear()), o = (h) => !!t[h], i = (h, c, f) => {
      n("navigate", { group: h, item: c, event: f });
    };
    return (h, c) => (s(), u("div", ym, [
      d("header", bm, [
        d("div", pm, [
          e.appSuite ? (s(), u("h1", wm, [
            e.appSuiteUrl ? (s(), u("a", {
              key: 0,
              href: e.appSuiteUrl,
              class: "flex hover:underline",
              onClick: c[0] || (c[0] = (f) => i(null, { title: e.appSuite, href: e.appSuiteUrl }, f))
            }, [
              d("span", km, A(e.appSuitePrefix), 1),
              d("span", null, A(e.appSuite), 1)
            ], 8, xm)) : (s(), u("p", Cm, [
              d("span", $m, A(e.appSuitePrefix), 1),
              d("span", null, A(e.appSuite), 1)
            ]))
          ])) : S("", !0)
        ]),
        d("div", Mm, [
          P(h.$slots, "user-section")
        ])
      ]),
      d("div", Sm, [
        d("div", Dm, [
          d("main", zm, [
            e.hidePageHeader ? S("", !0) : (s(), u("div", Tm, [
              d("div", Bm, [
                P(h.$slots, "page-title", { classList: "text-xl font-light text-gray-900 dark:text-gray-100" }, () => [
                  d("p", Lm, A(e.pageTitle), 1)
                ])
              ]),
              o("page-header") ? (s(), u("div", Im, [
                P(h.$slots, "page-header")
              ])) : S("", !0)
            ])),
            d("div", Vm, [
              P(h.$slots, "default")
            ])
          ]),
          d("footer", null, [
            o("footer-top") ? (s(), u("div", Am, [
              P(h.$slots, "footer-top")
            ])) : S("", !0),
            c[3] || (c[3] = d("hr", { class: "mx-4 border-t border-gray-200 dark:border-gray-800" }, null, -1)),
            d("div", Hm, [
              d("div", Om, [
                Q(ma, {
                  href: "https://sei.cmu.edu",
                  title: "Software Engineering Institute",
                  class: "my-auto text-black dark:text-white",
                  external: ""
                }, {
                  default: U(() => [
                    Q(ga, { class: "h-10 text-black dark:text-white" }),
                    c[1] || (c[1] = d("span", { class: "sr-only" }, "Software Engineering Institute", -1))
                  ]),
                  _: 1
                })
              ]),
              o("footer-middle") ? (s(), u("div", Pm, [
                d("div", Fm, [
                  P(h.$slots, "footer-middle")
                ])
              ])) : S("", !0),
              d("div", Em, [
                d("div", Rm, [
                  P(h.$slots, "footer-right", { year: r(l) }, () => [
                    d("div", Nm, [
                      d("p", Wm, " © " + A(r(l)) + " Carnegie Mellon University ", 1),
                      c[2] || (c[2] = d("p", { class: "ml-auto" }, " Proprietary. SEI Internal Use Only ", -1))
                    ])
                  ])
                ])
              ])
            ])
          ]),
          Q(Qe, {
            "enter-active-class": "transition-transform ease-in-out delay-250 duration-250",
            "enter-from-class": "translate-y-full",
            "enter-to-class": "translate-y-0",
            appear: ""
          }, {
            default: U(() => [
              !e.hideActionBar && o("action-bar") ? (s(), u("aside", qm, [
                d("div", Ym, [
                  P(h.$slots, "action-bar")
                ])
              ])) : S("", !0)
            ]),
            _: 3
          })
        ])
      ])
    ]));
  }
});
bn.install = (e) => {
  e.component(bn.name, bn);
};
const jm = {
  "data-id": "sds-brochure-site-wordmark",
  viewBox: "0 0 728.14 64.49"
}, Ea = /* @__PURE__ */ te({
  name: "SdsBrochureSiteWordmark",
  __name: "BrochureSiteWordmark",
  setup(e) {
    return (a, t) => (s(), u("svg", jm, [...t[0] || (t[0] = [
      $l('<polygon class="cls-1" points="213.53 18.71 213.53 45.54 218 45.54 218 47.31 200.12 47.31 200.12 45.54 204.59 45.54 204.59 20.6 201.12 20.6 201.12 18.71 213.53 18.71"></polygon><path class="cls-1" d="M36.93,1.38H35.31c-.07,1.38-.79,2-2.17,2C30.38,3.35,26.35,0,21.62,0,8.15,0,0,13.27,0,25S7.75,48.37,20.76,48.37c7.88,0,10.84-3.75,12.94-3.75,1.38,0,1.63,1.22,1.63,2.69h1.78V31.21H35.34l-.39,2.23C34,38.77,29.9,46.63,21.42,46.63,13.93,46.63,11,40.15,11,24.18,11,7.43,15,1.79,21.62,1.79c7.49,0,12.64,8.4,13.69,15.1h1.62Z"></path><path class="cls-1" d="M60,39.6c-.13,3.44-2.07,6.25-5.12,6.25-4.41,0-4.6-3.72-4.6-6.56,0-3.44.39-5.7,4.6-6.16L60,32.61ZM71.8,41.74c0,1.68-1.11,3.63-1.84,3.63-1.17,0-1.43-1.23-1.43-3.24V27.22c0-7.39-6.94-9.2-13.61-9.2-6.48,0-11.21,3.17-11.21,6.8A3.91,3.91,0,0,0,47.92,29a3.69,3.69,0,0,0,4-3.89c0-3.3-3.42-3.34-3.42-3.42,0-1.47,3.81-1.94,6-1.94,4.86,0,5.51,1.79,5.51,5.68v5.44l-6.35.52c-5.9.45-12.32,2-12.32,8.75,0,5.64,5.06,7.91,10,7.91,2.53,0,7-1,8.69-4.08a6.65,6.65,0,0,0,6.48,4.08c4.21,0,6.93-2.53,6.93-6.35Z"></path><polygon class="cls-1" points="674.53 18.61 674.53 45.45 679 45.45 679 47.22 661.11 47.22 661.11 45.45 665.58 45.45 665.58 20.5 661.11 20.5 661.11 18.61 674.53 18.61"></polygon><path class="cls-1" d="M286,32.45,296.7,1.73h14.81l0,1.83h-4.24v42h4.24v1.79H293.68V45.53H298V4h-.13l-15.1,43.29H281L265.53,3.25h-.13V40c0,5.25,1.36,5.53,4.86,5.53h.2v1.79H259.25V45.53h0c3.7,0,4.39-2.16,4.39-4.95v-37h-4.39V1.69h16.26Z"></path><path class="cls-1" d="M321.83,29.87V25.52c0-4.34,1.88-5.7,4.08-5.7,3.11,0,4.08,2.14,4.08,5.7v4.36Zm0,1.76h17.89c-.07-7-6.55-13.74-13.35-13.61-7.65,0-14.26,6.61-14.26,15.36,0,8.43,6.16,14.71,14.45,14.71,8,0,11.93-4.93,13.35-11.34h-1.77c-1.42,6-4.59,9.45-9.64,9.45-6,0-6.68-4.72-6.68-9.13Z"></path><path class="cls-1" d="M591.08,29.77V25.41c0-4.34,1.88-5.7,4.08-5.7,3.11,0,4.08,2.14,4.08,5.7v4.36Zm0,1.76H609c-.07-7-6.55-13.74-13.35-13.61-7.65,0-14.26,6.61-14.26,15.36,0,8.43,6.16,14.71,14.45,14.71,8,0,11.93-4.93,13.35-11.34H607.4c-1.42,6-4.59,9.45-9.64,9.45-6,0-6.68-4.72-6.68-9.13Z"></path><polygon class="cls-1" points="339.83 1.79 339.83 3.44 344.31 3.44 344.31 45.48 339.83 45.48 339.83 47.32 357.72 47.32 357.72 45.48 353.25 45.48 353.25 1.79 339.83 1.79"></polygon><polygon class="cls-1" points="358.97 1.79 358.97 3.44 363.44 3.44 363.44 45.48 358.97 45.48 358.97 47.32 376.86 47.32 376.86 45.48 372.39 45.48 372.39 1.79 358.97 1.79"></polygon><path class="cls-1" d="M397.43,39.47c0,4.86-2,6.87-5.31,6.87s-5.31-2-5.31-6.87V26.71c0-4.86,2-6.87,5.31-6.87s5.31,2,5.31,6.87Zm10.11-6.41c0-8.88-6.87-15-15.42-15s-15.42,6.16-15.42,15,6.87,15,15.42,15,15.42-6.16,15.42-15"></path><path class="cls-1" d="M454.05,3.28h4.53V32.07c0,10,6.93,16.14,17.5,16.14,11.93,0,17.11-6.29,17.11-15.81V7.78c0-3.76,1-4.5,3.37-4.5h1.31V1.54h-11.4V3.28h.82c3.3,0,3.76,1,3.76,4.76V33c0,8.82-5.47,12.83-11,12.83-9.46,0-11.34-6.35-11.9-14.65V3.28h4.25V1.54H454.05Z"></path><path class="cls-1" d="M566.34,47.95h1.75l9.59-22.68c1.94-4.24,3-4.77,4.47-4.84h.58V18.65H572.62v1.79h1.23c1.88,0,2.74-.12,2.74,1.56a10.5,10.5,0,0,1-1.1,3.94l-4.4,10.37L564,20.45h3.6V18.65H551.37v1.79h3Z"></path><path class="cls-1" d="M638.55,47.95h1.54a2.07,2.07,0,0,1,2.29-1.55c1.69,0,3.7,1.55,7.32,1.55a10.57,10.57,0,0,0,10.37-10.63c0-7.91-5.44-8.49-12.38-9.46-3.63-.52-5.68-1-5.68-3.89,0-3,2.66-4.32,6.16-4.32,4.86,0,6.75,3.22,8.36,7.44h1.53v-9.2h-1.47c0,.78-.67,1.43-1.9,1.43-2.08,0-3.76-1.43-6.74-1.43a9.63,9.63,0,0,0-9.66,9.66c0,8.36,6.35,9.08,11.28,9.66,4.67.58,6.35.88,6.35,3.86,0,3.43-2.85,5-6.35,5-4.92,0-8.31-4.26-9.48-9h-1.54Z"></path><polygon class="cls-1" points="549 18.61 549 45.45 553.47 45.45 553.47 47.22 535.58 47.22 535.58 45.45 540.05 45.45 540.05 20.5 535.58 20.5 535.58 18.61 549 18.61"></polygon><path class="cls-1" d="M540.06,9.67a4.46,4.46,0,1,0,4.46-4.47,4.45,4.45,0,0,0-4.46,4.47"></path><path class="cls-1" d="M665.57,9.67A4.46,4.46,0,1,0,670,5.2a4.45,4.45,0,0,0-4.46,4.47"></path><path class="cls-1" d="M149.79,29.86V25.51c0-4.34,1.88-5.7,4.08-5.7,3.11,0,4.08,2.14,4.08,5.7v4.35Zm0,1.76h17.89c-.07-7-6.55-13.74-13.35-13.61-7.65,0-14.26,6.61-14.26,15.36,0,8.43,6.16,14.71,14.45,14.71,8,0,11.93-4.93,13.35-11.34H166.1c-1.42,6-4.59,9.45-9.64,9.45-6,0-6.68-4.72-6.68-9.13Z"></path><path class="cls-1" d="M228,29.86V25.51c0-4.34,1.88-5.7,4.08-5.7s4.08,1.34,4.08,5.7v4.35Zm0,1.76h17.89c-.07-7-6.55-13.74-13.35-13.61-7.65,0-14.26,6.61-14.26,15.36,0,8.43,6.16,14.71,14.45,14.71,8,0,11.93-4.93,13.35-11.34h-1.77c-1.42,6-4.59,9.45-9.64,9.45-6,0-6.68-4.72-6.68-9.13Z"></path><path class="cls-1" d="M529.84,45.46V28c0-7-3-10.27-9.14-10.27-4.35,0-8.75,2.49-10.5,6.25h0V18.7H496.79v1.75h4.47v25h-4.47v1.75H514V45.46H510.2V28.36c.56-2.41,3.61-8,7.15-8,2.35,0,3.55.81,3.55,5.16v19.9h-3.7v1.75h17.11V45.46Z"></path><path class="cls-1" d="M420.93,18.8v5.25h0c1.75-3.76,6.15-6.25,10.5-6.25,6.16,0,9.14,3.27,9.14,10.27v17.5H445v1.75H427.93V45.57h3.7V25.67c0-4.35-1.19-5.16-3.55-5.16-3.54,0-6.59,5.55-7.15,8v17.1h3.83v1.75H407.52V45.57H412v-25h-4.47V18.8Z"></path><path class="cls-1" d="M135.52,45.56V28.06c0-7-3-10.27-9.14-10.27-4.35,0-8.75,2.49-10.5,6.25h0V18.79H102.47v1.75h4.47v25h-4.47v1.75h17.24V45.56h-3.83V28.46c.56-2.41,3.61-8,7.15-8,2.35,0,3.55.81,3.55,5.16v19.9h-3.7v1.75H140V45.56Z"></path><path class="cls-1" d="M204.62,9.84a4.46,4.46,0,1,0,4.46-4.47,4.45,4.45,0,0,0-4.46,4.47"></path><path class="cls-1" d="M718,18.62V20.5c2.76,0,4,.25,4,1.5a10.5,10.5,0,0,1-1.1,3.94l-4.4,10.37-7-15.81h3.68V18.62H690.81V4.72h-1.17c0,6.87-4.67,13.93-11.21,13.93v1.85h3.44V40.56A7.1,7.1,0,0,0,689,47.95a9.22,9.22,0,0,0,8.62-5l-1.39-.76c-.78,1.17-1.81,2.72-3.43,2.72-1.3,0-2-.92-2-3.06V20.51h9l11.84,27.31-4.1,9.65v0h0a.55.55,0,0,1-.49.32.54.54,0,0,1-.51-.37v0a4.46,4.46,0,1,0-6.3,5.18h0l.14.06.26.12a4.51,4.51,0,0,0,1.63.34c3.76.32,5.69-2.46,7-5.29.3-.64.57-1.29.83-1.9.57-1.37,1.56-3.73,2.73-6.48h0L714,46.82h0l9.12-21.55c1.94-4.24,2.69-4.78,5-4.78h0V18.62Z"></path><path class="cls-1" d="M95.94,17.71a9.29,9.29,0,0,0-8.56,6.09h-.13V18.87H74v1.81h4.47V45.62H74V47.4H93.34V45.62h-6v-14c0-4.17,1.09-8.44,3.83-10.79a.53.53,0,0,1,.85.5h0a6.22,6.22,0,0,0-.35,1.85,4.19,4.19,0,0,0,4.41,4.21,4.68,4.68,0,0,0,4.93-4.73C101.06,19.59,99,17.71,95.94,17.71Z"></path><path class="cls-1" d="M193.49,19.82c.13,0,.29-.11.39,0a.27.27,0,0,1,0,.35h0a2.78,2.78,0,0,0-.24,2.38,2.74,2.74,0,0,0,2,1.77,2.79,2.79,0,0,0,3.47-2.72,3,3,0,0,0-1.53-2.53,5.29,5.29,0,0,0-2.85-.75,7.68,7.68,0,0,0-4.76,2h0q-.44-.32-.92-.6A14,14,0,0,0,181.83,18c-5.44,0-11.28,3.56-11.28,9.46a8.42,8.42,0,0,0,5.38,7.91v.13A7.08,7.08,0,0,0,169.45,43c0,3.24,1.49,5.7,4.22,6.48v.13c-2.59.71-5.58,3.31-5.58,6.42,0,4.8,5.64,8.49,12.83,8.49,9,0,14.91-6.09,14.91-14,0-6.29-3.11-9.14-9.46-9H175.61c-1.62,0-2.7-.07-2.7-1.82s2.49-3.37,4.95-3.37a4.87,4.87,0,0,1,1.32.39,8.35,8.35,0,0,0,2.66.39c5.57,0,11.54-3.18,11.54-9.33A9.62,9.62,0,0,0,191,21.61a.22.22,0,0,1,0-.33,13.23,13.23,0,0,1,1.69-1.1,3.64,3.64,0,0,1,.76-.35Zm-8.61,29.82c6.48,0,8.2.27,8.2,4.23,0,4.73-5.8,9.07-12.34,9.07-5.83,0-8.63-3.58-8.76-6.69,0-2.85,1.42-4.73,3.17-6.61ZM186,27.51c0,7.53-1.75,7.78-4.08,7.78-2.59,0-4-.5-4-8,0-5.25.58-7.48,4-7.48,3,0,4,.2,4.08,7.66Z"></path><path class="cls-1" d="M631.67,17.45a9.29,9.29,0,0,0-8.56,6.09H623V18.61H609.7v1.81h4.47V45.36H609.7v1.77h19.38V45.36h-6v-14c0-4.17,1.09-8.43,3.82-10.78a.53.53,0,0,1,.85.5v0a6.23,6.23,0,0,0-.34,1.83,4.19,4.19,0,0,0,4.41,4.21,4.68,4.68,0,0,0,4.93-4.73C636.79,19.33,634.72,17.45,631.67,17.45Z"></path>', 26)
    ])]));
  }
}), Gm = { "data-id": "sds-brochure-site-header" }, Um = { class: "bg-red-600" }, Km = { class: "container px-4 pt-4 pb-2 mx-auto max-w-screen-xl md:px-8" }, Zm = {
  href: "https://www.cmu.edu/",
  target: "_self",
  class: "block w-80"
}, Qm = { class: "text-gray-700 bg-white" }, Xm = { class: "container px-4 pt-8 mx-auto max-w-screen-xl space-y-8 md:px-8" }, Jm = { class: "pb-6 space-y-4 border-b" }, _m = {
  key: 0,
  class: "text-2xl text-gray-500 break-words"
}, Ra = /* @__PURE__ */ te({
  name: "SdsBrochureSiteHeader",
  __name: "BrochureSiteHeader",
  props: {
    page: { default: () => ({}) }
  },
  setup(e) {
    return (a, t) => (s(), u("header", Gm, [
      d("div", Um, [
        d("div", Km, [
          d("a", Zm, [
            Q(Ea, { class: "text-white fill-current h-7" }),
            t[0] || (t[0] = d("span", { class: "sr-only" }, "Carnegie Mellon University", -1))
          ])
        ])
      ]),
      d("div", Qm, [
        d("div", Xm, [
          d("div", Jm, [
            t[1] || (t[1] = d("h1", { class: "text-5xl font-extralight" }, [
              d("a", {
                href: "https://sei.cmu.edu",
                class: "break-words hover:text-red-500"
              }, "Software Engineering Institute")
            ], -1)),
            e.page.organization ? (s(), u("h2", _m, A(e.page.organization), 1)) : S("", !0)
          ])
        ])
      ])
    ]));
  }
}), e5 = { "data-id": "sds-brochure-site-footer" }, t5 = { class: "py-8 text-gray-100 bg-gray-900" }, a5 = { class: "container px-4 max-w-screen-xl mx-auto space-y-6 md:px-8" }, n5 = { class: "text-sm" }, Na = /* @__PURE__ */ te({
  name: "SdsBrochureSiteFooter",
  __name: "BrochureSiteFooter",
  setup(e) {
    return (a, t) => (s(), u("section", e5, [
      d("div", t5, [
        d("div", a5, [
          t[0] || (t[0] = $l('<div class="grid grid-cols-1 gap-8 lg:grid-cols-3"><div><address class="not-italic"> Carnegie Mellon University<br> Software Engineering Institute<br> 4500 Fifth Avenue<br> Pittsburgh, PA 15213-2612<br><a href="tel:412-268-5800" target="_self" class="hover:underline">412-268-5800</a></address></div><ul class="flex flex-row gap-x-3"><li><a id="facebook-social" href="https://www.facebook.com/SEICMU/" rel="noopener" target="_blank" class="hover:opacity-50 focus:opacity-50 h-9 w-9 flex flex-col justify-center"><span class="sr-only">Facebook</span><svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 256 256"><path fill="#1877F2" d="M256 128C256 57.308 198.692 0 128 0S0 57.308 0 128c0 63.888 46.808 116.843 108 126.445V165H75.5v-37H108V99.8c0-32.08 19.11-49.8 48.348-49.8C170.352 50 185 52.5 185 52.5V84h-16.14C152.959 84 148 93.867 148 103.99V128h35.5l-5.675 37H148v89.445c61.192-9.602 108-62.556 108-126.445"></path><path fill="white" d="m177.825 165l5.675-37H148v-24.01C148 93.866 152.959 84 168.86 84H185V52.5S170.352 50 156.347 50C127.11 50 108 67.72 108 99.8V128H75.5v37H108v89.445A129 129 0 0 0 128 256a129 129 0 0 0 20-1.555V165z"></path></svg></a></li><li><a id="x-social" href="https://twitter.com/sei_cmu" rel="noopener" target="_blank" class="hover:opacity-50 focus:opacity-50 h-9 w-9 flex flex-col justify-center"><span class="sr-only">X</span><svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36" fill="none"><g clip-path="url(#clip0_2881_113)"><path d="M21.3298 15.2358L34.3593 0.00012207H31.2717L19.9582 13.2291L10.9221 0.00012207H0.5L14.1644 20.0046L0.5 35.9816H3.58776L15.5352 22.0114L25.0779 35.9816H35.5L21.329 15.2358H21.3298ZM17.1006 20.1809L15.7162 18.1889L4.70032 2.33834H9.44294L18.3328 15.1302L19.7173 17.1222L31.2732 33.7498H26.5306L17.1006 20.1817V20.1809Z" fill="white"></path></g><defs><clipPath id="clip0_2881_113"><rect width="35" height="36" fill="white" transform="translate(0.5 0.00012207)"></rect></clipPath></defs></svg></a></li><li><a id="linkedin-social" href="https://www.linkedin.com/company/software-engineering-institute" rel="noopener" target="_blank" class="hover:opacity-50 focus:opacity-50 h-9 w-9 flex flex-col justify-center"><span class="sr-only">LinkedIn</span><svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 20 20"><path fill="white" d="M17.04 17.043h-2.962v-4.64c0-1.107-.023-2.531-1.544-2.531c-1.544 0-1.78 1.204-1.78 2.449v4.722H7.793V7.5h2.844v1.3h.039c.397-.75 1.364-1.54 2.808-1.54c3.001 0 3.556 1.974 3.556 4.545zM4.447 6.194c-.954 0-1.72-.771-1.72-1.72s.767-1.72 1.72-1.72a1.72 1.72 0 0 1 0 3.44m1.484 10.85h-2.97V7.5h2.97zM18.522 0H1.476C.66 0 0 .645 0 1.44v17.12C0 19.355.66 20 1.476 20h17.042c.815 0 1.482-.644 1.482-1.44V1.44C20 .646 19.333 0 18.518 0z"></path></svg></a></li><li><a id="youtube-social" href="https://www.youtube.com/user/TheSEICMU" rel="noopener" target="_blank" class="hover:opacity-50 focus:opacity-50 h-9 w-9 flex flex-col justify-center"><span class="sr-only">YouTube</span><svg xmlns="http://www.w3.org/2000/svg" width="36" height="27.09" viewBox="0 0 256 180"><path fill="red" d="M250.346 28.075A32.18 32.18 0 0 0 227.69 5.418C207.824 0 127.87 0 127.87 0S47.912.164 28.046 5.582A32.18 32.18 0 0 0 5.39 28.24c-6.009 35.298-8.34 89.084.165 122.97a32.18 32.18 0 0 0 22.656 22.657c19.866 5.418 99.822 5.418 99.822 5.418s79.955 0 99.82-5.418a32.18 32.18 0 0 0 22.657-22.657c6.338-35.348 8.291-89.1-.164-123.134"></path><path fill="white" d="m102.421 128.06l66.328-38.418l-66.328-38.418z"></path></svg></a></li><li><a id="apple-podcasts-social" href="https://podcasts.apple.com/us/podcast/software-engineering-institute-sei-podcast-series/id566573552?mt=2" rel="noopener" target="_blank" class="hover:opacity-50 focus:opacity-50 h-9 w-9 flex flex-col justify-center"><span class="sr-only">Apple Podcasts</span><svg xmlns="http://www.w3.org/2000/svg" width="37" height="36" viewBox="0 0 37 36" fill="none"><g clip-path="url(#clip0_2881_117)"><path d="M36.0069 11.1074C36.0069 10.6832 36.0069 10.2591 36.0044 9.83503C36.0024 9.47799 35.998 9.12045 35.9886 8.76341C35.9674 7.98571 35.9215 7.20062 35.7835 6.43179C35.6429 5.65064 35.4141 4.92374 35.0526 4.2141C34.6975 3.51678 34.234 2.87914 33.6812 2.32631C33.1278 1.773 32.4902 1.30944 31.7929 0.954369C31.0837 0.593382 30.3568 0.364067 29.5762 0.224012C28.8069 0.0854371 28.0218 0.0400673 27.2436 0.0188618C26.8865 0.00899878 26.5295 0.00505358 26.1719 0.00308097C25.7478 0.00012207 25.3237 0.00012207 24.8996 0.00012207H11.6072C11.1831 0.00012207 10.759 0.00012207 10.3349 0.00258782C9.97786 0.00456043 9.62033 0.00899878 9.26329 0.0183686C8.4851 0.0395741 7.7 0.0854371 6.93069 0.223519C6.15003 0.364067 5.42362 0.592889 4.71397 0.953876C4.01666 1.30894 3.37901 1.77251 2.8257 2.32582C2.27288 2.87914 1.80882 3.51678 1.45425 4.2136C1.09277 4.92325 0.863945 5.65015 0.723397 6.4313C0.585315 7.20062 0.539452 7.98522 0.518247 8.76292C0.508384 9.11996 0.504438 9.477 0.502466 9.83453C0.5 10.2591 0.5 10.6832 0.5 11.1074V24.4002C0.5 24.8243 0.5 25.2485 0.502466 25.6726C0.504438 26.0296 0.508877 26.3871 0.518247 26.7442C0.539452 27.5219 0.585315 28.307 0.723397 29.0758C0.863945 29.8569 1.09277 30.5839 1.45425 31.2935C1.80932 31.9908 2.27288 32.6285 2.8257 33.1813C3.37901 33.7346 4.01666 34.1982 4.71397 34.5532C5.42312 34.9142 6.15003 35.1435 6.93069 35.2836C7.7 35.4221 8.4851 35.4675 9.26329 35.4887C9.62033 35.4986 9.97737 35.5025 10.3349 35.5045C10.759 35.507 11.1831 35.507 11.6072 35.507H24.9001C25.3242 35.507 25.7483 35.507 26.1724 35.5045C26.5295 35.5025 26.887 35.4981 27.2441 35.4887C28.0222 35.4675 28.8073 35.4217 29.5767 35.2836C30.3573 35.143 31.0837 34.9142 31.7934 34.5532C32.4907 34.1982 33.1283 33.7346 33.6816 33.1813C34.235 32.628 34.6985 31.9903 35.0531 31.2935C35.4146 30.5839 35.6434 29.8569 35.7839 29.0758C35.922 28.3065 35.9679 27.5219 35.9891 26.7442C35.999 26.3871 36.0029 26.0301 36.0049 25.6726C36.0069 25.248 36.0069 24.8239 36.0069 24.3997V11.1074Z" fill="url(#paint0_linear_2881_117)"></path><path d="M18.242 12.9128C19.7096 12.9128 20.8991 14.1018 20.8991 15.5689C20.8991 17.036 19.7096 18.225 18.242 18.225C16.7744 18.225 15.5849 17.036 15.5849 15.5689C15.5854 14.1018 16.7749 12.9128 18.242 12.9128ZM25.8903 16.5C25.8903 19.1211 24.5637 21.4384 22.5467 22.8162C22.4442 22.8863 22.3046 22.8069 22.3125 22.6831C22.3406 22.2171 22.3495 21.8043 22.3253 21.3797C22.3174 21.2401 22.3722 21.104 22.4742 21.0084C23.677 19.8795 24.4296 18.2763 24.4296 16.5005C24.4296 13.009 21.5205 10.1837 17.9979 10.3198C14.7569 10.4456 12.1427 13.0928 12.0574 16.3343C12.0091 18.1762 12.7705 19.8445 14.0108 21.0089C14.1129 21.1045 14.1671 21.2406 14.1597 21.3797C14.136 21.8043 14.1444 22.2171 14.173 22.6836C14.1804 22.8074 14.0414 22.8873 13.9388 22.8172C11.8957 21.4221 10.5612 19.0634 10.5952 16.4008C10.647 12.3531 13.8934 9.0174 17.9402 8.86057C22.2937 8.69192 25.8903 12.1839 25.8903 16.5ZM18.209 5.08748C24.5193 5.06973 29.6585 10.196 29.6585 16.5005C29.6585 21.4704 26.4643 25.7076 22.0205 27.2699C21.9116 27.3084 21.8011 27.2176 21.8183 27.1037C21.877 26.7131 21.9328 26.3211 21.9836 25.9349C22.0013 25.7988 22.0881 25.6805 22.2139 25.6257C25.7325 24.0896 28.1977 20.5778 28.1977 16.5005C28.1977 10.9856 23.6874 6.50381 18.1602 6.54819C12.7537 6.59159 8.33906 10.9979 8.28679 16.4023C8.24684 20.5206 10.7234 24.0762 14.2697 25.6247C14.3959 25.68 14.4827 25.7973 14.501 25.9339C14.5518 26.3201 14.6075 26.7126 14.6662 27.1032C14.6834 27.2176 14.573 27.3079 14.464 27.2694C9.97731 25.6918 6.76443 21.3876 6.82657 16.356C6.9035 10.1447 11.9953 5.10523 18.209 5.08748ZM18.242 19.2981C19.252 19.2981 20.1081 19.6275 20.5948 20.1414C20.8493 20.4097 20.9834 20.6844 21.0259 21.0759C21.1077 21.8344 21.0619 22.4873 20.9731 23.5308C20.8883 24.5255 20.728 25.8521 20.5179 27.2028C20.3685 28.1645 20.2472 28.6833 20.1367 29.0546C19.9577 29.6567 19.2885 30.1834 18.242 30.1834C17.1956 30.1834 16.5263 29.6567 16.3473 29.0546C16.2369 28.6833 16.1156 28.164 15.9661 27.2028C15.7565 25.8521 15.5958 24.5255 15.511 23.5308C15.4222 22.4868 15.3758 21.8339 15.4582 21.0759C15.5006 20.6844 15.6347 20.4097 15.8892 20.1414C16.3764 19.6275 17.232 19.2981 18.242 19.2981Z" fill="white"></path></g><defs><linearGradient id="paint0_linear_2881_117" x1="18.2534" y1="0.00012207" x2="18.2534" y2="35.507" gradientUnits="userSpaceOnUse"><stop stop-color="#D56EFC"></stop><stop offset="1" stop-color="#832BC1"></stop></linearGradient><clipPath id="clip0_2881_117"><rect width="36" height="36" fill="white" transform="translate(0.5 0.00012207)"></rect></clipPath></defs></svg></a></li></ul><div><a href="https://sei.cmu.edu/contact-us/" target="_self" class="py-8 text-xl text-center transition-colors duration-100 rounded-none btn btn-tertiary btn-white btn-lg btn-block"> Contact Us </a></div></div><ul class="space-x-1 text-sm"><li class="inline-block"><a href="https://www.sei.cmu.edu/locations/index.cfm" target="_self" class="hover:underline">Office Locations</a></li><li class="inline-block"> | </li><li class="inline-block"><a href="https://www.sei.cmu.edu/additional-sites-directory/index.cfm" target="_self" class="hover:underline">Additional Sites Directory</a></li><li class="inline-block"> | </li><li class="inline-block"><a href="https://www.sei.cmu.edu/legal/index.cfm" target="_self" class="hover:underline">Legal</a></li><li class="inline-block"> | </li><li class="inline-block"><a href="https://www.sei.cmu.edu/legal/privacy-notice/index.cfm" target="_self" class="hover:underline">Privacy Notice</a></li><li class="inline-block"> | </li><li class="inline-block"><a href="https://www.cmu.edu/hr/ethics-hotline/" target="_self" class="hover:underline">CMU Ethics Hotline</a></li><li class="inline-block"> | </li><li class="inline-block"><a href="https://www.sei.cmu.edu/index.cfm" target="_self" class="hover:underline">www.sei.cmu.edu</a></li></ul>', 2)),
          d("div", n5, " © " + A((/* @__PURE__ */ new Date()).getFullYear()) + " Carnegie Mellon University ", 1)
        ])
      ])
    ]));
  }
}), l5 = {
  "data-id": "sds-brochure-site",
  class: "flex flex-col justify-between w-full min-h-screen text-gray-900 bg-white"
}, r5 = { key: 0 }, o5 = {
  key: 1,
  class: "container p-4 mx-auto max-w-screen-xl md:p-8"
}, s5 = { key: 0 }, pn = /* @__PURE__ */ te({
  name: "SdsBrochureSite",
  __name: "BrochureSite",
  props: {
    page: { default: () => ({}) },
    removeContentPadding: { type: Boolean, default: !1 },
    showFooter: { type: Boolean, default: !1 }
  },
  setup(e) {
    return (a, t) => (s(), u("div", l5, [
      d("main", null, [
        P(a.$slots, "header", {}, () => [
          Q(Ra, { page: e.page }, null, 8, ["page"])
        ]),
        a.$slots.default ? (s(), u("section", r5, [
          e.removeContentPadding ? P(a.$slots, "default", { key: 0 }) : (s(), u("div", o5, [
            P(a.$slots, "default")
          ]))
        ])) : S("", !0)
      ]),
      e.showFooter || a.$slots.footer ? (s(), u("footer", s5, [
        P(a.$slots, "footer"),
        e.showFooter ? (s(), G(Na, { key: 0 })) : S("", !0)
      ])) : S("", !0)
    ]));
  }
});
pn.install = (e) => {
  e.component(pn.name, pn);
};
Na.install = (e) => {
  e.component(Na.name, Na);
};
Ra.install = (e) => {
  e.component(Ra.name, Ra);
};
const i5 = {
  "data-id": "sds-brochure-site-header-content",
  class: "space-y-4"
}, d5 = {
  key: 0,
  class: "text-3xl text-gray-500 break-words font-extralight"
}, u5 = {
  key: 1,
  class: "text-xl text-gray-500 break-words"
}, c5 = ["innerHTML"], wn = /* @__PURE__ */ te({
  name: "SdsBrochureSiteHeaderContent",
  __name: "BrochureSiteHeaderContent",
  props: {
    page: { default: () => ({}) }
  },
  setup(e) {
    return (a, t) => (s(), u("div", i5, [
      e.page.title ? (s(), u("h3", d5, A(e.page.title), 1)) : S("", !0),
      e.page.subtitle ? (s(), u("h4", u5, A(e.page.subtitle), 1)) : S("", !0),
      e.page.description ? (s(), u("div", {
        key: 2,
        class: "max-w-screen-md prose break-words prose-red",
        innerHTML: e.page.description
      }, null, 8, c5)) : S("", !0)
    ]));
  }
});
wn.install = (e) => {
  e.component(wn.name, wn);
};
const f5 = {
  "data-id": "sds-brochure-site-nav",
  class: "space-y-4"
}, h5 = { class: "text-xl text-gray-400 wrap-break-words" }, m5 = { class: "pb-2 space-y-2" }, g5 = ["href"], v5 = {
  key: 0,
  class: "pt-2 border-t border-t-gray-100"
}, y5 = ["href"], b5 = { class: "group-hover:underline" }, xn = /* @__PURE__ */ te({
  name: "SdsBrochureSiteNav",
  __name: "BrochureSiteNav",
  props: {
    page: { default: () => ({ nav: [] }) }
  },
  setup(e) {
    return (a, t) => {
      const n = ll;
      return s(), u("div", f5, [
        (s(!0), u(J, null, le(e.page.nav, (l) => (s(), u("div", {
          key: l.title,
          class: "p-4 space-y-2 bg-gray-50"
        }, [
          d("h3", h5, A(l.title), 1),
          d("ul", m5, [
            (s(!0), u(J, null, le(l.items, (o) => (s(), u("li", {
              key: o.title
            }, [
              d("a", {
                href: o.url,
                class: "text-red-600 wrap-break-words hover:text-red-700 hover:underline"
              }, A(o.title), 9, g5)
            ]))), 128))
          ]),
          l.seeAll ? (s(), u("div", v5, [
            d("a", {
              href: l.seeAll.url,
              class: "inline-flex font-bold uppercase group text-gray-600"
            }, [
              d("span", b5, A(l.seeAll.title), 1),
              Q(n, { class: "w-5 h-5 my-auto" })
            ], 8, y5)
          ])) : S("", !0)
        ]))), 128))
      ]);
    };
  }
});
xn.install = (e) => {
  e.component(xn.name, xn);
};
Ea.install = (e) => {
  e.component(Ea.name, Ea);
};
const p5 = {
  "data-id": "sds-structured-page",
  class: "flex flex-col w-full min-h-screen"
}, w5 = { class: "grow" }, kn = /* @__PURE__ */ te({
  name: "SdsStructuredPage",
  __name: "StructuredPage",
  props: {
    stickyHeader: { type: Boolean, default: !1 },
    stickyFooter: { type: Boolean, default: !1 }
  },
  setup(e) {
    const a = Qt(), t = M(() => !!a.header), n = M(() => !!a.footer);
    return (l, o) => (s(), u("div", p5, [
      r(t) ? (s(), u("header", {
        key: 0,
        class: D(["z-30 shrink", { "sticky top-0 shadow-sm": e.stickyHeader }])
      }, [
        P(l.$slots, "header")
      ], 2)) : S("", !0),
      d("main", w5, [
        P(l.$slots, "default")
      ]),
      r(n) ? (s(), u("footer", {
        key: 1,
        class: D(["z-20 shrink", { "sticky bottom-0 shadow-sm": e.stickyFooter }])
      }, [
        P(l.$slots, "footer")
      ], 2)) : S("", !0)
    ]));
  }
});
kn.install = (e) => {
  e.component(kn.name, kn);
};
ma.install = (e) => {
  e.component(ma.name, ma);
};
const Cn = /* @__PURE__ */ te({
  name: "SdsLoadingSkeleton",
  __name: "LoadingSkeleton",
  props: {
    height: { default: "h-full" },
    width: { default: "w-full" }
  },
  setup(e) {
    return (a, t) => (s(), u("span", {
      "data-id": "sds-loading-skeleton",
      class: D(["rounded-theme-sm flex flex-row relative overflow-hidden bg-gray-100 dark:bg-gray-800 animate-pulse", e.width, e.height])
    }, null, 2));
  }
});
Cn.install = (e) => {
  e.component(Cn.name, Cn);
};
const x5 = {
  "data-id": "sds-loading-spinner",
  role: "status"
}, k5 = {
  key: 0,
  class: "sr-only"
}, $n = /* @__PURE__ */ te({
  name: "SdsLoadingSpinner",
  __name: "LoadingSpinner",
  props: {
    size: { default: "md" },
    label: { default: null }
  },
  setup(e) {
    const a = e, t = ot(() => a.size, {
      lg: "h-20 w-20",
      sm: "h-4 w-4",
      auto: ""
    }, "h-12 w-12");
    return (n, l) => (s(), u("div", x5, [
      (s(), u("svg", {
        class: D(["animate-spin", r(t)]),
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24"
      }, [...l[0] || (l[0] = [
        d("circle", {
          class: "opacity-25",
          cx: "12",
          cy: "12",
          r: "10",
          stroke: "currentColor",
          "stroke-width": "4"
        }, null, -1),
        d("path", {
          class: "opacity-75",
          fill: "currentColor",
          d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
        }, null, -1)
      ])], 2)),
      e.label ? (s(), u("span", k5, A(e.label), 1)) : S("", !0)
    ]));
  }
});
$n.install = (e) => {
  e.component($n.name, $n);
};
const C5 = {
  viewBox: "0 0 640 640",
  "aria-hidden": "true",
  role: "img",
  width: "1.2em",
  height: "1.2em"
};
function $5(e, a) {
  return s(), u("svg", C5, [...a[0] || (a[0] = [
    d("path", {
      fill: "currentColor",
      d: "M384 64c-17.7 0-32 14.3-32 32s14.3 32 32 32h82.7L265.3 329.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L512 173.3V256c0 17.7 14.3 32 32 32s32-14.3 32-32V96c0-17.7-14.3-32-32-32zm-240 96c-44.2 0-80 35.8-80 80v256c0 44.2 35.8 80 80 80h256c44.2 0 80-35.8 80-80v-80c0-17.7-14.3-32-32-32s-32 14.3-32 32v80c0 8.8-7.2 16-16 16H144c-8.8 0-16-7.2-16-16V240c0-8.8 7.2-16 16-16h80c17.7 0 32-14.3 32-32s-14.3-32-32-32z"
    }, null, -1)
  ])]);
}
const go = $e({ name: "fa7-solid-arrow-up-right-from-square", render: $5 }), M5 = {
  viewBox: "0 0 640 640",
  "aria-hidden": "true",
  role: "img",
  width: "1.2em",
  height: "1.2em"
};
function S5(e, a) {
  return s(), u("svg", M5, [...a[0] || (a[0] = [
    d("path", {
      fill: "currentColor",
      d: "M297.4 169.4c12.5-12.5 32.8-12.5 45.3 0l192 192c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L320 237.3L150.6 406.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l192-192z"
    }, null, -1)
  ])]);
}
const D5 = $e({ name: "fa7-solid-chevron-up", render: S5 }), z5 = ["aria-label"], T5 = { class: "pointer-events-none" }, Mn = /* @__PURE__ */ te({
  name: "SdsMegaMenu",
  __name: "MegaMenu",
  props: /* @__PURE__ */ xe({
    type: { default: "underline" },
    width: { default: "full" },
    ariaLabel: { default: void 0 }
  }, {
    modelValue: { type: Array, default: [] },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(e) {
    const a = e, t = Te(e, "modelValue"), n = E(!1), l = E(), o = E(), i = E(), h = M(() => t.value.find((p) => p.selected) || null), c = E([]), f = M(() => typeof document > "u" ? null : h.value ? document.querySelector(`#sds-megamenu__top-link_${h.value.key}`) : null), { bottom: y } = ul(l), { right: m } = ul(o), { right: g } = ul(i), v = ($ = !0) => {
      $ && f.value?.focus(), t.value = t.value.map((p) => (p.selected = !1, p)), w("close");
    };
    Il(l, () => {
      v(!1);
    }), cs(l, () => {
      v(!1);
    }), Ya("Escape", ($) => {
      n.value && ($.preventDefault(), v());
    }), Xn(() => {
      if (c.value = [], i.value) {
        const $ = Array.prototype.slice.call(i.value.querySelectorAll(
          'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
        ));
        c.value = $;
      }
    });
    const C = ($) => {
      if (!i.value) return;
      if (c.value.length < 2 && $.key === "Tab") {
        $.preventDefault();
        return;
      }
      const p = c.value.length - 1;
      $.key === "Tab" && $.shiftKey === !1 && $.target === c.value[p] || $.key === "Tab" && $.shiftKey === !0 && $.target === c.value[0] ? ($.preventDefault(), f.value?.focus()) : $.key === "Tab" && $.shiftKey === !1 && $.target === f.value ? ($.preventDefault(), c.value[0].focus()) : $.key === "Tab" && $.shiftKey === !0 && $.target === f.value && ($.preventDefault(), c.value[p].focus());
    }, k = async ($, p) => {
      if ($.tag === "a" && $.href)
        return !0;
      p.preventDefault(), t.value = t.value.map((F) => (F.selected = F.selected ? !1 : $.key === F.key, F)), w();
    }, w = ($ = null) => {
      if ($ === "close")
        n.value = !1;
      else {
        let p = 0;
        t.value.forEach((F) => {
          F.selected && p++;
        }), p ? n.value = !0 : n.value = !1;
      }
    }, x = M(() => i.value && o.value ? g.value >= m.value : !1), I = /* @__PURE__ */ Xo(Qo), L = E(), z = E(), b = M(() => I.smaller("xl").value ? 16 : 32);
    return ye(f, ($) => {
      if (a.width === "full")
        L.value = void 0, z.value = void 0;
      else if (a.width === "auto") {
        const p = $?.offsetLeft || 0, F = ($?.offsetLeft || 0) - o.value?.offsetLeft - b.value > 0;
        L.value = `${F ? p - b.value : p}px`, z.value = void 0;
      }
    }, { deep: !0 }), ye(x, ($) => {
      a.width !== "full" && $ && (L.value = void 0, z.value = `${o.value?.offsetLeft || 0}px`);
    }), ($, p) => {
      const F = D5, R = go;
      return s(), u("nav", {
        ref_key: "root",
        ref: l,
        "data-id": "sds-megamenu",
        class: D(["relative w-full flex flex-col bg-white dark:bg-gray-900 border-b-2 border-gray-100 dark:border-gray-800", {
          "z-20": r(n)
        }]),
        "aria-label": e.ariaLabel,
        onKeydown: C,
        onClick: p[4] || (p[4] = fe((T) => v(!1), ["self"]))
      }, [
        d("div", {
          class: "w-full text-gray-900 dark:text-gray-100 container mx-auto px-4 max-w-full lg:px-8 lg:max-w-5xl xl:max-w-7xl 2xl:px-12 2xl:max-w-screen-2xl",
          onClick: p[1] || (p[1] = fe((T) => v(!1), ["self"]))
        }, [
          d("div", {
            ref_key: "menu",
            ref: o,
            class: D(["flex flex-row", {
              "gap-4 xl:gap-8": e.type === "underline"
            }]),
            role: "menu",
            onClick: p[0] || (p[0] = fe((T) => v(!1), ["self"]))
          }, [
            (s(!0), u(J, null, le(t.value, (T) => (s(), G(mt(T.tag ? T.tag : "button"), {
              id: `sds-megamenu__top-link_${T.key}`,
              key: T.key,
              type: !T.tag || T.tag === "button" ? "button" : void 0,
              href: T.href ? T.href : void 0,
              "aria-haspopup": T.tag === "button" ? !0 : void 0,
              "aria-expanded": T.tag === "button" ? T.selected : void 0,
              "data-id": `sds-megamenu_${T.key}`,
              "data-selected": T.selected,
              class: D([{
                "z-30": T.selected,
                "hover:z-30": !T.selected,
                "ml-auto": T.alignment === "right",
                "mr-auto": T.alignment === "left",
                "mx-auto": T.alignment === "center",
                "px-2 xl:px-3 2xl:px-4 border-gray-100 dark:border-gray-800 font-semibold": e.type === "block",
                "text-gray-700 dark:text-gray-100 hover:text-gray-900 hover:bg-gray-50 dark:hover:text-gray-100 dark:hover:bg-gray-850": e.type === "block" && !(T.selected || T.active && t.value.filter((j) => j.key !== T.key && j.selected).length < 1),
                "text-white bg-red-600 dark:text-gray-900 dark:bg-red-300": e.type === "block" && (T.selected || T.active && t.value.filter((j) => j.key !== T.key && j.selected).length < 1),
                "hover:text-red-600 hover:border-red-600 dark:hover:text-red-300 dark:hover:border-red-300": e.type === "underline",
                "text-red-600 dark:text-red-300 border-red-600 dark:border-red-300": e.type === "underline" && T.selected,
                "border-red-600 dark:border-red-300": e.type === "underline" && T.active,
                "border-transparent dark:border-transparent": e.type === "underline" && (!T.selected && !T.active || T.active && t.value.filter((j) => j.key !== T.key && j.selected).length > 0)
              }, "flex items-center gap-0.5 xl:gap-1 my-auto py-2 space-x border-b-2 group -mb-0.5 overflow-y-visible select-none shrink-0 text-sm xl:text-base focus-visible:outline-2 cursor-pointer"]),
              role: "menuitem",
              onClick: (j) => {
                k(T, j), T.onClick && T?.onClick(T, j);
              }
            }, {
              default: U(() => [
                P($.$slots, `link(${T.key})`, { item: T }, () => [
                  d("span", T5, A(T.title), 1),
                  T.tag !== "a" ? (s(), G(F, {
                    key: 0,
                    class: D([{
                      "rotate-0": T.selected,
                      "rotate-180": !T.selected
                    }, "mt-0.5 relative inline-block w-4 h-4 transition-transform ease-in-out duration-300 pointer-events-none"])
                  }, null, 8, ["class"])) : S("", !0),
                  T.tag === "a" && T.external ? (s(), G(R, {
                    key: 1,
                    class: "ml-0 relative inline-block w-4 h-4"
                  })) : S("", !0)
                ])
              ]),
              _: 2
            }, 1032, ["id", "type", "href", "aria-haspopup", "aria-expanded", "data-id", "data-selected", "class", "onClick"]))), 128))
          ], 2)
        ]),
        Q(Qe, {
          "enter-active-class": "transition-transform ease-in-out origin-top duration-150",
          "enter-from-class": "scale-y-0",
          "enter-to-class": "scale-y-100",
          "leave-active-class": "transition-transform ease-in-out origin-top duration-200",
          "leave-from-class": "scale-y-100",
          "leave-to-class": "scale-y-0"
        }, {
          default: U(() => [
            r(h) ? (s(), u("div", {
              key: 0,
              role: "menu",
              class: "z-20",
              onClick: p[2] || (p[2] = fe((T) => v(!1), ["self"]))
            }, [
              r(h)?.tag !== "a" ? (s(), u("div", {
                ref_key: "panel",
                ref: i,
                key: r(h)?.key,
                style: st({
                  left: r(L),
                  right: r(z)
                }),
                class: D([{
                  "shadow-lg border-t-2 border-b border-gray-100 dark:border-gray-800 rounded-b-theme-lg": r(h)?.selected,
                  "border-x": e.width === "auto",
                  "w-full": e.width === "full"
                }, "absolute text-gray-900 dark:text-gray-100 bg-white dark:bg-gray-900"])
              }, [
                d("div", {
                  class: D({
                    "container mx-auto max-w-full lg:max-w-5xl xl:max-w-7xl 2xl:max-w-screen-2xl py-4 px-8 2xl:px-12": e.width === "full",
                    "p-4 xl:px-8": e.width === "auto"
                  })
                }, [
                  r(h)?.selected ? P($.$slots, `panel(${r(h).key})`, {
                    key: 0,
                    close: v,
                    item: r(h),
                    content: r(h).content
                  }, () => [
                    r(h)?.selected ? P($.$slots, "default", {
                      key: 0,
                      close: v,
                      item: r(h),
                      content: r(h).content
                    }) : S("", !0)
                  ]) : S("", !0)
                ], 2)
              ], 6)) : S("", !0)
            ])) : S("", !0)
          ]),
          _: 3
        }),
        Q(Qe, {
          "enter-active-class": "transition-opacity ease-in-out duration-150",
          "enter-from-class": "opacity-0",
          "enter-to-class": "opacity-100",
          "leave-active-class": "transition-opacity ease-in-out duration-150",
          "leave-from-class": "opacity-100",
          "leave-to-class": "opacity-0"
        }, {
          default: U(() => [
            e.width === "full" && r(n) ? (s(), u("div", {
              key: 0,
              class: "z-10 mt-auto fixed inset-x-0 bottom-0 bg-black/50",
              style: st({
                top: `${r(y)}px`
              }),
              onClick: p[3] || (p[3] = (T) => v(!1))
            }, null, 4)) : S("", !0)
          ]),
          _: 1
        })
      ], 42, z5);
    };
  }
});
Mn.install = (e) => {
  e.component(Mn.name, Mn);
};
const B5 = ["target", "rel", "tabindex"], L5 = { key: 0 }, I5 = { class: "flex flex-row gap-4" }, V5 = { key: 0 }, A5 = { class: "flex flex-row justify-start w-full group" }, H5 = { class: "group-hover:text-red-600 dark:group-hover:text-red-300 w-fit inline-block my-auto" }, O5 = {
  key: 0,
  class: "w-fit my-auto h-full whitespace-nowrap"
}, P5 = { class: "text-gray-600 dark:text-gray-400" }, Sn = /* @__PURE__ */ te({
  name: "SdsMegaMenuItem",
  __name: "MegaMenuItem",
  props: {
    label: { default: "" },
    type: { default: "simple" },
    external: { type: Boolean, default: !1 },
    cta: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 }
  },
  setup(e) {
    const a = e, t = M(() => a.type || a.cta ? "link group w-full no-underline" : ""), n = M(() => {
      switch (a.type) {
        case "landing-page":
          return "p-4 text-lg hover:no-underline hover:text-red-600 dark:hover:text-red-300";
        case "descriptive":
          return "p-4 transition-all rounded-theme-lg hover:no-underline hover:bg-gray-25 dark:hover:bg-gray-850";
        case "simple":
          return "p-4 text-sm transition-all rounded-theme-lg hover:bg-gray-25 dark:hover:bg-gray-850 hover:text-red-600 dark:hover:text-red-300";
        default:
          return "";
      }
    }), l = M(() => a.disabled ? "disabled" : "");
    return (o, i) => {
      const h = go, c = Nl;
      return s(), u("a", {
        "data-id": "sds-megamenuitem",
        target: e.external ? "_blank" : void 0,
        rel: e.external ? "noopener noreferrer" : void 0,
        class: D([r(t), r(n), r(l)]),
        tabindex: e.disabled ? -1 : void 0,
        role: "menuitem"
      }, [
        o.$slots.top ? (s(), u("div", L5, [
          P(o.$slots, "top")
        ])) : S("", !0),
        d("div", I5, [
          o.$slots.left ? (s(), u("div", V5, [
            P(o.$slots, "left")
          ])) : S("", !0),
          d("div", {
            class: D([
              e.type === "descriptive" ? "gap-1" : "",
              "flex flex-col"
            ])
          }, [
            d("div", A5, [
              d("p", H5, [
                d("span", null, A(e.label), 1),
                e.cta || e.type === "landing-page" || e.external ? (s(), u("span", O5, [
                  i[0] || (i[0] = re(A(
                    " "
                    /* This is a whitespace character, it will prevent the trailing icon from wrapping */
                  ) + " ", -1)),
                  e.external && e.type === "landing-page" ? (s(), G(h, {
                    key: 0,
                    class: "-mt-1 -ml-1 relative inline-block mb-0.5 w-5 h-5 group-hover:ml-1 group-hover:-mr-1 text-red-600 dark:text-red-300 transition-all"
                  })) : S("", !0),
                  (e.cta || e.type === "landing-page") && !e.external ? (s(), G(c, {
                    key: 1,
                    class: "-mt-1 inline-block w-5 h-5 transition-all text-red-600 dark:text-red-300 group-hover:ml-2 group-hover:-mr-2"
                  })) : S("", !0),
                  e.external && (e.type === "simple" || e.type === "descriptive") ? (s(), G(h, {
                    key: 2,
                    class: "-mt-1 w-4 h-4 -ml-0.5 opacity-0 group-hover:opacity-100 relative inline-block transition-all"
                  })) : S("", !0)
                ])) : S("", !0)
              ])
            ]),
            d("p", P5, [
              P(o.$slots, "default")
            ])
          ], 2)
        ])
      ], 10, B5);
    };
  }
});
Sn.install = (e) => {
  e.component(Sn.name, Sn);
};
const F5 = ["aria-labelledby", "aria-describedby", "aria-label"], E5 = { class: "flex items-center shrink-0 sticky z-10 w-full top-0 p-6 bg-white/50 dark:bg-gray-900/50 backdrop-blur-sm" }, R5 = ["id"], N5 = ["id"], W5 = {
  key: 0,
  class: "flex shrink-0 sticky z-10 w-full bottom-0 p-6 bg-white/50 dark:bg-gray-900/50 backdrop-blur-sm"
}, Wa = /* @__PURE__ */ te({
  name: "SdsPanel",
  __name: "Panel",
  props: /* @__PURE__ */ xe({
    size: { default: "md" },
    side: { default: "right" },
    zIndex: { default: "50" }
  }, {
    modelValue: { type: Boolean, type: Boolean, default: !1 },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(e) {
    const a = tt(), t = e, n = Te(e, "modelValue"), l = Qt(), o = E(null), i = M(() => !!l.title), h = M(() => !!l.footer), c = M(() => !!l.default), { zIndexClass: f, close: y, trapFocus: m } = Sr(
      n,
      o,
      {
        zIndex: () => t.zIndex,
        closeOnEscape: !0,
        focusTrap: !0,
        lockBodyScroll: !0,
        autoFocus: !0,
        restoreFocus: !0,
        transitionDuration: 250,
        // delay-75 (75ms) + duration-150 (150ms) = 225ms, use 250ms to be safe
        onClose: () => {
          n.value = !1;
        }
      }
    );
    return (g, v) => {
      const C = xa;
      return s(), G(Ut, null, {
        default: U(() => [
          (s(), G(Jn, { to: "body" }, [
            Q(Qe, {
              "enter-active-class": "transition-opacity duration-75",
              "enter-from-class": "opacity-0",
              "leave-active-class": "transition-opacity duration-75 delay-150",
              "leave-to-class": "opacity-0"
            }, {
              default: U(() => [
                n.value ? (s(), u("div", {
                  key: 0,
                  "data-id": "sds-panel-backdrop",
                  class: D(["fixed inset-0 block h-full px-2 py-0 overflow-auto bg-black/50", [r(f)]])
                }, [
                  d("button", {
                    class: "absolute inset-0",
                    onClick: v[0] || (v[0] = //@ts-ignore
                    (...k) => r(y) && r(y)(...k))
                  }, [...v[3] || (v[3] = [
                    d("span", { class: "sr-only" }, "Close panel", -1)
                  ])])
                ], 2)) : S("", !0)
              ]),
              _: 1
            }),
            Q(Qe, {
              "enter-from-class": e.side === "bottom" ? "translate-y-full" : e.side === "left" ? "-translate-x-full" : "translate-x-full",
              "enter-to-class": e.side === "bottom" ? "translate-y-0" : e.side === "left" ? "-translate-x-0" : "translate-x-0",
              "leave-from-class": e.side === "bottom" ? "translate-y-0" : e.side === "left" ? "-translate-x-0" : "translate-x-0",
              "leave-to-class": e.side === "bottom" ? "translate-y-full" : e.side === "left" ? "-translate-x-full" : "translate-x-full",
              "leave-active-class": "transform transition ease-in-out duration-150",
              "enter-active-class": "transform transition ease-in-out duration-150 delay-75"
            }, {
              default: U(() => [
                n.value ? (s(), u("div", {
                  key: 0,
                  ref_key: "panelContainer",
                  ref: o,
                  role: "dialog",
                  "aria-modal": "true",
                  "data-id": "sds-panel",
                  "aria-labelledby": r(i) ? r(a) : void 0,
                  "aria-describedby": r(c) ? `${r(a)}-content` : void 0,
                  "aria-label": r(i) ? void 0 : "Panel",
                  class: D([{
                    [r(f)]: !0,
                    "max-w-sm": e.size === "sm" && e.side !== "bottom",
                    "max-w-md": e.size === "md" && e.side !== "bottom",
                    "max-w-lg": e.size === "lg" && e.side !== "bottom",
                    "max-w-xl": e.size === "xl" && e.side !== "bottom",
                    "max-h-[40vh]": e.size === "sm" && e.side === "bottom",
                    "max-h-[60vh]": e.size === "md" && e.side === "bottom",
                    "max-h-[75vh]": e.size === "lg" && e.side === "bottom",
                    "max-h-[90vh]": e.size === "xl" && e.side === "bottom",
                    "right-0 rounded-r-none inset-y-0 w-11/12": e.side === "right",
                    "left-0 rounded-l-none inset-y-0 w-11/12": e.side === "left",
                    "bottom-0 left-0 right-0 rounded-b-none w-full": e.side === "bottom"
                  }, "fixed flex flex-col bg-white overflow-y-scroll border rounded-theme-lg shadow-xl dark:text-gray-25 dark:bg-gray-900 dark:border-gray-800"]),
                  onKeydown: v[2] || (v[2] = //@ts-ignore
                  (...k) => r(m) && r(m)(...k))
                }, [
                  d("header", E5, [
                    r(i) ? (s(), u("div", {
                      key: 0,
                      id: r(a),
                      ref: "titleWrapper",
                      class: "flex items-center gap-2 text-2xl leading-7 font-light"
                    }, [
                      P(g.$slots, "title")
                    ], 8, R5)) : S("", !0),
                    d("button", {
                      ref: "closeButton",
                      type: "button",
                      "aria-label": "Close panel",
                      class: "inline-block p-0 ml-auto text-lg text-gray-500 bg-transparent border-0 cursor-pointer hover:text-gray-700 hover:outline-hidden focus:text-gray-700 focus:outline-hidden dark:hover:text-gray-300 dark:focus:text-gray-300 active:text-gray-500 dark:active:text-gray-600",
                      onClick: v[1] || (v[1] = //@ts-ignore
                      (...k) => r(y) && r(y)(...k))
                    }, [
                      Q(C)
                    ], 512)
                  ]),
                  d("main", {
                    id: `${r(a)}-content`,
                    class: "p-6 pt-0 flex grow flex-col z-1",
                    tabindex: "-1"
                  }, [
                    P(g.$slots, "default")
                  ], 8, N5),
                  r(h) ? (s(), u("footer", W5, [
                    P(g.$slots, "footer")
                  ])) : S("", !0)
                ], 42, F5)) : S("", !0)
              ]),
              _: 3
            }, 8, ["enter-from-class", "enter-to-class", "leave-from-class", "leave-to-class"])
          ]))
        ]),
        _: 3
      });
    };
  }
});
function q5(e, a, t = null) {
  let n = a;
  return { menus: e.map((o) => {
    const i = { ...o };
    return i.selected = i.selected ? !1 : t === i.key, i.selected && t && (n = t), i;
  }), panel: n };
}
const Y5 = ["aria-label"], j5 = { key: 0 }, G5 = { key: 0 }, Dn = /* @__PURE__ */ te({
  name: "SdsMobileMenu",
  __name: "MobileMenu",
  props: /* @__PURE__ */ xe({
    mobileMenus: { default: () => [] },
    size: { default: "md" },
    side: { default: "right" },
    zIndex: { default: "50" },
    ariaLabel: { default: void 0 }
  }, {
    modelValue: { type: Boolean, type: Boolean, default: !1 },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(e) {
    const a = E("transition-all duration-200 ease-in-out relative overflow-visible top-0 h-0"), t = e, n = Te(e, "modelValue"), l = E("root"), o = E(t.mobileMenus), i = (c = null) => {
      if (typeof document > "u") return null;
      const f = q5(o.value, l.value, c);
      f.menus.forEach((y, m) => {
        o.value[m].selected = y.selected;
      }), l.value = f.panel;
    }, h = M(() => o.value.find((c) => c.selected && c.type !== "expand"));
    return (c, f) => (s(), u("nav", {
      "data-id": "sds-mobilemenu",
      role: "menu",
      "aria-label": e.ariaLabel
    }, [
      Q(Wa, {
        modelValue: n.value,
        "onUpdate:modelValue": f[0] || (f[0] = (y) => n.value = y),
        side: e.side,
        size: e.size,
        "z-index": e.zIndex
      }, {
        title: U(() => [
          P(c.$slots, "title", {
            navigate: i,
            activePanel: l.value
          })
        ]),
        default: U(() => [
          Q(Qe, {
            "enter-active-class": a.value,
            "enter-from-class": "opacity-0 -right-full ml-40",
            "enter-to-class": "opacity-100 right-0 ml-0",
            "leave-active-class": a.value,
            "leave-from-class": "opacity-100 right-0 ml-0",
            "leave-to-class": "opacity-0 -right-full ml-40"
          }, {
            default: U(() => [
              typeof h.value < "u" && l.value === h.value.key ? (s(), u("div", j5, [
                P(c.$slots, `panel(${l.value})`, {
                  navigate: i,
                  activePanel: l.value
                })
              ])) : S("", !0)
            ]),
            _: 3
          }, 8, ["enter-active-class", "leave-active-class"]),
          Q(Qe, {
            "enter-active-class": a.value,
            "enter-from-class": "opacity-0 -left-full mr-40",
            "enter-to-class": "opacity-100 left-0 mr-0",
            "leave-active-class": a.value,
            "leave-from-class": "opacity-100 left-0 mr-0",
            "leave-to-class": "opacity-0 -left-full mr-40"
          }, {
            default: U(() => [
              typeof h.value > "u" ? (s(), u("div", G5, [
                P(c.$slots, "default", {
                  navigate: i,
                  activePanel: l.value
                })
              ])) : S("", !0)
            ]),
            _: 3
          }, 8, ["enter-active-class", "leave-active-class"])
        ]),
        footer: U(() => [
          P(c.$slots, "footer", {
            navigate: i,
            activePanel: l.value
          })
        ]),
        _: 3
      }, 8, ["modelValue", "side", "size", "z-index"])
    ], 8, Y5));
  }
});
Dn.install = (e) => {
  e.component(Dn.name, Dn);
};
const U5 = ["aria-labelledby"], K5 = ["id"], Z5 = {
  class: "p-6",
  tabindex: "-1"
}, Q5 = {
  key: 0,
  class: "p-6 pt-0"
}, zn = /* @__PURE__ */ te({
  name: "SdsModal",
  __name: "Modal",
  props: /* @__PURE__ */ xe({
    size: { default: "md" },
    title: { default: null },
    hideHeader: { type: Boolean, default: !1 },
    zIndex: { default: "50" }
  }, {
    modelValue: { type: Boolean, type: Boolean, default: !1 },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(e) {
    const a = tt(), t = e, n = Te(e, "modelValue"), l = Qt(), o = E(null), i = E(null), h = M(() => !!l.title), c = M(() => !!l.footer), { zIndexClass: f, close: y, trapFocus: m } = Sr(
      n,
      i,
      {
        zIndex: () => t.zIndex,
        closeOnEscape: !0,
        focusTrap: !0,
        lockBodyScroll: !0,
        autoFocus: !0,
        restoreFocus: !0,
        transitionDuration: 225,
        // delay-75 (75ms) + duration-75 (75ms) = 150ms, use 225ms to be safe
        onClose: () => {
          n.value = !1;
        }
      }
    );
    return (g, v) => {
      const C = xa;
      return s(), G(Ut, null, {
        default: U(() => [
          (s(), G(Jn, { to: "body" }, [
            Q(Qe, {
              "enter-active-class": "transition-opacity duration-75",
              "enter-from-class": "opacity-0",
              "leave-active-class": "transition-opacity duration-75 delay-75",
              "leave-to-class": "opacity-0"
            }, {
              default: U(() => [
                n.value ? (s(), u("div", {
                  key: 0,
                  "data-id": "sds-modal-backdrop",
                  class: D(["fixed inset-0 block h-full bg-black/50", [r(f)]])
                }, null, 2)) : S("", !0)
              ]),
              _: 1
            }),
            Q(Qe, {
              "enter-active-class": "transition-all duration-75 delay-75",
              "enter-from-class": "transform scale-90 opacity-0",
              "leave-active-class": "transition-all duration-75",
              "leave-to-class": "transform scale-90 opacity-0"
            }, {
              default: U(() => [
                n.value ? (s(), u("div", {
                  key: 0,
                  class: "fixed inset-0 block h-full w-full overflow-auto z-50",
                  onMousedown: v[4] || (v[4] = fe(
                    //@ts-ignore
                    (...k) => r(y) && r(y)(...k),
                    ["self"]
                  ))
                }, [
                  d("button", {
                    class: D(["fixed inset-0 h-full w-full cursor-auto", {
                      "sr-only": e.hideHeader
                    }]),
                    onClick: v[0] || (v[0] = //@ts-ignore
                    (...k) => r(y) && r(y)(...k))
                  }, [...v[5] || (v[5] = [
                    d("span", { class: "sr-only" }, "Close modal", -1)
                  ])], 2),
                  d("div", {
                    ref_key: "modalContainer",
                    ref: i,
                    role: "dialog",
                    "data-id": "sds-modal",
                    "aria-labelledby": r(o) && r(o).id || void 0,
                    class: "z-50 p-2",
                    onKeydown: v[2] || (v[2] = //@ts-ignore
                    (...k) => r(m) && r(m)(...k)),
                    onMousedown: v[3] || (v[3] = fe(
                      //@ts-ignore
                      (...k) => r(y) && r(y)(...k),
                      ["self"]
                    ))
                  }, [
                    d("div", {
                      class: D(["relative block w-full mx-auto bg-white border rounded-theme-lg shadow-xl dark:text-gray-25 dark:bg-gray-900 dark:border-gray-800 md:my-16", {
                        [r(f)]: !0,
                        "md:max-w-sm": e.size === "sm",
                        "md:max-w-xl": e.size === "md",
                        "md:max-w-xl lg:max-w-2xl": e.size === "lg",
                        "md:max-w-xl lg:max-w-2xl xl:max-w-4xl": e.size === "xl",
                        "md:max-w-xl lg:max-w-2xl xl:max-w-4xl 2xl:max-w-6xl": e.size === "2xl"
                      }])
                    }, [
                      d("div", {
                        class: D(["flex items-center p-6 pb-0", {
                          "sr-only": e.hideHeader
                        }])
                      }, [
                        r(h) || e.title ? (s(), u("div", {
                          key: 0,
                          id: r(a),
                          ref_key: "titleWrapper",
                          ref: o,
                          class: "flex items-center gap-2 text-2xl leading-7 font-light"
                        }, [
                          P(g.$slots, "title", {}, () => [
                            re(A(e.title), 1)
                          ])
                        ], 8, K5)) : S("", !0),
                        d("button", {
                          "aria-label": "close",
                          class: "inline-block p-0 ml-auto text-lg text-gray-500 bg-transparent border-0 cursor-pointer hover:text-gray-700 hover:outline-hidden focus:text-gray-700 focus:outline-hidden dark:hover:text-gray-300 dark:focus:text-gray-300 active:text-gray-500 dark:active:text-gray-600",
                          onClick: v[1] || (v[1] = //@ts-ignore
                          (...k) => r(y) && r(y)(...k))
                        }, [
                          Q(C)
                        ])
                      ], 2),
                      d("main", Z5, [
                        P(g.$slots, "default")
                      ]),
                      r(c) ? (s(), u("div", Q5, [
                        P(g.$slots, "footer")
                      ])) : S("", !0)
                    ], 2)
                  ], 40, U5)
                ], 32)) : S("", !0)
              ]),
              _: 3
            })
          ]))
        ]),
        _: 3
      });
    };
  }
});
zn.install = (e) => {
  e.component(zn.name, zn);
};
const X5 = ["title", "aria-label", "disabled", "onClick"], J5 = ["value", "placeholder", "readonly", "disabled", "maxlength"], _5 = {
  key: 1,
  "aria-hidden": "true",
  class: "multiselect-caret"
}, eg = ["id", "required", "multiple"], tg = ["value"], ag = {
  key: 0,
  class: "dropdown-list-item loading"
}, ng = ["disabled", "onClick", "onMouseover"], lg = {
  key: 2,
  class: "dropdown-list-item default"
}, rg = {
  key: 3,
  class: "dropdown-list-item no-result"
}, og = {
  key: 4,
  class: "dropdown-list-item cannot-add-result"
}, sg = {
  key: 5,
  class: "dropdown-list-item invalid-input"
}, ig = /* @__PURE__ */ te({
  name: "SdsMultiselect",
  __name: "Multiselect",
  props: /* @__PURE__ */ xe({
    id: { default: void 0 },
    selected: { default: () => [] },
    options: { default: () => [] },
    valueKey: { default: "key" },
    labelKey: { default: "value" },
    autofocus: { type: Boolean, default: !1 },
    multiple: { type: Boolean, default: !1 },
    loading: { type: Boolean, default: !1 },
    loadingMsg: { default: "Loading..." },
    defaultMsg: { default: "" },
    noResultsMsg: { default: "" },
    cannotAddResultsMsg: { default: "You have added the maximum amount of items allowed." },
    invalidInputMsg: { default: "HTML input is not allowed." },
    hideTags: { type: Boolean, default: !1 },
    canLoopOptions: { type: Boolean, default: !1 },
    toggleSelectedOptions: { type: Boolean, default: !1 },
    hideSelectedOptions: { type: Boolean, default: !1 },
    closeOnSelection: { type: Boolean, default: !0 },
    canSearch: { type: Boolean, default: !0 },
    disableRemoveLastSelection: { type: Boolean, default: !1 },
    clearInputOnSelection: { type: Boolean, default: !0 },
    clearOptionsOnSelection: { type: Boolean, default: !0 },
    placeholder: { default: "" },
    openDirection: { default: "auto" },
    maxHeight: { default: 200 },
    hideCaret: { type: Boolean, default: !1 },
    showClear: { type: Boolean, default: !1 },
    taggable: { type: Boolean, default: !1 },
    maxlength: { default: void 0 },
    maxItems: { default: -1 },
    enforceLowercaseNewTag: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 },
    readonly: { type: Boolean, default: !1 },
    required: { type: Boolean, default: !1 },
    valid: { type: Boolean, default: !1 },
    invalid: { type: Boolean, default: !1 }
  }, {
    modelValue: { type: String, default: "" },
    modelModifiers: {}
  }),
  emits: /* @__PURE__ */ xe(["update-selected", "update-options", "open", "close", "focus"], ["update:modelValue"]),
  setup(e, { emit: a }) {
    const t = e, n = Te(e, "modelValue"), l = a, { validationClasses: o } = Xt(t), i = E(), h = E(), c = E(), f = E(), y = E(!1), m = E(!1), g = E(0), v = E(0), C = E("auto"), k = E(!1), w = M(() => x.value || L.value || z.value || I.value || $.value || p.value), x = M(() => t.loading && y.value && F.value), I = M(() => X.value.length > 0 && y.value && !t.loading && F.value), L = M(() => t.defaultMsg !== "" && j.value === "" && X.value.length < 1 && !t.loading && y.value && F.value), z = M(() => t.noResultsMsg !== "" && j.value !== "" && X.value.length < 1 && !t.loading && y.value && F.value), b = M(() => t.placeholder !== "" && t.selected.length < 1 && j.value === ""), $ = M(() => y.value && !F.value && T.value), p = M(() => !T.value), F = M(() => T.value && (t.maxItems < 0 || t.selected.length < t.maxItems)), R = M(() => !t.canSearch), T = M(() => j.value.match(/<[^\s]|&[^\s;]*;/gi) === null), j = M(() => n.value.trim() || ""), X = M(() => {
      const Z = t.options;
      return t.taggable && j.value !== "" && (Z.some((se) => t.enforceLowercaseNewTag ? se[t.labelKey].trim().toLowerCase() === j.value.toLowerCase() : se[t.labelKey].trim() === j.value) || Z.push(pe.value)), t.hideSelectedOptions ? Z.filter((se) => t.selected.filter((Ee) => se[t.valueKey] === Ee[t.valueKey]).length === 0) : Z;
    }), pe = M(() => {
      const Z = {}, se = Math.floor(Math.random() * 9e5 + 1e5);
      return Z[t.valueKey] = se, Z[t.labelKey] = t.enforceLowercaseNewTag ? j.value.toLowerCase() : j.value, Z.isNewTag = !0, Z;
    });
    ye(w, (Z) => {
      Z && ge();
    }), ye(X, () => {
      v.value = 0;
    }), dt(() => {
      O(), setTimeout(() => {
        t.autofocus && (h.value.focus(), m.value = !0);
      }, 0);
    });
    const H = () => {
      h.value.setSelectionRange(0, n.value.length);
    }, Y = (Z) => {
      !t.canSearch || !Z.target || Xe(Z.target.value);
    }, O = () => {
      requestAnimationFrame(() => {
        if (b.value)
          g.value = "100%";
        else {
          const se = c.value && typeof c.value < "u" ? c.value.clientWidth + 20 : 0;
          let Ee = (i.value?.clientWidth || 0) - 20;
          (!t.hideCaret || t.showClear && t.selected.length > 0) && (Ee = Ee - 10);
          const ve = Math.min(Math.max(se, 20), Ee);
          g.value = ve + "px";
        }
      });
    }, _ = () => {
      if (n.value !== "" || !t.canSearch || t.hideTags || t.disableRemoveLastSelection)
        return;
      const Z = t.selected;
      Z.splice(-1, 1), be(Z), ge();
    }, oe = (Z) => {
      if (!F.value) return;
      if (de(Z)) {
        t.toggleSelectedOptions && K(Z);
        return;
      }
      let se = [];
      t.multiple && (se = t.selected), se.push(Z), be(se), t.clearInputOnSelection && Le(), t.clearOptionsOnSelection && Fe(), N(), ge();
    }, K = (Z) => {
      be(
        t.selected.filter(
          (se) => se[t.valueKey] !== Z[t.valueKey]
        )
      ), N(), ge();
    }, de = (Z) => t.selected.some(
      (se) => se[t.labelKey] === Z[t.labelKey]
    ), Me = () => {
      l("focus"), h.value.focus();
    }, Le = () => {
      Xe("");
    }, Ge = () => {
      be([]);
    }, Fe = () => {
      Jt([]);
    }, Xe = (Z) => {
      n.value = Z, O(), ge();
    }, be = (Z) => {
      l("update-selected", Z), O(), v.value > X.value.length - 1 && (v.value = X.value.length - 1);
    }, Jt = (Z) => {
      l("update-options", Z);
    }, ra = async () => {
      t.disabled || w.value || (l("open"), Me(), y.value = !0, await Ie(), v.value = 0);
    }, at = () => {
      w.value && (l("close"), t.multiple || Le(), y.value = !1, v.value = 0);
    }, ut = () => {
      Ge(), Le(), Me(), ge();
    }, qe = (Z) => {
      if (!w.value) return;
      const se = 0;
      switch (Z) {
        // When going down, select next result until end
        // then loop back around starting with original query.
        case "down":
          v.value < X.value.length - 1 ? (v.value = v.value + 1, Je()) : (t.canLoopOptions && (v.value = se), t.canLoopOptions && Je());
          break;
        // When going up, select prev result until at original query
        // then loop back around starting at the end of the results.
        case "up":
          v.value > se ? (v.value = v.value - 1, Je()) : (t.canLoopOptions && (v.value = X.value.length - 1), t.canLoopOptions && Je(!0));
          break;
      }
    }, Je = (Z = !1) => {
      if (!w.value || typeof f.value > "u")
        return;
      const se = f.value.children[v.value] || !1, Ee = se ? se.offsetHeight : 0;
      let ve = 0;
      for (let _t = 0; _t < v.value; _t++)
        ve += f.value.children[_t].offsetHeight;
      const Tt = ve + Ee, Ft = {
        top: f.value.scrollTop || 0,
        bottom: f.value.offsetHeight + f.value.scrollTop || 0
      };
      Z ? f.value.scrollTop = Tt : ve <= Ft.top ? f.value.scrollTop = ve : Tt >= Ft.bottom && (f.value.scrollTop = Ft.top + Ee);
    }, Ht = async (Z) => {
      w.value && v.value <= X.value.length - 1 && v.value > -1 && F.value && n.value && n.value.trim() !== "" && !de(X.value[v.value]) && (oe(X.value[v.value]), Z.preventDefault()), Xe(""), await Ie(), at();
    }, rt = (Z) => {
      if (t.disabled) return;
      const se = [
        "Enter",
        "Backspace",
        "Delete",
        "Tab",
        "Alt",
        "Shift",
        "Control",
        "Meta",
        "CapsLock",
        "Fn",
        "FnLock",
        "Hyper",
        "NumLock",
        "ScrollLock",
        "Super",
        "Symbol",
        "SymbolLock",
        "ArrowLeft",
        "ArrowRight",
        "Left",
        "Right"
      ];
      Z.key === "Enter" && w.value ? v.value <= X.value.length - 1 && v.value > -1 && oe(X.value[v.value]) : Z.key === "Escape" ? (Z.preventDefault(), Z.stopPropagation(), q()) : Z.key === "Tab" ? m.value || (m.value = !0) : !w.value && !se.includes(Z.key) && ra();
    }, Ot = (Z) => {
      t.disabled || (!t.canSearch && Z.key === "Space" && Z.preventDefault(), Z.key === "Enter" && w.value && Z.preventDefault(), Z.key === "Delete" || Z.key === "Backspace" ? _() : Z.key === "Tab" ? w.value && (Z.preventDefault(), v.value <= X.value.length - 1 && v.value > -1 && F.value && n.value && n.value.trim() !== "" && !de(X.value[v.value]) && oe(X.value[v.value])) : Z.key === "ArrowUp" || Z.key === "Up" ? (Z.preventDefault(), Z.stopPropagation(), qe("up")) : (Z.key === "ArrowDown" || Z.key === "Down") && (Z.preventDefault(), Z.stopPropagation(), qe("down")));
    }, ne = () => {
      t.disabled || (ra(), m.value = !0);
    }, N = () => {
      t.closeOnSelection ? at() : Me();
    }, ue = (Z) => {
      i.value?.contains(Z.target) || (w.value && v.value <= X.value.length - 1 && v.value > -1 && F.value && n.value && n.value.trim() !== "" && (oe(X.value[v.value]), Z.preventDefault()), m.value && (m.value = !1), at());
    }, ie = (Z) => {
      i.value?.contains(Z.target) || m.value && (m.value = !1);
    }, ge = async () => {
      if (w.value && (await Ie(), t.openDirection === "down" && (k.value = !1), t.openDirection === "up" && (k.value = !0, C.value = i.value.clientHeight + "px"), t.openDirection === "auto" && typeof window < "u")) {
        const se = window.innerHeight - i.value.getBoundingClientRect().bottom < t.maxHeight;
        k.value = se, C.value = k.value ? i.value.clientHeight + "px" : "auto";
      }
    }, q = () => {
      at();
    }, Pt = () => {
      h.value.focus(), m.value || (m.value = !0);
    }, bt = Ar(ge, 150);
    return ft(document, "click", ue), ft(document, "keyup", ie), ft(document, "scroll", bt), ft(window, "resize", bt), (Z, se) => {
      const Ee = xa;
      return s(), u("div", {
        ref_key: "root",
        ref: i,
        "data-id": "sds-multiselect",
        class: D(["sds-multiselect", {
          ...r(o),
          open: r(w),
          active: r(m),
          up: r(k),
          canSearch: e.canSearch,
          hideCaret: e.hideCaret,
          showClear: e.showClear,
          hasTags: !e.hideTags && e.selected.length > 0,
          showResults: r(I)
        }]),
        onMouseup: ne,
        onMousedown: se[2] || (se[2] = fe(() => {
        }, ["prevent", "stop", "self"])),
        onDblclick: H,
        onKeydown: se[3] || (se[3] = (ve) => Ot(ve)),
        onKeyup: se[4] || (se[4] = (ve) => rt(ve))
      }, [
        d("ul", {
          class: D(["tag-list", { single: !e.multiple }])
        }, [
          !e.hideTags || !e.multiple ? (s(!0), u(J, { key: 0 }, le(e.selected, (ve) => (s(), u("li", {
            key: ve[e.valueKey],
            class: "tag-list-item"
          }, [
            P(Z.$slots, "tagTemplate", {
              tag: ve,
              remove: K,
              disabled: e.disabled
            }, () => [
              e.multiple ? (s(), u("button", {
                key: 0,
                type: "button",
                class: "remove",
                tabindex: "-1",
                title: `Clear ${ve[e.labelKey]}`,
                "aria-label": `Clear ${ve[e.labelKey]}`,
                disabled: e.disabled,
                onClick: (Tt) => K(ve)
              }, [...se[5] || (se[5] = [
                d("span", { "aria-hidden": "true" }, "×", -1)
              ])], 8, X5)) : S("", !0),
              d("span", null, A(ve[e.labelKey]), 1)
            ], !0)
          ]))), 128)) : S("", !0),
          d("li", {
            style: st({
              width: !e.multiple && r(w) && e.canSearch ? "100%" : r(g)
            }),
            class: "tag-list-item input"
          }, [
            d("span", {
              ref_key: "fauxInput",
              ref: c,
              class: "faux-input",
              "aria-hidden": "true"
            }, A(n.value), 513),
            e.required && e.selected.length < 1 ? (s(), u("select", {
              key: 0,
              class: "faux-input",
              "aria-hidden": "true",
              tabindex: "-1",
              required: "",
              onFocus: Pt
            }, [...se[6] || (se[6] = [
              d("option", null, null, -1)
            ])], 32)) : S("", !0),
            d("label", null, [
              d("input", {
                ref_key: "input",
                ref: h,
                value: n.value,
                placeholder: r(b) ? e.placeholder : "",
                readonly: r(R) || void 0,
                disabled: e.disabled || void 0,
                style: st({
                  width: !e.multiple && r(w) && e.canSearch ? "100%" : r(g)
                }),
                maxlength: e.maxlength !== void 0 ? e.maxlength : void 0,
                autocomplete: "off",
                spellcheck: "false",
                autocorrect: "off",
                type: "text",
                class: "p-0 m-0 border-0 focus:shadow-none focus:ring-0",
                onBlur: se[0] || (se[0] = (ve) => Ht(ve)),
                onInput: se[1] || (se[1] = (ve) => Y(ve))
              }, null, 44, J5),
              se[7] || (se[7] = d("span", { class: "sr-only" }, "Enter text", -1))
            ])
          ], 4)
        ], 2),
        e.selected.length > 0 && e.showClear ? (s(), u("button", {
          key: 0,
          type: "button",
          tabindex: "-1",
          title: "Clear all",
          "aria-label": "Clear all",
          class: "multiselect-clear",
          onClick: fe(ut, ["prevent", "stop"])
        }, [
          Q(Ee)
        ])) : S("", !0),
        !e.hideCaret && !(e.showClear && e.selected.length > 0) ? (s(), u("div", _5)) : S("", !0),
        e.id ? (s(), u("select", {
          key: 2,
          id: e.id,
          required: e.required || void 0,
          multiple: e.multiple || void 0,
          class: "sr-only",
          "aria-hidden": "true",
          tabindex: "-1"
        }, [
          (s(!0), u(J, null, le(e.selected, (ve) => (s(), u("option", {
            key: ve.id,
            value: ve.id,
            selected: ""
          }, A(ve[e.labelKey]), 9, tg))), 128))
        ], 8, eg)) : S("", !0),
        r(w) ? (s(), u("ul", {
          key: 3,
          ref_key: "dropdownMenu",
          ref: f,
          style: st({ bottom: r(C), maxHeight: e.maxHeight + "px" }),
          class: "dropdown-list"
        }, [
          r(x) ? (s(), u("li", ag, [
            P(Z.$slots, "loadingTemplate", { loadingMsg: e.loadingMsg }, () => [
              re(A(e.loadingMsg), 1)
            ], !0)
          ])) : S("", !0),
          r(I) ? (s(!0), u(J, { key: 1 }, le(r(X), (ve, Tt) => (s(), u("li", {
            key: ve[e.valueKey],
            disabled: e.disabled,
            class: D(["dropdown-list-item", { selected: de(ve), active: Tt === r(v) }]),
            onClick: (Ft) => oe(ve),
            onMouseover: (Ft) => v.value = Tt
          }, [
            P(Z.$slots, "optionTemplate", {
              option: ve,
              add: oe,
              disabled: e.disabled,
              isSelectedOption: de(ve)
            }, () => [
              re(A(ve[e.labelKey]) + " ", 1),
              ve.isNewTag && !de(ve) ? (s(), u(J, { key: 0 }, [
                re(" (new) ")
              ], 64)) : S("", !0)
            ], !0)
          ], 42, ng))), 128)) : S("", !0),
          r(L) ? (s(), u("li", lg, [
            P(Z.$slots, "defaultTemplate", { defaultMsg: e.defaultMsg }, () => [
              re(A(e.defaultMsg), 1)
            ], !0)
          ])) : S("", !0),
          r(z) ? (s(), u("li", rg, [
            P(Z.$slots, "noResultsTemplate", { noResultsMsg: e.noResultsMsg }, () => [
              re(A(e.noResultsMsg), 1)
            ], !0)
          ])) : S("", !0),
          r($) ? (s(), u("li", og, [
            P(Z.$slots, "cannotAddResultsTemplate", { cannotAddResultsMsg: e.cannotAddResultsMsg }, () => [
              re(A(e.cannotAddResultsMsg), 1)
            ], !0)
          ])) : S("", !0),
          r(p) ? (s(), u("li", sg, [
            P(Z.$slots, "invalidInputTemplate", { invalidInputMsg: e.invalidInputMsg }, () => [
              re(A(e.invalidInputMsg), 1)
            ], !0)
          ])) : S("", !0)
        ], 4)) : S("", !0)
      ], 34);
    };
  }
}), Tn = /* @__PURE__ */ El(ig, [["__scopeId", "data-v-a642e476"]]);
Tn.install = (e) => {
  e.component(Tn.name, Tn);
};
const dg = {
  key: 0,
  class: "my-auto pointer-events-none"
}, ug = {
  key: 0,
  class: "select-none text-lg pointer-events-none"
}, cg = {
  key: 1,
  class: "my-auto ml-auto text-gray-500 dark:text-gray-400 group-hover:text-red-700 dark:group-hover:text-gray-100 pointer-events-none"
}, fg = {
  key: 3,
  class: "mt-4 mb-2 border-gray-200 dark:border-gray-700"
}, Bn = /* @__PURE__ */ te({
  name: "SdsNavigationItem",
  __name: "NavigationItem",
  props: {
    selected: { type: Boolean, default: !1 },
    label: { default: "" },
    href: { default: null },
    external: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 },
    type: { default: "simple" },
    onClick: { type: [Function, null], default: null }
  },
  setup(e) {
    const a = Qn()?.vnode.key ?? null;
    return (t, n) => {
      const l = ro, o = ll;
      return s(), u(J, null, [
        e.type === "back" ? (s(), u("button", {
          key: 0,
          class: "flex flex-row text-gray-700 dark:text-gray-300 text-xl cursor-pointer mb-4 w-full",
          onClick: n[0] || (n[0] = (i) => {
            e.onClick?.(i);
          })
        }, [
          Q(l, { class: "mr-2 my-auto pt-0.5 relative w-6 h-6 self-center flex flex-col pointer-events-none" }),
          n[2] || (n[2] = d("h3", { class: "text-2xl font-thin pointer-events-none" }, " Go Back ", -1))
        ])) : S("", !0),
        e.type !== "back" ? (s(), G(mt(e.href ? "a" : "button"), {
          key: 1,
          id: r(a) ? `sds-navigationitem__${r(a).toString()}` : "sds-navigationitem",
          "data-id": "sds-navigationitem",
          "data-type": e.type,
          target: e.external ? "_blank" : void 0,
          rel: e.external ? "noopener noreferrer" : void 0,
          href: e.href ? e.href : void 0,
          class: D(["group flex flex-row gap-4 text-sm transition-all border-l-8 w-[calc(100%+3rem)] -mx-6 py-3 pl-4 pr-6", {
            "cursor-pointer": e.type !== "title" && !e.disabled,
            "text-gray-400 bg-white dark:text-gray-700 dark:bg-gray-900 hover:text-gray-400 hover:bg-white dark:hover:text-gray-600 dark:hover:bg-gray-900 select-none pointer-events-none cursor-default border-l-transparent": e.disabled,
            "text-gray-700 bg-white dark:text-gray-400 dark:bg-gray-900 hover:text-red-700 hover:bg-gray-50 dark:hover:text-red-100 dark:hover:bg-gray-850 border-l-transparent": !e.disabled && !e.selected && e.type !== "title",
            "border-l-red-700 dark:border-l-red-400 text-gray-900 dark:text-gray-100 hover:text-red-700 dark:hover:text-red-100 hover:bg-gray-50 dark:hover:bg-gray-850": e.selected,
            "border-l-red-700 dark:border-l-red-400 text-gray-900 dark:text-gray-100 cursor-default": e.type === "title"
          }]),
          tabindex: e.disabled || e.type === "title" ? -1 : e.href ? void 0 : 0,
          role: "menuitem",
          onClick: n[1] || (n[1] = (i) => {
            e.onClick?.(i);
          })
        }, {
          default: U(() => [
            t.$slots.left ? (s(), u("div", dg, [
              P(t.$slots, "left")
            ])) : S("", !0),
            P(t.$slots, "default", {}, () => [
              e.label ? (s(), u("span", ug, A(e.label), 1)) : S("", !0)
            ]),
            e.type === "expand" && t.$slots.children || e.type === "slide" ? (s(), u("div", cg, [
              Q(o, {
                class: D(["ml-auto -mr-1 shrink-0", {
                  "transition-transform mr-0": e.type === "expand",
                  "rotate-90": !e.selected && e.type === "expand",
                  "-rotate-90": e.selected && e.type === "expand"
                }])
              }, null, 8, ["class"])
            ])) : S("", !0)
          ]),
          _: 3
        }, 8, ["id", "data-type", "target", "rel", "href", "class", "tabindex"])) : S("", !0),
        t.$slots.children && e.type === "expand" ? (s(), u("div", {
          key: 2,
          class: D(["-mx-6 px-6 bg-white dark:bg-gray-900 relative top-0 transition-all ease-in-out duration-200 origin-top pointer-events-none", {
            "z-10 opacity-100 max-h-screen": e.selected,
            "-z-10 opacity-0 max-h-0 select-none": !e.selected
          }])
        }, [
          n[3] || (n[3] = d("hr", { class: "border-gray-200 dark:border-gray-700" }, null, -1)),
          P(t.$slots, "children")
        ], 2)) : S("", !0),
        e.type === "title" ? (s(), u("hr", fg)) : S("", !0)
      ], 64);
    };
  }
});
Bn.install = (e) => {
  e.component(Bn.name, Bn);
};
Oa.install = (e) => {
  e.component(Oa.name, Oa);
};
Pa.install = (e) => {
  e.component(Pa.name, Pa);
};
Wa.install = (e) => {
  e.component(Wa.name, Wa);
};
const hg = ["onMouseover", "onMouseleave"], mg = ["onMouseover", "onMouseout"], Ln = /* @__PURE__ */ te({
  name: "SdsPopover",
  __name: "Popover",
  props: {
    zIndex: { default: "50" },
    openDelay: { default: 500 },
    closeDelay: { default: 250 },
    size: { default: "lg" },
    strategy: { default: "absolute" },
    placement: { default: "auto" },
    disabled: { type: Boolean, default: !1 },
    willOpen: { default: void 0 },
    willClose: { default: void 0 }
  },
  setup(e) {
    const a = e, { zIndexClass: t } = _n(() => a.zIndex), n = ot(
      () => a.size,
      {
        sm: "w-64",
        md: "w-80",
        lg: "w-96",
        auto: "min-w-96 w-auto"
      },
      "sm"
    );
    return (l, o) => (s(), G(St, {
      "data-id": "sds-popover",
      strategy: e.strategy,
      placement: e.placement,
      disabled: e.disabled,
      "will-open": e.willOpen,
      "will-close": e.willClose,
      "popper-class": `absolute bg-white dark:text-gray-50 dark:bg-gray-850 dark:border-gray-700 border shadow-lg rounded-theme-md ${r(n)} ${r(t)}`,
      "arrow-class": "absolute bg-white dark:bg-gray-850 dark:border-gray-700 border w-3 h-3 rotate-45",
      "placement-top-arrow-class": "-bottom-1.5 border-t-0 border-l-0",
      "placement-right-arrow-class": "-left-1.5 border-t-0 border-r-0",
      "placement-bottom-arrow-class": "-top-1.5 border-b-0 border-r-0",
      "placement-left-arrow-class": "-right-1.5 border-b-0 border-l-0",
      shift: ""
    }, {
      trigger: U(({ open: i, close: h }) => [
        d("div", {
          onMouseover: (c) => i(e.openDelay),
          onMouseleave: (c) => h(e.closeDelay)
        }, [
          P(l.$slots, "trigger")
        ], 40, hg)
      ]),
      default: U(({ open: i, close: h, toggle: c, isOpen: f }) => [
        d("div", {
          class: "p-4",
          onMouseover: (y) => i(),
          onMouseout: (y) => h(e.closeDelay)
        }, [
          P(l.$slots, "default", {
            close: h,
            open: i,
            toggle: c,
            isOpen: f
          })
        ], 40, mg)
      ]),
      _: 3
    }, 8, ["strategy", "placement", "disabled", "will-open", "will-close", "popper-class"]));
  }
});
Ln.install = (e) => {
  e.component(Ln.name, Ln);
};
const gg = ["id"], vg = ["id", "value", "name", "required", "disabled", "readonly", "onClick"], yg = ["for"], In = /* @__PURE__ */ te({
  name: "SdsRadioGroup",
  __name: "RadioGroup",
  props: /* @__PURE__ */ xe({
    name: { default: null },
    options: { default: () => [] },
    stacked: { type: Boolean, default: !1 },
    labelKey: { default: "text" },
    valueKey: { default: "value" },
    disabled: { type: Boolean, default: !1 },
    readonly: { type: Boolean, default: !1 },
    required: { type: Boolean, default: !1 },
    valid: { type: Boolean, default: !1 },
    invalid: { type: Boolean, default: !1 }
  }, {
    modelValue: { type: [Boolean, String, Number, null], type: [Boolean, String, Number, null], default: void 0 },
    modelModifiers: {}
  }),
  emits: /* @__PURE__ */ xe(["change"], ["update:modelValue"]),
  setup(e, { emit: a }) {
    const t = tt(), n = e, l = Te(e, "modelValue"), o = a, { validationClasses: i } = Xt(n), h = E(), c = (f) => {
      o("change", f);
    };
    return (f, y) => (s(), u("div", {
      id: r(t),
      ref_key: "root",
      ref: h,
      "data-id": "sds-radio-group",
      class: D(["flex", {
        "flex-col gap-2": e.stacked,
        "gap-4": !e.stacked
      }])
    }, [
      (s(!0), u(J, null, le(e.options, (m, g) => (s(), u("div", {
        key: `${r(h)?.id}_${JSON.stringify(m)}`,
        class: "flex gap-2 items-start"
      }, [
        Ze(d("input", {
          id: `${r(h)?.id}__option_${g}`,
          "onUpdate:modelValue": y[0] || (y[0] = (v) => l.value = v),
          type: "radio",
          class: D(["relative top-1", r(i)]),
          value: m[e.valueKey],
          name: e.name ? e.name : `${r(h)?.id}__option`,
          required: e.required && !l.value || void 0,
          disabled: e.disabled || void 0,
          readonly: e.readonly || void 0,
          onClick: (v) => c(m[e.valueKey])
        }, null, 10, vg), [
          [zo, l.value]
        ]),
        P(f.$slots, "label", {
          optionId: `${r(h)?.id}__option_${g}`,
          option: m
        }, () => [
          d("label", {
            for: `${r(h)?.id}__option_${g}`,
            class: D({
              "opacity-50 pointer-events-none select-none": e.disabled || e.readonly
            })
          }, [
            d("span", null, A(m[e.labelKey]), 1)
          ], 10, yg)
        ])
      ]))), 128))
    ], 10, gg));
  }
});
In.install = (e) => {
  e.component(In.name, In);
};
const bg = ["width", "height"], pg = ["width", "height", "x", "y"], Vn = /* @__PURE__ */ te({
  name: "SdsResizer",
  __name: "Resizer",
  props: {
    clamp: { type: Boolean, default: !0 },
    direction: { default: "bottom" },
    initial: { default: void 0 },
    max: { default: void 0 },
    min: { default: void 0 }
  },
  setup(e) {
    const a = e, t = E(null), n = E(null), l = E(), o = E(!1), i = E(!1), h = E(!1), c = E({
      clicks: 0,
      timer: void 0,
      delay: 300
    });
    let f = 0, y = 0;
    const m = a.max ? a.direction === "right" ? E(a.max) : E() : E(), g = a.max ? a.direction === "bottom" ? E(a.max) : E() : E(), v = E(null), C = E(null), k = [
      "flex-col",
      "overflow-y-auto",
      "after:mx-auto",
      "after:pointer-events-none",
      "after:border-solid",
      "after:border-transparent",
      "after:border-b",
      "dark:group-[.relative]:after:border-white",
      "group-[.relative]:after:border-black/55",
      'after:content-[""]',
      "after:to-transparent",
      "group-[.relative]:after:bg-gradient-to-t",
      "after:from-black/5",
      "dark:after:from-black/40",
      "dark:after:via-black/5",
      "after:w-full",
      "after:h-12",
      "after:block",
      "after:absolute",
      "after:bottom-0",
      "after:w-fit"
    ], w = [
      "flex-row",
      "overflow-x-auto",
      "after:pointer-events-none",
      "after:border-solid",
      "after:border-transparent",
      "after:border-r",
      "dark:group-[.relative]:after:border-white",
      "group-[.relative]:after:border-black/55",
      'after:content-[""]',
      "after:to-transparent",
      "group-[.relative]:after:bg-gradient-to-l",
      "after:from-black/5",
      "dark:after:from-black/40",
      "dark:after:via-black/5",
      "after:w-12",
      "after:h-full",
      "after:block",
      "after:absolute",
      "after:right-0",
      "after:top-0",
      "after:h-[calc(100%+8em)]"
    ], x = (H, Y) => {
      Y === "bottom" ? H.scrollTop = 0 : H.scrollLeft = 0;
    }, I = (H) => {
      H.preventDefault(), c.value.clicks++, c.value.clicks === 1 ? c.value.timer = setTimeout(() => {
        c.value.clicks = 0;
      }, c.value.delay) : (c.value.timer && clearTimeout(c.value.timer), v.value = a.initial ? `${a.initial}px` : m.value ? `${m.value}px` : null, C.value = a.initial ? `${a.initial}px` : g.value ? `${g.value}px` : null, n.value && x(n.value, a.direction), c.value.clicks = 0);
    }, L = (H) => {
      H.preventDefault(), o.value = !0;
    }, z = (H) => {
      H.preventDefault(), i.value = !0;
    }, b = (H, Y) => {
      switch (Y) {
        case "bottom":
          z(H);
          break;
        case "right":
          L(H);
          break;
        default:
          z(H);
          break;
      }
    }, $ = (H) => {
      H.preventDefault(), !(o.value || i.value) && (h.value = !0);
    }, p = (H) => {
      H.preventDefault(), !(o.value || i.value) && (h.value = !1);
    }, F = (H) => {
      if (!(!o.value && !i.value)) {
        if (o.value && t.value !== null) {
          const Y = t.value.getBoundingClientRect();
          H instanceof MouseEvent ? f = H.clientX - Y.right : window?.TouchEvent && H instanceof TouchEvent && (f = H.touches[0].clientX - Y.right);
          const O = f + t.value.offsetWidth < 1 ? "0px !important" : `${t.value.offsetWidth + f}px !important`;
          if (a.clamp) {
            const _ = m.value && t.value.offsetWidth + f > (a.direction === "right", m.value) ? v.value : O;
            _ && (a.min === void 0 || parseInt(_) > a.min) && (v.value = _);
          } else
            v.value = O;
        }
        if (i.value && t.value !== null) {
          const Y = t.value.getBoundingClientRect();
          H instanceof MouseEvent ? y = H.clientY - Y.bottom : window?.TouchEvent && H instanceof TouchEvent && (y = H.touches[0].clientY - Y.bottom);
          const O = y + t.value.offsetHeight < 1 ? "0px !important" : `${t.value.offsetHeight + y}px !important`;
          if (a.clamp) {
            const _ = g.value && t.value.offsetHeight + y > g.value ? C.value : O;
            _ && (a.min === void 0 || parseInt(_) > a.min) && (C.value = _);
          } else
            C.value = O;
        }
      }
    }, R = (H) => {
      o.value = !1, i.value = !1, l.value.contains(H.target) || (h.value = !1);
    }, T = () => {
      if (a.direction === "bottom") {
        if (C.value)
          return C.value > g.value ? "fit-content" : C.value;
      } else if (a.direction === "right")
        return "";
    }, j = () => {
      if (a.direction === "right")
        return v.value;
      if (a.direction === "bottom")
        return "";
    }, X = () => a.direction === "right" ? {
      width: j()
    } : {
      height: T()
    }, pe = () => {
      g.value = g.value ? g.value : t.value?.scrollHeight, m.value = m.value ? m.value : t.value?.scrollWidth, a.initial && v.value == null && C.value == null && (a.direction === "bottom" ? C.value = `${a.initial}px` : v.value = `${a.initial}px`);
    };
    return dt(() => {
      pe();
    }), xr(() => {
      c.value.timer && (clearTimeout(c.value.timer), c.value.timer = void 0);
    }), ft(document, "mousemove", F), ft(document, "touchmove", F), ft(document, "mouseup", R), ft(document, "touchend", R), (H, Y) => (s(), u("div", {
      "data-id": "sds-resizer",
      class: D(["flex justify-end", {
        "flex-col max-w-full": e.direction === "bottom",
        "flex-row max-w-full": e.direction === "right"
      }])
    }, [
      d("div", {
        ref_key: "scrollAreaOuter",
        ref: t,
        style: st(X()),
        class: D(["relative flex", [
          e.direction === "right" ? "overflow-y-auto overflow-x-hidden flex-row" : "overflow-x-auto overflow-y-hidden flex-col",
          h.value ? "group" : null
        ]])
      }, [
        d("div", {
          ref_key: "scrollAreaInner",
          ref: n,
          class: D(e.direction === "right" ? w : k)
        }, [
          P(H.$slots, "default")
        ], 2)
      ], 6),
      d("div", {
        ref_key: "handle",
        ref: l,
        class: D(["opacity-30 hover:opacity-55 relative z-0 bg-transparent", {
          "w-full h-0 flex-row hover:cursor-row-resize active:cursor-row-resize": e.direction === "bottom",
          "h-full w-0 flex-col hover:cursor-col-resize active:cursor-col-resize": e.direction === "right"
        }]),
        onClick: Y[0] || (Y[0] = (O) => I(O)),
        onTouch: Y[1] || (Y[1] = (O) => I(O)),
        onMouseout: Y[2] || (Y[2] = (O) => p(O)),
        onMouseover: Y[3] || (Y[3] = (O) => $(O)),
        onMousedown: Y[4] || (Y[4] = (O) => b(O, e.direction)),
        onTouchstart: Y[5] || (Y[5] = (O) => b(O, e.direction))
      }, [
        d("div", {
          class: D(["absolute", {
            "w-full h-4": e.direction === "bottom",
            "h-full w-4": e.direction === "right"
          }])
        }, [
          (s(), u("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: e.direction === "bottom" ? 64 : 16,
            height: e.direction === "bottom" ? 16 : 64,
            class: D({
              "mx-auto": e.direction === "bottom",
              "my-auto h-full": e.direction === "right"
            }),
            viewBox: "0 0 10 10"
          }, [
            d("rect", {
              width: e.direction === "bottom" ? 32 : 4,
              height: e.direction === "bottom" ? 4 : 32,
              x: e.direction === "bottom" ? -11.5 : 3,
              y: e.direction === "bottom" ? 3 : -11.5,
              fill: "currentColor",
              stroke: "currentColor",
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
              "stroke-width": "0",
              rx: "2"
            }, null, 8, pg)
          ], 10, bg))
        ], 2)
      ], 34)
    ], 2));
  }
});
Vn.install = (e) => {
  e.component(Vn.name, Vn);
};
La.install = (e) => {
  e.component(La.name, La);
};
const wg = ["href", "onClick"], xg = 56, An = /* @__PURE__ */ te({
  name: "SdsScrollspy",
  __name: "Scrollspy",
  props: {
    items: { default: () => [] },
    parent: { default: void 0 },
    itemClass: { default: "" },
    activeClass: { default: "" },
    inactiveClass: { default: "" }
  },
  setup(e) {
    const a = e, t = M(() => typeof document > "u" ? void 0 : a.parent ? document.querySelector(a.parent) : null), n = E(), l = E(), o = (g) => {
      if (typeof document > "u") return 0;
      const v = document.getElementById(g.id);
      return v ? v.getBoundingClientRect().top - xg - 15 : 0;
    }, i = (g, v, C) => {
      const k = t.value && t.value.getBoundingClientRect().top || (typeof window < "u" ? window.scrollY : 0);
      return g === 0 && k === 0 ? [!0, null] : k < o(v) ? [!1, null] : !C || k < o(C) ? [!0, v.id] : [!1, null];
    }, h = (g) => {
      if (typeof document > "u") return !1;
      const v = document.getElementById(g.id);
      if (!v) return !1;
      const C = v.getBoundingClientRect();
      if (t.value) {
        const k = t.value.getBoundingClientRect();
        return C.top >= k.top && C.bottom <= k.bottom;
      } else
        return C.top >= 0 && C.bottom <= (typeof window < "u" ? window.innerHeight || document.documentElement.clientHeight : 0);
    }, c = () => {
      const g = [];
      if (l.value = n.value, a.items.forEach((v) => {
        h(v) && g.push(v);
      }), g.length) {
        n.value = g[0].id;
        return;
      }
      if (l.value) {
        n.value = l.value;
        return;
      }
      if (a.items.length && !n.value) {
        for (let v = 0; v < a.items.length; v++) {
          const C = a.items[v], k = a.items[v + 1], [w, x] = i(v, C, k);
          w && (n.value = x);
        }
        return;
      }
    }, f = us(c, 100), y = E(void 0);
    dt(() => {
      y.value = t.value, requestAnimationFrame(c);
    }), a.parent ? ft(y, "scroll", f) : ft(window, "scroll", f);
    const m = (g, v) => {
      if (!t.value || typeof document > "u") return;
      const C = document.getElementById(g);
      C && (v.preventDefault(), t.value.scrollTop = C.offsetTop - t.value.offsetTop);
    };
    return (g, v) => (s(), u("nav", null, [
      (s(!0), u(J, null, le(e.items, (C) => (s(), u("a", {
        key: C.id,
        href: `#${C.id}`,
        "data-id": "sds-scrollspy",
        class: D({
          [e.itemClass]: !0,
          [e.activeClass]: r(n) === C.id,
          [e.inactiveClass]: r(n) !== C.id
        }),
        onClick: (k) => e.parent ? m(C.id, k) : void 0
      }, [
        P(g.$slots, "default", { item: C }, () => [
          re(A(C.text), 1)
        ])
      ], 10, wg))), 128))
    ]));
  }
});
An.install = (e) => {
  e.component(An.name, An);
};
const kg = { class: "self-center grow" }, Cg = {
  key: 0,
  class: "slot-title"
}, $g = {
  key: 1,
  class: "text-sm text-gray-500 dark:text-gray-400"
}, Hn = /* @__PURE__ */ te({
  name: "SdsSection",
  __name: "Section",
  props: {
    type: { default: "" },
    hideHeader: { type: Boolean, default: !1 },
    hideContent: { type: Boolean, default: !1 },
    navClass: { default: "" },
    contentClass: { default: "p-4" }
  },
  setup(e) {
    const a = Qt(), t = M(() => !!a.title), n = M(() => !!a.subtitle), l = M(() => !!a.nav), o = M(() => !!a.default);
    return (i, h) => (s(), u("div", {
      "data-id": "sds-section",
      class: D(["block bg-white dark:bg-gray-950", {
        "rounded-theme-sm": e.type === "simple",
        "border border-gray-200 dark:border-gray-800": e.type === "simple" || e.type === "raised",
        "shadow-md border rounded-theme-lg": e.type === "raised"
      }])
    }, [
      e.hideHeader ? S("", !0) : (s(), u("header", {
        key: 0,
        class: D({
          "border-b dark:border-gray-800": e.type === "simple" || e.type === "raised",
          "border-0 border-t-2 border-gray-900 dark:border-gray-600": e.type === "accented"
        })
      }, [
        d("div", {
          class: D(["flex px-4 py-3", { "border-b border-gray-200 dark:border-gray-800": e.type === "accented" }])
        }, [
          d("div", kg, [
            r(t) ? (s(), u("div", Cg, [
              P(i.$slots, "title")
            ])) : S("", !0),
            r(n) ? (s(), u("div", $g, [
              P(i.$slots, "subtitle")
            ])) : S("", !0)
          ]),
          r(l) ? (s(), u("div", {
            key: 0,
            class: D(["flex items-stretch self-start justify-center ml-auto", [e.navClass]])
          }, [
            P(i.$slots, "nav")
          ], 2)) : S("", !0)
        ], 2)
      ], 2)),
      !e.hideContent && r(o) ? (s(), u("div", {
        key: 1,
        class: D([e.contentClass])
      }, [
        P(i.$slots, "default")
      ], 2)) : S("", !0)
    ], 2));
  }
});
Hn.install = (e) => {
  e.component(Hn.name, Hn);
};
ga.install = (e) => {
  e.component(ga.name, ga);
};
Ha.install = (e) => {
  e.component(Ha.name, Ha);
};
const Mg = { class: "sr-only" }, Sg = { class: "sr-only" }, Dg = ["aria-labelledby"], On = /* @__PURE__ */ te({
  name: "SdsSortByDropdown",
  __name: "SortByDropdown",
  props: /* @__PURE__ */ xe({
    kind: { default: "ghost" },
    variant: { default: "gray" },
    size: { default: "sm" },
    zIndex: { default: "50" },
    title: { default: "Sort by" },
    iconOnly: { type: Boolean, default: !1 },
    placement: { default: "bottom-start" },
    disabled: { type: Boolean, default: !1 },
    name: { default: null },
    options: { default: () => [] },
    tooltip: { default: "Sort" },
    offset: { default: 5 },
    openDelay: { default: 0 },
    closeDelay: { default: 0 },
    block: { type: Boolean, default: !1 },
    strategy: { default: "absolute" }
  }, {
    modelValue: {
      type: Object,
      default: null
    },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(e) {
    const a = Cl(E({
      ALPHA: {
        ASCENDING: "A-Z",
        DESCENDING: "Z-A"
      },
      CHRONOLOGICAL: {
        ASCENDING: "Oldest first",
        DESCENDING: "Newest first"
      },
      NUMERICAL: {
        ASCENDING: "Lowest first",
        DESCENDING: "Highest first"
      },
      CUSTOM: {
        ASCENDING: (k) => k ? `Most ${k} first` : "Most first",
        DESCENDING: (k) => k ? `Least ${k} first` : "Least first"
      }
    })), t = e, n = Te(e, "modelValue"), {
      id: l,
      buttonRef: o,
      zIndexClass: i,
      iconOnlyClasses: h,
      iconSizeClasses: c
    } = Sl({
      prefix: "action-btn",
      kind: () => t.kind,
      variant: () => t.variant,
      size: () => t.size,
      zIndex: () => t.zIndex,
      disabled: () => t.disabled,
      block: () => t.block,
      iconOnly: () => t.iconOnly,
      openDelay: t.openDelay,
      closeDelay: t.closeDelay
    }), f = E(null), y = E(null), m = E(!1), g = M({
      get() {
        const k = f.value?.value;
        return typeof k == "string" || typeof k == "number" ? k : null;
      },
      set(k) {
        m.value = !0, f.value = t.options.find((w) => w.value === k) ?? null, y.value = f.value && f.value.type ? `${f.value.type}:ascending` : null, f.value && (n.value = {
          sortBy: f.value.value,
          orderBy: y.value
        }), Ie(() => {
          m.value = !1;
        });
      }
    }), v = M(() => f.value), C = M(() => {
      if (!v.value || !v.value.type) return [];
      const k = [], w = v.value.type.toUpperCase();
      if (a.value[w]) {
        const x = a.value[w];
        Object.entries(x).forEach(
          ([I, L]) => {
            const z = `${w.toLowerCase()}:${I.toLowerCase()}`, b = `${l}__${v.value?.type}__${z}`;
            let $;
            if (typeof L == "function") {
              const p = (v.value?.customAttribute || v.value?.label || "").toString().toLowerCase();
              $ = L(p);
            } else
              $ = L;
            k.push({
              id: b,
              label: $,
              value: z,
              direction: I.toLowerCase()
            });
          }
        );
      }
      return k;
    });
    return ye(y, (k, w) => {
      !m.value && k !== w && k !== null && f.value && (n.value = {
        sortBy: f.value.value,
        orderBy: k
      });
    }), ye(f, (k) => {
      !m.value && k && !y.value && (y.value = `${k.type}:ascending`);
    }, { immediate: !0 }), dt(() => {
      m.value = !0, n.value !== null ? n.value.sortBy && n.value.orderBy ? (f.value = t.options.find((k) => k.value === n.value?.sortBy) || null, y.value = n.value.orderBy) : (f.value = null, y.value = null) : t.options.length > 0 && (f.value = t.options[0], y.value = `${f.value.type}:ascending`, n.value = {
        sortBy: f.value.value,
        orderBy: y.value
      }), Ie(() => {
        m.value = !1;
      });
    }), (k, w) => {
      const x = ho, I = Ua, L = ql, z = Wl;
      return s(), G(St, {
        "data-id": "sds-sort-by-dropdown",
        offset: e.offset,
        strategy: e.strategy,
        placement: e.placement,
        "popper-class": `absolute border shadow-lg rounded-theme-md bg-white border-gray-200 dark:border-gray-700 dark:bg-gray-850 w-56 ${r(i)}`,
        "hide-arrow": "",
        shift: ""
      }, {
        trigger: U(({ isOpen: b, toggle: $ }) => [
          e.iconOnly && e.tooltip ? (s(), G(it, {
            key: 0,
            size: "auto",
            type: "dark",
            disabled: e.disabled
          }, {
            trigger: U(() => [
              Q(je, {
                id: r(l),
                ref_key: "button",
                ref: o,
                kind: e.kind,
                variant: e.variant,
                size: e.size,
                active: b,
                block: e.block,
                "aria-haspopup": "true",
                class: D(r(h)),
                disabled: e.disabled,
                onClick: (p) => $()
              }, {
                default: U(() => [
                  Q(x, {
                    class: D([r(c), "inline-block self-center"])
                  }, null, 8, ["class"]),
                  d("span", Mg, A(e.title), 1)
                ]),
                _: 1
              }, 8, ["id", "kind", "variant", "size", "active", "block", "class", "disabled", "onClick"])
            ]),
            default: U(() => [
              d("p", null, A(e.tooltip), 1)
            ]),
            _: 2
          }, 1032, ["disabled"])) : e.iconOnly ? (s(), G(je, {
            key: 1,
            id: r(l),
            ref_key: "button",
            ref: o,
            kind: e.kind,
            variant: e.variant,
            size: e.size,
            active: b,
            block: e.block,
            "aria-haspopup": "true",
            class: D(r(h)),
            disabled: e.disabled,
            onClick: (p) => $()
          }, {
            default: U(() => [
              Q(x, {
                class: D([r(c), "inline-block self-center"])
              }, null, 8, ["class"]),
              d("span", Sg, A(e.title), 1)
            ]),
            _: 1
          }, 8, ["id", "kind", "variant", "size", "active", "block", "class", "disabled", "onClick"])) : (s(), G(je, {
            key: 2,
            id: r(l),
            ref_key: "button",
            ref: o,
            kind: e.kind,
            variant: e.variant,
            size: e.size,
            active: b,
            block: e.block,
            "aria-haspopup": "true",
            disabled: e.disabled,
            onClick: (p) => $()
          }, {
            default: U(() => [
              Q(x, {
                class: D([r(c), "inline-block self-center"])
              }, null, 8, ["class"]),
              P(k.$slots, "title", {}, () => [
                d("span", null, A(e.title), 1)
              ]),
              Q(I, { class: "inline-block self-center w-4 h-4" })
            ]),
            _: 3
          }, 8, ["id", "kind", "variant", "size", "active", "block", "disabled", "onClick"]))
        ]),
        default: U(() => [
          d("div", {
            role: "menu",
            "aria-orientation": "vertical",
            "aria-labelledby": r(o) && r(o).id || void 0,
            class: "flex flex-col"
          }, [
            e.options.length ? (s(), G(Ga, {
              key: 0,
              title: "Sort by"
            }, {
              default: U(() => [
                (s(!0), u(J, null, le(e.options, (b, $) => (s(), G(kl, {
                  key: `${r(l)}__sortBy__option_${$}`,
                  modelValue: r(g),
                  "onUpdate:modelValue": w[0] || (w[0] = (p) => Ne(g) ? g.value = p : null),
                  value: b.value,
                  label: String(b.label || ""),
                  name: e.name ? e.name : `${r(l)}__sortBy__option`
                }, null, 8, ["modelValue", "value", "label", "name"]))), 128))
              ]),
              _: 1
            })) : S("", !0),
            r(v) ? (s(), G(Ga, {
              key: 1,
              title: "Order by",
              divider: ""
            }, {
              default: U(() => [
                (s(!0), u(J, null, le(r(C), (b, $) => (s(), G(kl, {
                  id: b.id,
                  key: $,
                  modelValue: r(y),
                  "onUpdate:modelValue": w[1] || (w[1] = (p) => Ne(y) ? y.value = p : null),
                  value: b.value,
                  name: e.name ? e.name : `${r(l)}__direction__option`,
                  onClick: w[2] || (w[2] = fe(() => {
                  }, ["stop"]))
                }, {
                  icon: U(() => [
                    b.direction.includes("ascending") ? (s(), G(L, {
                      key: 0,
                      class: "h-3.5 w-3.5"
                    })) : (s(), G(z, {
                      key: 1,
                      class: "h-3.5 w-3.5"
                    }))
                  ]),
                  default: U(() => [
                    re(" " + A(b.label), 1)
                  ]),
                  _: 2
                }, 1032, ["id", "modelValue", "value", "name"]))), 128))
              ]),
              _: 1
            })) : S("", !0)
          ], 8, Dg)
        ]),
        _: 3
      }, 8, ["offset", "strategy", "placement", "popper-class"]);
    };
  }
});
Ia.install = (e) => {
  e.component(Ia.name, Ia);
};
Fa.install = (e) => {
  e.component(Fa.name, Fa);
};
const zg = ["id", "data-link", "data-readonly"], Tg = {
  key: 1,
  class: "leading-none"
}, Bg = ["href", "rel", "target"], Lg = { key: 5 }, Pn = /* @__PURE__ */ te({
  name: "SdsTag",
  __name: "Tag",
  props: {
    action: { default: null },
    counter: { default: null },
    external: { type: Boolean, default: !1 },
    href: { default: null },
    id: { default: void 0 },
    label: { default: "" },
    readonly: { type: Boolean, default: !1 },
    size: { default: "sm" },
    disabled: { type: Boolean, default: !1 }
  },
  emits: ["increment", "decrement", "remove"],
  setup(e, { emit: a }) {
    const t = Qt(), n = ["increment", "decrement", "remove"], l = (L) => n.includes(L), o = e, i = a, h = E(o.counter ? o.counter : 0), c = E({
      increment: {
        sm: {
          height: 16,
          path: "M12.875 8.5C12.875 8.92188 12.5234 9.27344 12.125 9.27344H8.75V12.6484C8.75 13.0469 8.39844 13.375 8 13.375C7.57812 13.375 7.25 13.0469 7.25 12.6484V9.27344H3.875C3.45312 9.27344 3.125 8.92188 3.125 8.5C3.125 8.10156 3.45312 7.77344 3.875 7.77344H7.25V4.39844C7.25 3.97656 7.57812 3.625 8 3.625C8.39844 3.625 8.75 3.97656 8.75 4.39844V7.77344H12.125C12.5234 7.75 12.875 8.10156 12.875 8.5Z",
          viewBox: "0 0 16 16",
          width: 16
        },
        md: {
          height: 18,
          path: "M14.6875 8.75C14.6875 9.24219 14.2773 9.65234 13.8125 9.65234H9.875V13.5898C9.875 14.0547 9.46484 14.4375 9 14.4375C8.50781 14.4375 8.125 14.0547 8.125 13.5898V9.65234H4.1875C3.69531 9.65234 3.3125 9.24219 3.3125 8.75C3.3125 8.28516 3.69531 7.90234 4.1875 7.90234H8.125V3.96484C8.125 3.47266 8.50781 3.0625 9 3.0625C9.46484 3.0625 9.875 3.47266 9.875 3.96484V7.90234H13.8125C14.2773 7.875 14.6875 8.28516 14.6875 8.75Z",
          viewBox: "0 0 18 18",
          width: 18
        }
      },
      decrement: {
        sm: {
          height: 16,
          path: "M12.125 9.25H3.875C3.45312 9.25 3.125 8.92188 3.125 8.5C3.125 8.10156 3.45312 7.75 3.875 7.75H12.125C12.5234 7.75 12.875 8.10156 12.875 8.5C12.875 8.92188 12.5234 9.25 12.125 9.25Z",
          viewBox: "0 0 16 16",
          width: 16
        },
        md: {
          height: 18,
          path: "M13.8125 9.625H4.1875C3.69531 9.625 3.3125 9.24219 3.3125 8.75C3.3125 8.28516 3.69531 7.875 4.1875 7.875H13.8125C14.2773 7.875 14.6875 8.28516 14.6875 8.75C14.6875 9.24219 14.2773 9.625 13.8125 9.625Z",
          viewBox: "0 0 18 18",
          width: 18
        }
      },
      remove: {
        sm: {
          height: 16,
          path: "M11.5156 10.9844C11.8203 11.2656 11.8203 11.7578 11.5156 12.0391C11.375 12.1797 11.1875 12.25 11 12.25C10.7891 12.25 10.6016 12.1797 10.4609 12.0391L8 9.57812L5.51562 12.0391C5.375 12.1797 5.1875 12.25 5 12.25C4.78906 12.25 4.60156 12.1797 4.46094 12.0391C4.15625 11.7578 4.15625 11.2656 4.46094 10.9844L6.92188 8.5L4.46094 6.03906C4.15625 5.75781 4.15625 5.26562 4.46094 4.98438C4.74219 4.67969 5.23438 4.67969 5.51562 4.98438L8 7.44531L10.4609 4.98438C10.7422 4.67969 11.2344 4.67969 11.5156 4.98438C11.8203 5.26562 11.8203 5.75781 11.5156 6.03906L9.05469 8.52344L11.5156 10.9844Z",
          viewBox: "0 0 16 16",
          width: 16
        },
        md: {
          height: 18,
          path: "M13.1016 11.6484C13.457 11.9766 13.457 12.5508 13.1016 12.8789C12.9375 13.043 12.7188 13.125 12.5 13.125C12.2539 13.125 12.0352 13.043 11.8711 12.8789L9 10.0078L6.10156 12.8789C5.9375 13.043 5.71875 13.125 5.5 13.125C5.25391 13.125 5.03516 13.043 4.87109 12.8789C4.51562 12.5508 4.51562 11.9766 4.87109 11.6484L7.74219 8.75L4.87109 5.87891C4.51562 5.55078 4.51562 4.97656 4.87109 4.64844C5.19922 4.29297 5.77344 4.29297 6.10156 4.64844L9 7.51953L11.8711 4.64844C12.1992 4.29297 12.7734 4.29297 13.1016 4.64844C13.457 4.97656 13.457 5.55078 13.1016 5.87891L10.2305 8.77734L13.1016 11.6484Z",
          viewBox: "0 0 18 18",
          width: 18
        }
      }
    }), f = M(() => !!t.leftSlot), y = M(() => {
      const { action: L, readonly: z, size: b, counter: $, disabled: p } = o, F = (() => {
        switch (b) {
          case "sm":
            return $ ? L && l(L) && !z ? "" : "pr-2" : L && l(L) && !z ? f.value ? "pl-1 pr-0" : "pl-2 pr-0" : "px-2";
          case "md":
            return $ ? L && l(L) && !z ? "" : "pr-2.5" : L && l(L) && !z ? f.value ? "pl-1.5 pr-0" : "pl-3 pr-0" : "px-3";
          default:
            return "";
        }
      })(), R = (() => {
        switch (b) {
          case "sm":
            return "h-6";
          case "md":
            return "h-8";
          default:
            return "";
        }
      })(), T = (() => {
        switch (b) {
          case "sm":
            return "text-xs leading-4";
          case "md":
            return "text-base leading-6";
          default:
            return "";
        }
      })(), j = (() => {
        switch (b) {
          case "sm":
            return "h-5.5 w-6";
          case "md":
            return "h-7.5 w-8";
          default:
            return "";
        }
      })();
      return {
        padding: F,
        size: R,
        textSize: T,
        buttonSize: j,
        disabled: p ? "opacity-50 pointer-events-none" : ""
      };
    }), m = M(() => y.value.padding), g = M(() => y.value.size), v = M(() => y.value.textSize), C = M(() => y.value.buttonSize), k = M(() => y.value.disabled), w = () => {
      h.value += 1, i("increment", { id: o.id, count: h.value });
    }, x = () => {
      h.value -= 1, i("decrement", { id: o.id, count: h.value });
    }, I = () => i("remove", o.id);
    return (L, z) => (s(), u("div", {
      id: e.id,
      "data-id": "sds-tag",
      class: D(["inline-flex items-center bg-white dark:bg-gray-850 shadow-none border border-gray-200 dark:border-gray-700 rounded-full sds-theme-plaid:rounded-md overflow-clip font-semibold text-gray-600 dark:text-gray-400 has-[a:hover]:bg-gray-25 dark:has-[a:hover]:bg-gray-850 has-[a:hover]:shadow-sm has-[a:hover]:border-gray-600 dark:has-[a:hover]:border-gray-400 has-[a:hover:active]:bg-gray-50 dark:has-[a:hover:active]:bg-gray-800 has-[a:hover:active]:shadow-sm has-[a:hover:active]:border-gray-900 dark:has-[a:hover:active]:border-gray-100", [r(v), r(g), r(m), r(k)]]),
      "data-link": e.href && !e.readonly ? !0 : void 0,
      "data-readonly": e.readonly
    }, [
      d("div", {
        class: D(["flex flex-row flex-nowrap items-center", {
          "gap-x-0.5": e.size === "sm",
          "gap-x-1": e.size === "md"
        }])
      }, [
        e.counter ? (s(), u("span", {
          key: 0,
          class: D(["bg-blue-600 text-white text-center", e.size === "sm" ? "min-h-6 min-w-6 px-1.5 leading-6" : "min-h-8 min-w-8 px-1.5 leading-8"])
        }, A(e.counter.toLocaleString()), 3)) : S("", !0),
        L.$slots.leftSlot ? (s(), u("span", Tg, [
          P(L.$slots, "leftSlot")
        ])) : S("", !0),
        e.href && !e.readonly ? (s(), u("a", {
          key: 2,
          class: D(["hover:underline hover:text-gray-900 dark:hover:text-gray-100 active:underline active:text-black dark:active:text-white overflow-hidden text-nowrap text-ellipsis max-w-60", e.counter ? "pl-1" : ""]),
          href: e.href,
          rel: e.external ? "noopener noreferrer" : void 0,
          target: e.external ? "_blank" : void 0
        }, [
          P(L.$slots, "label", {}, () => [
            re(A(e.label), 1)
          ])
        ], 10, Bg)) : (s(), u("span", {
          key: 3,
          class: D(["overflow-hidden text-nowrap text-ellipsis max-w-60", e.counter ? "pl-1" : ""])
        }, [
          P(L.$slots, "label", {}, () => [
            re(A(e.label), 1)
          ])
        ], 2)),
        e.action && l(e.action) && !e.readonly ? (s(), u(J, { key: 4 }, [
          e.action === "increment" ? (s(), u("button", {
            key: 0,
            ref: "button",
            type: "button",
            class: D(["flex flex-col items-center justify-center text-blue-600 dark:text-blue-300 hover:bg-blue-50 dark:hover:bg-blue-900 focus:outline-none focus-visible:bg-blue-50", [r(C)]]),
            onClick: fe(w, ["stop"])
          }, [
            Q(r(We), {
              "aria-hidden": "true",
              fill: "none",
              preserveAspectRatio: "xMidYMid meet",
              role: "img",
              height: r(c).increment[e.size].height,
              path: r(c).increment[e.size].path,
              width: r(c).increment[e.size].width,
              "view-box": r(c).increment[e.size].viewBox
            }, null, 8, ["height", "path", "width", "view-box"]),
            z[0] || (z[0] = d("span", { class: "sr-only" }, "Increment", -1))
          ], 2)) : e.action === "decrement" ? (s(), u("button", {
            key: 1,
            ref: "button",
            type: "button",
            class: D(["flex flex-col items-center justify-center text-blue-600 dark:text-blue-300 hover:bg-blue-50 dark:hover:bg-blue-900 focus:outline-none focus-visible:bg-blue-50", [r(C)]]),
            onClick: fe(x, ["stop"])
          }, [
            Q(r(We), {
              "aria-hidden": "true",
              fill: "none",
              preserveAspectRatio: "xMidYMid meet",
              role: "img",
              height: r(c).decrement[e.size].height,
              path: r(c).decrement[e.size].path,
              width: r(c).decrement[e.size].width,
              "view-box": r(c).decrement[e.size].viewBox
            }, null, 8, ["height", "path", "width", "view-box"]),
            z[1] || (z[1] = d("span", { class: "sr-only" }, "Decrement", -1))
          ], 2)) : e.action === "remove" ? (s(), u("button", {
            key: 2,
            ref: "button",
            type: "button",
            class: D(["flex flex-col items-center justify-center text-red-600 dark:text-red-300 hover:bg-red-50 dark:hover:bg-red-900 focus:outline-none focus-visible:bg-red-50", [r(C)]]),
            onClick: fe(I, ["stop"])
          }, [
            Q(r(We), {
              "aria-hidden": "true",
              fill: "none",
              preserveAspectRatio: "xMidYMid meet",
              role: "img",
              height: r(c).remove[e.size].height,
              path: r(c).remove[e.size].path,
              width: r(c).remove[e.size].width,
              "view-box": r(c).remove[e.size].viewBox
            }, null, 8, ["height", "path", "width", "view-box"]),
            z[2] || (z[2] = d("span", { class: "sr-only" }, "Remove", -1))
          ], 2)) : S("", !0)
        ], 64)) : L.$slots.action ? (s(), u("span", Lg, [
          P(L.$slots, "action")
        ])) : S("", !0)
      ], 2)
    ], 10, zg));
  }
});
Pn.install = (e) => {
  e.component(Pn.name, Pn);
};
const Ig = {
  "data-id": "sds-textarea",
  class: "w-full relative"
}, Vg = ["id", "rows", "maxlength", "minlength", "placeholder", "autofocus", "disabled", "readonly", "required"], Fn = /* @__PURE__ */ te({
  name: "SdsTextarea",
  __name: "Textarea",
  props: /* @__PURE__ */ xe({
    countCharacters: { type: Boolean, default: !1 },
    minlength: { default: 0 },
    maxlength: { default: 524288 },
    id: { default: void 0 },
    placeholder: { default: "" },
    rows: { default: 5 },
    autofocus: { type: Boolean, default: !1 },
    resize: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 },
    readonly: { type: Boolean, default: !1 },
    required: { type: Boolean, default: !1 },
    valid: { type: Boolean, default: !1 },
    invalid: { type: Boolean, default: !1 }
  }, {
    modelValue: { type: String, default: "" },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(e) {
    const a = e, t = Te(e, "modelValue"), { validationClasses: n } = Xt(a);
    return (l, o) => (s(), u("div", Ig, [
      Ze(d("textarea", {
        id: e.id,
        "onUpdate:modelValue": o[0] || (o[0] = (i) => t.value = i),
        class: D(["form-control", { ...r(n), "resize-none": !e.resize }]),
        rows: e.rows,
        maxlength: e.maxlength !== void 0 ? e.maxlength : void 0,
        minlength: e.minlength !== void 0 ? e.minlength : void 0,
        placeholder: e.placeholder || void 0,
        autofocus: e.autofocus || void 0,
        disabled: e.disabled || void 0,
        readonly: e.readonly || void 0,
        required: e.required || void 0
      }, null, 10, Vg), [
        [qn, t.value]
      ]),
      e.countCharacters ? (s(), G(mo, {
        key: 0,
        class: "absolute right-0 text-gray-600 dark:text-gray-400",
        "current-value": t.value.length,
        "min-value": e.minlength,
        "max-value": e.maxlength
      }, null, 8, ["current-value", "min-value", "max-value"])) : S("", !0)
    ]));
  }
});
Fn.install = (e) => {
  e.component(Fn.name, Fn);
};
const Ag = {
  viewBox: "0 0 640 640",
  "aria-hidden": "true",
  role: "img",
  width: "1.2em",
  height: "1.2em"
};
function Hg(e, a) {
  return s(), u("svg", Ag, [...a[0] || (a[0] = [
    d("path", {
      fill: "currentColor",
      d: "M320 576C178.6 576 64 461.4 64 320S178.6 64 320 64s256 114.6 256 256s-114.6 256-256 256m0-192c-17.7 0-32 14.3-32 32s14.3 32 32 32s32-14.3 32-32s-14.3-32-32-32m0-192c-18.2 0-32.7 15.5-31.4 33.7l7.4 104c.9 12.6 11.4 22.3 23.9 22.3c12.6 0 23-9.7 23.9-22.3l7.4-104c1.3-18.2-13.1-33.7-31.4-33.7z"
    }, null, -1)
  ])]);
}
const Og = $e({ name: "fa7-solid-circle-exclamation", render: Hg }), Pg = {
  viewBox: "0 0 640 640",
  "aria-hidden": "true",
  role: "img",
  width: "1.2em",
  height: "1.2em"
};
function Fg(e, a) {
  return s(), u("svg", Pg, [...a[0] || (a[0] = [
    d("path", {
      fill: "currentColor",
      d: "M320 64c14.7 0 28.2 8.1 35.2 21l216 400c6.7 12.4 6.4 27.4-.8 39.5S550.1 544 536 544H104c-14.1 0-27.2-7.4-34.4-19.5s-7.5-27.1-.8-39.5l216-400c7-12.9 20.5-21 35.2-21m0 352c-17.7 0-32 14.3-32 32s14.3 32 32 32s32-14.3 32-32s-14.3-32-32-32m0-192c-18.2 0-32.7 15.5-31.4 33.7l7.4 104c.9 12.5 11.4 22.3 23.9 22.3c12.6 0 23-9.7 23.9-22.3l7.4-104c1.3-18.2-13.1-33.7-31.4-33.7z"
    }, null, -1)
  ])]);
}
const Eg = $e({ name: "fa7-solid-triangle-exclamation", render: Fg }), Rg = {
  viewBox: "0 0 640 640",
  "aria-hidden": "true",
  role: "img",
  width: "1.2em",
  height: "1.2em"
};
function Ng(e, a) {
  return s(), u("svg", Rg, [...a[0] || (a[0] = [
    d("path", {
      fill: "currentColor",
      d: "M320 576c141.4 0 256-114.6 256-256S461.4 64 320 64S64 178.6 64 320s114.6 256 256 256m-32-352c0-17.7 14.3-32 32-32s32 14.3 32 32s-14.3 32-32 32s-32-14.3-32-32m-8 64h48c13.3 0 24 10.7 24 24v88h8c13.3 0 24 10.7 24 24s-10.7 24-24 24h-80c-13.3 0-24-10.7-24-24s10.7-24 24-24h24v-64h-24c-13.3 0-24-10.7-24-24s10.7-24 24-24"
    }, null, -1)
  ])]);
}
const Wg = $e({ name: "fa7-solid-circle-info", render: Ng }), qg = {
  viewBox: "0 0 640 640",
  "aria-hidden": "true",
  role: "img",
  width: "1.2em",
  height: "1.2em"
};
function Yg(e, a) {
  return s(), u("svg", qg, [...a[0] || (a[0] = [
    d("path", {
      fill: "currentColor",
      d: "M320 576C178.6 576 64 461.4 64 320S178.6 64 320 64s256 114.6 256 256s-114.6 256-256 256m118-366.3c-10.7-7.8-25.7-5.4-33.5 5.3L285.1 379.2L233 327.1c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l72 72c5 5 11.8 7.5 18.8 7s13.4-4.1 17.5-9.8l135.9-187c7.8-10.7 5.4-25.7-5.3-33.5"
    }, null, -1)
  ])]);
}
const jg = $e({ name: "fa7-solid-circle-check", render: Yg }), Gg = { class: "overflow-hidden rounded-theme-sm ring-1 ring-black/5 dark:ring-gray-700" }, Ug = { class: "p-4" }, Kg = { class: "flex toasts-start" }, Zg = { class: "shrink-0" }, Qg = { class: "ml-3 w-0 flex-1 pt-0.5" }, Xg = {
  key: 0,
  class: "text-sm font-medium leading-5 text-gray-900 dark:text-gray-100"
}, Jg = {
  key: 1,
  class: "mt-1 text-sm leading-5 text-gray-600 dark:text-gray-400"
}, _g = { class: "flex shrink-0 ml-4" }, qa = /* @__PURE__ */ te({
  name: "SdsToast",
  __name: "Toast",
  props: {
    id: {},
    type: { default: null },
    title: {},
    text: {},
    autoHideDelay: { default: 5e3 },
    noAutoHide: { type: Boolean, default: !1 }
  },
  emits: ["remove"],
  setup(e, { emit: a }) {
    const t = e, n = a, l = M(() => t.type), o = () => {
      n("remove", t.id);
    }, i = fs(o, {
      delay: M(() => t.autoHideDelay),
      enabled: M(() => !t.noAutoHide),
      autoStart: !0
    });
    return (h, c) => {
      const f = jg, y = Wg, m = Eg, g = Og, v = xa;
      return s(), u("div", {
        "data-id": "sds-toast",
        role: "alert",
        "aria-live": "polite",
        class: "w-full max-w-sm bg-white rounded-theme-sm shadow-lg pointer-events-auto dark:bg-gray-850 dark:border dark:border-gray-700",
        onMouseenter: c[0] || (c[0] = //@ts-ignore
        (...C) => r(i).clear && r(i).clear(...C)),
        onMouseleave: c[1] || (c[1] = //@ts-ignore
        (...C) => r(i).reset && r(i).reset(...C))
      }, [
        d("div", Gg, [
          d("div", Ug, [
            d("div", Kg, [
              d("div", Zg, [
                r(l) === "success" ? (s(), G(f, {
                  key: 0,
                  class: "w-6 h-6 text-green-400 dark:text-green-300"
                })) : r(l) === "info" ? (s(), G(y, {
                  key: 1,
                  class: "w-6 h-6 text-blue-400 dark:text-blue-300"
                })) : r(l) === "warning" ? (s(), G(m, {
                  key: 2,
                  class: "w-6 h-6 text-orange-300 dark:text-orange-300"
                })) : r(l) === "danger" ? (s(), G(g, {
                  key: 3,
                  class: "w-6 h-6 text-red-600 dark:text-red-300"
                })) : S("", !0)
              ]),
              d("div", Qg, [
                e.title ? (s(), u("p", Xg, A(e.title), 1)) : S("", !0),
                e.text ? (s(), u("p", Jg, A(e.text), 1)) : S("", !0)
              ]),
              d("div", _g, [
                d("button", {
                  "aria-label": "Close toast",
                  class: "inline-flex text-gray-600 dark:text-gray-400 transition duration-150 ease-in-out focus:outline-hidden hover:text-gray-900 dark:hover:text-gray-100",
                  onClick: o
                }, [
                  Q(v),
                  c[2] || (c[2] = d("span", { class: "sr-only" }, "Close toast", -1))
                ])
              ])
            ])
          ])
        ])
      ], 32);
    };
  }
});
qa.install = (e) => {
  e.component(qa.name, qa);
};
const ev = {
  key: 0,
  "data-id": "sds-toaster",
  class: "fixed inset-0 z-50 p-4 pointer-events-none sm:p-6"
}, En = /* @__PURE__ */ te({
  name: "SdsToaster",
  __name: "Toaster",
  props: {
    modelValue: { type: Array, default: [] },
    modelModifiers: {}
  },
  emits: ["update:modelValue"],
  setup(e) {
    const a = Te(e, "modelValue"), t = (n) => {
      a.value = a.value.filter((l) => n !== l.id);
    };
    return (n, l) => (s(), G(Qe, {
      "enter-active-class": "transition duration-150 ease-out transform",
      "enter-from-class": "translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-12",
      "enter-to-class": "translate-y-0 opacity-100 sm:translate-x-0",
      "leave-active-class": "transition duration-200 ease-in",
      "leave-from-class": "opacity-100",
      "leave-to-class": "opacity-0"
    }, {
      default: U(() => [
        a.value.length > 0 ? (s(), u("div", ev, [
          Q(To, {
            tag: "div",
            "enter-active-class": "transition duration-150 ease-out transform",
            "enter-from-class": "translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-2",
            "enter-to-class": "translate-y-0 opacity-100 sm:translate-x-0",
            "leave-active-class": "transition duration-200 ease-in",
            "leave-from-class": "opacity-100",
            "leave-to-class": "opacity-0",
            class: "space-y-4"
          }, {
            default: U(() => [
              P(n.$slots, "default", {
                toasts: a.value,
                removeToast: t
              }, () => [
                (s(!0), u(J, null, le(a.value, (o) => (s(), G(qa, {
                  id: o.id,
                  key: o.id,
                  type: o.type,
                  title: o.title,
                  text: o.text,
                  "auto-hide-delay": o.autoHideDelay || 5e3,
                  "no-auto-hide": o.noAutoHide || !1,
                  class: "ml-auto",
                  onRemove: t
                }, null, 8, ["id", "type", "title", "text", "auto-hide-delay", "no-auto-hide"]))), 128))
              ])
            ]),
            _: 3
          })
        ])) : S("", !0)
      ]),
      _: 3
    }));
  }
});
En.install = (e) => {
  e.component(En.name, En);
};
const tv = {
  "data-id": "sds-toggle-switch",
  class: "flex items-center"
}, av = ["disabled", "aria-checked"], Rn = /* @__PURE__ */ te({
  name: "SdsToggleSwitch",
  __name: "ToggleSwitch",
  props: /* @__PURE__ */ xe({
    disabled: { type: Boolean, default: !1 }
  }, {
    modelValue: { type: Boolean, type: Boolean, default: !1 },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(e) {
    const a = Te(e, "modelValue"), t = () => {
      a.value = !a.value;
    };
    return (n, l) => (s(), u("div", tv, [
      d("button", {
        type: "button",
        class: D(["disabled:opacity-50 dark:disabled:opacity-100 hover:shadow-md relative inline-flex shrink-0 h-6 w-11 border-2 border-transparent rounded-full cursor-pointer transition-colors ease-in-out duration-200 focus:outline-hidden disabled:cursor-default disabled:shadow-none", [
          a.value ? "bg-green-500 disabled:bg-green-200 dark:disabled:bg-green-800" : "bg-gray-700 disabled:bg-gray-200 dark:disabled:bg-gray-800"
        ]]),
        disabled: e.disabled || void 0,
        role: "switch",
        "aria-checked": a.value,
        onClick: t
      }, [
        d("span", {
          "aria-hidden": "true",
          class: D(["pointer-events-none inline-block h-4 w-4 my-0.5 rounded-full transform transition ease-in-out duration-200", [
            a.value ? "translate-x-5.5" : "translate-x-0.5",
            e.disabled ? "bg-gray-50 dark:bg-gray-500" : "bg-white drop-shadow-sm shadow-lg"
          ]])
        }, null, 2),
        l[0] || (l[0] = d("span", { class: "sr-only" }, "Toggle switch", -1))
      ], 10, av)
    ]));
  }
});
Rn.install = (e) => {
  e.component(Rn.name, Rn);
};
it.install = (e) => {
  e.component(it.name, it);
};
const nv = {
  "data-id": "sds-top-five-chart",
  class: "space-y-4 chart"
}, lv = { key: 0 }, rv = { class: "space-y-6" }, ov = { class: "flex" }, sv = { class: "grow" }, iv = { class: "mb-2" }, dv = ["title", "aria-valuenow", "aria-valuemax"], uv = { class: "sr-only" }, cv = { class: "text-sm font-semibold chart-label-section" }, fv = ["href"], hv = ["onClick"], mv = { key: 1 }, gv = {
  key: 0,
  class: "mt-4"
}, vv = ["href"], yv = { key: 1 }, bv = { key: 0 }, pv = { key: 1 }, Nn = /* @__PURE__ */ te({
  name: "SdsTopFiveChart",
  __name: "TopFiveChart",
  props: {
    title: { default: null },
    entries: { default: () => [] },
    doNotLinkEntries: { type: Boolean, default: !1 },
    viewAllUrl: { default: null },
    variant: { default: null },
    showPercent: { type: Boolean, default: !1 },
    smallHeading: { type: Boolean, default: !1 },
    noDataMsg: { default: "There is no chart data to display at this time." },
    missingPropsMsg: { default: "The chart data is malformed and cannot be displayed at this time." }
  },
  emits: ["result-click"],
  setup(e, { emit: a }) {
    const t = e, n = a, l = M(() => o.value ? t.entries.slice(0, 5) : []), o = M(() => t.entries.length < 1 ? !0 : t.entries.every((g) => Object.prototype.hasOwnProperty.call(g, "id") && Object.prototype.hasOwnProperty.call(g, "title") && Object.prototype.hasOwnProperty.call(g, "count"))), i = M(() => Math.max(...l.value.map((g) => g.count))), h = (g) => g * 100 / i.value, c = (g) => t.showPercent ? `${g}%` : g, f = (g) => typeof g.url < "u", y = (g) => {
      n("result-click", g);
    }, m = (g) => {
      switch (t.variant) {
        case "teal":
          if (g === 0)
            return "bg-teal-800 dark:bg-teal-600";
          if (g === 1)
            return "bg-teal-700 dark:bg-teal-500";
          if (g === 2)
            return "bg-teal-600 dark:bg-teal-400";
          if (g === 3)
            return "bg-teal-500 dark:bg-teal-300";
          if (g === 4)
            return "bg-teal-400 dark:bg-teal-200";
          break;
        case "red":
          if (g === 0)
            return "bg-red-800 dark:bg-red-600";
          if (g === 1)
            return "bg-red-700 dark:bg-red-500";
          if (g === 2)
            return "bg-red-600 dark:bg-red-400";
          if (g === 3)
            return "bg-red-500 dark:bg-red-300";
          if (g === 4)
            return "bg-red-400 dark:bg-red-200";
          break;
        case "gray":
          if (g === 0)
            return "bg-gray-800 dark:bg-gray-600";
          if (g === 1)
            return "bg-gray-700 dark:bg-gray-500";
          if (g === 2)
            return "bg-gray-600 dark:bg-gray-400";
          if (g === 3)
            return "bg-gray-500 dark:bg-gray-300";
          if (g === 4)
            return "bg-gray-400 dark:bg-gray-200";
          break;
        case "tan":
          if (g === 0)
            return "bg-tan-800 dark:bg-tan-600";
          if (g === 1)
            return "bg-tan-700 dark:bg-tan-500";
          if (g === 2)
            return "bg-tan-600 dark:bg-tan-400";
          if (g === 3)
            return "bg-tan-500 dark:bg-tan-300";
          if (g === 4)
            return "bg-tan-400 dark:bg-tan-200";
          break;
        case "green":
          if (g === 0)
            return "bg-green-800 dark:bg-green-600";
          if (g === 1)
            return "bg-green-700 dark:bg-green-500";
          if (g === 2)
            return "bg-green-600 dark:bg-green-400";
          if (g === 3)
            return "bg-green-500 dark:bg-green-300";
          if (g === 4)
            return "bg-green-400 dark:bg-green-200";
          break;
        case "yellow":
          if (g === 0)
            return "bg-yellow-800 dark:bg-yellow-600";
          if (g === 1)
            return "bg-yellow-700 dark:bg-yellow-500";
          if (g === 2)
            return "bg-yellow-600 dark:bg-yellow-400";
          if (g === 3)
            return "bg-yellow-500 dark:bg-yellow-300";
          if (g === 4)
            return "bg-yellow-400 dark:bg-yellow-200";
          break;
        case "orange":
          if (g === 0)
            return "bg-orange-800 dark:bg-orange-600";
          if (g === 1)
            return "bg-orange-700 dark:bg-orange-500";
          if (g === 2)
            return "bg-orange-600 dark:bg-orange-400";
          if (g === 3)
            return "bg-orange-500 dark:bg-orange-300";
          if (g === 4)
            return "bg-orange-400 dark:bg-orange-200";
          break;
        case "indigo":
          if (g === 0)
            return "bg-indigo-800 dark:bg-indigo-600";
          if (g === 1)
            return "bg-indigo-700 dark:bg-indigo-500";
          if (g === 2)
            return "bg-indigo-600 dark:bg-indigo-400";
          if (g === 3)
            return "bg-indigo-500 dark:bg-indigo-300";
          if (g === 4)
            return "bg-indigo-400 dark:bg-indigo-200";
          break;
        case "purple":
          if (g === 0)
            return "bg-purple-800 dark:bg-purple-600";
          if (g === 1)
            return "bg-purple-700 dark:bg-purple-500";
          if (g === 2)
            return "bg-purple-600 dark:bg-purple-400";
          if (g === 3)
            return "bg-purple-500 dark:bg-purple-300";
          if (g === 4)
            return "bg-purple-400 dark:bg-purple-200";
          break;
        default:
          if (g === 0)
            return "bg-blue-800 dark:bg-blue-600";
          if (g === 1)
            return "bg-blue-700 dark:bg-blue-500";
          if (g === 2)
            return "bg-blue-600 dark:bg-blue-400";
          if (g === 3)
            return "bg-blue-500 dark:bg-blue-300";
          if (g === 4)
            return "bg-blue-400 dark:bg-blue-200";
          break;
      }
    };
    return (g, v) => (s(), u("div", nv, [
      d("h3", {
        class: D({
          "text-lg font-light": e.smallHeading,
          "text-2xl font-light": !e.smallHeading
        })
      }, A(e.title), 3),
      r(l).length > 0 ? (s(), u("div", lv, [
        d("ul", rv, [
          (s(!0), u(J, null, le(r(l), (C, k) => (s(), u("li", {
            key: C.id
          }, [
            d("div", ov, [
              d("div", sv, [
                d("div", iv, [
                  d("div", {
                    class: D(["h-6 mr-2 rounded-theme-sm", [m(k)]]),
                    role: "progressbar",
                    title: `${C.count}`,
                    "aria-valuenow": C.count,
                    "aria-valuemin": "0",
                    "aria-valuemax": r(i),
                    style: st({ width: `${h(C.count)}%` })
                  }, [
                    d("span", uv, A(c(C.count)) + " " + A(C.title), 1)
                  ], 14, dv)
                ]),
                d("div", cv, [
                  re(A(c(C.count)) + " · ", 1),
                  e.doNotLinkEntries ? (s(), u("span", mv, A(C.title), 1)) : (s(), u(J, { key: 0 }, [
                    f(C) ? (s(), u("a", {
                      key: 0,
                      href: C.url,
                      class: "hover:underline focus:underline focus:outline-hidden"
                    }, A(C.title), 9, fv)) : (s(), u("a", {
                      key: 1,
                      href: "#",
                      class: "hover:underline focus:underline focus:outline-hidden",
                      onClick: fe((w) => y(C), ["prevent"])
                    }, A(C.title), 9, hv))
                  ], 64))
                ])
              ])
            ])
          ]))), 128)),
          e.viewAllUrl !== null ? (s(), u("li", gv, [
            d("a", {
              href: e.viewAllUrl,
              class: "link link-primary link-blue link-cta"
            }, " View All ", 8, vv)
          ])) : S("", !0)
        ])
      ])) : (s(), u("div", yv, [
        r(o) ? (s(), u("p", bv, A(e.noDataMsg), 1)) : (s(), u("p", pv, A(e.missingPropsMsg), 1))
      ]))
    ]));
  }
});
Nn.install = (e) => {
  e.component(Nn.name, Nn);
};
On.install = (e) => {
  e.component(On.name, On);
};
const vr = {
  SdsActionButton: je,
  SdsActionDropdown: fa,
  SdsAvatar: ta,
  SdsAvatarGroup: an,
  SdsBadge: nn,
  SdsButton: ha,
  SdsCalendar: Ba,
  SdsCallout: ln,
  SdsCheckboxGroup: rn,
  SdsClientOnly: Ut,
  SdsComboBox: Va,
  SdsDatapoint: on,
  SdsDatepicker: sn,
  SdsDataTable: dn,
  SdsDropdown: ca,
  SdsDropdownCheckboxItem: wl,
  SdsDropdownDivider: un,
  SdsDropdownInputItem: xl,
  SdsDropdownFilterInput: xl,
  // Backwards compatibility alias
  SdsDropdownFooter: fo,
  SdsDropdownHeader: cn,
  SdsDropdownItem: Ta,
  SdsDropdownRadioItem: kl,
  SdsDropdownSection: Ga,
  SdsExpandCollapse: fn,
  SdsFileUploader: hn,
  SdsFilterByDropdown: Aa,
  SdsFloatingActionButton: mn,
  SdsFloatingUi: St,
  SdsFormGroup: gn,
  SdsIndicator: aa,
  SdsInput: vn,
  SdsApplication: yn,
  SdsSimpleApplication: bn,
  SdsBrochureSite: pn,
  SdsBrochureSiteFooter: Na,
  SdsBrochureSiteHeader: Ra,
  SdsBrochureSiteHeaderContent: wn,
  SdsBrochureSiteNav: xn,
  SdsBrochureSiteWordmark: Ea,
  SdsStructuredPage: kn,
  SdsLink: ma,
  SdsLoadingSkeleton: Cn,
  SdsLoadingSpinner: $n,
  SdsMegaMenu: Mn,
  SdsMegaMenuItem: Sn,
  SdsMobileMenu: Dn,
  SdsModal: zn,
  SdsMultiselect: Tn,
  SdsNavigationItem: Bn,
  SdsPaginator: Oa,
  SdsPaginatorRange: Pa,
  SdsPanel: Wa,
  SdsPopover: Ln,
  SdsRadioGroup: In,
  SdsResizer: Vn,
  SdsScrollArea: La,
  SdsScrollspy: An,
  SdsSection: Hn,
  SdsSeiWordmark: ga,
  SdsSelect: Ha,
  SdsSortByDropdown: On,
  SdsSvgIcon: We,
  SdsTabs: Ia,
  SdsTable: Fa,
  SdsTag: Pn,
  SdsTextarea: Fn,
  SdsToast: qa,
  SdsToaster: En,
  SdsToggleSwitch: Rn,
  SdsTooltip: it,
  SdsTopFiveChart: Nn
}, Sv = {
  install(e) {
    Object.keys(vr).forEach((a) => {
      e.component(a, vr[a]);
    });
  }
};
export {
  ls as FOCUSABLE_SELECTOR,
  je as SdsActionButton,
  fa as SdsActionDropdown,
  yn as SdsApplication,
  ta as SdsAvatar,
  an as SdsAvatarGroup,
  nn as SdsBadge,
  pn as SdsBrochureSite,
  Na as SdsBrochureSiteFooter,
  Ra as SdsBrochureSiteHeader,
  wn as SdsBrochureSiteHeaderContent,
  xn as SdsBrochureSiteNav,
  Ea as SdsBrochureSiteWordmark,
  ha as SdsButton,
  Ba as SdsCalendar,
  ln as SdsCallout,
  rn as SdsCheckboxGroup,
  Ut as SdsClientOnly,
  Va as SdsComboBox,
  dn as SdsDataTable,
  on as SdsDatapoint,
  sn as SdsDatepicker,
  ca as SdsDropdown,
  wl as SdsDropdownCheckboxItem,
  un as SdsDropdownDivider,
  xl as SdsDropdownFilterInput,
  fo as SdsDropdownFooter,
  cn as SdsDropdownHeader,
  xl as SdsDropdownInputItem,
  Ta as SdsDropdownItem,
  kl as SdsDropdownRadioItem,
  Ga as SdsDropdownSection,
  fn as SdsExpandCollapse,
  hn as SdsFileUploader,
  Aa as SdsFilterByDropdown,
  mn as SdsFloatingActionButton,
  St as SdsFloatingUi,
  gn as SdsFormGroup,
  aa as SdsIndicator,
  vn as SdsInput,
  ma as SdsLink,
  Cn as SdsLoadingSkeleton,
  $n as SdsLoadingSpinner,
  Mn as SdsMegaMenu,
  Sn as SdsMegaMenuItem,
  Dn as SdsMobileMenu,
  zn as SdsModal,
  Tn as SdsMultiselect,
  Bn as SdsNavigationItem,
  Oa as SdsPaginator,
  Pa as SdsPaginatorRange,
  Wa as SdsPanel,
  Ln as SdsPopover,
  In as SdsRadioGroup,
  Vn as SdsResizer,
  La as SdsScrollArea,
  An as SdsScrollspy,
  Hn as SdsSection,
  ga as SdsSeiWordmark,
  Ha as SdsSelect,
  bn as SdsSimpleApplication,
  On as SdsSortByDropdown,
  kn as SdsStructuredPage,
  We as SdsSvgIcon,
  Fa as SdsTable,
  Ia as SdsTabs,
  Pn as SdsTag,
  Fn as SdsTextarea,
  qa as SdsToast,
  En as SdsToaster,
  Rn as SdsToggleSwitch,
  it as SdsTooltip,
  Nn as SdsTopFiveChart,
  Sv as default,
  kv as formFieldProps,
  Ml as useButtonClasses,
  Il as useClickOutside,
  ns as useCloseOnEscape,
  Ar as useDebounce,
  Sl as useDropdown,
  ft as useEventListener,
  Ll as useFocusTrap,
  Xt as useFormField,
  is as useFormValidation,
  $v as useLocalStorage,
  xv as useMultipleVariantClasses,
  Sr as useOverlay,
  ss as usePaginationRange,
  cs as useResizeObserver,
  Mv as useSessionStorage,
  Cv as useThrottle,
  us as useThrottleAndDebounce,
  fs as useTimedAction,
  ot as useVariantClasses,
  _n as useZIndex
};
